(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3023],{

/***/ 16926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varAdditional01Extra400":"var(--tkww-union-color-additional-01extra-400, #0073E6)"};

/***/ }),

/***/ 19915:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"var-md-max":"1023.98px","varMdMax":"1023.98px","varSpDown4":"0.125rem","varSpUp7":"2.75rem","varSpDown1":"0.75rem","varSpUp1":"1.25rem","varSpDown2":"0.5rem","varSpUp4":"2rem","varNeutral500":"var(--tkww-union-color-neutral-500, #51545C)","varFontSize100":"var(--tkww-union-typography-scale-100-font-size, 0.75rem)","varFontSize300":"var(--tkww-union-typography-scale-300-font-size, 1rem)","var-in-mobile":"max-width: 767.98px","varInMobile":"max-width: 767.98px","var-in-desktop":"min-width: 768px","varInDesktop":"min-width: 768px","searchBar":"searchBar--146cb","searchBar__container":"searchBar__container--cb1fb","searchBarContainer":"searchBar__container--cb1fb","searchBar__inputContainer":"searchBar__inputContainer--1fd8a","searchBarInputContainer":"searchBar__inputContainer--1fd8a","searchField__label":"searchField__label--2e23d","searchFieldLabel":"searchField__label--2e23d","clearSearchButton__wrapper":"clearSearchButton__wrapper--a5121","clearSearchButtonWrapper":"clearSearchButton__wrapper--a5121","searchBarButton":"searchBarButton--47453","searchBarButton__animated__ww":"searchBarButton__animated__ww--58c20","searchBarButtonAnimatedWw":"searchBarButton__animated__ww--58c20","searchBarButton__label":"searchBarButton__label--ed7ec","searchBarButtonLabel":"searchBarButton__label--ed7ec"};

/***/ }),

/***/ 60858:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varSpDown3":"0.25rem","var-in-mobile":"max-width: 767.98px","varInMobile":"max-width: 767.98px","subNavIconButton__container":"subNavIconButton__container--ae104","subNavIconButtonContainer":"subNavIconButton__container--ae104","subNavIconButton__closeIcon":"subNavIconButton__closeIcon--27e77","subNavIconButtonCloseIcon":"subNavIconButton__closeIcon--27e77"};

/***/ }),

/***/ 69419:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varSpUp3":"1.75rem","varSpDown2":"0.5rem","varNeutralWhite":"var(--tkww-union-color-neutral-white, #FFF)","var-in-mobile":"max-width: 767.98px","varInMobile":"max-width: 767.98px","var-in-desktop":"min-width: 768px","varInDesktop":"min-width: 768px","subNav__linkSection":"subNav__linkSection--4c2ec","subNavLinkSection":"subNav__linkSection--4c2ec","subNav__linksContainer":"subNav__linksContainer--c4e0a","subNavLinksContainer":"subNav__linksContainer--c4e0a","subNav__iconButtonSection":"subNav__iconButtonSection--4d018","subNavIconButtonSection":"subNav__iconButtonSection--4d018"};

/***/ }),

/***/ 99369:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subNavButton":"subNavButton--58eeb","subNavButton__ww":"subNavButton__ww--c30ea","subNavButtonWw":"subNavButton__ww--c30ea"};

/***/ }),

/***/ 42851:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subNavElementLink__link":"subNavElementLink__link--6d63a","subNavElementLinkLink":"subNavElementLink__link--6d63a","subNavElementLink__menuExpander":"subNavElementLink__menuExpander--61fb4","subNavElementLinkMenuExpander":"subNavElementLink__menuExpander--61fb4"};

/***/ }),

/***/ 22200:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varSpBase":"1rem","varSpDown3":"0.25rem","varSpDown1":"0.75rem","varSpDown2":"0.5rem","varSpUp1":"1.25rem","varSpDown5":"0.0625rem","varNeutralWhite":"var(--tkww-union-color-neutral-white, #FFF)","varNeutral300":"var(--tkww-union-color-neutral-300, #CACCD0)","varNeutral500":"var(--tkww-union-color-neutral-500, #51545C)","varNeutral600":"var(--tkww-union-color-neutral-600, #37393F)","varAdditional01Extra300":"var(--tkww-union-color-additional-01extra-300, #A1CDF5)","var-shadow":"0 var(--tkww-union-shadow-box-shadow, 2px 4px rgba(31,31,31,0.12))","varShadow":"0 var(--tkww-union-shadow-box-shadow, 2px 4px rgba(31,31,31,0.12))","varFontSize200":"var(--tkww-union-typography-scale-200-font-size, 0.875rem)","subNavElementLinkMenu__wrapper":"subNavElementLinkMenu__wrapper--161d2","subNavElementLinkMenuWrapper":"subNavElementLinkMenu__wrapper--161d2","subNavElementLinkMenu__container":"subNavElementLinkMenu__container--6cc73","subNavElementLinkMenuContainer":"subNavElementLinkMenu__container--6cc73","subNavElementLinkMenu__content":"subNavElementLinkMenu__content--ffd3d","subNavElementLinkMenuContent":"subNavElementLinkMenu__content--ffd3d","subNavElementLinkMenu__item":"subNavElementLinkMenu__item--1e9bf","subNavElementLinkMenuItem":"subNavElementLinkMenu__item--1e9bf","subNavElementLinkMenu__item__link":"subNavElementLinkMenu__item__link--dd698","subNavElementLinkMenuItemLink":"subNavElementLinkMenu__item__link--dd698","subNavElementLinkMenu__item__link__ww":"subNavElementLinkMenu__item__link__ww--06c5d","subNavElementLinkMenuItemLinkWw":"subNavElementLinkMenu__item__link__ww--06c5d","subNavElementLinkMenu__badge":"subNavElementLinkMenu__badge--88956","subNavElementLinkMenuBadge":"subNavElementLinkMenu__badge--88956","subNavElementLinkMenu__badgeNewIn":"subNavElementLinkMenu__badgeNewIn--410e4","subNavElementLinkMenuBadgeNewIn":"subNavElementLinkMenu__badgeNewIn--410e4"};

/***/ }),

/***/ 41154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varSpBase":"1rem","varSpDown3":"0.25rem","varNeutralWhite":"var(--tkww-union-color-neutral-white, #FFF)","var-in-mobile":"max-width: 767.98px","varInMobile":"max-width: 767.98px","var-in-desktop":"min-width: 768px","varInDesktop":"min-width: 768px","var-xxl":"1360px","varXxl":"1360px","subNavIconLink__container":"subNavIconLink__container--3e970","subNavIconLinkContainer":"subNavIconLink__container--3e970","subNavIconLink__text":"subNavIconLink__text--42ed9","subNavIconLinkText":"subNavIconLink__text--42ed9","subNavIconLink__text__experiment":"subNavIconLink__text__experiment--cb5f9","subNavIconLinkTextExperiment":"subNavIconLink__text__experiment--cb5f9","subNavIconLink__badge":"subNavIconLink__badge--63194","subNavIconLinkBadge":"subNavIconLink__badge--63194","subNavIconLink__icon":"subNavIconLink__icon--860b5","subNavIconLinkIcon":"subNavIconLink__icon--860b5"};

/***/ }),

/***/ 93668:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subNav":"subNav--baafb"};

/***/ }),

/***/ 59251:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subNav":"subNav--18157"};

/***/ }),

/***/ 71644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varAdditional01Extra400":"var(--tkww-union-color-additional-01extra-400, #0073E6)","var-in-mobile":"max-width: 767.98px","varInMobile":"max-width: 767.98px","varFontSize100":"var(--tkww-union-typography-scale-100-font-size, 0.75rem)","varLineHeight100":"var(--tkww-union-typography-scale-100-line-height, 1.34)","varFontSize200":"var(--tkww-union-typography-scale-200-font-size, 0.875rem)","varLineHeight200":"var(--tkww-union-typography-scale-200-line-height, 1.42857)","varFontSize300":"var(--tkww-union-typography-scale-300-font-size, 1rem)","varLineHeight300":"var(--tkww-union-typography-scale-300-line-height, 1.5)","varFontSize400":"var(--tkww-union-typography-scale-400-font-size, 1.125rem)","varLineHeight400":"var(--tkww-union-typography-scale-400-line-height, 1.3333)","varFontSize450":"var(--tkww-union-typography-scale-450-font-size, 1.125rem)","varLineHeight450":"var(--tkww-union-typography-scale-450-line-height, 1.78)","varFontSize500":"var(--tkww-union-typography-scale-500-font-size, 1.25rem)","varLineHeight500":"var(--tkww-union-typography-scale-500-line-height, 1.4)","varFontSize600":"var(--tkww-union-typography-scale-600-font-size, 1.5rem)","varLineHeight600":"var(--tkww-union-typography-scale-600-line-height, 1.333375)","varFontSize700":"var(--tkww-union-typography-scale-700-font-size, 1.75rem)","varLineHeight700":"var(--tkww-union-typography-scale-700-line-height, 1.286)","varFontSize800":"var(--tkww-union-typography-scale-800-font-size, 2rem)","varLineHeight800":"var(--tkww-union-typography-scale-800-line-height, 1.25)","varFontSize900":"var(--tkww-union-typography-scale-900-font-size, 2.25rem)","varLineHeight900":"var(--tkww-union-typography-scale-900-line-height, 1.2225)","var-hero-xl-letter-spacing":"var(--tkww-union-typography-category-hero-xl-letter-spacing, -0.02em)","varHeroXlLetterSpacing":"var(--tkww-union-typography-category-hero-xl-letter-spacing, -0.02em)","var-hero-xl-font-weight":"var(--tkww-union-typography-category-hero-xl-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","varHeroXlFontWeight":"var(--tkww-union-typography-category-hero-xl-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","var-hero-xl-font-family":"var(--tkww-union-typography-category-hero-xl-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varHeroXlFontFamily":"var(--tkww-union-typography-category-hero-xl-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-hero-xl-font-size":"var(--tkww-union-typography-category-hero-xl-font-size, 5.625rem)","varHeroXlFontSize":"var(--tkww-union-typography-category-hero-xl-font-size, 5.625rem)","var-hero-xl-line-height":"var(--tkww-union-typography-category-hero-xl-line-height, 1)","varHeroXlLineHeight":"var(--tkww-union-typography-category-hero-xl-line-height, 1)","var-hero-lg-letter-spacing":"var(--tkww-union-typography-category-hero-lg-letter-spacing, -0.02em)","varHeroLgLetterSpacing":"var(--tkww-union-typography-category-hero-lg-letter-spacing, -0.02em)","var-hero-lg-font-weight":"var(--tkww-union-typography-category-hero-lg-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","varHeroLgFontWeight":"var(--tkww-union-typography-category-hero-lg-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","var-hero-lg-font-family":"var(--tkww-union-typography-category-hero-lg-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varHeroLgFontFamily":"var(--tkww-union-typography-category-hero-lg-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-hero-lg-font-size":"var(--tkww-union-typography-category-hero-lg-font-size, 3.75rem)","varHeroLgFontSize":"var(--tkww-union-typography-category-hero-lg-font-size, 3.75rem)","var-hero-lg-line-height":"var(--tkww-union-typography-category-hero-lg-line-height, 1)","varHeroLgLineHeight":"var(--tkww-union-typography-category-hero-lg-line-height, 1)","var-hero-md-letter-spacing":"var(--tkww-union-typography-category-hero-md-letter-spacing, -0.02em)","varHeroMdLetterSpacing":"var(--tkww-union-typography-category-hero-md-letter-spacing, -0.02em)","var-hero-md-font-weight":"var(--tkww-union-typography-category-hero-md-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","varHeroMdFontWeight":"var(--tkww-union-typography-category-hero-md-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","var-hero-md-font-family":"var(--tkww-union-typography-category-hero-md-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varHeroMdFontFamily":"var(--tkww-union-typography-category-hero-md-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-hero-md-font-size":"var(--tkww-union-typography-category-hero-md-font-size, 3rem)","varHeroMdFontSize":"var(--tkww-union-typography-category-hero-md-font-size, 3rem)","var-hero-md-line-height":"var(--tkww-union-typography-category-hero-md-line-height, 1)","varHeroMdLineHeight":"var(--tkww-union-typography-category-hero-md-line-height, 1)","var-hero-sm-letter-spacing":"var(--tkww-union-typography-category-hero-sm-letter-spacing, -0.02em)","varHeroSmLetterSpacing":"var(--tkww-union-typography-category-hero-sm-letter-spacing, -0.02em)","var-hero-sm-font-weight":"var(--tkww-union-typography-category-hero-sm-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","varHeroSmFontWeight":"var(--tkww-union-typography-category-hero-sm-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","var-hero-sm-font-family":"var(--tkww-union-typography-category-hero-sm-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varHeroSmFontFamily":"var(--tkww-union-typography-category-hero-sm-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-hero-sm-font-size":"var(--tkww-union-typography-category-hero-sm-font-size, 2.125rem)","varHeroSmFontSize":"var(--tkww-union-typography-category-hero-sm-font-size, 2.125rem)","var-hero-sm-line-height":"var(--tkww-union-typography-category-hero-sm-line-height, 1)","varHeroSmLineHeight":"var(--tkww-union-typography-category-hero-sm-line-height, 1)","var-h1-font-weight":"var(--tkww-union-typography-category-h1-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varH1FontWeight":"var(--tkww-union-typography-category-h1-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-h1-font-family":"var(--tkww-union-typography-category-h1-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varH1FontFamily":"var(--tkww-union-typography-category-h1-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-h1-font-size":"var(--tkww-union-typography-category-h1-font-size, 1.875rem)","varH1FontSize":"var(--tkww-union-typography-category-h1-font-size, 1.875rem)","var-h1-line-height":"var(--tkww-union-typography-category-h1-line-height, 1.2)","varH1LineHeight":"var(--tkww-union-typography-category-h1-line-height, 1.2)","var-h2-font-weight":"var(--tkww-union-typography-category-h2-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varH2FontWeight":"var(--tkww-union-typography-category-h2-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-h2-font-family":"var(--tkww-union-typography-category-h2-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varH2FontFamily":"var(--tkww-union-typography-category-h2-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-h2-font-size":"var(--tkww-union-typography-category-h2-font-size, 1.75rem)","varH2FontSize":"var(--tkww-union-typography-category-h2-font-size, 1.75rem)","var-h2-line-height":"var(--tkww-union-typography-category-h2-line-height, 1.2142857143)","varH2LineHeight":"var(--tkww-union-typography-category-h2-line-height, 1.2142857143)","var-h3-letter-spacing":"var(--tkww-union-typography-category-h3-letter-spacing, 0)","varH3LetterSpacing":"var(--tkww-union-typography-category-h3-letter-spacing, 0)","var-h3-font-weight":"var(--tkww-union-typography-category-h3-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varH3FontWeight":"var(--tkww-union-typography-category-h3-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-h3-font-family":"var(--tkww-union-typography-category-h3-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varH3FontFamily":"var(--tkww-union-typography-category-h3-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-h3-font-size":"var(--tkww-union-typography-category-h3-font-size, var(--tkww-union-typography-scale-600-font-size, 1.5rem))","varH3FontSize":"var(--tkww-union-typography-category-h3-font-size, var(--tkww-union-typography-scale-600-font-size, 1.5rem))","var-h3-line-height":"var(--tkww-union-typography-category-h3-line-height, 1.1666666667)","varH3LineHeight":"var(--tkww-union-typography-category-h3-line-height, 1.1666666667)","var-h4-letter-spacing":"var(--tkww-union-typography-category-h4-letter-spacing, 0)","varH4LetterSpacing":"var(--tkww-union-typography-category-h4-letter-spacing, 0)","var-h4-font-weight":"var(--tkww-union-typography-category-h4-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varH4FontWeight":"var(--tkww-union-typography-category-h4-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-h4-font-family":"var(--tkww-union-typography-category-h4-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varH4FontFamily":"var(--tkww-union-typography-category-h4-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-h4-font-size":"var(--tkww-union-typography-category-h4-font-size, 1.375rem)","varH4FontSize":"var(--tkww-union-typography-category-h4-font-size, 1.375rem)","var-h4-line-height":"var(--tkww-union-typography-category-h4-line-height, 1.1818181818)","varH4LineHeight":"var(--tkww-union-typography-category-h4-line-height, 1.1818181818)","var-subhead-letter-spacing":"var(--tkww-union-typography-category-subhead-letter-spacing, 0)","varSubheadLetterSpacing":"var(--tkww-union-typography-category-subhead-letter-spacing, 0)","var-subhead-font-family":"var(--tkww-union-typography-category-subhead-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varSubheadFontFamily":"var(--tkww-union-typography-category-subhead-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-subhead-font-size":"var(--tkww-union-typography-category-subhead-font-size, var(--tkww-union-typography-scale-500-font-size, 1.25rem))","varSubheadFontSize":"var(--tkww-union-typography-category-subhead-font-size, var(--tkww-union-typography-scale-500-font-size, 1.25rem))","var-subhead-line-height":"var(--tkww-union-typography-category-subhead-line-height, var(--tkww-union-typography-scale-500-line-height, 1.4))","varSubheadLineHeight":"var(--tkww-union-typography-category-subhead-line-height, var(--tkww-union-typography-scale-500-line-height, 1.4))","var-editorial-letter-spacing":"var(--tkww-union-typography-category-editorial-letter-spacing, 0)","varEditorialLetterSpacing":"var(--tkww-union-typography-category-editorial-letter-spacing, 0)","var-editorial-font-family":"var(--tkww-union-typography-category-editorial-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varEditorialFontFamily":"var(--tkww-union-typography-category-editorial-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-editorial-font-size":"var(--tkww-union-typography-category-editorial-font-size, var(--tkww-union-typography-scale-450-font-size, 1.125rem))","varEditorialFontSize":"var(--tkww-union-typography-category-editorial-font-size, var(--tkww-union-typography-scale-450-font-size, 1.125rem))","var-editorial-line-height":"var(--tkww-union-typography-category-editorial-line-height, 1.4444444444)","varEditorialLineHeight":"var(--tkww-union-typography-category-editorial-line-height, 1.4444444444)","var-body1-letter-spacing":"var(--tkww-union-typography-category-body1-letter-spacing, 0)","varBody1LetterSpacing":"var(--tkww-union-typography-category-body1-letter-spacing, 0)","var-body1-font-family":"var(--tkww-union-typography-category-body1-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varBody1FontFamily":"var(--tkww-union-typography-category-body1-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-body1-font-size":"var(--tkww-union-typography-category-body1-font-size, var(--tkww-union-typography-scale-300-font-size, 1rem))","varBody1FontSize":"var(--tkww-union-typography-category-body1-font-size, var(--tkww-union-typography-scale-300-font-size, 1rem))","var-body1-line-height":"var(--tkww-union-typography-category-body1-line-height, 1.375)","varBody1LineHeight":"var(--tkww-union-typography-category-body1-line-height, 1.375)","var-body2-letter-spacing":"var(--tkww-union-typography-category-body2-letter-spacing, 0)","varBody2LetterSpacing":"var(--tkww-union-typography-category-body2-letter-spacing, 0)","var-body2-font-family":"var(--tkww-union-typography-category-body2-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varBody2FontFamily":"var(--tkww-union-typography-category-body2-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-body2-font-size":"var(--tkww-union-typography-category-body2-font-size, var(--tkww-union-typography-scale-200-font-size, 0.875rem))","varBody2FontSize":"var(--tkww-union-typography-category-body2-font-size, var(--tkww-union-typography-scale-200-font-size, 0.875rem))","var-body2-line-height":"var(--tkww-union-typography-category-body2-line-height, var(--tkww-union-typography-scale-200-line-height, 1.42857))","varBody2LineHeight":"var(--tkww-union-typography-category-body2-line-height, var(--tkww-union-typography-scale-200-line-height, 1.42857))","var-buttonL-letter-spacing":"var(--tkww-union-typography-category-buttonL-letter-spacing, 0)","varButtonLLetterSpacing":"var(--tkww-union-typography-category-buttonL-letter-spacing, 0)","var-buttonL-font-weight":"var(--tkww-union-typography-category-buttonL-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varButtonLFontWeight":"var(--tkww-union-typography-category-buttonL-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-buttonL-font-family":"var(--tkww-union-typography-category-buttonL-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varButtonLFontFamily":"var(--tkww-union-typography-category-buttonL-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-buttonL-font-size":"var(--tkww-union-typography-category-buttonL-font-size, var(--tkww-union-typography-scale-300-font-size, 1rem))","varButtonLFontSize":"var(--tkww-union-typography-category-buttonL-font-size, var(--tkww-union-typography-scale-300-font-size, 1rem))","var-buttonL-line-height":"var(--tkww-union-typography-category-buttonL-line-height, var(--tkww-union-typography-scale-300-line-height, 1.5))","varButtonLLineHeight":"var(--tkww-union-typography-category-buttonL-line-height, var(--tkww-union-typography-scale-300-line-height, 1.5))","var-buttonM-letter-spacing":"var(--tkww-union-typography-category-buttonM-letter-spacing, 0)","varButtonMLetterSpacing":"var(--tkww-union-typography-category-buttonM-letter-spacing, 0)","var-buttonM-font-weight":"var(--tkww-union-typography-category-buttonM-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varButtonMFontWeight":"var(--tkww-union-typography-category-buttonM-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-buttonM-font-family":"var(--tkww-union-typography-category-buttonM-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varButtonMFontFamily":"var(--tkww-union-typography-category-buttonM-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-buttonM-font-size":"var(--tkww-union-typography-category-buttonM-font-size, var(--tkww-union-typography-scale-200-font-size, 0.875rem))","varButtonMFontSize":"var(--tkww-union-typography-category-buttonM-font-size, var(--tkww-union-typography-scale-200-font-size, 0.875rem))","var-buttonM-line-height":"var(--tkww-union-typography-category-buttonM-line-height, var(--tkww-union-typography-scale-200-line-height, 1.42857))","varButtonMLineHeight":"var(--tkww-union-typography-category-buttonM-line-height, var(--tkww-union-typography-scale-200-line-height, 1.42857))","var-overline-letter-spacing":"var(--tkww-union-typography-category-overline-letter-spacing, 2px)","varOverlineLetterSpacing":"var(--tkww-union-typography-category-overline-letter-spacing, 2px)","var-overline-text-transform":"var(--tkww-union-typography-category-overline-text-transform, uppercase)","varOverlineTextTransform":"var(--tkww-union-typography-category-overline-text-transform, uppercase)","var-overline-font-weight":"var(--tkww-union-typography-category-overline-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varOverlineFontWeight":"var(--tkww-union-typography-category-overline-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-overline-font-family":"var(--tkww-union-typography-category-overline-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varOverlineFontFamily":"var(--tkww-union-typography-category-overline-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-overline-font-size":"var(--tkww-union-typography-category-overline-font-size, var(--tkww-union-typography-scale-100-font-size, 0.75rem))","varOverlineFontSize":"var(--tkww-union-typography-category-overline-font-size, var(--tkww-union-typography-scale-100-font-size, 0.75rem))","var-overline-line-height":"var(--tkww-union-typography-category-overline-line-height, 1.3333333333)","varOverlineLineHeight":"var(--tkww-union-typography-category-overline-line-height, 1.3333333333)","var-caption-lg-letter-spacing":"var(--tkww-union-typography-category-caption-lg-letter-spacing, 0)","varCaptionLgLetterSpacing":"var(--tkww-union-typography-category-caption-lg-letter-spacing, 0)","var-caption-lg-font-weight":"var(--tkww-union-typography-category-caption-lg-font-weight, var(--tkww-union-typography-regular-font-weight, 400))","varCaptionLgFontWeight":"var(--tkww-union-typography-category-caption-lg-font-weight, var(--tkww-union-typography-regular-font-weight, 400))","var-caption-lg-font-family":"var(--tkww-union-typography-category-caption-lg-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varCaptionLgFontFamily":"var(--tkww-union-typography-category-caption-lg-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-caption-lg-font-size":"var(--tkww-union-typography-category-caption-lg-font-size, var(--tkww-union-typography-scale-100-font-size, 0.75rem))","varCaptionLgFontSize":"var(--tkww-union-typography-category-caption-lg-font-size, var(--tkww-union-typography-scale-100-font-size, 0.75rem))","var-caption-lg-line-height":"var(--tkww-union-typography-category-caption-lg-line-height, 1.3333333333)","varCaptionLgLineHeight":"var(--tkww-union-typography-category-caption-lg-line-height, 1.3333333333)","var-caption-sm-letter-spacing":"var(--tkww-union-typography-category-caption-sm-letter-spacing, 0)","varCaptionSmLetterSpacing":"var(--tkww-union-typography-category-caption-sm-letter-spacing, 0)","var-caption-sm-font-weight":"var(--tkww-union-typography-category-caption-sm-font-weight, var(--tkww-union-typography-regular-font-weight, 400))","varCaptionSmFontWeight":"var(--tkww-union-typography-category-caption-sm-font-weight, var(--tkww-union-typography-regular-font-weight, 400))","var-caption-sm-font-family":"var(--tkww-union-typography-category-caption-sm-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varCaptionSmFontFamily":"var(--tkww-union-typography-category-caption-sm-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-caption-sm-font-size":"var(--tkww-union-typography-category-caption-sm-font-size, 0.6875rem)","varCaptionSmFontSize":"var(--tkww-union-typography-category-caption-sm-font-size, 0.6875rem)","var-caption-sm-line-height":"var(--tkww-union-typography-category-caption-sm-line-height, 1.4545454545)","varCaptionSmLineHeight":"var(--tkww-union-typography-category-caption-sm-line-height, 1.4545454545)","var-mobile-hero-xl-font-size":"var(--tkww-union-typography-category-hero-xl-font-size, 3.75rem)","varMobileHeroXlFontSize":"var(--tkww-union-typography-category-hero-xl-font-size, 3.75rem)","var-mobile-hero-xl-line-height":"var(--tkww-union-typography-category-hero-xl-line-height, 1)","varMobileHeroXlLineHeight":"var(--tkww-union-typography-category-hero-xl-line-height, 1)","var-mobile-hero-lg-font-size":"var(--tkww-union-typography-category-hero-lg-font-size, 2.8125rem)","varMobileHeroLgFontSize":"var(--tkww-union-typography-category-hero-lg-font-size, 2.8125rem)","var-mobile-hero-lg-line-height":"var(--tkww-union-typography-category-hero-lg-line-height, 1)","varMobileHeroLgLineHeight":"var(--tkww-union-typography-category-hero-lg-line-height, 1)","var-mobile-hero-md-font-size":"var(--tkww-union-typography-category-hero-md-font-size, 2.25rem)","varMobileHeroMdFontSize":"var(--tkww-union-typography-category-hero-md-font-size, 2.25rem)","var-mobile-hero-md-line-height":"var(--tkww-union-typography-category-hero-md-line-height, 1)","varMobileHeroMdLineHeight":"var(--tkww-union-typography-category-hero-md-line-height, 1)","var-mobile-hero-sm-font-size":"var(--tkww-union-typography-category-hero-sm-font-size, 1.875rem)","varMobileHeroSmFontSize":"var(--tkww-union-typography-category-hero-sm-font-size, 1.875rem)","var-mobile-hero-sm-line-height":"var(--tkww-union-typography-category-hero-sm-line-height, 1)","varMobileHeroSmLineHeight":"var(--tkww-union-typography-category-hero-sm-line-height, 1)","var-mobile-h1-font-size":"var(--tkww-union-typography-category-h1-font-size, 1.75rem)","varMobileH1FontSize":"var(--tkww-union-typography-category-h1-font-size, 1.75rem)","var-mobile-h1-line-height":"var(--tkww-union-typography-category-h1-line-height, 1.2142857143)","varMobileH1LineHeight":"var(--tkww-union-typography-category-h1-line-height, 1.2142857143)","var-mobile-h2-font-size":"var(--tkww-union-typography-category-h2-font-size, 1.625rem)","varMobileH2FontSize":"var(--tkww-union-typography-category-h2-font-size, 1.625rem)","var-mobile-h2-line-height":"var(--tkww-union-typography-category-h2-line-height, 1.2307692308)","varMobileH2LineHeight":"var(--tkww-union-typography-category-h2-line-height, 1.2307692308)","var-mobile-h3-font-size":"var(--tkww-union-typography-category-h3-font-size, 1.5rem)","varMobileH3FontSize":"var(--tkww-union-typography-category-h3-font-size, 1.5rem)","var-mobile-h3-line-height":"var(--tkww-union-typography-category-h3-line-height, 1.1666666667)","varMobileH3LineHeight":"var(--tkww-union-typography-category-h3-line-height, 1.1666666667)","var-mobile-h4-font-size":"var(--tkww-union-typography-category-h4-font-size, 1.375rem)","varMobileH4FontSize":"var(--tkww-union-typography-category-h4-font-size, 1.375rem)","var-mobile-h4-line-height":"var(--tkww-union-typography-category-h4-line-height, 1.1818181818)","varMobileH4LineHeight":"var(--tkww-union-typography-category-h4-line-height, 1.1818181818)","var-mobile-subhead-font-size":"var(--tkww-union-typography-category-subhead-font-size, 1.25rem)","varMobileSubheadFontSize":"var(--tkww-union-typography-category-subhead-font-size, 1.25rem)","var-mobile-subhead-line-height":"var(--tkww-union-typography-category-subhead-line-height, 1.4)","varMobileSubheadLineHeight":"var(--tkww-union-typography-category-subhead-line-height, 1.4)","varTextSubtle":"var(--tkww-union-color-text-subtle, var(--tkww-union-color-neutral-500, #51545C))","varTextDefault":"var(--tkww-union-color-text-default, var(--tkww-union-color-neutral-black, #000))","varTextDisabled":"var(--tkww-union-color-text-disabled, var(--tkww-union-color-neutral-300, #CACCD0))","varTextOnDarkDefault":"var(--tkww-union-color-text-on-dark-default, var(--tkww-union-color-neutral-white, #FFF))","varBackgroundDark":"var(--tkww-union-color-background-dark, var(--tkww-union-color-neutral-black, #000))","varBorderDarkDefault":"var(--tkww-union-color-border-dark-default, var(--tkww-union-color-neutral-black, #000))","varBackgroundLight":"var(--tkww-union-color-background-light, var(--tkww-union-color-neutral-white, #FFF))","varLinkOnDarkDisabled":"var(--tkww-union-color-link-on-dark-disabled, var(--tkww-union-color-neutral-400, #9699A0))","var-sm":"480px","varSm":"480px","varMediaSmLow":"max-width: 480px","caption_label":"caption_label--91f1c","captionLabel":"caption_label--91f1c","head_cell":"head_cell--5c03d","headCell":"head_cell--5c03d","root":"root--5b0d3","months":"months--b4104","month":"month--05fa6","head":"head--5fe40","multiple_months":"multiple_months--0b983","multipleMonths":"multiple_months--0b983","nav":"nav--9f114","button_reset":"button_reset--7f9a2","buttonReset":"button_reset--7f9a2","nav_button":"nav_button--8df53","navButton":"nav_button--8df53","button":"button--9495b","day_selected":"day_selected--1a127","daySelected":"day_selected--1a127","day_outside":"day_outside--2c56a","dayOutside":"day_outside--2c56a","day":"day--4ffbd","table":"table--b6520","day_today":"day_today--2866c","dayToday":"day_today--2866c","caption":"caption--fc229","cell":"cell--fa5b5","row":"row--a1469"};

/***/ }),

/***/ 70067:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"root--9a322","vhidden":"vhidden--69caf","button_reset":"button_reset--1c03f","buttonReset":"button_reset--1c03f","button":"button--af2e9","day_selected":"day_selected--34c93","daySelected":"day_selected--34c93","months":"months--dad59","month":"month--94cf2","table":"table--c3488","with_weeknumber":"with_weeknumber--96430","withWeeknumber":"with_weeknumber--96430","caption":"caption--01599","multiple_months":"multiple_months--75a44","multipleMonths":"multiple_months--75a44","caption_dropdowns":"caption_dropdowns--ded60","captionDropdowns":"caption_dropdowns--ded60","caption_label":"caption_label--60e79","captionLabel":"caption_label--60e79","nav":"nav--31ee4","caption_start":"caption_start--f95c7","captionStart":"caption_start--f95c7","caption_end":"caption_end--18b5d","captionEnd":"caption_end--18b5d","nav_button":"nav_button--447ae","navButton":"nav_button--447ae","dropdown_year":"dropdown_year--9ca7c","dropdownYear":"dropdown_year--9ca7c","dropdown_month":"dropdown_month--f0b47","dropdownMonth":"dropdown_month--f0b47","dropdown":"dropdown--f2a9f","dropdown_icon":"dropdown_icon--ddce2","dropdownIcon":"dropdown_icon--ddce2","head":"head--2f2c5","head_row":"head_row--819e2","headRow":"head_row--819e2","row":"row--309ce","head_cell":"head_cell--6ab2e","headCell":"head_cell--6ab2e","tbody":"tbody--27ba0","tfoot":"tfoot--90d12","cell":"cell--6dbd0","weeknumber":"weeknumber--b4f53","day":"day--90c6e","day_today":"day_today--539b2","dayToday":"day_today--539b2","day_outside":"day_outside--d5973","dayOutside":"day_outside--d5973","day_range_start":"day_range_start--35fe7","dayRangeStart":"day_range_start--35fe7","day_range_end":"day_range_end--2fd63","dayRangeEnd":"day_range_end--2fd63","day_range_middle":"day_range_middle--401b0","dayRangeMiddle":"day_range_middle--401b0"};

/***/ }),

/***/ 29744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varBorderDefault":"var(--tkww-union-color-border-default, var(--tkww-union-color-neutral-300, #CACCD0))","varBackgroundLight":"var(--tkww-union-color-background-light, var(--tkww-union-color-neutral-white, #FFF))","varAdditional01Extra300":"var(--tkww-union-color-additional-01extra-300, #A1CDF5)","varIconSubtle":"var(--tkww-union-color-icon-subtle, var(--tkww-union-color-neutral-500, #51545C))","var-sm":"480px","varSm":"480px","varMediaSmLow":"max-width: 480px","relative-container":"relative-container--7c565","relativeContainer":"relative-container--7c565","parent-container":"parent-container--73f80","parentContainer":"parent-container--73f80","is-block":"is-block--12d07","isBlock":"is-block--12d07","is-inline":"is-inline--6ab35","isInline":"is-inline--6ab35","is-closed":"is-closed--7bce3","isClosed":"is-closed--7bce3","is-open":"is-open--b2952","isOpen":"is-open--b2952","dropdown-container":"dropdown-container--ba736","dropdownContainer":"dropdown-container--ba736","picker-container":"picker-container--c8190","pickerContainer":"picker-container--c8190","arrow-up":"arrow-up--4fcf7","arrowUp":"arrow-up--4fcf7","mobile-overlay":"mobile-overlay--6e7e2","mobileOverlay":"mobile-overlay--6e7e2","close-button-container":"close-button-container--1995c","closeButtonContainer":"close-button-container--1995c","close-button":"close-button--d9674 subhead--150a2","closeButton":"close-button--d9674 subhead--150a2","grid-cell":"grid-cell--74f10","gridCell":"grid-cell--74f10"};

/***/ }),

/***/ 74510:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varTextDefault":"var(--tkww-union-color-text-default, var(--tkww-union-color-neutral-black, #000))","varTextSubtle":"var(--tkww-union-color-text-subtle, var(--tkww-union-color-neutral-500, #51545C))","varNeutral600":"var(--tkww-union-color-neutral-600, #37393F)","varBorderDefault":"var(--tkww-union-color-border-default, var(--tkww-union-color-neutral-300, #CACCD0))","varBackgroundLight":"var(--tkww-union-color-background-light, var(--tkww-union-color-neutral-white, #FFF))","varBackgroundActive":"var(--tkww-union-color-background-active, var(--tkww-union-color-additional-04extra-100, #FFF5ED))","var-sp-down-2":"0.5rem","varSpDown2":"0.5rem","var-sp-down-1":"0.75rem","varSpDown1":"0.75rem","base":"base--b5452","container":"container--3bc0c","list-container":"list-container--1cc0c","listContainer":"list-container--1cc0c","list":"list--e6ac4 base--b5452","item-base":"item-base--28e4a","itemBase":"item-base--28e4a","item":"item--f8e1f item-base--28e4a","item-is-disabled":"item-is-disabled--67406 item--f8e1f item-base--28e4a","itemIsDisabled":"item-is-disabled--67406 item--f8e1f item-base--28e4a","item-is-active":"item-is-active--09c75 item-base--28e4a","itemIsActive":"item-is-active--09c75 item-base--28e4a"};

/***/ }),

/***/ 93187:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varBackgroundLightContrast":"var(--tkww-union-color-background-light-contrast, var(--tkww-union-color-neutral-100, #F1F2F4))","var-sp-down-4":"0.125rem","varSpDown4":"0.125rem","var-sp-down-2":"0.5rem","varSpDown2":"0.5rem","container":"container--82e14","sub-text":"sub-text--8b420 next-to-input--5e678","subText":"sub-text--8b420 next-to-input--5e678","is-neutral":"is-neutral--2ce87","isNeutral":"is-neutral--2ce87","is-valid":"is-valid--c88ae","isValid":"is-valid--c88ae","is-invalid":"is-invalid--010aa","isInvalid":"is-invalid--010aa","horizontal-spacing":"calc(%__imported_item__5__% + %__imported_item__6__%)","horizontalSpacing":"calc(%__imported_item__5__% + %__imported_item__6__%)","input":"input--f45af field-base--ef31a body1--e44d4 base--b5452 ease-out--9d4b8 input-with-animated-label--f64b4","input-container":"input-container--d8289","inputContainer":"input-container--d8289","label":"label--abc8d animated-label--5c1b9 ease-out--9d4b8 label--e1548 body1--e44d4"};

/***/ }),

/***/ 55316:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varTextDefault":"var(--tkww-union-color-text-default, var(--tkww-union-color-neutral-black, #000))","varBackgroundActive":"var(--tkww-union-color-background-active, var(--tkww-union-color-additional-04extra-100, #FFF5ED))","var-sp-up-1":"1.25rem","varSpUp1":"1.25rem","container":"container--c93cc body1--e44d4","is-normal":"is-normal--25c55","isNormal":"is-normal--25c55","checkmark":"checkmark--5007b","is-selected":"is-selected--89bbb","isSelected":"is-selected--89bbb","is-active":"is-active--0a768","isActive":"is-active--0a768"};

/***/ }),

/***/ 74885:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varTextDisabled":"var(--tkww-union-color-text-disabled, var(--tkww-union-color-neutral-300, #CACCD0))","varBorderDefault":"var(--tkww-union-color-border-default, var(--tkww-union-color-neutral-300, #CACCD0))","var-sp-base":"1rem","varSpBase":"1rem","base":"base--b5452","disabled":"disabled--a9d82 disabled--19829","sub-text":"sub-text--8b420 next-to-input--5e678","subText":"sub-text--8b420 next-to-input--5e678","is-neutral":"is-neutral--2ce87","isNeutral":"is-neutral--2ce87","is-valid":"is-valid--c88ae","isValid":"is-valid--c88ae","is-invalid":"is-invalid--010aa","isInvalid":"is-invalid--010aa","container":"container--82e14","input":"input--eface base--b5452 input--f45af field-base--ef31a body1--e44d4 ease-out--9d4b8 input-with-animated-label--f64b4","label":"label--2fdef animated-label--5c1b9 ease-out--9d4b8 label--e1548 body1--e44d4","caret":"caret--502b6","list":"list--9b439 base--b5452","is-open":"is-open--93641","isOpen":"is-open--93641","is-closed":"is-closed--0af10","isClosed":"is-closed--0af10"};

/***/ }),

/***/ 46140:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"var-in-mobile":"max-width: 767.98px","varInMobile":"max-width: 767.98px","varFontSize100":"var(--tkww-union-typography-scale-100-font-size, 0.75rem)","varLineHeight100":"var(--tkww-union-typography-scale-100-line-height, 1.34)","varFontSize200":"var(--tkww-union-typography-scale-200-font-size, 0.875rem)","varLineHeight200":"var(--tkww-union-typography-scale-200-line-height, 1.42857)","varFontSize300":"var(--tkww-union-typography-scale-300-font-size, 1rem)","varLineHeight300":"var(--tkww-union-typography-scale-300-line-height, 1.5)","varFontSize400":"var(--tkww-union-typography-scale-400-font-size, 1.125rem)","varLineHeight400":"var(--tkww-union-typography-scale-400-line-height, 1.3333)","varFontSize450":"var(--tkww-union-typography-scale-450-font-size, 1.125rem)","varLineHeight450":"var(--tkww-union-typography-scale-450-line-height, 1.78)","varFontSize500":"var(--tkww-union-typography-scale-500-font-size, 1.25rem)","varLineHeight500":"var(--tkww-union-typography-scale-500-line-height, 1.4)","varFontSize600":"var(--tkww-union-typography-scale-600-font-size, 1.5rem)","varLineHeight600":"var(--tkww-union-typography-scale-600-line-height, 1.333375)","varFontSize700":"var(--tkww-union-typography-scale-700-font-size, 1.75rem)","varLineHeight700":"var(--tkww-union-typography-scale-700-line-height, 1.286)","varFontSize800":"var(--tkww-union-typography-scale-800-font-size, 2rem)","varLineHeight800":"var(--tkww-union-typography-scale-800-line-height, 1.25)","varFontSize900":"var(--tkww-union-typography-scale-900-font-size, 2.25rem)","varLineHeight900":"var(--tkww-union-typography-scale-900-line-height, 1.2225)","var-hero-xl-letter-spacing":"var(--tkww-union-typography-category-hero-xl-letter-spacing, -0.02em)","varHeroXlLetterSpacing":"var(--tkww-union-typography-category-hero-xl-letter-spacing, -0.02em)","var-hero-xl-font-weight":"var(--tkww-union-typography-category-hero-xl-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","varHeroXlFontWeight":"var(--tkww-union-typography-category-hero-xl-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","var-hero-xl-font-family":"var(--tkww-union-typography-category-hero-xl-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varHeroXlFontFamily":"var(--tkww-union-typography-category-hero-xl-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-hero-xl-font-size":"var(--tkww-union-typography-category-hero-xl-font-size, 5.625rem)","varHeroXlFontSize":"var(--tkww-union-typography-category-hero-xl-font-size, 5.625rem)","var-hero-xl-line-height":"var(--tkww-union-typography-category-hero-xl-line-height, 1)","varHeroXlLineHeight":"var(--tkww-union-typography-category-hero-xl-line-height, 1)","var-hero-lg-letter-spacing":"var(--tkww-union-typography-category-hero-lg-letter-spacing, -0.02em)","varHeroLgLetterSpacing":"var(--tkww-union-typography-category-hero-lg-letter-spacing, -0.02em)","var-hero-lg-font-weight":"var(--tkww-union-typography-category-hero-lg-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","varHeroLgFontWeight":"var(--tkww-union-typography-category-hero-lg-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","var-hero-lg-font-family":"var(--tkww-union-typography-category-hero-lg-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varHeroLgFontFamily":"var(--tkww-union-typography-category-hero-lg-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-hero-lg-font-size":"var(--tkww-union-typography-category-hero-lg-font-size, 3.75rem)","varHeroLgFontSize":"var(--tkww-union-typography-category-hero-lg-font-size, 3.75rem)","var-hero-lg-line-height":"var(--tkww-union-typography-category-hero-lg-line-height, 1)","varHeroLgLineHeight":"var(--tkww-union-typography-category-hero-lg-line-height, 1)","var-hero-md-letter-spacing":"var(--tkww-union-typography-category-hero-md-letter-spacing, -0.02em)","varHeroMdLetterSpacing":"var(--tkww-union-typography-category-hero-md-letter-spacing, -0.02em)","var-hero-md-font-weight":"var(--tkww-union-typography-category-hero-md-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","varHeroMdFontWeight":"var(--tkww-union-typography-category-hero-md-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","var-hero-md-font-family":"var(--tkww-union-typography-category-hero-md-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varHeroMdFontFamily":"var(--tkww-union-typography-category-hero-md-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-hero-md-font-size":"var(--tkww-union-typography-category-hero-md-font-size, 3rem)","varHeroMdFontSize":"var(--tkww-union-typography-category-hero-md-font-size, 3rem)","var-hero-md-line-height":"var(--tkww-union-typography-category-hero-md-line-height, 1)","varHeroMdLineHeight":"var(--tkww-union-typography-category-hero-md-line-height, 1)","var-hero-sm-letter-spacing":"var(--tkww-union-typography-category-hero-sm-letter-spacing, -0.02em)","varHeroSmLetterSpacing":"var(--tkww-union-typography-category-hero-sm-letter-spacing, -0.02em)","var-hero-sm-font-weight":"var(--tkww-union-typography-category-hero-sm-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","varHeroSmFontWeight":"var(--tkww-union-typography-category-hero-sm-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","var-hero-sm-font-family":"var(--tkww-union-typography-category-hero-sm-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varHeroSmFontFamily":"var(--tkww-union-typography-category-hero-sm-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-hero-sm-font-size":"var(--tkww-union-typography-category-hero-sm-font-size, 2.125rem)","varHeroSmFontSize":"var(--tkww-union-typography-category-hero-sm-font-size, 2.125rem)","var-hero-sm-line-height":"var(--tkww-union-typography-category-hero-sm-line-height, 1)","varHeroSmLineHeight":"var(--tkww-union-typography-category-hero-sm-line-height, 1)","var-h1-font-weight":"var(--tkww-union-typography-category-h1-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varH1FontWeight":"var(--tkww-union-typography-category-h1-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-h1-font-family":"var(--tkww-union-typography-category-h1-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varH1FontFamily":"var(--tkww-union-typography-category-h1-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-h1-font-size":"var(--tkww-union-typography-category-h1-font-size, 1.875rem)","varH1FontSize":"var(--tkww-union-typography-category-h1-font-size, 1.875rem)","var-h1-line-height":"var(--tkww-union-typography-category-h1-line-height, 1.2)","varH1LineHeight":"var(--tkww-union-typography-category-h1-line-height, 1.2)","var-h2-font-weight":"var(--tkww-union-typography-category-h2-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varH2FontWeight":"var(--tkww-union-typography-category-h2-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-h2-font-family":"var(--tkww-union-typography-category-h2-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varH2FontFamily":"var(--tkww-union-typography-category-h2-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-h2-font-size":"var(--tkww-union-typography-category-h2-font-size, 1.75rem)","varH2FontSize":"var(--tkww-union-typography-category-h2-font-size, 1.75rem)","var-h2-line-height":"var(--tkww-union-typography-category-h2-line-height, 1.2142857143)","varH2LineHeight":"var(--tkww-union-typography-category-h2-line-height, 1.2142857143)","var-h3-letter-spacing":"var(--tkww-union-typography-category-h3-letter-spacing, 0)","varH3LetterSpacing":"var(--tkww-union-typography-category-h3-letter-spacing, 0)","var-h3-font-weight":"var(--tkww-union-typography-category-h3-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varH3FontWeight":"var(--tkww-union-typography-category-h3-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-h3-font-family":"var(--tkww-union-typography-category-h3-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varH3FontFamily":"var(--tkww-union-typography-category-h3-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-h3-font-size":"var(--tkww-union-typography-category-h3-font-size, var(--tkww-union-typography-scale-600-font-size, 1.5rem))","varH3FontSize":"var(--tkww-union-typography-category-h3-font-size, var(--tkww-union-typography-scale-600-font-size, 1.5rem))","var-h3-line-height":"var(--tkww-union-typography-category-h3-line-height, 1.1666666667)","varH3LineHeight":"var(--tkww-union-typography-category-h3-line-height, 1.1666666667)","var-h4-letter-spacing":"var(--tkww-union-typography-category-h4-letter-spacing, 0)","varH4LetterSpacing":"var(--tkww-union-typography-category-h4-letter-spacing, 0)","var-h4-font-weight":"var(--tkww-union-typography-category-h4-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varH4FontWeight":"var(--tkww-union-typography-category-h4-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-h4-font-family":"var(--tkww-union-typography-category-h4-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varH4FontFamily":"var(--tkww-union-typography-category-h4-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-h4-font-size":"var(--tkww-union-typography-category-h4-font-size, 1.375rem)","varH4FontSize":"var(--tkww-union-typography-category-h4-font-size, 1.375rem)","var-h4-line-height":"var(--tkww-union-typography-category-h4-line-height, 1.1818181818)","varH4LineHeight":"var(--tkww-union-typography-category-h4-line-height, 1.1818181818)","var-subhead-letter-spacing":"var(--tkww-union-typography-category-subhead-letter-spacing, 0)","varSubheadLetterSpacing":"var(--tkww-union-typography-category-subhead-letter-spacing, 0)","var-subhead-font-family":"var(--tkww-union-typography-category-subhead-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varSubheadFontFamily":"var(--tkww-union-typography-category-subhead-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-subhead-font-size":"var(--tkww-union-typography-category-subhead-font-size, var(--tkww-union-typography-scale-500-font-size, 1.25rem))","varSubheadFontSize":"var(--tkww-union-typography-category-subhead-font-size, var(--tkww-union-typography-scale-500-font-size, 1.25rem))","var-subhead-line-height":"var(--tkww-union-typography-category-subhead-line-height, var(--tkww-union-typography-scale-500-line-height, 1.4))","varSubheadLineHeight":"var(--tkww-union-typography-category-subhead-line-height, var(--tkww-union-typography-scale-500-line-height, 1.4))","var-editorial-letter-spacing":"var(--tkww-union-typography-category-editorial-letter-spacing, 0)","varEditorialLetterSpacing":"var(--tkww-union-typography-category-editorial-letter-spacing, 0)","var-editorial-font-family":"var(--tkww-union-typography-category-editorial-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varEditorialFontFamily":"var(--tkww-union-typography-category-editorial-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-editorial-font-size":"var(--tkww-union-typography-category-editorial-font-size, var(--tkww-union-typography-scale-450-font-size, 1.125rem))","varEditorialFontSize":"var(--tkww-union-typography-category-editorial-font-size, var(--tkww-union-typography-scale-450-font-size, 1.125rem))","var-editorial-line-height":"var(--tkww-union-typography-category-editorial-line-height, 1.4444444444)","varEditorialLineHeight":"var(--tkww-union-typography-category-editorial-line-height, 1.4444444444)","var-body1-letter-spacing":"var(--tkww-union-typography-category-body1-letter-spacing, 0)","varBody1LetterSpacing":"var(--tkww-union-typography-category-body1-letter-spacing, 0)","var-body1-font-family":"var(--tkww-union-typography-category-body1-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varBody1FontFamily":"var(--tkww-union-typography-category-body1-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-body1-font-size":"var(--tkww-union-typography-category-body1-font-size, var(--tkww-union-typography-scale-300-font-size, 1rem))","varBody1FontSize":"var(--tkww-union-typography-category-body1-font-size, var(--tkww-union-typography-scale-300-font-size, 1rem))","var-body1-line-height":"var(--tkww-union-typography-category-body1-line-height, 1.375)","varBody1LineHeight":"var(--tkww-union-typography-category-body1-line-height, 1.375)","var-body2-letter-spacing":"var(--tkww-union-typography-category-body2-letter-spacing, 0)","varBody2LetterSpacing":"var(--tkww-union-typography-category-body2-letter-spacing, 0)","var-body2-font-family":"var(--tkww-union-typography-category-body2-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varBody2FontFamily":"var(--tkww-union-typography-category-body2-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-body2-font-size":"var(--tkww-union-typography-category-body2-font-size, var(--tkww-union-typography-scale-200-font-size, 0.875rem))","varBody2FontSize":"var(--tkww-union-typography-category-body2-font-size, var(--tkww-union-typography-scale-200-font-size, 0.875rem))","var-body2-line-height":"var(--tkww-union-typography-category-body2-line-height, var(--tkww-union-typography-scale-200-line-height, 1.42857))","varBody2LineHeight":"var(--tkww-union-typography-category-body2-line-height, var(--tkww-union-typography-scale-200-line-height, 1.42857))","var-buttonL-letter-spacing":"var(--tkww-union-typography-category-buttonL-letter-spacing, 0)","varButtonLLetterSpacing":"var(--tkww-union-typography-category-buttonL-letter-spacing, 0)","var-buttonL-font-weight":"var(--tkww-union-typography-category-buttonL-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varButtonLFontWeight":"var(--tkww-union-typography-category-buttonL-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-buttonL-font-family":"var(--tkww-union-typography-category-buttonL-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varButtonLFontFamily":"var(--tkww-union-typography-category-buttonL-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-buttonL-font-size":"var(--tkww-union-typography-category-buttonL-font-size, var(--tkww-union-typography-scale-300-font-size, 1rem))","varButtonLFontSize":"var(--tkww-union-typography-category-buttonL-font-size, var(--tkww-union-typography-scale-300-font-size, 1rem))","var-buttonL-line-height":"var(--tkww-union-typography-category-buttonL-line-height, var(--tkww-union-typography-scale-300-line-height, 1.5))","varButtonLLineHeight":"var(--tkww-union-typography-category-buttonL-line-height, var(--tkww-union-typography-scale-300-line-height, 1.5))","var-buttonM-letter-spacing":"var(--tkww-union-typography-category-buttonM-letter-spacing, 0)","varButtonMLetterSpacing":"var(--tkww-union-typography-category-buttonM-letter-spacing, 0)","var-buttonM-font-weight":"var(--tkww-union-typography-category-buttonM-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varButtonMFontWeight":"var(--tkww-union-typography-category-buttonM-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-buttonM-font-family":"var(--tkww-union-typography-category-buttonM-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varButtonMFontFamily":"var(--tkww-union-typography-category-buttonM-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-buttonM-font-size":"var(--tkww-union-typography-category-buttonM-font-size, var(--tkww-union-typography-scale-200-font-size, 0.875rem))","varButtonMFontSize":"var(--tkww-union-typography-category-buttonM-font-size, var(--tkww-union-typography-scale-200-font-size, 0.875rem))","var-buttonM-line-height":"var(--tkww-union-typography-category-buttonM-line-height, var(--tkww-union-typography-scale-200-line-height, 1.42857))","varButtonMLineHeight":"var(--tkww-union-typography-category-buttonM-line-height, var(--tkww-union-typography-scale-200-line-height, 1.42857))","var-overline-letter-spacing":"var(--tkww-union-typography-category-overline-letter-spacing, 2px)","varOverlineLetterSpacing":"var(--tkww-union-typography-category-overline-letter-spacing, 2px)","var-overline-text-transform":"var(--tkww-union-typography-category-overline-text-transform, uppercase)","varOverlineTextTransform":"var(--tkww-union-typography-category-overline-text-transform, uppercase)","var-overline-font-weight":"var(--tkww-union-typography-category-overline-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varOverlineFontWeight":"var(--tkww-union-typography-category-overline-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-overline-font-family":"var(--tkww-union-typography-category-overline-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varOverlineFontFamily":"var(--tkww-union-typography-category-overline-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-overline-font-size":"var(--tkww-union-typography-category-overline-font-size, var(--tkww-union-typography-scale-100-font-size, 0.75rem))","varOverlineFontSize":"var(--tkww-union-typography-category-overline-font-size, var(--tkww-union-typography-scale-100-font-size, 0.75rem))","var-overline-line-height":"var(--tkww-union-typography-category-overline-line-height, 1.3333333333)","varOverlineLineHeight":"var(--tkww-union-typography-category-overline-line-height, 1.3333333333)","var-caption-lg-letter-spacing":"var(--tkww-union-typography-category-caption-lg-letter-spacing, 0)","varCaptionLgLetterSpacing":"var(--tkww-union-typography-category-caption-lg-letter-spacing, 0)","var-caption-lg-font-weight":"var(--tkww-union-typography-category-caption-lg-font-weight, var(--tkww-union-typography-regular-font-weight, 400))","varCaptionLgFontWeight":"var(--tkww-union-typography-category-caption-lg-font-weight, var(--tkww-union-typography-regular-font-weight, 400))","var-caption-lg-font-family":"var(--tkww-union-typography-category-caption-lg-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varCaptionLgFontFamily":"var(--tkww-union-typography-category-caption-lg-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-caption-lg-font-size":"var(--tkww-union-typography-category-caption-lg-font-size, var(--tkww-union-typography-scale-100-font-size, 0.75rem))","varCaptionLgFontSize":"var(--tkww-union-typography-category-caption-lg-font-size, var(--tkww-union-typography-scale-100-font-size, 0.75rem))","var-caption-lg-line-height":"var(--tkww-union-typography-category-caption-lg-line-height, 1.3333333333)","varCaptionLgLineHeight":"var(--tkww-union-typography-category-caption-lg-line-height, 1.3333333333)","var-caption-sm-letter-spacing":"var(--tkww-union-typography-category-caption-sm-letter-spacing, 0)","varCaptionSmLetterSpacing":"var(--tkww-union-typography-category-caption-sm-letter-spacing, 0)","var-caption-sm-font-weight":"var(--tkww-union-typography-category-caption-sm-font-weight, var(--tkww-union-typography-regular-font-weight, 400))","varCaptionSmFontWeight":"var(--tkww-union-typography-category-caption-sm-font-weight, var(--tkww-union-typography-regular-font-weight, 400))","var-caption-sm-font-family":"var(--tkww-union-typography-category-caption-sm-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varCaptionSmFontFamily":"var(--tkww-union-typography-category-caption-sm-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-caption-sm-font-size":"var(--tkww-union-typography-category-caption-sm-font-size, 0.6875rem)","varCaptionSmFontSize":"var(--tkww-union-typography-category-caption-sm-font-size, 0.6875rem)","var-caption-sm-line-height":"var(--tkww-union-typography-category-caption-sm-line-height, 1.4545454545)","varCaptionSmLineHeight":"var(--tkww-union-typography-category-caption-sm-line-height, 1.4545454545)","var-mobile-hero-xl-font-size":"var(--tkww-union-typography-category-hero-xl-font-size, 3.75rem)","varMobileHeroXlFontSize":"var(--tkww-union-typography-category-hero-xl-font-size, 3.75rem)","var-mobile-hero-xl-line-height":"var(--tkww-union-typography-category-hero-xl-line-height, 1)","varMobileHeroXlLineHeight":"var(--tkww-union-typography-category-hero-xl-line-height, 1)","var-mobile-hero-lg-font-size":"var(--tkww-union-typography-category-hero-lg-font-size, 2.8125rem)","varMobileHeroLgFontSize":"var(--tkww-union-typography-category-hero-lg-font-size, 2.8125rem)","var-mobile-hero-lg-line-height":"var(--tkww-union-typography-category-hero-lg-line-height, 1)","varMobileHeroLgLineHeight":"var(--tkww-union-typography-category-hero-lg-line-height, 1)","var-mobile-hero-md-font-size":"var(--tkww-union-typography-category-hero-md-font-size, 2.25rem)","varMobileHeroMdFontSize":"var(--tkww-union-typography-category-hero-md-font-size, 2.25rem)","var-mobile-hero-md-line-height":"var(--tkww-union-typography-category-hero-md-line-height, 1)","varMobileHeroMdLineHeight":"var(--tkww-union-typography-category-hero-md-line-height, 1)","var-mobile-hero-sm-font-size":"var(--tkww-union-typography-category-hero-sm-font-size, 1.875rem)","varMobileHeroSmFontSize":"var(--tkww-union-typography-category-hero-sm-font-size, 1.875rem)","var-mobile-hero-sm-line-height":"var(--tkww-union-typography-category-hero-sm-line-height, 1)","varMobileHeroSmLineHeight":"var(--tkww-union-typography-category-hero-sm-line-height, 1)","var-mobile-h1-font-size":"var(--tkww-union-typography-category-h1-font-size, 1.75rem)","varMobileH1FontSize":"var(--tkww-union-typography-category-h1-font-size, 1.75rem)","var-mobile-h1-line-height":"var(--tkww-union-typography-category-h1-line-height, 1.2142857143)","varMobileH1LineHeight":"var(--tkww-union-typography-category-h1-line-height, 1.2142857143)","var-mobile-h2-font-size":"var(--tkww-union-typography-category-h2-font-size, 1.625rem)","varMobileH2FontSize":"var(--tkww-union-typography-category-h2-font-size, 1.625rem)","var-mobile-h2-line-height":"var(--tkww-union-typography-category-h2-line-height, 1.2307692308)","varMobileH2LineHeight":"var(--tkww-union-typography-category-h2-line-height, 1.2307692308)","var-mobile-h3-font-size":"var(--tkww-union-typography-category-h3-font-size, 1.5rem)","varMobileH3FontSize":"var(--tkww-union-typography-category-h3-font-size, 1.5rem)","var-mobile-h3-line-height":"var(--tkww-union-typography-category-h3-line-height, 1.1666666667)","varMobileH3LineHeight":"var(--tkww-union-typography-category-h3-line-height, 1.1666666667)","var-mobile-h4-font-size":"var(--tkww-union-typography-category-h4-font-size, 1.375rem)","varMobileH4FontSize":"var(--tkww-union-typography-category-h4-font-size, 1.375rem)","var-mobile-h4-line-height":"var(--tkww-union-typography-category-h4-line-height, 1.1818181818)","varMobileH4LineHeight":"var(--tkww-union-typography-category-h4-line-height, 1.1818181818)","var-mobile-subhead-font-size":"var(--tkww-union-typography-category-subhead-font-size, 1.25rem)","varMobileSubheadFontSize":"var(--tkww-union-typography-category-subhead-font-size, 1.25rem)","var-mobile-subhead-line-height":"var(--tkww-union-typography-category-subhead-line-height, 1.4)","varMobileSubheadLineHeight":"var(--tkww-union-typography-category-subhead-line-height, 1.4)","varNeutralWhite":"var(--tkww-union-color-neutral-white, #FFF)","varNeutral500":"var(--tkww-union-color-neutral-500, #51545C)","varNeutral600":"var(--tkww-union-color-neutral-600, #37393F)","varTextError":"var(--tkww-union-color-text-error, var(--tkww-union-color-status-error-200, #EB1400))","varTextSubtle":"var(--tkww-union-color-text-subtle, var(--tkww-union-color-neutral-500, #51545C))","varBackgroundLightContrast":"var(--tkww-union-color-background-light-contrast, var(--tkww-union-color-neutral-100, #F1F2F4))","varBackgroundLightContrast2":"var(--tkww-union-color-background-light-contrast-2, var(--tkww-union-color-neutral-200, #E4E5E9))","var-sp-down-1":"0.75rem","varSpDown1":"0.75rem","var-sp-down-2":"0.5rem","varSpDown2":"0.5rem","var-sp-down-3":"0.25rem","varSpDown3":"0.25rem","var-sp-down-4":"0.125rem","varSpDown4":"0.125rem","var-sp-up-1":"1.25rem","varSpUp1":"1.25rem","base":"base--b5452","sub-text":"sub-text--8b420 next-to-input--5e678","subText":"sub-text--8b420 next-to-input--5e678","is-neutral":"is-neutral--2ce87","isNeutral":"is-neutral--2ce87","is-invalid":"is-invalid--010aa","isInvalid":"is-invalid--010aa","is-valid":"is-valid--c88ae","isValid":"is-valid--c88ae","horizontal-spacing":"calc(%__imported_item__133__% + %__imported_item__131__%)","horizontalSpacing":"calc(%__imported_item__133__% + %__imported_item__131__%)","input":"input--f2c8d field-base--ef31a body1--e44d4 base--b5452 input-with-animated-label--f64b4 custom-scrollbar--99132 text-area-reset--464c6","container":"container--7de7c container--82e14","custom-scrollbar":"custom-scrollbar--99132","customScrollbar":"custom-scrollbar--99132","text-area-reset":"text-area-reset--464c6","textAreaReset":"text-area-reset--464c6","placeholder":"placeholder--c86f1","label":"label--d6d8e animated-label--5c1b9 ease-out--9d4b8 label--e1548 body1--e44d4","length-indicator":"length-indicator--afc4d","lengthIndicator":"length-indicator--afc4d","length-indicator-valid":"length-indicator-valid--1df4c","lengthIndicatorValid":"length-indicator-valid--1df4c","length-indicator-invalid":"length-indicator-invalid--d245b","lengthIndicatorInvalid":"length-indicator-invalid--d245b"};

/***/ }),

/***/ 8678:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animated":"animated--a2915","overlay":"overlay--252ff","not-visible":"not-visible--b9158","notVisible":"not-visible--b9158","not-enabled":"not-enabled--5be17","notEnabled":"not-enabled--5be17","color-dark":"color-dark--b0bbc","colorDark":"color-dark--b0bbc","color-light":"color-light--f6c9a","colorLight":"color-light--f6c9a","fixed-to-relative":"fixed-to-relative--af9e1","fixedToRelative":"fixed-to-relative--af9e1","fixed-to-page":"fixed-to-page--c5248","fixedToPage":"fixed-to-page--c5248"};

/***/ }),

/***/ 24065:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"sr-only--19d91","srOnly":"sr-only--19d91"};

/***/ }),

/***/ 33946:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"no-scroll":"no-scroll--2ecef","noScroll":"no-scroll--2ecef"};

/***/ }),

/***/ 50688:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"var-sm-max":"767.98px","varSmMax":"767.98px","zendeskLauncher":"zendeskLauncher--12f31","hide":"hide--bc9ea","iconChatContainer":"iconChatContainer--97da0","chatIcon":"chatIcon--8ba52","messageCount":"messageCount--6e655"};

/***/ }),

/***/ 5912:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon--1935d","icon-has-no-size":"icon-has-no-size--189a8","iconHasNoSize":"icon-has-no-size--189a8","size-sm":"size-sm--ad48b","sizeSm":"size-sm--ad48b","size-md":"size-md--ffa00","sizeMd":"size-md--ffa00","size-lg":"size-lg--2b900","sizeLg":"size-lg--2b900"};

/***/ }),

/***/ 31046:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"container--e7bf7","is-inline":"is-inline--fda67","isInline":"is-inline--fda67","is-block":"is-block--c90e8","isBlock":"is-block--c90e8","size-sm":"size-sm--9552e","sizeSm":"size-sm--9552e","size-md":"size-md--a869b","sizeMd":"size-md--a869b","size-lg":"size-lg--47a16","sizeLg":"size-lg--47a16"};

/***/ }),

/***/ 90248:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"button--5b2f7"};

/***/ }),

/***/ 60974:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varAdditional01Extra400":"var(--tkww-union-color-additional-01extra-400, #0073E6)","tab":"tab--b64d1","no-tab":"no-tab--f8995","noTab":"no-tab--f8995"};

/***/ }),

/***/ 10204:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varSpUp3":"1.75rem","varSpBase":"1rem","varSpDown1":"0.75rem","varBackgroundDark":"var(--tkww-union-color-background-dark, var(--tkww-union-color-neutral-black, #000))","varTextOnDarkDefault":"var(--tkww-union-color-text-on-dark-default, var(--tkww-union-color-neutral-white, #FFF))","var-xs-max":"479.98px","varXsMax":"479.98px","snackbar-wrapper":"snackbar-wrapper--fa618","snackbarWrapper":"snackbar-wrapper--fa618","fixed-to-relative":"fixed-to-relative--06c35","fixedToRelative":"fixed-to-relative--06c35","fixed-to-page":"fixed-to-page--46c34","fixedToPage":"fixed-to-page--46c34","close-button-container":"close-button-container--9e9e2","closeButtonContainer":"close-button-container--9e9e2","container":"container--75aff body1--e44d4 shadow--f55d3","children":"children--770c6","is-visible":"is-visible--22f1e","isVisible":"is-visible--22f1e","is-not-visible":"is-not-visible--ec2ba","isNotVisible":"is-not-visible--ec2ba"};

/***/ }),

/***/ 3105:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon--1935d","icon-has-no-size":"icon-has-no-size--189a8","iconHasNoSize":"icon-has-no-size--189a8","size-sm":"size-sm--ad48b","sizeSm":"size-sm--ad48b","size-md":"size-md--ffa00","sizeMd":"size-md--ffa00","size-lg":"size-lg--2b900","sizeLg":"size-lg--2b900"};

/***/ }),

/***/ 70967:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"container--e7bf7","is-inline":"is-inline--fda67","isInline":"is-inline--fda67","is-block":"is-block--c90e8","isBlock":"is-block--c90e8","size-sm":"size-sm--9552e","sizeSm":"size-sm--9552e","size-md":"size-md--a869b","sizeMd":"size-md--a869b","size-lg":"size-lg--47a16","sizeLg":"size-lg--47a16"};

/***/ }),

/***/ 15618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"var-in-desktop":"min-width: 768px","varInDesktop":"min-width: 768px","var-in-mobile":"max-width: 767.98px","varInMobile":"max-width: 767.98px","areYouVendorHeader":"areYouVendorHeader--49831","areYouVendorLink":"areYouVendorLink--0be7f","appDownload":"appDownload--8975f","appContainer":"appContainer--ae291","qrCodeContainer":"qrCodeContainer--f6abb","qrCode":"qrCode--2af75","logoColumn":"logoColumn--c6595","linksColumn":"linksColumn--693db","linksRow":"linksRow--41c62","container":"container--203da","contentWrapper":"contentWrapper--f55f4","footer":"footer--301bb","footerLink":"footerLink--583cb body2--f71c1","heartIcon":"heartIcon--4c4bc","madeWith":"madeWith--0feb7","mediumRow":"mediumRow--96a89","section":"section--f9362","sectionsWrapper":"sectionsWrapper--b569f","storeBadge":"storeBadge--8e3d6","storeBadgeContainer":"storeBadgeContainer--f1834","rowColumns":"rowColumns--ef172","chatBubble":"chatBubble--420ff","chatCta":"chatCta--4e99c","chatSpinner":"chatSpinner--f0bdb","companySection":"companySection--1d4fd section--f9362","desktopSectionLabel":"desktopSectionLabel--1a1b3 sectionLabel--f0839","hidden":"hidden--0d587","mobileSectionLabel":"mobileSectionLabel--3f306 sectionLabel--f0839","productsSection":"productsSection--910a0 section--f9362","sectionItemsWrapper":"sectionItemsWrapper--6396a","sectionItemsList":"sectionItemsList--39f2f","sectionGroupRow":"sectionGroupRow--b7d58","brandsSection":"brandsSection--f5dba","chatSection":"chatSection--7240b","hideChatInDesktop":"hideChatInDesktop--36700","hideChatInMobile":"hideChatInMobile--7ccc4","businessItemBase":"businessItemBase--7a8f7 sectionItemBase--739d4 body2--f71c1","businessLinksContainer":"businessLinksContainer--f4bec","copyrightItem":"copyrightItem--ea931 businessItemBase--7a8f7 sectionItemBase--739d4 body2--f71c1","logo":"logo--68272 hero-sm--d1e56","sectionItem":"sectionItem--a25a6 sectionItemBase--739d4 body2--f71c1","socialIcon":"socialIcon--7747b h3--ddfd5","socialIconsSection":"socialIconsSection--24135","cookieSettingsButton":"cookieSettingsButton--9b52d businessItemBase--7a8f7 sectionItemBase--739d4 body2--f71c1"};

/***/ }),

/***/ 99050:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"block--26e2c","block-xs":"block-xs--6b8d5","blockXs":"block-xs--6b8d5","block-sm":"block-sm--809b6","blockSm":"block-sm--809b6","block-md":"block-md--699c6","blockMd":"block-md--699c6","block-lg":"block-lg--37db8","blockLg":"block-lg--37db8","block-xl":"block-xl--a9dd9","blockXl":"block-xl--a9dd9","disable-children-pointer-events":"disable-children-pointer-events--008ec","disableChildrenPointerEvents":"disable-children-pointer-events--008ec","varCtaHover":"var(--tkww-union-color-cta-hover, var(--tkww-union-color-primary-400, #D700A0))","varCtaDefault":"var(--tkww-union-color-cta-default, var(--tkww-union-color-primary-300, #FF44CB))","varCtaDisabled":"var(--tkww-union-color-cta-disabled, var(--tkww-union-color-primary-200, #FEBBF7))","varTextOnDarkDefault":"var(--tkww-union-color-text-on-dark-default, var(--tkww-union-color-neutral-white, #FFF))","varCtaDarkDefault":"var(--tkww-union-color-cta-dark-default, var(--tkww-union-color-neutral-black, #000))","varCtaDarkDefaultDisabled":"var(--tkww-union-color-cta-dark-default-disabled, var(--tkww-union-color-neutral-300, #CACCD0))","varCtaDarkDefaultHover":"var(--tkww-union-color-cta-dark-default-hover, var(--tkww-union-color-neutral-600, #37393F))","varNeutralWhite":"var(--tkww-union-color-neutral-white, #FFF)","varBackgroundLight":"var(--tkww-union-color-background-light, var(--tkww-union-color-neutral-white, #FFF))","var-sp-base":"1rem","varSpBase":"1rem","var-sp-up-1":"1.25rem","varSpUp1":"1.25rem","animated-element":"animated-element--d7e20","animatedElement":"animated-element--d7e20","clicked":"clicked--927ab","btn-transitions":"btn-transitions--72b61","btnTransitions":"btn-transitions--72b61","cta-container":"cta-container--b8e2a","ctaContainer":"cta-container--b8e2a","icon":"icon--2f6f0","has-right-label":"has-right-label--e0af3","hasRightLabel":"has-right-label--e0af3","has-left-label":"has-left-label--81eda","hasLeftLabel":"has-left-label--81eda","loading-container":"loading-container--1cd9b cta-container--b8e2a","loadingContainer":"loading-container--1cd9b cta-container--b8e2a","loading-spinner":"loading-spinner--affe3","loadingSpinner":"loading-spinner--affe3","lg":"lg--6088e","md":"md--a5e6f","sm":"sm--6df06","btn":"btn--e1435 btn-transitions--72b61 disable-children-pointer-events--008ec buttonL--736ee","disabled":"disabled--be605","container":"container--5fa1f","primary":"primary--7aced","active":"active--311ff","primary-alternative":"primary-alternative--8dfe6","primaryAlternative":"primary-alternative--8dfe6","secondary":"secondary--2c01f","secondary-alternative":"secondary-alternative--fd0e3","secondaryAlternative":"secondary-alternative--fd0e3","tertiary":"tertiary--844aa","tertiary-alternative":"tertiary-alternative--026be","tertiaryAlternative":"tertiary-alternative--026be","quaternary":"quaternary--7aa06","quaternary-alternative":"quaternary-alternative--86dfc","quaternaryAlternative":"quaternary-alternative--86dfc"};

/***/ }),

/***/ 90510:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon--1935d","icon-has-no-size":"icon-has-no-size--189a8","iconHasNoSize":"icon-has-no-size--189a8","size-sm":"size-sm--ad48b","sizeSm":"size-sm--ad48b","size-md":"size-md--ffa00","sizeMd":"size-md--ffa00","size-lg":"size-lg--2b900","sizeLg":"size-lg--2b900"};

/***/ }),

/***/ 50049:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"container--e7bf7","is-inline":"is-inline--fda67","isInline":"is-inline--fda67","is-block":"is-block--c90e8","isBlock":"is-block--c90e8","size-sm":"size-sm--9552e","sizeSm":"size-sm--9552e","size-md":"size-md--a869b","sizeMd":"size-md--a869b","size-lg":"size-lg--47a16","sizeLg":"size-lg--47a16"};

/***/ }),

/***/ 35075:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"var-xs":"0px","varXs":"0px","var-sm":"480px","varSm":"480px","var-md":"768px","varMd":"768px","var-lg":"1024px","varLg":"1024px","var-xl":"1192px","varXl":"1192px","var-xxl":"1360px","varXxl":"1360px","var-xs-max":"479.98px","varXsMax":"479.98px","var-sm-max":"767.98px","varSmMax":"767.98px","var-md-max":"1023.98px","varMdMax":"1023.98px","var-lg-max":"1191.98px","varLgMax":"1191.98px","var-xl-max":"1359.98px","varXlMax":"1359.98px","var-in-mobile":"max-width: 767.98px","varInMobile":"max-width: 767.98px","var-in-desktop":"min-width: 768px","varInDesktop":"min-width: 768px","container":"container--35f67","container-fluid":"container-fluid--8cabb","containerFluid":"container-fluid--8cabb","container-xl":"container-xl--c88c1","containerXl":"container-xl--c88c1","container-lg":"container-lg--5764c","containerLg":"container-lg--5764c","container-md":"container-md--76167","containerMd":"container-md--76167","container-sm":"container-sm--5a2e8","containerSm":"container-sm--5a2e8","row":"row--a6f92","no-gutters":"no-gutters--24d50","noGutters":"no-gutters--24d50","col":"col--51449","col-xxl":"col-xxl--a0353","colXxl":"col-xxl--a0353","col-xxl-auto":"col-xxl-auto--9382e","colXxlAuto":"col-xxl-auto--9382e","col-xxl-12":"col-xxl-12--8e66b","colXxl12":"col-xxl-12--8e66b","col-xxl-11":"col-xxl-11--e68e6","colXxl11":"col-xxl-11--e68e6","col-xxl-10":"col-xxl-10--dcf83","colXxl10":"col-xxl-10--dcf83","col-xxl-9":"col-xxl-9--dd424","colXxl9":"col-xxl-9--dd424","col-xxl-8":"col-xxl-8--1aaa9","colXxl8":"col-xxl-8--1aaa9","col-xxl-7":"col-xxl-7--4abd0","colXxl7":"col-xxl-7--4abd0","col-xxl-6":"col-xxl-6--75613","colXxl6":"col-xxl-6--75613","col-xxl-5":"col-xxl-5--872ce","colXxl5":"col-xxl-5--872ce","col-xxl-4":"col-xxl-4--80f68","colXxl4":"col-xxl-4--80f68","col-xxl-3":"col-xxl-3--3186e","colXxl3":"col-xxl-3--3186e","col-xxl-2":"col-xxl-2--c7705","colXxl2":"col-xxl-2--c7705","col-xxl-1":"col-xxl-1--2f019","colXxl1":"col-xxl-1--2f019","col-xl":"col-xl--5bec6","colXl":"col-xl--5bec6","col-xl-auto":"col-xl-auto--391fd","colXlAuto":"col-xl-auto--391fd","col-xl-12":"col-xl-12--7eaa3","colXl12":"col-xl-12--7eaa3","col-xl-11":"col-xl-11--fa285","colXl11":"col-xl-11--fa285","col-xl-10":"col-xl-10--720cc","colXl10":"col-xl-10--720cc","col-xl-9":"col-xl-9--b2ac9","colXl9":"col-xl-9--b2ac9","col-xl-8":"col-xl-8--86eee","colXl8":"col-xl-8--86eee","col-xl-7":"col-xl-7--acbc2","colXl7":"col-xl-7--acbc2","col-xl-6":"col-xl-6--53322","colXl6":"col-xl-6--53322","col-xl-5":"col-xl-5--26990","colXl5":"col-xl-5--26990","col-xl-4":"col-xl-4--96a33","colXl4":"col-xl-4--96a33","col-xl-3":"col-xl-3--21ce3","colXl3":"col-xl-3--21ce3","col-xl-2":"col-xl-2--49fdd","colXl2":"col-xl-2--49fdd","col-xl-1":"col-xl-1--44bb4","colXl1":"col-xl-1--44bb4","col-lg":"col-lg--b02ff","colLg":"col-lg--b02ff","col-lg-auto":"col-lg-auto--48e47","colLgAuto":"col-lg-auto--48e47","col-lg-12":"col-lg-12--e740f","colLg12":"col-lg-12--e740f","col-lg-11":"col-lg-11--caa1e","colLg11":"col-lg-11--caa1e","col-lg-10":"col-lg-10--accf7","colLg10":"col-lg-10--accf7","col-lg-9":"col-lg-9--2eb45","colLg9":"col-lg-9--2eb45","col-lg-8":"col-lg-8--88d8f","colLg8":"col-lg-8--88d8f","col-lg-7":"col-lg-7--276a8","colLg7":"col-lg-7--276a8","col-lg-6":"col-lg-6--be908","colLg6":"col-lg-6--be908","col-lg-5":"col-lg-5--ff559","colLg5":"col-lg-5--ff559","col-lg-4":"col-lg-4--4691c","colLg4":"col-lg-4--4691c","col-lg-3":"col-lg-3--9fba5","colLg3":"col-lg-3--9fba5","col-lg-2":"col-lg-2--857de","colLg2":"col-lg-2--857de","col-lg-1":"col-lg-1--4baec","colLg1":"col-lg-1--4baec","col-md":"col-md--3f898","colMd":"col-md--3f898","col-md-auto":"col-md-auto--89507","colMdAuto":"col-md-auto--89507","col-md-12":"col-md-12--006fc","colMd12":"col-md-12--006fc","col-md-11":"col-md-11--7a225","colMd11":"col-md-11--7a225","col-md-10":"col-md-10--09be4","colMd10":"col-md-10--09be4","col-md-9":"col-md-9--cc60d","colMd9":"col-md-9--cc60d","col-md-8":"col-md-8--d5d8a","colMd8":"col-md-8--d5d8a","col-md-7":"col-md-7--f16c9","colMd7":"col-md-7--f16c9","col-md-6":"col-md-6--3db49","colMd6":"col-md-6--3db49","col-md-5":"col-md-5--a8ea3","colMd5":"col-md-5--a8ea3","col-md-4":"col-md-4--d56b4","colMd4":"col-md-4--d56b4","col-md-3":"col-md-3--fcc00","colMd3":"col-md-3--fcc00","col-md-2":"col-md-2--e771c","colMd2":"col-md-2--e771c","col-md-1":"col-md-1--d336a","colMd1":"col-md-1--d336a","col-sm":"col-sm--89869","colSm":"col-sm--89869","col-sm-auto":"col-sm-auto--28b14","colSmAuto":"col-sm-auto--28b14","col-sm-12":"col-sm-12--42b5c","colSm12":"col-sm-12--42b5c","col-sm-11":"col-sm-11--cd087","colSm11":"col-sm-11--cd087","col-sm-10":"col-sm-10--f277e","colSm10":"col-sm-10--f277e","col-sm-9":"col-sm-9--a9016","colSm9":"col-sm-9--a9016","col-sm-8":"col-sm-8--4704c","colSm8":"col-sm-8--4704c","col-sm-7":"col-sm-7--3acd0","colSm7":"col-sm-7--3acd0","col-sm-6":"col-sm-6--4777c","colSm6":"col-sm-6--4777c","col-sm-5":"col-sm-5--2e276","colSm5":"col-sm-5--2e276","col-sm-4":"col-sm-4--ba26a","colSm4":"col-sm-4--ba26a","col-sm-3":"col-sm-3--b24c1","colSm3":"col-sm-3--b24c1","col-sm-2":"col-sm-2--b6657","colSm2":"col-sm-2--b6657","col-sm-1":"col-sm-1--1a641","colSm1":"col-sm-1--1a641","col-auto":"col-auto--3e50f","colAuto":"col-auto--3e50f","col-12":"col-12--71dcc","col12":"col-12--71dcc","col-11":"col-11--e5d4c","col11":"col-11--e5d4c","col-10":"col-10--923f2","col10":"col-10--923f2","col-9":"col-9--032e5","col9":"col-9--032e5","col-8":"col-8--60af6","col8":"col-8--60af6","col-7":"col-7--e9386","col7":"col-7--e9386","col-6":"col-6--b81fd","col6":"col-6--b81fd","col-5":"col-5--84859","col5":"col-5--84859","col-4":"col-4--caed1","col4":"col-4--caed1","col-3":"col-3--721d7","col3":"col-3--721d7","col-2":"col-2--39576","col2":"col-2--39576","col-1":"col-1--6f51a","col1":"col-1--6f51a","row-cols-1":"row-cols-1--49494","rowCols1":"row-cols-1--49494","row-cols-2":"row-cols-2--3554b","rowCols2":"row-cols-2--3554b","row-cols-3":"row-cols-3--18db0","rowCols3":"row-cols-3--18db0","row-cols-4":"row-cols-4--9d86f","rowCols4":"row-cols-4--9d86f","row-cols-5":"row-cols-5--c54a6","rowCols5":"row-cols-5--c54a6","row-cols-6":"row-cols-6--02cf7","rowCols6":"row-cols-6--02cf7","order-first":"order-first--43405","orderFirst":"order-first--43405","order-last":"order-last--94af6","orderLast":"order-last--94af6","order-0":"order-0--7d7c7","order0":"order-0--7d7c7","order-1":"order-1--2018a","order1":"order-1--2018a","order-2":"order-2--b5203","order2":"order-2--b5203","order-3":"order-3--7019e","order3":"order-3--7019e","order-4":"order-4--30d61","order4":"order-4--30d61","order-5":"order-5--0e5b7","order5":"order-5--0e5b7","order-6":"order-6--ab09a","order6":"order-6--ab09a","order-7":"order-7--e5c98","order7":"order-7--e5c98","order-8":"order-8--811fa","order8":"order-8--811fa","order-9":"order-9--6d4ca","order9":"order-9--6d4ca","order-10":"order-10--eab77","order10":"order-10--eab77","order-11":"order-11--44e60","order11":"order-11--44e60","order-12":"order-12--3795a","order12":"order-12--3795a","offset-1":"offset-1--f1cf5","offset1":"offset-1--f1cf5","offset-2":"offset-2--76c74","offset2":"offset-2--76c74","offset-3":"offset-3--127e4","offset3":"offset-3--127e4","offset-4":"offset-4--23abb","offset4":"offset-4--23abb","offset-5":"offset-5--fe5cf","offset5":"offset-5--fe5cf","offset-6":"offset-6--385bd","offset6":"offset-6--385bd","offset-7":"offset-7--4e52c","offset7":"offset-7--4e52c","offset-8":"offset-8--05417","offset8":"offset-8--05417","offset-9":"offset-9--ac4d8","offset9":"offset-9--ac4d8","offset-10":"offset-10--f7571","offset10":"offset-10--f7571","offset-11":"offset-11--4924f","offset11":"offset-11--4924f","row-cols-sm-1":"row-cols-sm-1--1fd4f","rowColsSm1":"row-cols-sm-1--1fd4f","row-cols-sm-2":"row-cols-sm-2--080df","rowColsSm2":"row-cols-sm-2--080df","row-cols-sm-3":"row-cols-sm-3--4b4d7","rowColsSm3":"row-cols-sm-3--4b4d7","row-cols-sm-4":"row-cols-sm-4--640f4","rowColsSm4":"row-cols-sm-4--640f4","row-cols-sm-5":"row-cols-sm-5--3a951","rowColsSm5":"row-cols-sm-5--3a951","row-cols-sm-6":"row-cols-sm-6--f5835","rowColsSm6":"row-cols-sm-6--f5835","order-sm-first":"order-sm-first--865e3","orderSmFirst":"order-sm-first--865e3","order-sm-last":"order-sm-last--cd3e5","orderSmLast":"order-sm-last--cd3e5","order-sm-0":"order-sm-0--1cb34","orderSm0":"order-sm-0--1cb34","order-sm-1":"order-sm-1--15a6d","orderSm1":"order-sm-1--15a6d","order-sm-2":"order-sm-2--cab5b","orderSm2":"order-sm-2--cab5b","order-sm-3":"order-sm-3--ac6ac","orderSm3":"order-sm-3--ac6ac","order-sm-4":"order-sm-4--17040","orderSm4":"order-sm-4--17040","order-sm-5":"order-sm-5--b9ef6","orderSm5":"order-sm-5--b9ef6","order-sm-6":"order-sm-6--b9d1d","orderSm6":"order-sm-6--b9d1d","order-sm-7":"order-sm-7--fa245","orderSm7":"order-sm-7--fa245","order-sm-8":"order-sm-8--651e7","orderSm8":"order-sm-8--651e7","order-sm-9":"order-sm-9--4f5a1","orderSm9":"order-sm-9--4f5a1","order-sm-10":"order-sm-10--6625b","orderSm10":"order-sm-10--6625b","order-sm-11":"order-sm-11--06374","orderSm11":"order-sm-11--06374","order-sm-12":"order-sm-12--1f559","orderSm12":"order-sm-12--1f559","offset-sm-0":"offset-sm-0--a2ba6","offsetSm0":"offset-sm-0--a2ba6","offset-sm-1":"offset-sm-1--6e7a4","offsetSm1":"offset-sm-1--6e7a4","offset-sm-2":"offset-sm-2--783a1","offsetSm2":"offset-sm-2--783a1","offset-sm-3":"offset-sm-3--91bee","offsetSm3":"offset-sm-3--91bee","offset-sm-4":"offset-sm-4--d66f2","offsetSm4":"offset-sm-4--d66f2","offset-sm-5":"offset-sm-5--c87b3","offsetSm5":"offset-sm-5--c87b3","offset-sm-6":"offset-sm-6--21e35","offsetSm6":"offset-sm-6--21e35","offset-sm-7":"offset-sm-7--c6437","offsetSm7":"offset-sm-7--c6437","offset-sm-8":"offset-sm-8--319de","offsetSm8":"offset-sm-8--319de","offset-sm-9":"offset-sm-9--0fb03","offsetSm9":"offset-sm-9--0fb03","offset-sm-10":"offset-sm-10--46111","offsetSm10":"offset-sm-10--46111","offset-sm-11":"offset-sm-11--19e0d","offsetSm11":"offset-sm-11--19e0d","row-cols-md-1":"row-cols-md-1--c133c","rowColsMd1":"row-cols-md-1--c133c","row-cols-md-2":"row-cols-md-2--81ffd","rowColsMd2":"row-cols-md-2--81ffd","row-cols-md-3":"row-cols-md-3--e05e8","rowColsMd3":"row-cols-md-3--e05e8","row-cols-md-4":"row-cols-md-4--b7102","rowColsMd4":"row-cols-md-4--b7102","row-cols-md-5":"row-cols-md-5--031b4","rowColsMd5":"row-cols-md-5--031b4","row-cols-md-6":"row-cols-md-6--08add","rowColsMd6":"row-cols-md-6--08add","order-md-first":"order-md-first--7e210","orderMdFirst":"order-md-first--7e210","order-md-last":"order-md-last--053d0","orderMdLast":"order-md-last--053d0","order-md-0":"order-md-0--9da20","orderMd0":"order-md-0--9da20","order-md-1":"order-md-1--7faeb","orderMd1":"order-md-1--7faeb","order-md-2":"order-md-2--fb88c","orderMd2":"order-md-2--fb88c","order-md-3":"order-md-3--c8702","orderMd3":"order-md-3--c8702","order-md-4":"order-md-4--b0e86","orderMd4":"order-md-4--b0e86","order-md-5":"order-md-5--f4119","orderMd5":"order-md-5--f4119","order-md-6":"order-md-6--d70e9","orderMd6":"order-md-6--d70e9","order-md-7":"order-md-7--6875a","orderMd7":"order-md-7--6875a","order-md-8":"order-md-8--b38ac","orderMd8":"order-md-8--b38ac","order-md-9":"order-md-9--445db","orderMd9":"order-md-9--445db","order-md-10":"order-md-10--8b6c2","orderMd10":"order-md-10--8b6c2","order-md-11":"order-md-11--a42ea","orderMd11":"order-md-11--a42ea","order-md-12":"order-md-12--458d9","orderMd12":"order-md-12--458d9","offset-md-0":"offset-md-0--871b8","offsetMd0":"offset-md-0--871b8","offset-md-1":"offset-md-1--569a0","offsetMd1":"offset-md-1--569a0","offset-md-2":"offset-md-2--6f7f2","offsetMd2":"offset-md-2--6f7f2","offset-md-3":"offset-md-3--5a07f","offsetMd3":"offset-md-3--5a07f","offset-md-4":"offset-md-4--c03c5","offsetMd4":"offset-md-4--c03c5","offset-md-5":"offset-md-5--1b597","offsetMd5":"offset-md-5--1b597","offset-md-6":"offset-md-6--0aea0","offsetMd6":"offset-md-6--0aea0","offset-md-7":"offset-md-7--1ad04","offsetMd7":"offset-md-7--1ad04","offset-md-8":"offset-md-8--d6a5d","offsetMd8":"offset-md-8--d6a5d","offset-md-9":"offset-md-9--1007a","offsetMd9":"offset-md-9--1007a","offset-md-10":"offset-md-10--91553","offsetMd10":"offset-md-10--91553","offset-md-11":"offset-md-11--8d644","offsetMd11":"offset-md-11--8d644","row-cols-lg-1":"row-cols-lg-1--a8e5f","rowColsLg1":"row-cols-lg-1--a8e5f","row-cols-lg-2":"row-cols-lg-2--8e05d","rowColsLg2":"row-cols-lg-2--8e05d","row-cols-lg-3":"row-cols-lg-3--38805","rowColsLg3":"row-cols-lg-3--38805","row-cols-lg-4":"row-cols-lg-4--0402e","rowColsLg4":"row-cols-lg-4--0402e","row-cols-lg-5":"row-cols-lg-5--9c4a4","rowColsLg5":"row-cols-lg-5--9c4a4","row-cols-lg-6":"row-cols-lg-6--b5311","rowColsLg6":"row-cols-lg-6--b5311","order-lg-first":"order-lg-first--92228","orderLgFirst":"order-lg-first--92228","order-lg-last":"order-lg-last--f07be","orderLgLast":"order-lg-last--f07be","order-lg-0":"order-lg-0--b082c","orderLg0":"order-lg-0--b082c","order-lg-1":"order-lg-1--21613","orderLg1":"order-lg-1--21613","order-lg-2":"order-lg-2--4e48f","orderLg2":"order-lg-2--4e48f","order-lg-3":"order-lg-3--2806d","orderLg3":"order-lg-3--2806d","order-lg-4":"order-lg-4--bb827","orderLg4":"order-lg-4--bb827","order-lg-5":"order-lg-5--1bcfd","orderLg5":"order-lg-5--1bcfd","order-lg-6":"order-lg-6--1c5c4","orderLg6":"order-lg-6--1c5c4","order-lg-7":"order-lg-7--ad1d7","orderLg7":"order-lg-7--ad1d7","order-lg-8":"order-lg-8--18d51","orderLg8":"order-lg-8--18d51","order-lg-9":"order-lg-9--c1457","orderLg9":"order-lg-9--c1457","order-lg-10":"order-lg-10--bf667","orderLg10":"order-lg-10--bf667","order-lg-11":"order-lg-11--bb08e","orderLg11":"order-lg-11--bb08e","order-lg-12":"order-lg-12--c5b36","orderLg12":"order-lg-12--c5b36","offset-lg-0":"offset-lg-0--057d8","offsetLg0":"offset-lg-0--057d8","offset-lg-1":"offset-lg-1--1aa3f","offsetLg1":"offset-lg-1--1aa3f","offset-lg-2":"offset-lg-2--116f9","offsetLg2":"offset-lg-2--116f9","offset-lg-3":"offset-lg-3--e4ace","offsetLg3":"offset-lg-3--e4ace","offset-lg-4":"offset-lg-4--5e970","offsetLg4":"offset-lg-4--5e970","offset-lg-5":"offset-lg-5--3fb17","offsetLg5":"offset-lg-5--3fb17","offset-lg-6":"offset-lg-6--7ca8b","offsetLg6":"offset-lg-6--7ca8b","offset-lg-7":"offset-lg-7--529c4","offsetLg7":"offset-lg-7--529c4","offset-lg-8":"offset-lg-8--97ef7","offsetLg8":"offset-lg-8--97ef7","offset-lg-9":"offset-lg-9--3f26d","offsetLg9":"offset-lg-9--3f26d","offset-lg-10":"offset-lg-10--7214f","offsetLg10":"offset-lg-10--7214f","offset-lg-11":"offset-lg-11--e2bbd","offsetLg11":"offset-lg-11--e2bbd","row-cols-xl-1":"row-cols-xl-1--95650","rowColsXl1":"row-cols-xl-1--95650","row-cols-xl-2":"row-cols-xl-2--44145","rowColsXl2":"row-cols-xl-2--44145","row-cols-xl-3":"row-cols-xl-3--46d24","rowColsXl3":"row-cols-xl-3--46d24","row-cols-xl-4":"row-cols-xl-4--5e905","rowColsXl4":"row-cols-xl-4--5e905","row-cols-xl-5":"row-cols-xl-5--438dd","rowColsXl5":"row-cols-xl-5--438dd","row-cols-xl-6":"row-cols-xl-6--40f75","rowColsXl6":"row-cols-xl-6--40f75","order-xl-first":"order-xl-first--dd7d4","orderXlFirst":"order-xl-first--dd7d4","order-xl-last":"order-xl-last--7b222","orderXlLast":"order-xl-last--7b222","order-xl-0":"order-xl-0--58223","orderXl0":"order-xl-0--58223","order-xl-1":"order-xl-1--0f239","orderXl1":"order-xl-1--0f239","order-xl-2":"order-xl-2--03766","orderXl2":"order-xl-2--03766","order-xl-3":"order-xl-3--31872","orderXl3":"order-xl-3--31872","order-xl-4":"order-xl-4--93f40","orderXl4":"order-xl-4--93f40","order-xl-5":"order-xl-5--53691","orderXl5":"order-xl-5--53691","order-xl-6":"order-xl-6--46617","orderXl6":"order-xl-6--46617","order-xl-7":"order-xl-7--9d7a0","orderXl7":"order-xl-7--9d7a0","order-xl-8":"order-xl-8--ceca9","orderXl8":"order-xl-8--ceca9","order-xl-9":"order-xl-9--ba8f7","orderXl9":"order-xl-9--ba8f7","order-xl-10":"order-xl-10--e945b","orderXl10":"order-xl-10--e945b","order-xl-11":"order-xl-11--240a7","orderXl11":"order-xl-11--240a7","order-xl-12":"order-xl-12--9ba17","orderXl12":"order-xl-12--9ba17","offset-xl-0":"offset-xl-0--e09eb","offsetXl0":"offset-xl-0--e09eb","offset-xl-1":"offset-xl-1--ca751","offsetXl1":"offset-xl-1--ca751","offset-xl-2":"offset-xl-2--5f679","offsetXl2":"offset-xl-2--5f679","offset-xl-3":"offset-xl-3--dc0ed","offsetXl3":"offset-xl-3--dc0ed","offset-xl-4":"offset-xl-4--fbed1","offsetXl4":"offset-xl-4--fbed1","offset-xl-5":"offset-xl-5--7657e","offsetXl5":"offset-xl-5--7657e","offset-xl-6":"offset-xl-6--4ef46","offsetXl6":"offset-xl-6--4ef46","offset-xl-7":"offset-xl-7--b1dc3","offsetXl7":"offset-xl-7--b1dc3","offset-xl-8":"offset-xl-8--d8c6c","offsetXl8":"offset-xl-8--d8c6c","offset-xl-9":"offset-xl-9--6a90c","offsetXl9":"offset-xl-9--6a90c","offset-xl-10":"offset-xl-10--48552","offsetXl10":"offset-xl-10--48552","offset-xl-11":"offset-xl-11--2d31c","offsetXl11":"offset-xl-11--2d31c","row-cols-xxl-1":"row-cols-xxl-1--d6835","rowColsXxl1":"row-cols-xxl-1--d6835","row-cols-xxl-2":"row-cols-xxl-2--6e4fd","rowColsXxl2":"row-cols-xxl-2--6e4fd","row-cols-xxl-3":"row-cols-xxl-3--4b454","rowColsXxl3":"row-cols-xxl-3--4b454","row-cols-xxl-4":"row-cols-xxl-4--277eb","rowColsXxl4":"row-cols-xxl-4--277eb","row-cols-xxl-5":"row-cols-xxl-5--f437f","rowColsXxl5":"row-cols-xxl-5--f437f","row-cols-xxl-6":"row-cols-xxl-6--feebb","rowColsXxl6":"row-cols-xxl-6--feebb","order-xxl-first":"order-xxl-first--6099a","orderXxlFirst":"order-xxl-first--6099a","order-xxl-last":"order-xxl-last--39d67","orderXxlLast":"order-xxl-last--39d67","order-xxl-0":"order-xxl-0--88e8a","orderXxl0":"order-xxl-0--88e8a","order-xxl-1":"order-xxl-1--1050d","orderXxl1":"order-xxl-1--1050d","order-xxl-2":"order-xxl-2--cc696","orderXxl2":"order-xxl-2--cc696","order-xxl-3":"order-xxl-3--836d0","orderXxl3":"order-xxl-3--836d0","order-xxl-4":"order-xxl-4--91fc2","orderXxl4":"order-xxl-4--91fc2","order-xxl-5":"order-xxl-5--fb1d1","orderXxl5":"order-xxl-5--fb1d1","order-xxl-6":"order-xxl-6--34c69","orderXxl6":"order-xxl-6--34c69","order-xxl-7":"order-xxl-7--0b5e9","orderXxl7":"order-xxl-7--0b5e9","order-xxl-8":"order-xxl-8--d9b87","orderXxl8":"order-xxl-8--d9b87","order-xxl-9":"order-xxl-9--b0a55","orderXxl9":"order-xxl-9--b0a55","order-xxl-10":"order-xxl-10--e1ff6","orderXxl10":"order-xxl-10--e1ff6","order-xxl-11":"order-xxl-11--e86de","orderXxl11":"order-xxl-11--e86de","order-xxl-12":"order-xxl-12--6ab3b","orderXxl12":"order-xxl-12--6ab3b","offset-xxl-0":"offset-xxl-0--229ef","offsetXxl0":"offset-xxl-0--229ef","offset-xxl-1":"offset-xxl-1--452ac","offsetXxl1":"offset-xxl-1--452ac","offset-xxl-2":"offset-xxl-2--d99e9","offsetXxl2":"offset-xxl-2--d99e9","offset-xxl-3":"offset-xxl-3--45688","offsetXxl3":"offset-xxl-3--45688","offset-xxl-4":"offset-xxl-4--b9234","offsetXxl4":"offset-xxl-4--b9234","offset-xxl-5":"offset-xxl-5--3c20f","offsetXxl5":"offset-xxl-5--3c20f","offset-xxl-6":"offset-xxl-6--c2ad4","offsetXxl6":"offset-xxl-6--c2ad4","offset-xxl-7":"offset-xxl-7--1ee2a","offsetXxl7":"offset-xxl-7--1ee2a","offset-xxl-8":"offset-xxl-8--07b36","offsetXxl8":"offset-xxl-8--07b36","offset-xxl-9":"offset-xxl-9--06d86","offsetXxl9":"offset-xxl-9--06d86","offset-xxl-10":"offset-xxl-10--2a6ed","offsetXxl10":"offset-xxl-10--2a6ed","offset-xxl-11":"offset-xxl-11--fab3a","offsetXxl11":"offset-xxl-11--fab3a","top-level-container":"top-level-container--c290f","topLevelContainer":"top-level-container--c290f","full-bleed-container":"full-bleed-container--728e2","fullBleedContainer":"full-bleed-container--728e2","sticky-left-column":"sticky-left-column--06d53","stickyLeftColumn":"sticky-left-column--06d53","main-content-column":"main-content-column--c6222","mainContentColumn":"main-content-column--c6222","justify-content-start":"justify-content-start--841de","justifyContentStart":"justify-content-start--841de","justify-content-center":"justify-content-center--40276","justifyContentCenter":"justify-content-center--40276","justify-content-end":"justify-content-end--5e0be","justifyContentEnd":"justify-content-end--5e0be","align-items-start":"align-items-start--007c7","alignItemsStart":"align-items-start--007c7","align-items-center":"align-items-center--54c7c","alignItemsCenter":"align-items-center--54c7c","align-items-end":"align-items-end--801de","alignItemsEnd":"align-items-end--801de","vertical-gutters":"vertical-gutters--9318b","verticalGutters":"vertical-gutters--9318b"};

/***/ }),

/***/ 1489:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"var-md":"768px","varMd":"768px","varBackgroundLightContrast":"var(--tkww-union-color-background-light-contrast, var(--tkww-union-color-neutral-100, #F1F2F4))","left-nav-container":"left-nav-container--90c77","leftNavContainer":"left-nav-container--90c77","left-nav":"left-nav--83811","leftNav":"left-nav--83811","skip-to-content":"skip-to-content--d3b27","skipToContent":"skip-to-content--d3b27"};

/***/ }),

/***/ 49455:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varPrimary100":"var(--tkww-union-color-primary-100, #FFE4FB)","varPrimary200":"var(--tkww-union-color-primary-200, #FEBBF7)","varPrimary300":"var(--tkww-union-color-primary-300, #FF44CB)","varPrimary400":"var(--tkww-union-color-primary-400, #D700A0)","varPrimary500":"var(--tkww-union-color-primary-500, #AC007C)","varNeutral100":"var(--tkww-union-color-neutral-100, #F1F2F4)","varNeutral200":"var(--tkww-union-color-neutral-200, #E4E5E9)","varNeutral300":"var(--tkww-union-color-neutral-300, #CACCD0)","varNeutral400":"var(--tkww-union-color-neutral-400, #9699A0)","varNeutral500":"var(--tkww-union-color-neutral-500, #51545C)","varNeutral600":"var(--tkww-union-color-neutral-600, #37393F)","varNeutralBlack":"var(--tkww-union-color-neutral-black, #000)","varNeutralWhite":"var(--tkww-union-color-neutral-white, #FFF)","varStatusError100":"var(--tkww-union-color-status-error-100, #FFECE4)","varStatusError200":"var(--tkww-union-color-status-error-200, #EB1400)","varStatusError300":"var(--tkww-union-color-status-error-300, #A1000B)","varStatusInfo100":"var(--tkww-union-color-status-info-100, #F4F9FF)","varStatusInfo200":"var(--tkww-union-color-status-info-200, #0073E6)","varStatusInfo300":"var(--tkww-union-color-status-info-300, #114394)","varStatusSuccess100":"var(--tkww-union-color-status-success-100, #E2FFEE)","varStatusSuccess200":"var(--tkww-union-color-status-success-200, #008A05)","varStatusSuccess300":"var(--tkww-union-color-status-success-300, #005A25)","varStatusWarning100":"var(--tkww-union-color-status-warning-100, #FFF3DD)","varStatusWarning200":"var(--tkww-union-color-status-warning-200, #C25400)","varStatusWarning300":"var(--tkww-union-color-status-warning-300, #823300)","varAdditional01Extra100":"var(--tkww-union-color-additional-01extra-100, #E6F2FC)","varAdditional01Extra200":"var(--tkww-union-color-additional-01extra-200, #C4DFF9)","varAdditional01Extra300":"var(--tkww-union-color-additional-01extra-300, #A1CDF5)","varAdditional01Extra400":"var(--tkww-union-color-additional-01extra-400, #0073E6)","varAdditional01Extra500":"var(--tkww-union-color-additional-01extra-500, #364C9D)","varAdditional02Extra100":"var(--tkww-union-color-additional-02extra-100, #FFF7E1)","varAdditional02Extra200":"var(--tkww-union-color-additional-02extra-200, #FDDE81)","varAdditional02Extra300":"var(--tkww-union-color-additional-02extra-300, #FBBB03)","varAdditional02Extra400":"var(--tkww-union-color-additional-02extra-400, #FBAF00)","varAdditional02Extra500":"var(--tkww-union-color-additional-02extra-500, #FB8B00)","varAdditional03Extra100":"var(--tkww-union-color-additional-03extra-100, #FFD1BD)","varAdditional03Extra200":"var(--tkww-union-color-additional-03extra-200, #FF9357)","varAdditional03Extra300":"var(--tkww-union-color-additional-03extra-300, #FF6F00)","varAdditional03Extra400":"var(--tkww-union-color-additional-03extra-400, #FA592D)","varAdditional03Extra500":"var(--tkww-union-color-additional-03extra-500, #DB4936)","varAdditional04Extra100":"var(--tkww-union-color-additional-04extra-100, #FFF5ED)","varAdditional04Extra200":"var(--tkww-union-color-additional-04extra-200, #F7E6DC)","varAdditional04Extra300":"var(--tkww-union-color-additional-04extra-300, #E8D5CA)","varAdditional04Extra400":"var(--tkww-union-color-additional-04extra-400, #C7AFA1)","varAdditional04Extra500":"var(--tkww-union-color-additional-04extra-500, #AD9587)","varBackgroundActive":"var(--tkww-union-color-background-active, var(--tkww-union-color-additional-04extra-100, #FFF5ED))","varBackgroundDark":"var(--tkww-union-color-background-dark, var(--tkww-union-color-neutral-black, #000))","varBackgroundDarkContrast":"var(--tkww-union-color-background-dark-contrast, var(--tkww-union-color-neutral-400, #9699A0))","varBackgroundError":"var(--tkww-union-color-background-error, var(--tkww-union-color-status-error-100, #FFECE4))","varBackgroundLight":"var(--tkww-union-color-background-light, var(--tkww-union-color-neutral-white, #FFF))","varBackgroundLightContrast":"var(--tkww-union-color-background-light-contrast, var(--tkww-union-color-neutral-100, #F1F2F4))","varBackgroundLightContrast2":"var(--tkww-union-color-background-light-contrast-2, var(--tkww-union-color-neutral-200, #E4E5E9))","varBackgroundSuccess":"var(--tkww-union-color-background-success, var(--tkww-union-color-status-success-100, #E2FFEE))","varBackgroundWarning":"var(--tkww-union-color-background-warning, var(--tkww-union-color-status-warning-100, #FFF3DD))","varBorderDarkDefault":"var(--tkww-union-color-border-dark-default, var(--tkww-union-color-neutral-black, #000))","varBorderDefault":"var(--tkww-union-color-border-default, var(--tkww-union-color-neutral-300, #CACCD0))","varBorderError":"var(--tkww-union-color-border-error, var(--tkww-union-color-status-error-200, #EB1400))","varBorderSelected":"var(--tkww-union-color-border-selected, var(--tkww-union-color-neutral-500, #51545C))","varBorderSuccess":"var(--tkww-union-color-border-success, var(--tkww-union-color-status-success-200, #008A05))","varBorderWarning":"var(--tkww-union-color-border-warning, var(--tkww-union-color-status-warning-200, #C25400))","varBrandPrimary":"var(--tkww-union-color-brand-primary, var(--tkww-union-color-primary-300, #FF44CB))","varCtaDarkDefault":"var(--tkww-union-color-cta-dark-default, var(--tkww-union-color-neutral-black, #000))","varCtaDarkDefaultDisabled":"var(--tkww-union-color-cta-dark-default-disabled, var(--tkww-union-color-neutral-300, #CACCD0))","varCtaDarkDefaultHover":"var(--tkww-union-color-cta-dark-default-hover, var(--tkww-union-color-neutral-600, #37393F))","varCtaDefault":"var(--tkww-union-color-cta-default, var(--tkww-union-color-primary-300, #FF44CB))","varCtaDisabled":"var(--tkww-union-color-cta-disabled, var(--tkww-union-color-primary-200, #FEBBF7))","varCtaHover":"var(--tkww-union-color-cta-hover, var(--tkww-union-color-primary-400, #D700A0))","varDividerDefault":"var(--tkww-union-color-divider-default, var(--tkww-union-color-neutral-300, #CACCD0))","varIconCta":"var(--tkww-union-color-icon-cta, var(--tkww-union-color-primary-400, #D700A0))","varIconDefault":"var(--tkww-union-color-icon-default, var(--tkww-union-color-neutral-black, #000))","varIconOnDarkDefault":"var(--tkww-union-color-icon-on-dark-default, var(--tkww-union-color-neutral-white, #FFF))","varIconSubtle":"var(--tkww-union-color-icon-subtle, var(--tkww-union-color-neutral-500, #51545C))","varLinkOnLight":"var(--tkww-union-color-link-on-light, var(--tkww-union-color-additional-01extra-400, #0073E6))","varLinkOnLightDisabled":"var(--tkww-union-color-link-on-light-disabled, var(--tkww-union-color-additional-01extra-200, #C4DFF9))","varLinkOnLightHover":"var(--tkww-union-color-link-on-light-hover, var(--tkww-union-color-additional-01extra-400, #0073E6))","varLinkOnDark":"var(--tkww-union-color-link-on-dark, var(--tkww-union-color-neutral-white, #FFF))","varLinkOnDarkDisabled":"var(--tkww-union-color-link-on-dark-disabled, var(--tkww-union-color-neutral-400, #9699A0))","varLinkDarkOnLight":"var(--tkww-union-color-link-dark-on-light, var(--tkww-union-color-neutral-black, #000))","varLinkDarkOnLightDisabled":"var(--tkww-union-color-link-dark-on-light-disabled, var(--tkww-union-color-neutral-300, #CACCD0))","varLinkGrayOnLight":"var(--tkww-union-color-link-gray-on-light, var(--tkww-union-color-neutral-500, #51545C))","varLinkGrayOnLightDisabled":"var(--tkww-union-color-link-gray-on-light-disabled, var(--tkww-union-color-neutral-200, #E4E5E9))","varTextBrand":"var(--tkww-union-color-text-brand, var(--tkww-union-color-primary-400, #D700A0))","varTextDefault":"var(--tkww-union-color-text-default, var(--tkww-union-color-neutral-black, #000))","varTextDisabled":"var(--tkww-union-color-text-disabled, var(--tkww-union-color-neutral-300, #CACCD0))","varTextError":"var(--tkww-union-color-text-error, var(--tkww-union-color-status-error-200, #EB1400))","varTextOnDarkDefault":"var(--tkww-union-color-text-on-dark-default, var(--tkww-union-color-neutral-white, #FFF))","varTextOnDarkSubtle":"var(--tkww-union-color-text-on-dark-subtle, var(--tkww-union-color-neutral-300, #CACCD0))","varTextSubtle":"var(--tkww-union-color-text-subtle, var(--tkww-union-color-neutral-500, #51545C))","varTextSuccess":"var(--tkww-union-color-text-success, var(--tkww-union-color-status-success-200, #008A05))","varTextWarning":"var(--tkww-union-color-text-warning, var(--tkww-union-color-status-warning-200, #C25400))","varWhite":"var(--tkww-union-color-white, var(--tkww-union-color-neutral-white, #FFF))","varCoolgray100":"var(--tkww-union-color-coolgray-100, var(--tkww-union-color-neutral-100, #F1F2F4))","varCoolgray200":"var(--tkww-union-color-coolgray-200, var(--tkww-union-color-neutral-200, #E4E5E9))","varCoolgray300":"var(--tkww-union-color-coolgray-300, var(--tkww-union-color-neutral-300, #CACCD0))","varCoolgray400":"var(--tkww-union-color-coolgray-400, var(--tkww-union-color-neutral-400, #9699A0))","varCoolgray500":"var(--tkww-union-color-coolgray-500, var(--tkww-union-color-neutral-500, #51545C))","varGold100":"var(--tkww-union-color-gold-100, var(--tkww-union-color-additional-02extra-100, #FFF7E1))","varGold200":"var(--tkww-union-color-gold-200, var(--tkww-union-color-additional-02extra-100, #FFF7E1))","varGold300":"var(--tkww-union-color-gold-300, var(--tkww-union-color-additional-02extra-200, #FDDE81))","varGold400":"var(--tkww-union-color-gold-400, var(--tkww-union-color-additional-02extra-300, #FBBB03))","varGold500":"var(--tkww-union-color-gold-500, var(--tkww-union-color-additional-02extra-400, #FBAF00))","varGold900":"var(--tkww-union-color-gold-900, var(--tkww-union-color-additional-02extra-500, #FB8B00))","varIndigo400":"var(--tkww-union-color-indigo-400, var(--tkww-union-color-additional-01extra-100, #E6F2FC))","varIndigo500":"var(--tkww-union-color-indigo-500, var(--tkww-union-color-additional-01extra-100, #E6F2FC))","varIndigo600":"var(--tkww-union-color-indigo-600, var(--tkww-union-color-additional-01extra-200, #C4DFF9))","varIndigo650":"var(--tkww-union-color-indigo-650, var(--tkww-union-color-additional-01extra-300, #A1CDF5))","varIndigo700":"var(--tkww-union-color-indigo-700, var(--tkww-union-color-additional-01extra-300, #A1CDF5))","varIndigo800":"var(--tkww-union-color-indigo-800, var(--tkww-union-color-additional-01extra-400, #0073E6))","varIndigo900":"var(--tkww-union-color-indigo-900, var(--tkww-union-color-additional-01extra-500, #364C9D))","varMidnight":"var(--tkww-union-color-midnight, var(--tkww-union-color-neutral-600, #37393F))","varPeach300":"var(--tkww-union-color-peach-300, var(--tkww-union-color-additional-03extra-100, #FFD1BD))","varPeach400":"var(--tkww-union-color-peach-400, var(--tkww-union-color-additional-03extra-100, #FFD1BD))","varPeach500":"var(--tkww-union-color-peach-500, var(--tkww-union-color-additional-03extra-100, #FFD1BD))","varRaspberry200":"var(--tkww-union-color-raspberry-200, var(--tkww-union-color-primary-100, #FFE4FB))","varRaspberry300":"var(--tkww-union-color-raspberry-300, var(--tkww-union-color-primary-200, #FEBBF7))","varRaspberry400":"var(--tkww-union-color-raspberry-400, var(--tkww-union-color-primary-400, #D700A0))","varRaspberry500":"var(--tkww-union-color-raspberry-500, var(--tkww-union-color-primary-500, #AC007C))","varTeal100":"var(--tkww-union-color-teal-100, var(--tkww-union-color-status-success-100, #E2FFEE))","varTeal200":"var(--tkww-union-color-teal-200, var(--tkww-union-color-status-success-100, #E2FFEE))","varTeal300":"var(--tkww-union-color-teal-300, var(--tkww-union-color-status-success-200, #008A05))","varTeal400":"var(--tkww-union-color-teal-400, var(--tkww-union-color-status-success-200, #008A05))","varTeal500":"var(--tkww-union-color-teal-500, var(--tkww-union-color-status-success-300, #005A25))","varTeal600":"var(--tkww-union-color-teal-600, var(--tkww-union-color-status-success-300, #005A25))","varTkred100":"var(--tkww-union-color-tkred-100, var(--tkww-union-color-primary-100, #FFE4FB))","varTkred200":"var(--tkww-union-color-tkred-200, var(--tkww-union-color-primary-200, #FEBBF7))","varTkred300":"var(--tkww-union-color-tkred-300, var(--tkww-union-color-primary-300, #FF44CB))","varTkred400":"var(--tkww-union-color-tkred-400, var(--tkww-union-color-primary-400, #D700A0))","varTkred500":"var(--tkww-union-color-tkred-500, var(--tkww-union-color-primary-500, #AC007C))","varTkred600":"var(--tkww-union-color-tkred-600, var(--tkww-union-color-primary-500, #AC007C))"};

/***/ }),

/***/ 55828:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varNeutral300":"var(--tkww-union-color-neutral-300, #CACCD0)","varNeutral500":"var(--tkww-union-color-neutral-500, #51545C)","varNeutralWhite":"var(--tkww-union-color-neutral-white, #FFF)","varBackgroundDark":"var(--tkww-union-color-background-dark, var(--tkww-union-color-neutral-black, #000))","varTextSubtle":"var(--tkww-union-color-text-subtle, var(--tkww-union-color-neutral-500, #51545C))","varTextOnDarkDefault":"var(--tkww-union-color-text-on-dark-default, var(--tkww-union-color-neutral-white, #FFF))","list-item":"list-item--ba824","listItem":"list-item--ba824","button":"button--59a76"};

/***/ }),

/***/ 70093:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varBackgroundDark":"var(--tkww-union-color-background-dark, var(--tkww-union-color-neutral-black, #000))","var-xl":"1192px","varXl":"1192px","min-desktop-width":"948px","minDesktopWidth":"948px","sub-nav-container":"sub-nav-container--7b881","subNavContainer":"sub-nav-container--7b881","sub-nav-item-list":"sub-nav-item-list--acf97","subNavItemList":"sub-nav-item-list--acf97"};

/***/ }),

/***/ 44805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varTextOnDarkDefault":"var(--tkww-union-color-text-on-dark-default, var(--tkww-union-color-neutral-white, #FFF))","varNeutralWhite":"var(--tkww-union-color-neutral-white, #FFF)","list-item":"list-item--07994","listItem":"list-item--07994","link":"link--46456","active":"active--1ad54"};

/***/ }),

/***/ 28448:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"disablePointerEvents":"disablePointerEvents--117b1"};

/***/ }),

/***/ 89228:
/***/ (function(module) {

"use strict";


function isMeta(e) {
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) {
    return true;
  }

  // Logic that handles checks for the middle mouse button, based
  // on [jQuery](https://github.com/jquery/jquery/blob/master/src/event.js#L466).
  var which = e.which;
  var button = e.button;
  if (!which && button !== undefined) {
    // eslint-disable-next-line no-bitwise, no-extra-parens
    return (!button & 1) && (!button & 2) && (button & 4);
  } else if (which === 2) {
    return true;
  }

  return false;
}

/*
 * Exports.
 */

module.exports = isMeta;


/***/ }),

/***/ 53847:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(710);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.EventPreventionWrapper = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(70509));
var _react = _interopRequireDefault(__webpack_require__(99084));
const EventPreventionWrapper = _ref => {
  let {
    children,
    ...props
  } = _ref;
  const preventEvents = event => {
    if (event.eventPhase === Event.BUBBLING_PHASE) {
      event.stopPropagation();
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    onClick: preventEvents
  }, props), children);
};
exports.EventPreventionWrapper = EventPreventionWrapper;

/***/ }),

/***/ 40154:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _WeakMap = __webpack_require__(48492);
var _Object$defineProperty = __webpack_require__(710);
var _Object$getOwnPropertyDescriptor = __webpack_require__(17412);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _trim = _interopRequireDefault(__webpack_require__(90537));
var _react = _interopRequireWildcard(__webpack_require__(99084));
var _tkComponentFields = __webpack_require__(35760);
var _tkComponentButtons = __webpack_require__(17218);
var _reactCssModules = __webpack_require__(33289);
var _tkComponentIcons = _interopRequireDefault(__webpack_require__(52824));
var _SearchBarModule = _interopRequireDefault(__webpack_require__(19915));
var _SubNavContext = __webpack_require__(25828);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SearchBarClearButton = _ref => {
  let {
    onClick,
    onKeyDown
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _SearchBarModule.default.clearSearchButton__wrapper,
    "data-testid": "SearchBar__clearButton",
    "aria-label": "clear search",
    role: "button",
    tabIndex: 0,
    onClick: onClick,
    onKeyDown: onKeyDown
  }, /*#__PURE__*/_react.default.createElement(_tkComponentIcons.default, {
    name: "close_circle",
    role: "img",
    size: "sm"
  }));
};
const SearchBarSearchButton = _ref2 => {
  let {
    onClickHandlerSearchButton,
    doesSearchFieldHasValue
  } = _ref2;
  const {
    tenant
  } = (0, _react.useContext)(_SubNavContext.SubNavContext);
  const searchButtonClassOverrides = (0, _reactCssModules.compose)({
    'animated-element': tenant === 'tk' ? '' : _SearchBarModule.default.searchBarButton__animated__ww
  });
  const searchButtonStyles = [_SearchBarModule.default.searchBarButton];
  return /*#__PURE__*/_react.default.createElement(_tkComponentButtons.Button, {
    "aria-label": "Search",
    size: 'md',
    "data-testid": "SearchBar__searchButton",
    className: searchButtonStyles.join(' '),
    onClick: onClickHandlerSearchButton,
    disabled: !doesSearchFieldHasValue,
    classes: searchButtonClassOverrides
  }, /*#__PURE__*/_react.default.createElement(_tkComponentIcons.default, {
    name: "search",
    size: "md"
  }));
};
const buildSearchFieldClassOverrides = () => {
  const searchBarInputContainerStyles = [_SearchBarModule.default.searchBar__inputContainer];
  return (0, _reactCssModules.compose)({
    container: searchBarInputContainerStyles.join(' '),
    label: _SearchBarModule.default.searchField__label
  });
};
const SearchBar = _ref3 => {
  let {
    onSearch,
    placeholder,
    initialSearchTerm = '',
    handleClick,
    shouldFocusSearchBar = false
  } = _ref3;
  const {
    trackProductsSearched,
    trackSearchInitialized
  } = (0, _react.useContext)(_SubNavContext.SubNavContext);
  const [searchTerm, setSearchTerm] = (0, _react.useState)(initialSearchTerm);
  const [hasSearchInitialized, setHasSearchInitialized] = (0, _react.useState)(false);
  const doesSearchFieldHasValue = () => !!(0, _trim.default)(searchTerm).call(searchTerm).length;
  const onClickHandlerClearSearchInput = () => {
    setSearchTerm('');
  };
  const onKeyDownHandlerClearSearchInput = event => {
    if (event.key === 'Enter') {
      setSearchTerm('');
    }
  };
  const onChangeHandlerSearchInput = event => {
    const target = event.target;
    const searchInputValue = target.value;
    setSearchTerm(searchInputValue);
    if (searchInputValue.length > 1 && !hasSearchInitialized) {
      trackSearchInitialized === null || trackSearchInitialized === void 0 || trackSearchInitialized();
      setHasSearchInitialized(true);
    }
  };
  const onKeyDownHandlerSearchInput = event => {
    if (event.key === 'Enter') {
      trackProductsSearched === null || trackProductsSearched === void 0 || trackProductsSearched(searchTerm);
      onSearch(searchTerm);
    }
  };
  const onClickHandlerSearchButton = () => {
    trackProductsSearched === null || trackProductsSearched === void 0 || trackProductsSearched(searchTerm);
    onSearch(searchTerm);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    role: "searchbox",
    className: _SearchBarModule.default.searchBar,
    "aria-label": "main search box",
    "data-testid": "SearchBar"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SearchBarModule.default.searchBar__container
  }, /*#__PURE__*/_react.default.createElement(_tkComponentFields.Field, {
    classes: buildSearchFieldClassOverrides(),
    name: "",
    type: "search",
    onChange: onChangeHandlerSearchInput,
    onKeyDown: onKeyDownHandlerSearchInput,
    value: searchTerm,
    onClick: handleClick,
    id: "products-search-input",
    "data-testid": "SearchBar__input",
    autoComplete: "off",
    placeholder: placeholder,
    autoFocus: shouldFocusSearchBar
  }), doesSearchFieldHasValue() && /*#__PURE__*/_react.default.createElement(SearchBarClearButton, {
    onClick: onClickHandlerClearSearchInput,
    onKeyDown: onKeyDownHandlerClearSearchInput
  })), /*#__PURE__*/_react.default.createElement(SearchBarSearchButton, {
    onClickHandlerSearchButton: onClickHandlerSearchButton,
    doesSearchFieldHasValue: doesSearchFieldHasValue()
  }));
};
var _default = exports["default"] = SearchBar;

/***/ }),

/***/ 42162:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _WeakMap = __webpack_require__(48492);
var _Object$defineProperty = __webpack_require__(710);
var _Object$getOwnPropertyDescriptor = __webpack_require__(17412);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__(99084));
var _tkComponentIcons = __webpack_require__(52824);
var _SearchBar = _interopRequireDefault(__webpack_require__(40154));
var _SearchButtonModule = _interopRequireDefault(__webpack_require__(60858));
var _SubNavContext = __webpack_require__(25828);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SearchButton = _ref => {
  let {
    isSearchBarRendered,
    setIsSearchBarRendered,
    onSearch,
    searchBarPlaceholder
  } = _ref;
  const {
    trackMenuInteraction
  } = (0, _react.useContext)(_SubNavContext.SubNavContext);
  const [shouldFocusSearchBar, setShouldFocusSearchBar] = (0, _react.useState)(false);
  const shouldRenderCloseIcon = isSearchBarRendered;
  const handleClick = () => {
    trackMenuInteraction === null || trackMenuInteraction === void 0 || trackMenuInteraction('search clicked');
    setIsSearchBarRendered(true);
    setShouldFocusSearchBar(true);
  };
  const handleClose = () => {
    setIsSearchBarRendered(false);
    setShouldFocusSearchBar(false);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isSearchBarRendered && /*#__PURE__*/_react.default.createElement(_SearchBar.default, {
    onSearch: onSearch,
    placeholder: searchBarPlaceholder,
    shouldFocusSearchBar: shouldFocusSearchBar
  }), !isSearchBarRendered && /*#__PURE__*/_react.default.createElement(_SearchBar.default, {
    onSearch: onSearch,
    placeholder: searchBarPlaceholder,
    handleClick: handleClick,
    shouldFocusSearchBar: shouldFocusSearchBar
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _SearchButtonModule.default.subNavIconButton__container,
    "data-testid": "SearchButton"
  }, shouldRenderCloseIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: _SearchButtonModule.default.subNavIconButton__closeIcon,
    onClick: () => handleClose(),
    "data-testid": "SearchButton__closeIcon"
  }, /*#__PURE__*/_react.default.createElement(_tkComponentIcons.IconButton, {
    name: 'close',
    size: 'md',
    "aria-label": "Close Search"
  }))));
};
var _default = exports["default"] = SearchButton;

/***/ }),

/***/ 82790:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _WeakMap = __webpack_require__(48492);
var _Object$defineProperty = __webpack_require__(710);
var _Object$getOwnPropertyDescriptor = __webpack_require__(17412);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getSubNavLinks = exports["default"] = void 0;
var _map = _interopRequireDefault(__webpack_require__(93726));
__webpack_require__(31430);
var _react = _interopRequireWildcard(__webpack_require__(99084));
var _tkUiSubNav = __webpack_require__(11945);
var _SubNavModule = _interopRequireDefault(__webpack_require__(69419));
var _SubNavElementLink = _interopRequireDefault(__webpack_require__(42169));
var _SubNavIconLink = _interopRequireDefault(__webpack_require__(17271));
var _SearchButton = _interopRequireDefault(__webpack_require__(42162));
var _SubNavButton = _interopRequireDefault(__webpack_require__(82714));
var _GlobalVariables = _interopRequireDefault(__webpack_require__(91298));
var _tkUiBreakpoints = __webpack_require__(91354);
var _SubNavContext = __webpack_require__(25828);
var _EventPreventionWrapper = __webpack_require__(53847);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getSubNavLinks = (links, additionalLink) => {
  return [...links, additionalLink];
};
exports.getSubNavLinks = getSubNavLinks;
const SubNav = _ref => {
  var _useMedia;
  let {
    tenant,
    links,
    subNavButtons,
    rightSideLinks,
    onSearch,
    searchBarPlaceholder,
    MenuItemComponent,
    trackMenuInteraction,
    trackProductsSearched,
    trackSearchInitialized,
    withExperiment,
    additionalLink
  } = _ref;
  const [isSearchBarRendered, setIsSearchBarRendered] = (0, _react.useState)(false);
  const isDesktop = (_useMedia = (0, _tkUiBreakpoints.useMedia)('(min-width: 950px)')) === null || _useMedia === void 0 ? void 0 : _useMedia.yes;
  (0, _react.useEffect)(() => {
    setIsSearchBarRendered(!isDesktop);
  }, [isDesktop]);
  const iconButtonSectionStyles = [_SubNavModule.default.subNav__iconButtonSection];
  const subNavLinks = additionalLink ? getSubNavLinks(links, additionalLink) : links;
  return /*#__PURE__*/_react.default.createElement(_SubNavContext.SubNavProvider, {
    tenant: tenant,
    MenuItemComponent: MenuItemComponent,
    trackMenuInteraction: trackMenuInteraction,
    trackProductsSearched: trackProductsSearched,
    trackSearchInitialized: trackSearchInitialized,
    withExperiment: withExperiment,
    additionalLink: additionalLink
  }, /*#__PURE__*/_react.default.createElement(_GlobalVariables.default, null, /*#__PURE__*/_react.default.createElement(_tkUiSubNav.SubNavContainer, {
    analyticsProps: {
      product: 'paper'
    },
    links: /*#__PURE__*/_react.default.createElement("div", {
      className: _SubNavModule.default.subNav__linkSection,
      "data-testid": "SubNav__links"
    }, !isSearchBarRendered && /*#__PURE__*/_react.default.createElement(_EventPreventionWrapper.EventPreventionWrapper, {
      className: _SubNavModule.default.subNav__linksContainer,
      "data-testid": "SubNav__linksContainer"
    }, subNavLinks === null || subNavLinks === void 0 ? void 0 : (0, _map.default)(subNavLinks).call(subNavLinks, data => /*#__PURE__*/_react.default.createElement(_SubNavElementLink.default, {
      key: data.text,
      text: data.text,
      href: data.href,
      target: data.target,
      links: data.links
    })), subNavButtons === null || subNavButtons === void 0 ? void 0 : (0, _map.default)(subNavButtons).call(subNavButtons, data => /*#__PURE__*/_react.default.createElement(_SubNavButton.default, {
      key: data.title,
      onClick: data.onClick,
      title: data.title
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: iconButtonSectionStyles.join(' '),
      "data-testid": "SubNav__iconButtonSection"
    }, /*#__PURE__*/_react.default.createElement(_SearchButton.default, {
      isSearchBarRendered: isSearchBarRendered,
      setIsSearchBarRendered: setIsSearchBarRendered,
      onSearch: onSearch,
      searchBarPlaceholder: searchBarPlaceholder
    }), rightSideLinks === null || rightSideLinks === void 0 ? void 0 : (0, _map.default)(rightSideLinks).call(rightSideLinks, data => /*#__PURE__*/_react.default.createElement(_SubNavIconLink.default, {
      key: data.href,
      iconName: data.iconName,
      text: data.text,
      size: "md",
      ariaLabel: data.ariaLabel,
      href: data.href,
      hasBadge: data.hasBadge,
      badgeValue: data.badgeValue
    }))))
  })));
};
var _default = exports["default"] = SubNav;

/***/ }),

/***/ 82714:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _WeakMap = __webpack_require__(48492);
var _Object$defineProperty = __webpack_require__(710);
var _Object$getOwnPropertyDescriptor = __webpack_require__(17412);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__(99084));
var _tkUiSubNav = __webpack_require__(11945);
var _SubNavButtonModule = _interopRequireDefault(__webpack_require__(99369));
var _reactCssModules = __webpack_require__(33289);
var _SubNavContext = __webpack_require__(25828);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SubNavButton = _ref => {
  let {
    title,
    onClick
  } = _ref;
  const {
    tenant
  } = (0, _react.useContext)(_SubNavContext.SubNavContext);
  const styleClasses = [_SubNavButtonModule.default.subNavButton];
  if (tenant === 'ww') {
    styleClasses.push(_SubNavButtonModule.default.subNavButton__ww);
  }
  const classOverrides = (0, _reactCssModules.compose)({
    button: styleClasses.join(' ')
  });
  return /*#__PURE__*/_react.default.createElement(_tkUiSubNav.SubNavButton, {
    onClick: onClick,
    classes: classOverrides
  }, title);
};
var _default = exports["default"] = SubNavButton;

/***/ }),

/***/ 42169:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _WeakMap = __webpack_require__(48492);
var _Object$defineProperty = __webpack_require__(710);
var _Object$getOwnPropertyDescriptor = __webpack_require__(17412);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.isTabActive = exports["default"] = void 0;
var _includes = _interopRequireDefault(__webpack_require__(28858));
var _some = _interopRequireDefault(__webpack_require__(80945));
var _react = _interopRequireWildcard(__webpack_require__(99084));
var _tkUiSubNav = __webpack_require__(11945);
var _SubNavElementLinkMenu = _interopRequireDefault(__webpack_require__(96250));
var _tkComponentIcons = _interopRequireDefault(__webpack_require__(52824));
var _SubNavElementLinkModule = _interopRequireDefault(__webpack_require__(42851));
var _reactCssModules = __webpack_require__(33289);
var _SubNavContext = __webpack_require__(25828);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const isTabActive = (href, links) => {
  const currentUrl = window.location.href;
  const doesUrlMatchTopLevelLink = (0, _includes.default)(currentUrl).call(currentUrl, href);
  const doesUrlMatchChildLink = (0, _some.default)(links).call(links, link => (0, _includes.default)(currentUrl).call(currentUrl, link.href));
  const doesUrlMatchAnyLink = doesUrlMatchTopLevelLink || doesUrlMatchChildLink;
  return doesUrlMatchAnyLink;
};
exports.isTabActive = isTabActive;
const SubNavElementLink = _ref => {
  let {
    text,
    href,
    target,
    links
  } = _ref;
  const [isHovering, setIsHovering] = (0, _react.useState)(false);
  const [isActive, setIsActive] = (0, _react.useState)(false);
  const openMenu = () => {
    setIsHovering(true);
  };
  const closeMenu = () => {
    setIsHovering(false);
  };
  const onKeyDownHandlerAccessibilityButton = event => {
    if (event.key === 'Escape') {
      closeMenu();
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      openMenu();
    }
  };
  const onBlurHandlerMenu = e => {
    const currentTarget = e.currentTarget;
    const relatedTarget = e.relatedTarget;
    if (relatedTarget && !currentTarget.contains(relatedTarget)) {
      closeMenu();
      const previousSibling = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.previousElementSibling;
      previousSibling === null || previousSibling === void 0 || previousSibling.focus();
    }
  };
  (0, _react.useEffect)(() => {
    setIsActive(isTabActive(href, links));
  }, []);
  const {
    trackMenuInteraction
  } = (0, _react.useContext)(_SubNavContext.SubNavContext);
  const classOverrides = (0, _reactCssModules.compose)({
    link: _SubNavElementLinkModule.default.subNavElementLink__link
  });
  return /*#__PURE__*/_react.default.createElement(_tkUiSubNav.SubNavLink, {
    href: href,
    onClick: () => trackMenuInteraction === null || trackMenuInteraction === void 0 ? void 0 : trackMenuInteraction(text),
    target: target,
    active: isActive || isHovering,
    onMouseEnter: openMenu,
    onMouseLeave: closeMenu,
    onBlur: onBlurHandlerMenu,
    classes: classOverrides,
    "data-testid": "SubNavElementLink"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SubNavElementLinkModule.default.subNavElementLinkMenu__wrapper
  }, /*#__PURE__*/_react.default.createElement("div", null, text), /*#__PURE__*/_react.default.createElement("div", {
    className: _SubNavElementLinkModule.default.subNavElementLink__menuExpander
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: openMenu,
    onKeyDown: onKeyDownHandlerAccessibilityButton,
    "aria-expanded": isHovering,
    "aria-controls": text,
    "data-testid": "SubNavElementLink__accessibilityControl"
  }, /*#__PURE__*/_react.default.createElement(_tkComponentIcons.default, {
    name: "arrow_down",
    size: "sm",
    "aria-hidden": "true"
  }))), isHovering && /*#__PURE__*/_react.default.createElement(_SubNavElementLinkMenu.default, {
    onBlur: onBlurHandlerMenu,
    links: links
  })));
};
var _default = exports["default"] = SubNavElementLink;

/***/ }),

/***/ 96250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _WeakMap = __webpack_require__(48492);
var _Object$defineProperty = __webpack_require__(710);
var _Object$getOwnPropertyDescriptor = __webpack_require__(17412);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _map = _interopRequireDefault(__webpack_require__(93726));
var _react = _interopRequireWildcard(__webpack_require__(99084));
var _SubNavElementLinkMenuModule = _interopRequireDefault(__webpack_require__(22200));
var _SubNavContext = __webpack_require__(25828);
var _EventPreventionWrapper = __webpack_require__(53847);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SubNavElementLinkMenu = _ref => {
  let {
    onBlur,
    links
  } = _ref;
  const {
    MenuItemComponent,
    tenant,
    trackMenuInteraction
  } = (0, _react.useContext)(_SubNavContext.SubNavContext);
  const linkStyleClasses = [_SubNavElementLinkMenuModule.default.subNavElementLinkMenu__item__link];
  if (tenant === 'ww') {
    linkStyleClasses.push(_SubNavElementLinkMenuModule.default.subNavElementLinkMenu__item__link__ww);
  }
  const onClickHandler = selection => {
    trackMenuInteraction === null || trackMenuInteraction === void 0 || trackMenuInteraction(selection);
  };
  return /*#__PURE__*/_react.default.createElement(_EventPreventionWrapper.EventPreventionWrapper, {
    onBlur: onBlur,
    "data-testid": "SubNavElementLinkMenu"
  }, /*#__PURE__*/_react.default.createElement("nav", {
    className: _SubNavElementLinkMenuModule.default.subNavElementLinkMenu__container
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: _SubNavElementLinkMenuModule.default.subNavElementLinkMenu__content
  }, (0, _map.default)(links).call(links, link => /*#__PURE__*/_react.default.createElement("li", {
    key: link.text,
    className: _SubNavElementLinkMenuModule.default.subNavElementLinkMenu__item
  }, /*#__PURE__*/_react.default.createElement(MenuItemComponent, {
    href: link.href,
    target: link.target,
    className: linkStyleClasses.join(' '),
    "data-testid": link.text,
    onClick: () => onClickHandler(link.text)
  }, /*#__PURE__*/_react.default.createElement("span", null, link.text), !!link.badge && /*#__PURE__*/_react.default.createElement("span", {
    className: `${_SubNavElementLinkMenuModule.default.subNavElementLinkMenu__badge} ${_SubNavElementLinkMenuModule.default.subNavElementLinkMenu__badge}${link.badgeType}`
  }, link.badge)))))));
};
var _default = exports["default"] = SubNavElementLinkMenu;

/***/ }),

/***/ 17271:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(710);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(99084));
var _tkComponentIcons = __webpack_require__(52824);
var _SubNavIconLinkModule = _interopRequireDefault(__webpack_require__(41154));
const renderIcon = (iconName, size, hasBadge, badgeValue) => {
  const shouldRenderBadge = hasBadge || !!badgeValue && badgeValue > 0;
  const badgeContent = !!badgeValue && badgeValue > 0 ? badgeValue : undefined;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "SubNavIconLink__icon"
  }, shouldRenderBadge && /*#__PURE__*/_react.default.createElement("div", {
    className: _SubNavIconLinkModule.default.subNavIconLink__badge,
    "data-testid": "SubNavIconLink__icon__badge"
  }, badgeContent), /*#__PURE__*/_react.default.createElement(_tkComponentIcons.IconButton, {
    name: iconName,
    size: size,
    className: _SubNavIconLinkModule.default.subNavIconLink__icon,
    "aria-label": iconName
  }));
};
const SubNavIconLink = _ref => {
  let {
    iconName,
    text,
    size,
    href,
    ariaLabel,
    hasBadge,
    badgeValue
  } = _ref;
  const shouldRenderText = !!text;
  const classes = _SubNavIconLinkModule.default.subNavIconLink__text__experiment;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: _SubNavIconLinkModule.default.subNavIconLink__container,
    href: href,
    "aria-label": ariaLabel,
    "data-testid": "SubNavIconLink"
  }, !shouldRenderText && renderIcon(iconName, size, hasBadge, badgeValue), shouldRenderText && /*#__PURE__*/_react.default.createElement("span", {
    className: classes,
    "data-testid": "SubNavIconLink__text"
  }, text));
};
var _default = exports["default"] = SubNavIconLink;

/***/ }),

/***/ 25828:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _WeakMap = __webpack_require__(48492);
var _Object$defineProperty = __webpack_require__(710);
var _Object$getOwnPropertyDescriptor = __webpack_require__(17412);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SubNavProvider = exports.SubNavContext = void 0;
var _react = _interopRequireWildcard(__webpack_require__(99084));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SubNavContext = exports.SubNavContext = /*#__PURE__*/(0, _react.createContext)({
  tenant: 'tk',
  MenuItemComponent: 'a'
});
const SubNavProvider = _ref => {
  let {
    children,
    tenant,
    trackMenuInteraction,
    trackProductsSearched,
    trackSearchInitialized,
    MenuItemComponent = 'a',
    withExperiment,
    additionalLink
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(SubNavContext.Provider, {
    value: {
      tenant,
      MenuItemComponent,
      trackMenuInteraction,
      trackProductsSearched,
      trackSearchInitialized,
      withExperiment,
      additionalLink
    }
  }, children);
};
exports.SubNavProvider = SubNavProvider;

/***/ }),

/***/ 64338:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(710);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "PaperSubNav", {
  enumerable: true,
  get: function () {
    return _PaperSubNav.default;
  }
});
_Object$defineProperty(exports, "SubNav", {
  enumerable: true,
  get: function () {
    return _SubNav.default;
  }
});
var _SubNav = _interopRequireDefault(__webpack_require__(82790));
var _PaperSubNav = _interopRequireDefault(__webpack_require__(62792));

/***/ }),

/***/ 91298:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _WeakMap = __webpack_require__(48492);
var _Object$defineProperty = __webpack_require__(710);
var _Object$getOwnPropertyDescriptor = __webpack_require__(17412);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__(99084));
var _ww = _interopRequireDefault(__webpack_require__(59251));
var _tk = _interopRequireDefault(__webpack_require__(93668));
var _SubNavContext = __webpack_require__(25828);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const GlobalVariables = _ref => {
  let {
    children
  } = _ref;
  const {
    tenant
  } = (0, _react.useContext)(_SubNavContext.SubNavContext);
  let className;
  if (tenant === 'tk') {
    className = _tk.default.subNav;
  } else if (tenant === 'ww') {
    className = _ww.default.subNav;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, children);
};
var _default = exports["default"] = GlobalVariables;

/***/ }),

/***/ 17598:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(710);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.filterLinksByFeatureFlag = void 0;
exports.transformTree = transformTree;
var _map = _interopRequireDefault(__webpack_require__(93726));
var _filter = _interopRequireDefault(__webpack_require__(99646));
var _keys = _interopRequireDefault(__webpack_require__(9938));
var _forEach = _interopRequireDefault(__webpack_require__(28301));
const filterLinksByFeatureFlag = (links, featureFlags) => {
  return (0, _map.default)(links).call(links, link => {
    if (link.links) {
      var _context;
      link.links = (0, _filter.default)(_context = link.links).call(_context, element => {
        const featureFlagKey = (0, _keys.default)(element.featureFlag || {})[0];
        if (!element.featureFlag) {
          return true;
        }
        return featureFlags[featureFlagKey] && element.featureFlag[featureFlagKey];
      });
    }
    return link;
  });
};
exports.filterLinksByFeatureFlag = filterLinksByFeatureFlag;
function transformTree(menuTreeData) {
  var _context2;
  const links = [];
  (0, _forEach.default)(_context2 = menuTreeData.treeStructure).call(_context2, treeItem => {
    const link = {
      text: treeItem.menuItem.text,
      href: treeItem.menuItem.url,
      links: []
    };
    if (treeItem.children) {
      var _context3;
      link.links = (0, _map.default)(_context3 = treeItem.children).call(_context3, child => {
        return {
          text: child.menuItem.text,
          href: child.menuItem.url,
          badge: child.menuItem.badge ? child.menuItem.badge.text : undefined,
          badgeType: child.menuItem.badge ? child.menuItem.badge.color : undefined
        };
      });
    }
    links.push(link);
  });
  return links;
}

/***/ }),

/***/ 62792:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(710);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(99084));
var _SubNav = _interopRequireDefault(__webpack_require__(82790));
var _PaperSubNavData = __webpack_require__(95192);
var _linksHelper = __webpack_require__(17598);
const PaperSubNav = _ref => {
  let {
    tenant,
    onSearch,
    cartCount,
    draftCount,
    isUserLoggedIn,
    MenuItemComponent,
    trackMenuInteraction,
    trackProductsSearched,
    trackSearchInitialized,
    withExperiment,
    additionalLink,
    searchBarPlaceholder,
    flags = {},
    menuTreeData
  } = _ref;
  let links;
  if (tenant === 'tk') {
    links = (0, _linksHelper.transformTree)(menuTreeData);
  } else {
    links = (0, _linksHelper.filterLinksByFeatureFlag)(_PaperSubNavData.wwLinks, flags);
  }
  const subNavButtons = tenant === 'tk' ? _PaperSubNavData.tkSubNavButtons : _PaperSubNavData.wwSubNavButtons;
  const iconLinks = tenant === 'tk' ? (0, _PaperSubNavData.buildTKIconLinks)(isUserLoggedIn, cartCount, draftCount) : (0, _PaperSubNavData.buildWWIconLinks)(isUserLoggedIn, cartCount);
  return /*#__PURE__*/_react.default.createElement(_SubNav.default, {
    tenant: tenant,
    onSearch: onSearch,
    links: links,
    subNavButtons: subNavButtons,
    rightSideLinks: iconLinks,
    searchBarPlaceholder: searchBarPlaceholder || 'Search rustic, modern, floral and more!',
    MenuItemComponent: MenuItemComponent,
    trackMenuInteraction: trackMenuInteraction,
    trackProductsSearched: trackProductsSearched,
    trackSearchInitialized: trackSearchInitialized,
    withExperiment: withExperiment,
    additionalLink: additionalLink
  });
};
var _default = exports["default"] = PaperSubNav;

/***/ }),

/***/ 95192:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(710);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.wwSubNavButtons = exports.wwLinks = exports.tkSubNavButtons = exports.buildWWIconLinks = exports.buildTKIconLinks = void 0;
var _concat = _interopRequireDefault(__webpack_require__(33028));
const tkSubNavButtons = exports.tkSubNavButtons = [{
  title: 'Free Samples',
  onClick: () => window.location.assign(`/paper/free-samples`)
}];
const wwSubNavButtons = exports.wwSubNavButtons = [{
  title: 'Free Samples',
  onClick: () => window.location.assign(`/wedding-paper/page/free-wedding-invitation-samples`)
}];
const buildTKIconLinks = (isUserLoggedIn, cartCount, draftCount) => {
  const links = [];
  if (isUserLoggedIn) {
    links.push({
      iconName: 'truck',
      text: 'Your Orders',
      href: '/paper/your-orders',
      ariaLabel: 'Your Orders'
    });
  }
  return (0, _concat.default)(links).call(links, [{
    iconName: 'bookmark',
    href: '/paper/your-drafts',
    ariaLabel: 'Your Drafts',
    badgeValue: draftCount
  }, {
    iconName: 'cart',
    href: '/paper/cart',
    ariaLabel: 'Your Cart',
    badgeValue: cartCount
  }]);
};
exports.buildTKIconLinks = buildTKIconLinks;
const buildWWIconLinks = (isUserLoggedIn, cartCount) => {
  const links = [];
  if (isUserLoggedIn) {
    links.push({
      iconName: 'truck',
      text: 'Your Orders',
      href: '/wedding-paper/your-orders',
      ariaLabel: 'Your Orders'
    });
  }
  return (0, _concat.default)(links).call(links, [{
    iconName: 'cart',
    href: '/wedding-paper/cart',
    ariaLabel: 'Your Cart',
    badgeValue: cartCount
  }]);
};
exports.buildWWIconLinks = buildWWIconLinks;
const wwLinks = exports.wwLinks = [{
  text: 'Save the Dates',
  href: '/wedding-paper/save-the-dates',
  links: [{
    text: 'Save the Date Cards',
    href: '/wedding-paper/save-the-date-cards'
  }, {
    text: 'Save the Date Postcards',
    href: '/wedding-paper/save-the-date-postcards'
  }]
}, {
  text: 'Invitations',
  href: '/wedding-paper/invitations',
  links: [{
    text: 'Wedding Invitations',
    href: '/wedding-paper/wedding-invitations'
  }, {
    text: 'Enclosure Cards',
    href: '/wedding-paper/wedding-enclosure-cards'
  }, {
    text: 'RSVP Cards',
    href: '/wedding-paper/wedding-rsvp-cards'
  }, {
    text: 'Envelope Liners',
    href: '/wedding-paper/wedding-envelope-liners'
  }, {
    text: 'Bridal Shower',
    href: '/wedding-paper/bridal-shower-invitations'
  }, {
    text: 'Rehearsal Dinner',
    href: '/wedding-paper/rehearsal-dinner-invitations'
  }]
}, {
  text: 'Ceremony & Reception',
  href: '/wedding-paper/ceremony-reception',
  links: [{
    text: 'Programs',
    href: '/wedding-paper/wedding-programs'
  }, {
    text: 'Place Cards',
    href: '/wedding-paper/wedding-place-cards'
  }, {
    text: 'Guest Books',
    href: '/wedding-paper/wedding-guest-books'
  }, {
    text: 'Menus',
    href: '/wedding-paper/wedding-menus'
  }, {
    text: 'Stickers',
    href: '/wedding-paper/wedding-stickers'
  }, {
    text: 'Table Numbers',
    href: '/wedding-paper/wedding-table-numbers'
  }, {
    text: 'Gift Tags',
    href: '/wedding-paper/wedding-gift-tags'
  }]
}, {
  text: 'Thank Yous',
  href: '/wedding-paper/thank-yous',
  links: [{
    text: 'Thank You Cards',
    href: '/wedding-paper/thank-you-cards'
  }, {
    text: 'Thank You Postcards',
    href: '/wedding-paper/thank-you-postcards'
  }]
}];

/***/ }),

/***/ 35760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AsyncTypeahead": function() { return /* reexport */ components_AsyncTypeahead; },
  "DatePickerField": function() { return /* reexport */ components_DatePickerField; },
  "Field": function() { return /* reexport */ components_Field; },
  "Form": function() { return /* reexport */ Form/* default */.Z; },
  "List": function() { return /* reexport */ components_List; },
  "ListItem": function() { return /* reexport */ ListItem; },
  "Option": function() { return /* reexport */ lib_components_Option; },
  "Select": function() { return /* reexport */ components_Select; },
  "Textarea": function() { return /* reexport */ components_Textarea; }
});

// EXTERNAL MODULE: ./node_modules/@xo-union/ui-form-validations/lib/Form/index.js + 2 modules
var Form = __webpack_require__(63938);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/extends.js
var esm_extends = __webpack_require__(70509);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/filter.js
var filter = __webpack_require__(99646);
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/@xo-union/react-css-modules/lib/index.js
var lib = __webpack_require__(33289);
// EXTERNAL MODULE: ./node_modules/@xo-union/react-unique-id/lib/index.js
var react_unique_id_lib = __webpack_require__(79946);
// EXTERNAL MODULE: ./node_modules/lodash/upperFirst.js
var upperFirst = __webpack_require__(35102);
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);
// EXTERNAL MODULE: ./node_modules/lodash/lowerCase.js
var lowerCase = __webpack_require__(8788);
var lowerCase_default = /*#__PURE__*/__webpack_require__.n(lowerCase);
// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var noop = __webpack_require__(21818);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/Input/index.js




const determineHasValue = val => val != null && val.toString().length > 0;
const Input = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    defaultValue,
    value,
    onChange = (noop_default()),
    ...props
  } = _ref;
  const isValueControlledRef = react.useRef(value !== undefined);
  let hasValue;
  let handleChange;
  if (isValueControlledRef.current) {
    hasValue = determineHasValue(value);
    handleChange = onChange;
  } else {
    /* eslint-disable react-hooks/rules-of-hooks */
    const [hasValueState, setHasValue] = react.useState(determineHasValue(defaultValue));
    handleChange = evt => {
      const {
        value: newValue
      } = evt.currentTarget;
      setHasValue(determineHasValue(newValue));
      onChange(evt);
    };
    hasValue = hasValueState;
  }
  return /*#__PURE__*/react.createElement("input", (0,esm_extends["default"])({
    ref: ref,
    onChange: handleChange,
    value: value,
    defaultValue: defaultValue,
    "data-has-value": hasValue ? '' : undefined
  }, props));
});
 false ? 0 : void 0;
/* harmony default export */ var components_Input = (Input);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/Field/styles.css
var styles = __webpack_require__(93187);
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/WithValidations.js



const wrapComponent = Component => {
  const WithValidation = /*#__PURE__*/react.forwardRef((props, ref) => {
    const {
      name,
      defaultValue,
      value,
      validations,
      onBlur,
      onChange,
      subText,
      subTextOnValid,
      subTextOnInvalid,
      state,
      ...restOfProps
    } = props;
    return /*#__PURE__*/react.createElement(Form/* Input */.I, {
      ref: ref,
      name: name,
      value: value,
      defaultValue: defaultValue,
      onBlur: onBlur,
      onChange: onChange,
      subText: subText,
      subTextOnValid: subTextOnValid,
      subTextOnInvalid: subTextOnInvalid,
      state: state,
      validations: validations
    }, (validationProps, data) => {
      const finalProps = {
        ...restOfProps,
        ...validationProps,
        state: data.state,
        subText: data.subText
      };
      return /*#__PURE__*/react.createElement(Component, finalProps);
    });
  });
  WithValidation.displayName = `WithValidation(${Component.displayName || Component.name || 'Component'})`;
   false ? 0 : void 0;
  return WithValidation;
};
/* harmony default export */ var WithValidations = (wrapComponent);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-typography/lib/components/Caption/index.js
var Caption = __webpack_require__(27308);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/SubText.js



const SubText = _ref => {
  let {
    className,
    id,
    state,
    children
  } = _ref;
  return /*#__PURE__*/react.createElement(Caption/* default */.Z, {
    id: id,
    className: className,
    "aria-live": state === 'invalid' ? 'polite' : undefined
  }, children);
};
 false ? 0 : void 0;
/* harmony default export */ var components_SubText = (SubText);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/Field/index.js













const Field = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _context;
  const {
    name,
    subText,
    type,
    state,
    label = upperFirst_default()(lowerCase_default()(name)),
    id: idProp,
    'aria-describedby': ariaDescribedByIds,
    classes: classesProp,
    ...restOfProps
  } = props;
  const id = (0,react_unique_id_lib/* useUniqueID */.h)(idProp);
  const classes = (0,lib.useClasses)((styles_default()), classesProp);
  const validationClassMap = {
    neutral: classes['is-neutral'],
    invalid: classes['is-invalid'],
    valid: classes['is-valid']
  };
  const validationClass = validationClassMap[state];
  let subtextId;
  if (subText) {
    subtextId = `${id}-subtext`;
  }
  const ariaDescribedBy = filter_default()(_context = [ariaDescribedByIds, subtextId]).call(_context, Boolean).join(' ') || null;
  return /*#__PURE__*/react.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/react.createElement(components_Input, (0,esm_extends["default"])({
    ref: ref,
    type: type,
    className: `${classes.input} ${validationClass}`,
    id: id,
    name: name,
    placeholder: " ",
    "aria-describedby": ariaDescribedBy
  }, restOfProps)), /*#__PURE__*/react.createElement("label", {
    className: classes.label,
    htmlFor: id
  }, label), subText && /*#__PURE__*/react.createElement(components_SubText, {
    state: state,
    className: classes['sub-text'],
    id: subtextId
  }, subText));
});
Field.defaultProps = {
  state: 'neutral',
  type: 'text'
};
const validationProp =  false ? 0 : {};
 false ? 0 : void 0;
/* harmony default export */ var components_Field = (WithValidations(Field));
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 18 modules
var esm_format = __webpack_require__(27155);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-icons/lib/components/IconButton/index.js
var IconButton = __webpack_require__(51197);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-subnav/node_modules/classnames/index.js
var classnames = __webpack_require__(68068);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-icons/lib/components/Icon/index.js
var Icon = __webpack_require__(21647);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(73299);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(4989);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfMonth/index.js


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfMonth/index.js


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfDay/index.js


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isSameYear/index.js


/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(34459);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDaysInMonth/index.js


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setMonth/index.js




/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(dirtyDate, dirtyMonth) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var month = (0,toInteger/* default */.Z)(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setYear/index.js



/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(dirtyDate, dirtyYear) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = (0,toInteger/* default */.Z)(dirtyYear);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  date.setFullYear(year);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfYear/index.js


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var cleanDate = (0,toDate/* default */.Z)(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarMonths/index.js


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addMonths/index.js



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  var dayOfMonth = date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isSameMonth/index.js


/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isBefore/index.js


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(dirtyDate, dirtyDateToCompare) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var dateToCompare = (0,toDate/* default */.Z)(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(70914);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfWeek/index.js




/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfISOWeek/index.js


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addDays/index.js



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isSameDay/index.js


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isAfter/index.js


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var dateToCompare = (0,toDate/* default */.Z)(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subDays/index.js



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addDays(dirtyDate, -amount);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(27762);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarDays/index.js



var MILLISECONDS_IN_DAY = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays_differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isDate/index.js
var isDate = __webpack_require__(542);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addWeeks/index.js



/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addYears/index.js



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfWeek/index.js




/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfISOWeek/index.js


/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return endOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(51411);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/max/index.js



/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */
function max(dirtyDatesArray) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var datesArray;
  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;

    // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if ((0,esm_typeof/* default */.Z)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }
  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0,toDate/* default */.Z)(dirtyDate);
    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/min/index.js



/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} - the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */
function min(dirtyDatesArray) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var datesArray;
  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;
    // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if ((0,esm_typeof/* default */.Z)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }
  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0,toDate/* default */.Z)(dirtyDate);
    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getTime/index.js


/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getUnixTime/index.js


/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */
function getUnixTime(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(getTime(dirtyDate) / 1000);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getISOWeekYear/index.js



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfISOWeekYear/index.js



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getWeekYear/index.js





/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the local week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfWeekYear/index.js





/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the start of a week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  var date = startOfWeek(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getWeek/index.js




var getWeek_MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfWeek(date, options).getTime() - startOfWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / getWeek_MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarWeeks/index.js



var differenceInCalendarWeeks_MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */
function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, options);
  var startOfWeekRight = startOfWeek(dirtyDateRight, options);
  var timestampLeft = startOfWeekLeft.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfWeekRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / differenceInCalendarWeeks_MILLISECONDS_IN_WEEK);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/lastDayOfMonth/index.js


/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getWeeksInMonth/index.js




/**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */
function getWeeksInMonth(date, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return differenceInCalendarWeeks(lastDayOfMonth(date), startOfMonth(date), options) + 1;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js + 9 modules
var en_US = __webpack_require__(39866);
;// CONCATENATED MODULE: ./node_modules/react-day-picker/dist/index.esm.js




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min () {
	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
	hasRequiredReactJsxRuntime_production_min = 1;
var f=react,k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
	function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}reactJsxRuntime_production_min.Fragment=l;reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;
	return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;

	if (false) {}
	return reactJsxRuntime_development;
}

if (true) {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {}

var jsxRuntimeExports = jsxRuntime.exports;

/** Returns true when the props are of type {@link DayPickerMultipleProps}. */
function isDayPickerMultiple(props) {
    return props.mode === 'multiple';
}

/** Returns true when the props are of type {@link DayPickerRangeProps}. */
function isDayPickerRange(props) {
    return props.mode === 'range';
}

/** Returns true when the props are of type {@link DayPickerSingleProps}. */
function isDayPickerSingle(props) {
    return props.mode === 'single';
}

/**
 * The name of the default CSS classes.
 */
var defaultClassNames = {
    root: 'rdp',
    multiple_months: 'rdp-multiple_months',
    with_weeknumber: 'rdp-with_weeknumber',
    vhidden: 'rdp-vhidden',
    button_reset: 'rdp-button_reset',
    button: 'rdp-button',
    caption: 'rdp-caption',
    caption_start: 'rdp-caption_start',
    caption_end: 'rdp-caption_end',
    caption_between: 'rdp-caption_between',
    caption_label: 'rdp-caption_label',
    caption_dropdowns: 'rdp-caption_dropdowns',
    dropdown: 'rdp-dropdown',
    dropdown_month: 'rdp-dropdown_month',
    dropdown_year: 'rdp-dropdown_year',
    dropdown_icon: 'rdp-dropdown_icon',
    months: 'rdp-months',
    month: 'rdp-month',
    table: 'rdp-table',
    tbody: 'rdp-tbody',
    tfoot: 'rdp-tfoot',
    head: 'rdp-head',
    head_row: 'rdp-head_row',
    head_cell: 'rdp-head_cell',
    nav: 'rdp-nav',
    nav_button: 'rdp-nav_button',
    nav_button_previous: 'rdp-nav_button_previous',
    nav_button_next: 'rdp-nav_button_next',
    nav_icon: 'rdp-nav_icon',
    row: 'rdp-row',
    weeknumber: 'rdp-weeknumber',
    cell: 'rdp-cell',
    day: 'rdp-day',
    day_today: 'rdp-day_today',
    day_outside: 'rdp-day_outside',
    day_selected: 'rdp-day_selected',
    day_disabled: 'rdp-day_disabled',
    day_hidden: 'rdp-day_hidden',
    day_range_start: 'rdp-day_range_start',
    day_range_end: 'rdp-day_range_end',
    day_range_middle: 'rdp-day_range_middle'
};

/**
 * The default formatter for the caption.
 */
function formatCaption(month, options) {
    return (0,esm_format/* default */.Z)(month, 'LLLL y', options);
}

/**
 * The default formatter for the Day button.
 */
function formatDay(day, options) {
    return (0,esm_format/* default */.Z)(day, 'd', options);
}

/**
 * The default formatter for the Month caption.
 */
function formatMonthCaption(month, options) {
    return (0,esm_format/* default */.Z)(month, 'LLLL', options);
}

/**
 * The default formatter for the week number.
 */
function formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}

/**
 * The default formatter for the name of the weekday.
 */
function formatWeekdayName(weekday, options) {
    return (0,esm_format/* default */.Z)(weekday, 'cccccc', options);
}

/**
 * The default formatter for the Year caption.
 */
function formatYearCaption(year, options) {
    return (0,esm_format/* default */.Z)(year, 'yyyy', options);
}

var formatters = /*#__PURE__*/Object.freeze({
    __proto__: null,
    formatCaption: formatCaption,
    formatDay: formatDay,
    formatMonthCaption: formatMonthCaption,
    formatWeekNumber: formatWeekNumber,
    formatWeekdayName: formatWeekdayName,
    formatYearCaption: formatYearCaption
});

/**
 * The default ARIA label for the day button.
 */
var labelDay = function (day, activeModifiers, options) {
    return (0,esm_format/* default */.Z)(day, 'do MMMM (EEEE)', options);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelMonthDropdown = function () {
    return 'Month: ';
};

/**
 * The default ARIA label for next month button in navigation
 */
var labelNext = function () {
    return 'Go to next month';
};

/**
 * The default ARIA label for previous month button in navigation
 */
var labelPrevious = function () {
    return 'Go to previous month';
};

/**
 * The default ARIA label for the Weekday element.
 */
var labelWeekday = function (day, options) {
    return (0,esm_format/* default */.Z)(day, 'cccc', options);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelWeekNumber = function (n) {
    return "Week n. ".concat(n);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelYearDropdown = function () {
    return 'Year: ';
};

var labels = /*#__PURE__*/Object.freeze({
    __proto__: null,
    labelDay: labelDay,
    labelMonthDropdown: labelMonthDropdown,
    labelNext: labelNext,
    labelPrevious: labelPrevious,
    labelWeekNumber: labelWeekNumber,
    labelWeekday: labelWeekday,
    labelYearDropdown: labelYearDropdown
});

/**
 * Returns the default values to use in the DayPickerContext, in case they are
 * not passed down with the DayPicker initial props.
 */
function getDefaultContextValues() {
    var captionLayout = 'buttons';
    var classNames = defaultClassNames;
    var locale = en_US/* default */.Z;
    var modifiersClassNames = {};
    var modifiers = {};
    var numberOfMonths = 1;
    var styles = {};
    var today = new Date();
    return {
        captionLayout: captionLayout,
        classNames: classNames,
        formatters: formatters,
        labels: labels,
        locale: locale,
        modifiersClassNames: modifiersClassNames,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        styles: styles,
        today: today,
        mode: 'default'
    };
}

/** Return the `fromDate` and `toDate` prop values values parsing the DayPicker props. */
function parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) {
        fromDate = startOfMonth(fromMonth);
    }
    else if (fromYear) {
        fromDate = new Date(fromYear, 0, 1);
    }
    if (toMonth) {
        toDate = endOfMonth(toMonth);
    }
    else if (toYear) {
        toDate = new Date(toYear, 11, 31);
    }
    return {
        fromDate: fromDate ? startOfDay(fromDate) : undefined,
        toDate: toDate ? startOfDay(toDate) : undefined
    };
}

/**
 * The DayPicker context shares the props passed to DayPicker within internal
 * and custom components. It is used to set the default values and perform
 * one-time calculations required to render the days.
 *
 * Access to this context from the {@link useDayPicker} hook.
 */
var DayPickerContext = (0,react.createContext)(undefined);
/**
 * The provider for the {@link DayPickerContext}, assigning the defaults from the
 * initial DayPicker props.
 */
function DayPickerProvider(props) {
    var _a;
    var initialProps = props.initialProps;
    var defaultContextValues = getDefaultContextValues();
    var _b = parseFromToProps(initialProps), fromDate = _b.fromDate, toDate = _b.toDate;
    var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
    if (captionLayout !== 'buttons' && (!fromDate || !toDate)) {
        // When no from/to dates are set, the caption is always buttons
        captionLayout = 'buttons';
    }
    var onSelect;
    if (isDayPickerSingle(initialProps) ||
        isDayPickerMultiple(initialProps) ||
        isDayPickerRange(initialProps)) {
        onSelect = initialProps.onSelect;
    }
    var value = __assign(__assign(__assign({}, defaultContextValues), initialProps), { captionLayout: captionLayout, classNames: __assign(__assign({}, defaultContextValues.classNames), initialProps.classNames), components: __assign({}, initialProps.components), formatters: __assign(__assign({}, defaultContextValues.formatters), initialProps.formatters), fromDate: fromDate, labels: __assign(__assign({}, defaultContextValues.labels), initialProps.labels), mode: initialProps.mode || defaultContextValues.mode, modifiers: __assign(__assign({}, defaultContextValues.modifiers), initialProps.modifiers), modifiersClassNames: __assign(__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames), onSelect: onSelect, styles: __assign(__assign({}, defaultContextValues.styles), initialProps.styles), toDate: toDate });
    return (jsxRuntimeExports.jsx(DayPickerContext.Provider, __assign({ value: value }, { children: props.children })));
}
/**
 * Hook to access the {@link DayPickerContextValue}.
 *
 * Use the DayPicker context to access to the props passed to DayPicker inside
 * internal or custom components.
 */
function useDayPicker() {
    var context = (0,react.useContext)(DayPickerContext);
    if (!context) {
        throw new Error("useDayPicker must be used within a DayPickerProvider.");
    }
    return context;
}

/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */
function CaptionLabel(props) {
    var _a = useDayPicker(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, formatCaption = _a.formatters.formatCaption;
    return (jsxRuntimeExports.jsx("div", __assign({ className: classNames.caption_label, style: styles.caption_label, "aria-live": "polite", role: "presentation", id: props.id }, { children: formatCaption(props.displayMonth, { locale: locale }) })));
}

/**
 * Render the icon in the styled drop-down.
 */
function IconDropdown(props) {
    return (jsxRuntimeExports.jsx("svg", __assign({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, props, { children: jsxRuntimeExports.jsx("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) })));
}

/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */
function Dropdown(props) {
    var _a, _b;
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var dayPicker = useDayPicker();
    var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : IconDropdown;
    return (jsxRuntimeExports.jsxs("div", __assign({ className: className, style: style }, { children: [jsxRuntimeExports.jsx("span", __assign({ className: dayPicker.classNames.vhidden }, { children: props['aria-label'] })), jsxRuntimeExports.jsx("select", __assign({ name: props.name, "aria-label": props['aria-label'], className: dayPicker.classNames.dropdown, style: dayPicker.styles.dropdown, value: value, onChange: onChange }, { children: children })), jsxRuntimeExports.jsxs("div", __assign({ className: dayPicker.classNames.caption_label, style: dayPicker.styles.caption_label, "aria-hidden": "true" }, { children: [caption, jsxRuntimeExports.jsx(IconDropdownComponent, { className: dayPicker.classNames.dropdown_icon, style: dayPicker.styles.dropdown_icon })] }))] })));
}

/** Render the dropdown to navigate between months. */
function MonthsDropdown(props) {
    var _a;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, styles = _b.styles, locale = _b.locale, formatMonthCaption = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown = _b.labels.labelMonthDropdown;
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    if (!toDate)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    var dropdownMonths = [];
    if (isSameYear(fromDate, toDate)) {
        // only display the months included in the range
        var date = startOfMonth(fromDate);
        for (var month = fromDate.getMonth(); month <= toDate.getMonth(); month++) {
            dropdownMonths.push(setMonth(date, month));
        }
    }
    else {
        // display all the 12 months
        var date = startOfMonth(new Date()); // Any date should be OK, as we just need the year
        for (var month = 0; month <= 11; month++) {
            dropdownMonths.push(setMonth(date, month));
        }
    }
    var handleChange = function (e) {
        var selectedMonth = Number(e.target.value);
        var newMonth = setMonth(startOfMonth(props.displayMonth), selectedMonth);
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (jsxRuntimeExports.jsx(DropdownComponent, __assign({ name: "months", "aria-label": labelMonthDropdown(), className: classNames.dropdown_month, style: styles.dropdown_month, onChange: handleChange, value: props.displayMonth.getMonth(), caption: formatMonthCaption(props.displayMonth, { locale: locale }) }, { children: dropdownMonths.map(function (m) { return (jsxRuntimeExports.jsx("option", __assign({ value: m.getMonth() }, { children: formatMonthCaption(m, { locale: locale }) }), m.getMonth())); }) })));
}

/**
 * Render a dropdown to change the year. Take in account the `nav.fromDate` and
 * `toDate` from context.
 */
function YearsDropdown(props) {
    var _a;
    var displayMonth = props.displayMonth;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, locale = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, formatYearCaption = _b.formatters.formatYearCaption, labelYearDropdown = _b.labels.labelYearDropdown;
    var years = [];
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    if (!toDate)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for (var year = fromYear; year <= toYear; year++) {
        years.push(setYear(startOfYear(new Date()), year));
    }
    var handleChange = function (e) {
        var newMonth = setYear(startOfMonth(displayMonth), Number(e.target.value));
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (jsxRuntimeExports.jsx(DropdownComponent, __assign({ name: "years", "aria-label": labelYearDropdown(), className: classNames.dropdown_year, style: styles.dropdown_year, onChange: handleChange, value: displayMonth.getFullYear(), caption: formatYearCaption(displayMonth, { locale: locale }) }, { children: years.map(function (year) { return (jsxRuntimeExports.jsx("option", __assign({ value: year.getFullYear() }, { children: formatYearCaption(year, { locale: locale }) }), year.getFullYear())); }) })));
}

/**
 * Helper hook for using controlled/uncontrolled values from a component props.
 *
 * When the value is not controlled, pass `undefined` as `controlledValue` and
 * use the returned setter to update it.
 *
 * When the value is controlled, pass the controlled value as second
 * argument, which will be always returned as `value`.
 */
function useControlledValue(defaultValue, controlledValue) {
    var _a = (0,react.useState)(defaultValue), uncontrolledValue = _a[0], setValue = _a[1];
    var value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [value, setValue];
}

/** Return the initial month according to the given options. */
function getInitialMonth(context) {
    var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
    var initialMonth = month || defaultMonth || today || new Date();
    var toDate = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    // Fix the initialMonth if is after the to-date
    if (toDate && differenceInCalendarMonths(toDate, initialMonth) < 0) {
        var offset = -1 * (numberOfMonths - 1);
        initialMonth = addMonths(toDate, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (fromDate && differenceInCalendarMonths(initialMonth, fromDate) < 0) {
        initialMonth = fromDate;
    }
    return startOfMonth(initialMonth);
}

/** Controls the navigation state. */
function useNavigationState() {
    var context = useDayPicker();
    var initialMonth = getInitialMonth(context);
    var _a = useControlledValue(initialMonth, context.month), month = _a[0], setMonth = _a[1];
    var goToMonth = function (date) {
        var _a;
        if (context.disableNavigation)
            return;
        var month = startOfMonth(date);
        setMonth(month);
        (_a = context.onMonthChange) === null || _a === void 0 ? void 0 : _a.call(context, month);
    };
    return [month, goToMonth];
}

/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */
function getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = startOfMonth(month);
    var end = startOfMonth(addMonths(start, numberOfMonths));
    var monthsDiff = differenceInCalendarMonths(end, start);
    var months = [];
    for (var i = 0; i < monthsDiff; i++) {
        var nextMonth = addMonths(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths)
        months = months.reverse();
    return months;
}

/**
 * Returns the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - if after the `toDate` range, is undefined;
 * - if the navigation is paged, is the number of months displayed ahead.
 *
 */
function getNextMonth(startingMonth, options) {
    if (options.disableNavigation) {
        return undefined;
    }
    var toDate = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = startOfMonth(startingMonth);
    if (!toDate) {
        return addMonths(month, offset);
    }
    var monthsDiff = differenceInCalendarMonths(toDate, startingMonth);
    if (monthsDiff < numberOfMonths) {
        return undefined;
    }
    // Jump forward as the number of months when paged navigation
    return addMonths(month, offset);
}

/**
 * Returns the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - if before the `fromDate` date, is `undefined`;
 * - if the navigation is paged, is the number of months displayed before.
 *
 */
function getPreviousMonth(startingMonth, options) {
    if (options.disableNavigation) {
        return undefined;
    }
    var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = startOfMonth(startingMonth);
    if (!fromDate) {
        return addMonths(month, -offset);
    }
    var monthsDiff = differenceInCalendarMonths(month, fromDate);
    if (monthsDiff <= 0) {
        return undefined;
    }
    // Jump back as the number of months when paged navigation
    return addMonths(month, -offset);
}

/**
 * The Navigation context shares details and methods to navigate the months in DayPicker.
 * Access this context from the {@link useNavigation} hook.
 */
var NavigationContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link NavigationContext}. */
function NavigationProvider(props) {
    var dayPicker = useDayPicker();
    var _a = useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
    var displayMonths = getDisplayMonths(currentMonth, dayPicker);
    var nextMonth = getNextMonth(currentMonth, dayPicker);
    var previousMonth = getPreviousMonth(currentMonth, dayPicker);
    var isDateDisplayed = function (date) {
        return displayMonths.some(function (displayMonth) {
            return isSameMonth(date, displayMonth);
        });
    };
    var goToDate = function (date, refDate) {
        if (isDateDisplayed(date)) {
            return;
        }
        if (refDate && isBefore(date, refDate)) {
            goToMonth(addMonths(date, 1 + dayPicker.numberOfMonths * -1));
        }
        else {
            goToMonth(date);
        }
    };
    var value = {
        currentMonth: currentMonth,
        displayMonths: displayMonths,
        goToMonth: goToMonth,
        goToDate: goToDate,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        isDateDisplayed: isDateDisplayed
    };
    return (jsxRuntimeExports.jsx(NavigationContext.Provider, __assign({ value: value }, { children: props.children })));
}
/**
 * Hook to access the {@link NavigationContextValue}. Use this hook to navigate
 * between months or years in DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useNavigation() {
    var context = (0,react.useContext)(NavigationContext);
    if (!context) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
}

/**
 * Render a caption with the dropdowns to navigate between months and years.
 */
function CaptionDropdowns(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = useNavigation().goToMonth;
    var handleMonthChange = function (newMonth) {
        goToMonth(addMonths(newMonth, props.displayIndex ? -props.displayIndex : 0));
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var captionLabel = (jsxRuntimeExports.jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }));
    return (jsxRuntimeExports.jsxs("div", __assign({ className: classNames.caption_dropdowns, style: styles.caption_dropdowns }, { children: [jsxRuntimeExports.jsx("div", __assign({ className: classNames.vhidden }, { children: captionLabel })), jsxRuntimeExports.jsx(MonthsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth }), jsxRuntimeExports.jsx(YearsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth })] })));
}

/**
 * Render the "previous month" button in the navigation.
 */
function IconLeft(props) {
    return (jsxRuntimeExports.jsx("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props, { children: jsxRuntimeExports.jsx("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) })));
}

/**
 * Render the "next month" button in the navigation.
 */
function IconRight(props) {
    return (jsxRuntimeExports.jsx("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props, { children: jsxRuntimeExports.jsx("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) })));
}

/** Render a button HTML element applying the reset class name. */
var Button = (0,react.forwardRef)(function (props, ref) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [classNames.button_reset, classNames.button];
    if (props.className) {
        classNamesArr.push(props.className);
    }
    var className = classNamesArr.join(' ');
    var style = __assign(__assign({}, styles.button_reset), styles.button);
    if (props.style) {
        Object.assign(style, props.style);
    }
    return (jsxRuntimeExports.jsx("button", __assign({}, props, { ref: ref, type: "button", className: className, style: style })));
});

/** A component rendering the navigation buttons or the drop-downs. */
function Navigation(props) {
    var _a, _b;
    var _c = useDayPicker(), dir = _c.dir, locale = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious = _d.labelPrevious, labelNext = _d.labelNext, components = _c.components;
    if (!props.nextMonth && !props.previousMonth) {
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    }
    var previousLabel = labelPrevious(props.previousMonth, { locale: locale });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(' ');
    var nextLabel = labelNext(props.nextMonth, { locale: locale });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_next
    ].join(' ');
    var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : IconRight;
    var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : IconLeft;
    return (jsxRuntimeExports.jsxs("div", __assign({ className: classNames.nav, style: styles.nav }, { children: [!props.hidePrevious && (jsxRuntimeExports.jsx(Button, __assign({ name: "previous-month", "aria-label": previousLabel, className: previousClassName, style: styles.nav_button_previous, disabled: !props.previousMonth, onClick: props.onPreviousClick }, { children: dir === 'rtl' ? (jsxRuntimeExports.jsx(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon })) : (jsxRuntimeExports.jsx(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon })) }))), !props.hideNext && (jsxRuntimeExports.jsx(Button, __assign({ name: "next-month", "aria-label": nextLabel, className: nextClassName, style: styles.nav_button_next, disabled: !props.nextMonth, onClick: props.onNextClick }, { children: dir === 'rtl' ? (jsxRuntimeExports.jsx(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon })) : (jsxRuntimeExports.jsx(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon })) })))] })));
}

/**
 * Render a caption with a button-based navigation.
 */
function CaptionNavigation(props) {
    var numberOfMonths = useDayPicker().numberOfMonths;
    var _a = useNavigation(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
    var displayIndex = displayMonths.findIndex(function (month) {
        return isSameMonth(props.displayMonth, month);
    });
    var isFirst = displayIndex === 0;
    var isLast = displayIndex === displayMonths.length - 1;
    var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
    var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
    var handlePreviousClick = function () {
        if (!previousMonth)
            return;
        goToMonth(previousMonth);
    };
    var handleNextClick = function () {
        if (!nextMonth)
            return;
        goToMonth(nextMonth);
    };
    return (jsxRuntimeExports.jsx(Navigation, { displayMonth: props.displayMonth, hideNext: hideNext, hidePrevious: hidePrevious, nextMonth: nextMonth, previousMonth: previousMonth, onPreviousClick: handlePreviousClick, onNextClick: handleNextClick }));
}

/**
 * Render the caption of a month. The caption has a different layout when
 * setting the {@link DayPickerBase.captionLayout} prop.
 */
function index_esm_Caption(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var caption;
    if (disableNavigation) {
        caption = (jsxRuntimeExports.jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }));
    }
    else if (captionLayout === 'dropdown') {
        caption = (jsxRuntimeExports.jsx(CaptionDropdowns, { displayMonth: props.displayMonth, id: props.id }));
    }
    else if (captionLayout === 'dropdown-buttons') {
        caption = (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(CaptionDropdowns, { displayMonth: props.displayMonth, displayIndex: props.displayIndex, id: props.id }), jsxRuntimeExports.jsx(CaptionNavigation, { displayMonth: props.displayMonth, displayIndex: props.displayIndex, id: props.id })] }));
    }
    else {
        caption = (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth, displayIndex: props.displayIndex }), jsxRuntimeExports.jsx(CaptionNavigation, { displayMonth: props.displayMonth, id: props.id })] }));
    }
    return (jsxRuntimeExports.jsx("div", __assign({ className: classNames.caption, style: styles.caption }, { children: caption })));
}

/** Render the Footer component (empty as default).*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Footer(props) {
    var _a = useDayPicker(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    return (jsxRuntimeExports.jsx("tfoot", __assign({ className: tfoot, style: styles.tfoot }, { children: jsxRuntimeExports.jsx("tr", { children: jsxRuntimeExports.jsx("td", __assign({ colSpan: 8 }, { children: footer })) }) })));
}

/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */
function getWeekdays(locale, 
/** The index of the first day of the week (0 - Sunday). */
weekStartsOn, 
/** Use ISOWeek instead of locale/ */
ISOWeek) {
    var start = ISOWeek
        ? startOfISOWeek(new Date())
        : startOfWeek(new Date(), { locale: locale, weekStartsOn: weekStartsOn });
    var days = [];
    for (var i = 0; i < 7; i++) {
        var day = addDays(start, i);
        days.push(day);
    }
    return days;
}

/**
 * Render the HeadRow component - i.e. the table head row with the weekday names.
 */
function HeadRow() {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = getWeekdays(locale, weekStartsOn, ISOWeek);
    return (jsxRuntimeExports.jsxs("tr", __assign({ style: styles.head_row, className: classNames.head_row }, { children: [showWeekNumber && (jsxRuntimeExports.jsx("td", { style: styles.head_cell, className: classNames.head_cell })), weekdays.map(function (weekday, i) { return (jsxRuntimeExports.jsx("th", __assign({ scope: "col", className: classNames.head_cell, style: styles.head_cell, "aria-label": labelWeekday(weekday, { locale: locale }) }, { children: formatWeekdayName(weekday, { locale: locale }) }), i)); })] })));
}

/** Render the table head. */
function Head() {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : HeadRow;
    return (jsxRuntimeExports.jsx("thead", __assign({ style: styles.head, className: classNames.head }, { children: jsxRuntimeExports.jsx(HeadRowComponent, {}) })));
}

/** Render the content of the day cell. */
function DayContent(props) {
    var _a = useDayPicker(), locale = _a.locale, formatDay = _a.formatters.formatDay;
    return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: formatDay(props.date, { locale: locale }) });
}

/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the {@link useSelectMultiple} hook.
 */
var SelectMultipleContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link SelectMultipleContext}. */
function SelectMultipleProvider(props) {
    if (!isDayPickerMultiple(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                disabled: []
            }
        };
        return (jsxRuntimeExports.jsx(SelectMultipleContext.Provider, __assign({ value: emptyContextValue }, { children: props.children })));
    }
    return (jsxRuntimeExports.jsx(SelectMultipleProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectMultipleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected, min = initialProps.min, max = initialProps.max;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        var isMinSelected = Boolean(activeModifiers.selected && min && (selected === null || selected === void 0 ? void 0 : selected.length) === min);
        if (isMinSelected) {
            return;
        }
        var isMaxSelected = Boolean(!activeModifiers.selected && max && (selected === null || selected === void 0 ? void 0 : selected.length) === max);
        if (isMaxSelected) {
            return;
        }
        var selectedDays = selected ? __spreadArray([], selected, true) : [];
        if (activeModifiers.selected) {
            var index = selectedDays.findIndex(function (selectedDay) {
                return isSameDay(day, selectedDay);
            });
            selectedDays.splice(index, 1);
        }
        else {
            selectedDays.push(day);
        }
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, selectedDays, day, activeModifiers, e);
    };
    var modifiers = {
        disabled: []
    };
    if (selected) {
        modifiers.disabled.push(function (day) {
            var isMaxSelected = max && selected.length > max - 1;
            var isSelected = selected.some(function (selectedDay) {
                return isSameDay(selectedDay, day);
            });
            return Boolean(isMaxSelected && !isSelected);
        });
    }
    var contextValue = {
        selected: selected,
        onDayClick: onDayClick,
        modifiers: modifiers
    };
    return (jsxRuntimeExports.jsx(SelectMultipleContext.Provider, __assign({ value: contextValue }, { children: children })));
}
/**
 * Hook to access the {@link SelectMultipleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectMultiple() {
    var context = (0,react.useContext)(SelectMultipleContext);
    if (!context) {
        throw new Error('useSelectMultiple must be used within a SelectMultipleProvider');
    }
    return context;
}

/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */
function addToRange(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (from && to) {
        if (isSameDay(to, day) && isSameDay(from, day)) {
            return undefined;
        }
        if (isSameDay(to, day)) {
            return { from: to, to: undefined };
        }
        if (isSameDay(from, day)) {
            return undefined;
        }
        if (isAfter(from, day)) {
            return { from: day, to: to };
        }
        return { from: from, to: day };
    }
    if (to) {
        if (isAfter(day, to)) {
            return { from: to, to: day };
        }
        return { from: day, to: to };
    }
    if (from) {
        if (isBefore(day, from)) {
            return { from: day, to: from };
        }
        return { from: from, to: day };
    }
    return { from: day, to: undefined };
}

/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the {@link useSelectRange} hook.
 */
var SelectRangeContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link SelectRangeProvider}. */
function SelectRangeProvider(props) {
    if (!isDayPickerRange(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                range_start: [],
                range_end: [],
                range_middle: [],
                disabled: []
            }
        };
        return (jsxRuntimeExports.jsx(SelectRangeContext.Provider, __assign({ value: emptyContextValue }, { children: props.children })));
    }
    return (jsxRuntimeExports.jsx(SelectRangeProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectRangeProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected;
    var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
    var min = initialProps.min;
    var max = initialProps.max;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        var newRange = addToRange(day, selected);
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, newRange, day, activeModifiers, e);
    };
    var modifiers = {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
    };
    if (selectedFrom) {
        modifiers.range_start = [selectedFrom];
        if (!selectedTo) {
            modifiers.range_end = [selectedFrom];
        }
        else {
            modifiers.range_end = [selectedTo];
            if (!isSameDay(selectedFrom, selectedTo)) {
                modifiers.range_middle = [
                    {
                        after: selectedFrom,
                        before: selectedTo
                    }
                ];
            }
        }
    }
    else if (selectedTo) {
        modifiers.range_start = [selectedTo];
        modifiers.range_end = [selectedTo];
    }
    if (min) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                after: subDays(selectedFrom, min - 1),
                before: addDays(selectedFrom, min - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            modifiers.disabled.push({
                after: selectedFrom,
                before: addDays(selectedFrom, min - 1)
            });
        }
        if (!selectedFrom && selectedTo) {
            modifiers.disabled.push({
                after: subDays(selectedTo, min - 1),
                before: addDays(selectedTo, min - 1)
            });
        }
    }
    if (max) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                before: addDays(selectedFrom, -max + 1)
            });
            modifiers.disabled.push({
                after: addDays(selectedFrom, max - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            var selectedCount = differenceInCalendarDays_differenceInCalendarDays(selectedTo, selectedFrom) + 1;
            var offset = max - selectedCount;
            modifiers.disabled.push({
                before: subDays(selectedFrom, offset)
            });
            modifiers.disabled.push({
                after: addDays(selectedTo, offset)
            });
        }
        if (!selectedFrom && selectedTo) {
            modifiers.disabled.push({
                before: addDays(selectedTo, -max + 1)
            });
            modifiers.disabled.push({
                after: addDays(selectedTo, max - 1)
            });
        }
    }
    return (jsxRuntimeExports.jsx(SelectRangeContext.Provider, __assign({ value: { selected: selected, onDayClick: onDayClick, modifiers: modifiers } }, { children: children })));
}
/**
 * Hook to access the {@link SelectRangeContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectRange() {
    var context = (0,react.useContext)(SelectRangeContext);
    if (!context) {
        throw new Error('useSelectRange must be used within a SelectRangeProvider');
    }
    return context;
}

/** Normalize to array a matcher input. */
function matcherToArray(matcher) {
    if (Array.isArray(matcher)) {
        return __spreadArray([], matcher, true);
    }
    else if (matcher !== undefined) {
        return [matcher];
    }
    else {
        return [];
    }
}

/** Create CustomModifiers from dayModifiers */
function getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function (_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = matcherToArray(matcher);
    });
    return customModifiers;
}

/** The name of the modifiers that are used internally by DayPicker. */
var InternalModifier;
(function (InternalModifier) {
    InternalModifier["Outside"] = "outside";
    /** Name of the modifier applied to the disabled days, using the `disabled` prop. */
    InternalModifier["Disabled"] = "disabled";
    /** Name of the modifier applied to the selected days using the `selected` prop). */
    InternalModifier["Selected"] = "selected";
    /** Name of the modifier applied to the hidden days using the `hidden` prop). */
    InternalModifier["Hidden"] = "hidden";
    /** Name of the modifier applied to the day specified using the `today` prop). */
    InternalModifier["Today"] = "today";
    /** The modifier applied to the day starting a selected range, when in range selection mode.  */
    InternalModifier["RangeStart"] = "range_start";
    /** The modifier applied to the day ending a selected range, when in range selection mode.  */
    InternalModifier["RangeEnd"] = "range_end";
    /** The modifier applied to the days between the start and the end of a selected range, when in range selection mode.  */
    InternalModifier["RangeMiddle"] = "range_middle";
})(InternalModifier || (InternalModifier = {}));

var Selected = InternalModifier.Selected, Disabled = InternalModifier.Disabled, Hidden = InternalModifier.Hidden, Today = InternalModifier.Today, RangeEnd = InternalModifier.RangeEnd, RangeMiddle = InternalModifier.RangeMiddle, RangeStart = InternalModifier.RangeStart, Outside = InternalModifier.Outside;
/** Return the {@link InternalModifiers} from the DayPicker and select contexts. */
function getInternalModifiers(dayPicker, selectMultiple, selectRange) {
    var _a;
    var internalModifiers = (_a = {},
        _a[Selected] = matcherToArray(dayPicker.selected),
        _a[Disabled] = matcherToArray(dayPicker.disabled),
        _a[Hidden] = matcherToArray(dayPicker.hidden),
        _a[Today] = [dayPicker.today],
        _a[RangeEnd] = [],
        _a[RangeMiddle] = [],
        _a[RangeStart] = [],
        _a[Outside] = [],
        _a);
    if (dayPicker.fromDate) {
        internalModifiers[Disabled].push({ before: dayPicker.fromDate });
    }
    if (dayPicker.toDate) {
        internalModifiers[Disabled].push({ after: dayPicker.toDate });
    }
    if (isDayPickerMultiple(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectMultiple.modifiers[Disabled]);
    }
    else if (isDayPickerRange(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectRange.modifiers[Disabled]);
        internalModifiers[RangeStart] = selectRange.modifiers[RangeStart];
        internalModifiers[RangeMiddle] = selectRange.modifiers[RangeMiddle];
        internalModifiers[RangeEnd] = selectRange.modifiers[RangeEnd];
    }
    return internalModifiers;
}

/** The Modifiers context store the modifiers used in DayPicker. To access the value of this context, use {@link useModifiers}. */
var ModifiersContext = (0,react.createContext)(undefined);
/** Provide the value for the {@link ModifiersContext}. */
function ModifiersProvider(props) {
    var dayPicker = useDayPicker();
    var selectMultiple = useSelectMultiple();
    var selectRange = useSelectRange();
    var internalModifiers = getInternalModifiers(dayPicker, selectMultiple, selectRange);
    var customModifiers = getCustomModifiers(dayPicker.modifiers);
    var modifiers = __assign(__assign({}, internalModifiers), customModifiers);
    return (jsxRuntimeExports.jsx(ModifiersContext.Provider, __assign({ value: modifiers }, { children: props.children })));
}
/**
 * Return the modifiers used by DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 * Requires to be wrapped into {@link ModifiersProvider}.
 *
 */
function useModifiers() {
    var context = (0,react.useContext)(ModifiersContext);
    if (!context) {
        throw new Error('useModifiers must be used within a ModifiersProvider');
    }
    return context;
}

/** Returns true if `matcher` is of type {@link DateInterval}. */
function isDateInterval(matcher) {
    return Boolean(matcher &&
        typeof matcher === 'object' &&
        'before' in matcher &&
        'after' in matcher);
}
/** Returns true if `value` is a {@link DateRange} type. */
function isDateRange(value) {
    return Boolean(value && typeof value === 'object' && 'from' in value);
}
/** Returns true if `value` is of type {@link DateAfter}. */
function isDateAfterType(value) {
    return Boolean(value && typeof value === 'object' && 'after' in value);
}
/** Returns true if `value` is of type {@link DateBefore}. */
function isDateBeforeType(value) {
    return Boolean(value && typeof value === 'object' && 'before' in value);
}
/** Returns true if `value` is a {@link DayOfWeek} type. */
function isDayOfWeekType(value) {
    return Boolean(value && typeof value === 'object' && 'dayOfWeek' in value);
}

/** Return `true` whether `date` is inside `range`. */
function isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (from && to) {
        var isRangeInverted = differenceInCalendarDays_differenceInCalendarDays(to, from) < 0;
        if (isRangeInverted) {
            _a = [to, from], from = _a[0], to = _a[1];
        }
        var isInRange = differenceInCalendarDays_differenceInCalendarDays(date, from) >= 0 &&
            differenceInCalendarDays_differenceInCalendarDays(to, date) >= 0;
        return isInRange;
    }
    if (to) {
        return isSameDay(to, date);
    }
    if (from) {
        return isSameDay(from, date);
    }
    return false;
}

/** Returns true if `value` is a Date type. */
function isDateType(value) {
    return (0,isDate/* default */.Z)(value);
}
/** Returns true if `value` is an array of valid dates. */
function isArrayOfDates(value) {
    return Array.isArray(value) && value.every(isDate/* default */.Z);
}
/**
 * Returns whether a day matches against at least one of the given Matchers.
 *
 * ```
 * const day = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *    from: new Date(2021, 12, 21),
 *    to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *    from: new Date(2022, 5, 1),
 *    to: new Date(2022, 5, 23)
 * }
 *
 * const isMatch(day, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 * */
function isMatch(day, matchers) {
    return matchers.some(function (matcher) {
        if (typeof matcher === 'boolean') {
            return matcher;
        }
        if (isDateType(matcher)) {
            return isSameDay(day, matcher);
        }
        if (isArrayOfDates(matcher)) {
            return matcher.includes(day);
        }
        if (isDateRange(matcher)) {
            return isDateInRange(day, matcher);
        }
        if (isDayOfWeekType(matcher)) {
            return matcher.dayOfWeek.includes(day.getDay());
        }
        if (isDateInterval(matcher)) {
            var diffBefore = differenceInCalendarDays_differenceInCalendarDays(matcher.before, day);
            var diffAfter = differenceInCalendarDays_differenceInCalendarDays(matcher.after, day);
            var isDayBefore = diffBefore > 0;
            var isDayAfter = diffAfter < 0;
            var isClosedInterval = isAfter(matcher.before, matcher.after);
            if (isClosedInterval) {
                return isDayAfter && isDayBefore;
            }
            else {
                return isDayBefore || isDayAfter;
            }
        }
        if (isDateAfterType(matcher)) {
            return differenceInCalendarDays_differenceInCalendarDays(day, matcher.after) > 0;
        }
        if (isDateBeforeType(matcher)) {
            return differenceInCalendarDays_differenceInCalendarDays(matcher.before, day) > 0;
        }
        if (typeof matcher === 'function') {
            return matcher(day);
        }
        return false;
    });
}

/** Return the active modifiers for the given day. */
function getActiveModifiers(day, 
/** The modifiers to match for the given date. */
modifiers, 
/** The month where the day is displayed, to add the "outside" modifiers.  */
displayMonth) {
    var matchedModifiers = Object.keys(modifiers).reduce(function (result, key) {
        var modifier = modifiers[key];
        if (isMatch(day, modifier)) {
            result.push(key);
        }
        return result;
    }, []);
    var activeModifiers = {};
    matchedModifiers.forEach(function (modifier) { return (activeModifiers[modifier] = true); });
    if (displayMonth && !isSameMonth(day, displayMonth)) {
        activeModifiers.outside = true;
    }
    return activeModifiers;
}

/**
 * Returns the day that should be the target of the focus when DayPicker is
 * rendered the first time.
 *
 * TODO: this function doesn't consider if the day is outside the month. We
 * implemented this check in `useDayRender` but it should probably go here. See
 * https://github.com/gpbl/react-day-picker/pull/1576
 */
function getInitialFocusTarget(displayMonths, modifiers) {
    var firstDayInMonth = startOfMonth(displayMonths[0]);
    var lastDayInMonth = endOfMonth(displayMonths[displayMonths.length - 1]);
    // TODO: cleanup code
    var firstFocusableDay;
    var today;
    var date = firstDayInMonth;
    while (date <= lastDayInMonth) {
        var activeModifiers = getActiveModifiers(date, modifiers);
        var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
        if (!isFocusable) {
            date = addDays(date, 1);
            continue;
        }
        if (activeModifiers.selected) {
            return date;
        }
        if (activeModifiers.today && !today) {
            today = date;
        }
        if (!firstFocusableDay) {
            firstFocusableDay = date;
        }
        date = addDays(date, 1);
    }
    if (today) {
        return today;
    }
    else {
        return firstFocusableDay;
    }
}

var MAX_RETRY = 365;
/** Return the next date to be focused. */
function getNextFocus(focusedDay, options) {
    var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers = options.modifiers, _a = options.retry, retry = _a === void 0 ? { count: 0, lastFocused: focusedDay } : _a;
    var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate = context.toDate, locale = context.locale;
    var moveFns = {
        day: addDays,
        week: addWeeks,
        month: addMonths,
        year: addYears,
        startOfWeek: function (date) {
            return context.ISOWeek
                ? startOfISOWeek(date)
                : startOfWeek(date, { locale: locale, weekStartsOn: weekStartsOn });
        },
        endOfWeek: function (date) {
            return context.ISOWeek
                ? endOfISOWeek(date)
                : endOfWeek(date, { locale: locale, weekStartsOn: weekStartsOn });
        }
    };
    var newFocusedDay = moveFns[moveBy](focusedDay, direction === 'after' ? 1 : -1);
    if (direction === 'before' && fromDate) {
        newFocusedDay = max([fromDate, newFocusedDay]);
    }
    else if (direction === 'after' && toDate) {
        newFocusedDay = min([toDate, newFocusedDay]);
    }
    var isFocusable = true;
    if (modifiers) {
        var activeModifiers = getActiveModifiers(newFocusedDay, modifiers);
        isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    }
    if (isFocusable) {
        return newFocusedDay;
    }
    else {
        if (retry.count > MAX_RETRY) {
            return retry.lastFocused;
        }
        return getNextFocus(newFocusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers,
            retry: __assign(__assign({}, retry), { count: retry.count + 1 })
        });
    }
}

/**
 * The Focus context shares details about the focused day for the keyboard
 *
 * Access this context from the {@link useFocusContext} hook.
 */
var FocusContext = (0,react.createContext)(undefined);
/** The provider for the {@link FocusContext}. */
function FocusProvider(props) {
    var navigation = useNavigation();
    var modifiers = useModifiers();
    var _a = (0,react.useState)(), focusedDay = _a[0], setFocusedDay = _a[1];
    var _b = (0,react.useState)(), lastFocused = _b[0], setLastFocused = _b[1];
    var initialFocusTarget = getInitialFocusTarget(navigation.displayMonths, modifiers);
    // TODO: cleanup and test obscure code below
    var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : (lastFocused && navigation.isDateDisplayed(lastFocused)))
        ? lastFocused
        : initialFocusTarget;
    var blur = function () {
        setLastFocused(focusedDay);
        setFocusedDay(undefined);
    };
    var focus = function (date) {
        setFocusedDay(date);
    };
    var context = useDayPicker();
    var moveFocus = function (moveBy, direction) {
        if (!focusedDay)
            return;
        var nextFocused = getNextFocus(focusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers
        });
        if (isSameDay(focusedDay, nextFocused))
            return undefined;
        navigation.goToDate(nextFocused, focusedDay);
        focus(nextFocused);
    };
    var value = {
        focusedDay: focusedDay,
        focusTarget: focusTarget,
        blur: blur,
        focus: focus,
        focusDayAfter: function () { return moveFocus('day', 'after'); },
        focusDayBefore: function () { return moveFocus('day', 'before'); },
        focusWeekAfter: function () { return moveFocus('week', 'after'); },
        focusWeekBefore: function () { return moveFocus('week', 'before'); },
        focusMonthBefore: function () { return moveFocus('month', 'before'); },
        focusMonthAfter: function () { return moveFocus('month', 'after'); },
        focusYearBefore: function () { return moveFocus('year', 'before'); },
        focusYearAfter: function () { return moveFocus('year', 'after'); },
        focusStartOfWeek: function () { return moveFocus('startOfWeek', 'before'); },
        focusEndOfWeek: function () { return moveFocus('endOfWeek', 'after'); }
    };
    return (jsxRuntimeExports.jsx(FocusContext.Provider, __assign({ value: value }, { children: props.children })));
}
/**
 * Hook to access the {@link FocusContextValue}. Use this hook to handle the
 * focus state of the elements.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useFocusContext() {
    var context = (0,react.useContext)(FocusContext);
    if (!context) {
        throw new Error('useFocusContext must be used within a FocusProvider');
    }
    return context;
}

/**
 * Return the active modifiers for the specified day.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 * @param day
 * @param displayMonth
 */
function useActiveModifiers(day, 
/**
 * The month where the date is displayed. If not the same as `date`, the day
 * is an "outside day".
 */
displayMonth) {
    var modifiers = useModifiers();
    var activeModifiers = getActiveModifiers(day, modifiers, displayMonth);
    return activeModifiers;
}

/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the {@link useSelectSingle} hook.
 */
var SelectSingleContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link SelectSingleProvider}. */
function SelectSingleProvider(props) {
    if (!isDayPickerSingle(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined
        };
        return (jsxRuntimeExports.jsx(SelectSingleContext.Provider, __assign({ value: emptyContextValue }, { children: props.children })));
    }
    return (jsxRuntimeExports.jsx(SelectSingleProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectSingleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b, _c;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        if (activeModifiers.selected && !initialProps.required) {
            (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, undefined, day, activeModifiers, e);
            return;
        }
        (_c = initialProps.onSelect) === null || _c === void 0 ? void 0 : _c.call(initialProps, day, day, activeModifiers, e);
    };
    var contextValue = {
        selected: initialProps.selected,
        onDayClick: onDayClick
    };
    return (jsxRuntimeExports.jsx(SelectSingleContext.Provider, __assign({ value: contextValue }, { children: children })));
}
/**
 * Hook to access the {@link SelectSingleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectSingle() {
    var context = (0,react.useContext)(SelectSingleContext);
    if (!context) {
        throw new Error('useSelectSingle must be used within a SelectSingleProvider');
    }
    return context;
}

/**
 * This hook returns details about the content to render in the day cell.
 *
 *
 * When a day cell is rendered in the table, DayPicker can either:
 *
 * - render nothing: when the day is outside the month or has matched the
 *   "hidden" modifier.
 * - render a button when `onDayClick` or a selection mode is set.
 * - render a non-interactive element: when no selection mode is set, the day
 *   cell shouldn’t respond to any interaction. DayPicker should render a `div`
 *   or a `span`.
 *
 * ### Usage
 *
 * Use this hook to customize the behavior of the {@link Day} component. Create a
 * new `Day` component using this hook and pass it to the `components` prop.
 * The source of {@link Day} can be a good starting point.
 *
 */
function useDayEventHandlers(date, activeModifiers) {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var _a = useFocusContext(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
    var onClick = function (e) {
        var _a, _b, _c, _d;
        if (isDayPickerSingle(dayPicker)) {
            (_a = single.onDayClick) === null || _a === void 0 ? void 0 : _a.call(single, date, activeModifiers, e);
        }
        else if (isDayPickerMultiple(dayPicker)) {
            (_b = multiple.onDayClick) === null || _b === void 0 ? void 0 : _b.call(multiple, date, activeModifiers, e);
        }
        else if (isDayPickerRange(dayPicker)) {
            (_c = range.onDayClick) === null || _c === void 0 ? void 0 : _c.call(range, date, activeModifiers, e);
        }
        else {
            (_d = dayPicker.onDayClick) === null || _d === void 0 ? void 0 : _d.call(dayPicker, date, activeModifiers, e);
        }
    };
    var onFocus = function (e) {
        var _a;
        focus(date);
        (_a = dayPicker.onDayFocus) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onBlur = function (e) {
        var _a;
        blur();
        (_a = dayPicker.onDayBlur) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseEnter = function (e) {
        var _a;
        (_a = dayPicker.onDayMouseEnter) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseLeave = function (e) {
        var _a;
        (_a = dayPicker.onDayMouseLeave) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerEnter = function (e) {
        var _a;
        (_a = dayPicker.onDayPointerEnter) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerLeave = function (e) {
        var _a;
        (_a = dayPicker.onDayPointerLeave) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchCancel = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchCancel) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchEnd = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchEnd) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchMove = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchMove) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchStart = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchStart) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyUp = function (e) {
        var _a;
        (_a = dayPicker.onDayKeyUp) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyDown = function (e) {
        var _a;
        switch (e.key) {
            case 'ArrowLeft':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayAfter() : focusDayBefore();
                break;
            case 'ArrowRight':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayBefore() : focusDayAfter();
                break;
            case 'ArrowDown':
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfter();
                break;
            case 'ArrowUp':
                e.preventDefault();
                e.stopPropagation();
                focusWeekBefore();
                break;
            case 'PageUp':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearBefore() : focusMonthBefore();
                break;
            case 'PageDown':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearAfter() : focusMonthAfter();
                break;
            case 'Home':
                e.preventDefault();
                e.stopPropagation();
                focusStartOfWeek();
                break;
            case 'End':
                e.preventDefault();
                e.stopPropagation();
                focusEndOfWeek();
                break;
        }
        (_a = dayPicker.onDayKeyDown) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var eventHandlers = {
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onTouchCancel: onTouchCancel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    return eventHandlers;
}

/**
 * Return the current selected days when DayPicker is in selection mode. Days
 * selected by the custom selection mode are not returned.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 */
function useSelectedDays() {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var selectedDays = isDayPickerSingle(dayPicker)
        ? single.selected
        : isDayPickerMultiple(dayPicker)
            ? multiple.selected
            : isDayPickerRange(dayPicker)
                ? range.selected
                : undefined;
    return selectedDays;
}

function isInternalModifier(modifier) {
    return Object.values(InternalModifier).includes(modifier);
}
/**
 * Return the class names for the Day element, according to the given active
 * modifiers.
 *
 * Custom class names are set via `modifiersClassNames` or `classNames`,
 * where the first have the precedence.
 */
function getDayClassNames(dayPicker, activeModifiers) {
    var classNames = [dayPicker.classNames.day];
    Object.keys(activeModifiers).forEach(function (modifier) {
        var customClassName = dayPicker.modifiersClassNames[modifier];
        if (customClassName) {
            classNames.push(customClassName);
        }
        else if (isInternalModifier(modifier)) {
            var internalClassName = dayPicker.classNames["day_".concat(modifier)];
            if (internalClassName) {
                classNames.push(internalClassName);
            }
        }
    });
    return classNames;
}

/** Return the style for the Day element, according to the given active modifiers. */
function getDayStyle(dayPicker, activeModifiers) {
    var style = __assign({}, dayPicker.styles.day);
    Object.keys(activeModifiers).forEach(function (modifier) {
        var _a;
        style = __assign(__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
    });
    return style;
}

/**
 * Return props and data used to render the {@link Day} component.
 *
 * Use this hook when creating a component to replace the built-in `Day`
 * component.
 */
function useDayRender(
/** The date to render. */
day, 
/** The month where the date is displayed (if not the same as `date`, it means it is an "outside" day). */
displayMonth, 
/** A ref to the button element that will be target of focus when rendered (if required). */
buttonRef) {
    var _a;
    var _b, _c;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var activeModifiers = useActiveModifiers(day, displayMonth);
    var eventHandlers = useDayEventHandlers(day, activeModifiers);
    var selectedDays = useSelectedDays();
    var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== 'default');
    // Focus the button if the day is focused according to the focus context
    (0,react.useEffect)(function () {
        var _a;
        if (activeModifiers.outside)
            return;
        if (!focusContext.focusedDay)
            return;
        if (!isButton)
            return;
        if (isSameDay(focusContext.focusedDay, day)) {
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [
        focusContext.focusedDay,
        day,
        buttonRef,
        isButton,
        activeModifiers.outside
    ]);
    var className = getDayClassNames(dayPicker, activeModifiers).join(' ');
    var style = getDayStyle(dayPicker, activeModifiers);
    var isHidden = Boolean((activeModifiers.outside && !dayPicker.showOutsideDays) ||
        activeModifiers.hidden);
    var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : DayContent;
    var children = (jsxRuntimeExports.jsx(DayContentComponent, { date: day, displayMonth: displayMonth, activeModifiers: activeModifiers }));
    var divProps = {
        style: style,
        className: className,
        children: children,
        role: 'gridcell'
    };
    var isFocusTarget = focusContext.focusTarget &&
        isSameDay(focusContext.focusTarget, day) &&
        !activeModifiers.outside;
    var isFocused = focusContext.focusedDay && isSameDay(focusContext.focusedDay, day);
    var buttonProps = __assign(__assign(__assign({}, divProps), (_a = { disabled: activeModifiers.disabled, role: 'gridcell' }, _a['aria-selected'] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
    var dayRender = {
        isButton: isButton,
        isHidden: isHidden,
        activeModifiers: activeModifiers,
        selectedDays: selectedDays,
        buttonProps: buttonProps,
        divProps: divProps
    };
    return dayRender;
}

/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */
function Day(props) {
    var buttonRef = (0,react.useRef)(null);
    var dayRender = useDayRender(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) {
        return jsxRuntimeExports.jsx("div", { role: "gridcell" });
    }
    if (!dayRender.isButton) {
        return jsxRuntimeExports.jsx("div", __assign({}, dayRender.divProps));
    }
    return jsxRuntimeExports.jsx(Button, __assign({ name: "day", ref: buttonRef }, dayRender.buttonProps));
}

/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */
function WeekNumber(props) {
    var weekNumber = props.number, dates = props.dates;
    var _a = useDayPicker(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale = _a.locale, labelWeekNumber = _a.labels.labelWeekNumber, formatWeekNumber = _a.formatters.formatWeekNumber;
    var content = formatWeekNumber(Number(weekNumber), { locale: locale });
    if (!onWeekNumberClick) {
        return (jsxRuntimeExports.jsx("span", __assign({ className: classNames.weeknumber, style: styles.weeknumber }, { children: content })));
    }
    var label = labelWeekNumber(Number(weekNumber), { locale: locale });
    var handleClick = function (e) {
        onWeekNumberClick(weekNumber, dates, e);
    };
    return (jsxRuntimeExports.jsx(Button, __assign({ name: "week-number", "aria-label": label, className: classNames.weeknumber, style: styles.weeknumber, onClick: handleClick }, { children: content })));
}

/** Render a row in the calendar, with the days and the week number. */
function Row(props) {
    var _a, _b;
    var _c = useDayPicker(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
    var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : Day;
    var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : WeekNumber;
    var weekNumberCell;
    if (showWeekNumber) {
        weekNumberCell = (jsxRuntimeExports.jsx("td", __assign({ className: classNames.cell, style: styles.cell }, { children: jsxRuntimeExports.jsx(WeeknumberComponent, { number: props.weekNumber, dates: props.dates }) })));
    }
    return (jsxRuntimeExports.jsxs("tr", __assign({ className: classNames.row, style: styles.row }, { children: [weekNumberCell, props.dates.map(function (date) { return (jsxRuntimeExports.jsx("td", __assign({ className: classNames.cell, style: styles.cell, role: "presentation" }, { children: jsxRuntimeExports.jsx(DayComponent, { displayMonth: props.displayMonth, date: date }) }), getUnixTime(date))); })] })));
}

/** Return the weeks between two dates.  */
function daysToMonthWeeks(fromDate, toDate, options) {
    var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek)
        ? endOfISOWeek(toDate)
        : endOfWeek(toDate, options);
    var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek)
        ? startOfISOWeek(fromDate)
        : startOfWeek(fromDate, options);
    var nOfDays = differenceInCalendarDays_differenceInCalendarDays(toWeek, fromWeek);
    var days = [];
    for (var i = 0; i <= nOfDays; i++) {
        days.push(addDays(fromWeek, i));
    }
    var weeksInMonth = days.reduce(function (result, date) {
        var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek)
            ? getISOWeek(date)
            : getWeek(date, options);
        var existingWeek = result.find(function (value) { return value.weekNumber === weekNumber; });
        if (existingWeek) {
            existingWeek.dates.push(date);
            return result;
        }
        result.push({
            weekNumber: weekNumber,
            dates: [date]
        });
        return result;
    }, []);
    return weeksInMonth;
}

/**
 * Return the weeks belonging to the given month, adding the "outside days" to
 * the first and last week.
 */
function getMonthWeeks(month, options) {
    var weeksInMonth = daysToMonthWeeks(startOfMonth(month), endOfMonth(month), options);
    if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
        // Add extra weeks to the month, up to 6 weeks
        var nrOfMonthWeeks = getWeeksInMonth(month, options);
        if (nrOfMonthWeeks < 6) {
            var lastWeek = weeksInMonth[weeksInMonth.length - 1];
            var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
            var toDate = addWeeks(lastDate, 6 - nrOfMonthWeeks);
            var extraWeeks = daysToMonthWeeks(addWeeks(lastDate, 1), toDate, options);
            weeksInMonth.push.apply(weeksInMonth, extraWeeks);
        }
    }
    return weeksInMonth;
}

/** Render the table with the calendar. */
function Table(props) {
    var _a, _b, _c;
    var _d = useDayPicker(), locale = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
    var weeks = getMonthWeeks(props.displayMonth, {
        useFixedWeeks: Boolean(fixedWeeks),
        ISOWeek: ISOWeek,
        locale: locale,
        weekStartsOn: weekStartsOn,
        firstWeekContainsDate: firstWeekContainsDate
    });
    var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : Head;
    var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : Row;
    var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : Footer;
    return (jsxRuntimeExports.jsxs("table", __assign({ id: props.id, className: classNames.table, style: styles.table, role: "grid", "aria-labelledby": props['aria-labelledby'] }, { children: [!hideHead && jsxRuntimeExports.jsx(HeadComponent, {}), jsxRuntimeExports.jsx("tbody", __assign({ className: classNames.tbody, style: styles.tbody }, { children: weeks.map(function (week) { return (jsxRuntimeExports.jsx(RowComponent, { displayMonth: props.displayMonth, dates: week.dates, weekNumber: week.weekNumber }, week.weekNumber)); }) })), jsxRuntimeExports.jsx(FooterComponent, { displayMonth: props.displayMonth })] })));
}

/*
The MIT License (MIT)

Copyright (c) 2018-present, React Training LLC

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/*
 * Welcome to @reach/auto-id!
 * Let's see if we can make sense of why this hook exists and its
 * implementation.
 *
 * Some background:
 *   1. Accessibility APIs rely heavily on element IDs
 *   2. Requiring developers to put IDs on every element in Reach UI is both
 *      cumbersome and error-prone
 *   3. With a component model, we can generate IDs for them!
 *
 * Solution 1: Generate random IDs.
 *
 * This works great as long as you don't server render your app. When React (in
 * the client) tries to reuse the markup from the server, the IDs won't match
 * and React will then recreate the entire DOM tree.
 *
 * Solution 2: Increment an integer
 *
 * This sounds great. Since we're rendering the exact same tree on the server
 * and client, we can increment a counter and get a deterministic result between
 * client and server. Also, JS integers can go up to nine-quadrillion. I'm
 * pretty sure the tab will be closed before an app never needs
 * 10 quadrillion IDs!
 *
 * Problem solved, right?
 *
 * Ah, but there's a catch! React's concurrent rendering makes this approach
 * non-deterministic. While the client and server will end up with the same
 * elements in the end, depending on suspense boundaries (and possibly some user
 * input during the initial render) the incrementing integers won't always match
 * up.
 *
 * Solution 3: Don't use IDs at all on the server; patch after first render.
 *
 * What we've done here is solution 2 with some tricks. With this approach, the
 * ID returned is an empty string on the first render. This way the server and
 * client have the same markup no matter how wild the concurrent rendering may
 * have gotten.
 *
 * After the render, we patch up the components with an incremented ID. This
 * causes a double render on any components with `useId`. Shouldn't be a problem
 * since the components using this hook should be small, and we're only updating
 * the ID attribute on the DOM, nothing big is happening.
 *
 * It doesn't have to be an incremented number, though--we could do generate
 * random strings instead, but incrementing a number is probably the cheapest
 * thing we can do.
 *
 * Additionally, we only do this patchup on the very first client render ever.
 * Any calls to `useId` that happen dynamically in the client will be
 * populated immediately with a value. So, we only get the double render after
 * server hydration and never again, SO BACK OFF ALRIGHT?
 */
function canUseDOM() {
    return !!(typeof window !== 'undefined' &&
        window.document &&
        window.document.createElement);
}
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */
var useIsomorphicLayoutEffect = canUseDOM() ? react.useLayoutEffect : react.useEffect;
var serverHandoffComplete = false;
var id = 0;
function genId() {
    return "react-day-picker-".concat(++id);
}
function useId(providedId) {
    // TODO: Remove error flag when updating internal deps to React 18. None of
    // our tricks will play well with concurrent rendering anyway.
    var _a;
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    var initialId = providedId !== null && providedId !== void 0 ? providedId : (serverHandoffComplete ? genId() : null);
    var _b = (0,react.useState)(initialId), id = _b[0], setId = _b[1];
    useIsomorphicLayoutEffect(function () {
        if (id === null) {
            // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
            // rendering flicker, though it'll make the first render slower (unlikely
            // to matter, but you're welcome to measure your app and let us know if
            // it's a problem).
            setId(genId());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function () {
        if (serverHandoffComplete === false) {
            // Flag all future uses of `useId` to skip the update dance. This is in
            // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
            // accidentally bail out of the patch-up dance prematurely.
            serverHandoffComplete = true;
        }
    }, []);
    return (_a = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _a !== void 0 ? _a : undefined;
}

/** Render a month. */
function Month(props) {
    var _a;
    var _b;
    var dayPicker = useDayPicker();
    var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
    var displayMonths = useNavigation().displayMonths;
    var captionId = useId(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : undefined);
    var tableId = dayPicker.id
        ? "".concat(dayPicker.id, "-grid-").concat(props.displayIndex)
        : undefined;
    var className = [classNames.month];
    var style = styles.month;
    var isStart = props.displayIndex === 0;
    var isEnd = props.displayIndex === displayMonths.length - 1;
    var isCenter = !isStart && !isEnd;
    if (dir === 'rtl') {
        _a = [isStart, isEnd], isEnd = _a[0], isStart = _a[1];
    }
    if (isStart) {
        className.push(classNames.caption_start);
        style = __assign(__assign({}, style), styles.caption_start);
    }
    if (isEnd) {
        className.push(classNames.caption_end);
        style = __assign(__assign({}, style), styles.caption_end);
    }
    if (isCenter) {
        className.push(classNames.caption_between);
        style = __assign(__assign({}, style), styles.caption_between);
    }
    var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : index_esm_Caption;
    return (jsxRuntimeExports.jsxs("div", __assign({ className: className.join(' '), style: style }, { children: [jsxRuntimeExports.jsx(CaptionComponent, { id: captionId, displayMonth: props.displayMonth, displayIndex: props.displayIndex }), jsxRuntimeExports.jsx(Table, { id: tableId, "aria-labelledby": captionId, displayMonth: props.displayMonth })] }), props.displayIndex));
}

/**
 * Render the wrapper for the month grids.
 */
function Months(props) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    return (jsxRuntimeExports.jsx("div", __assign({ className: classNames.months, style: styles.months }, { children: props.children })));
}

/** Render the container with the months according to the number of months to display. */
function Root(_a) {
    var _b, _c;
    var initialProps = _a.initialProps;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var navigation = useNavigation();
    var _d = (0,react.useState)(false), hasInitialFocus = _d[0], setHasInitialFocus = _d[1];
    // Focus the focus target when initialFocus is passed in
    (0,react.useEffect)(function () {
        if (!dayPicker.initialFocus)
            return;
        if (!focusContext.focusTarget)
            return;
        if (hasInitialFocus)
            return;
        focusContext.focus(focusContext.focusTarget);
        setHasInitialFocus(true);
    }, [
        dayPicker.initialFocus,
        hasInitialFocus,
        focusContext.focus,
        focusContext.focusTarget,
        focusContext
    ]);
    // Apply classnames according to props
    var classNames = [dayPicker.classNames.root, dayPicker.className];
    if (dayPicker.numberOfMonths > 1) {
        classNames.push(dayPicker.classNames.multiple_months);
    }
    if (dayPicker.showWeekNumber) {
        classNames.push(dayPicker.classNames.with_weeknumber);
    }
    var style = __assign(__assign({}, dayPicker.styles.root), dayPicker.style);
    var dataAttributes = Object.keys(initialProps)
        .filter(function (key) { return key.startsWith('data-'); })
        .reduce(function (attrs, key) {
        var _a;
        return __assign(__assign({}, attrs), (_a = {}, _a[key] = initialProps[key], _a));
    }, {});
    var MonthsComponent = (_c = (_b = initialProps.components) === null || _b === void 0 ? void 0 : _b.Months) !== null && _c !== void 0 ? _c : Months;
    return (jsxRuntimeExports.jsx("div", __assign({ className: classNames.join(' '), style: style, dir: dayPicker.dir, id: dayPicker.id, nonce: initialProps.nonce, title: initialProps.title, lang: initialProps.lang }, dataAttributes, { children: jsxRuntimeExports.jsx(MonthsComponent, { children: navigation.displayMonths.map(function (month, i) { return (jsxRuntimeExports.jsx(Month, { displayIndex: i, displayMonth: month }, i)); }) }) })));
}

/** Provide the value for all the context providers. */
function RootProvider(props) {
    var children = props.children, initialProps = __rest(props, ["children"]);
    return (jsxRuntimeExports.jsx(DayPickerProvider, __assign({ initialProps: initialProps }, { children: jsxRuntimeExports.jsx(NavigationProvider, { children: jsxRuntimeExports.jsx(SelectSingleProvider, __assign({ initialProps: initialProps }, { children: jsxRuntimeExports.jsx(SelectMultipleProvider, __assign({ initialProps: initialProps }, { children: jsxRuntimeExports.jsx(SelectRangeProvider, __assign({ initialProps: initialProps }, { children: jsxRuntimeExports.jsx(ModifiersProvider, { children: jsxRuntimeExports.jsx(FocusProvider, { children: children }) }) })) })) })) }) })));
}

/**
 * DayPicker render a date picker component to let users pick dates from a
 * calendar. See http://react-day-picker.js.org for updated documentation and
 * examples.
 *
 * ### Customization
 *
 * DayPicker offers different customization props. For example,
 *
 * - show multiple months using `numberOfMonths`
 * - display a dropdown to navigate the months via `captionLayout`
 * - display the week numbers with `showWeekNumbers`
 * - disable or hide days with `disabled` or `hidden`
 *
 * ### Controlling the months
 *
 * Change the initially displayed month using the `defaultMonth` prop. The
 * displayed months are controlled by DayPicker and stored in its internal
 * state. To control the months yourself, use `month` instead of `defaultMonth`
 * and use the `onMonthChange` event to set it.
 *
 * To limit the months the user can navigate to, use
 * `fromDate`/`fromMonth`/`fromYear` or `toDate`/`toMonth`/`toYear`.
 *
 * ### Selection modes
 *
 * DayPicker supports different selection mode that can be toggled using the
 * `mode` prop:
 *
 * - `mode="single"`: only one day can be selected. Use `required` to make the
 *   selection required. Use the `onSelect` event handler to get the selected
 *   days.
 * - `mode="multiple"`: users can select one or more days. Limit the amount of
 *   days that can be selected with the `min` or the `max` props.
 * - `mode="range"`: users can select a range of days. Limit the amount of days
 *   in the range with the `min` or the `max` props.
 * - `mode="default"` (default): the built-in selections are disabled. Implement
 *   your own selection mode with `onDayClick`.
 *
 * The selection modes should cover the most common use cases. In case you
 * need a more refined way of selecting days, use `mode="default"`. Use the
 * `selected` props and add the day event handlers to add/remove days from the
 * selection.
 *
 * ### Modifiers
 *
 * A _modifier_ represents different styles or states for the days displayed in
 * the calendar (like "selected" or "disabled"). Define custom modifiers using
 * the `modifiers` prop.
 *
 * ### Formatters and custom component
 *
 * You can customize how the content is displayed in the date picker by using
 * either the formatters or replacing the internal components.
 *
 * For the most common cases you want to use the `formatters` prop to change how
 * the content is formatted in the calendar. Use the `components` prop to
 * replace the internal components, like the navigation icons.
 *
 * ### Styling
 *
 * DayPicker comes with a default, basic style in `react-day-picker/style` – use
 * it as template for your own style.
 *
 * If you are using CSS modules, pass the imported styles object the
 * `classNames` props.
 *
 * You can also style the elements via inline styles using the `styles` prop.
 *
 * ### Form fields
 *
 * If you need to bind the date picker to a form field, you can use the
 * `useInput` hooks for a basic behavior. See the `useInput` source as an
 * example to bind the date picker with form fields.
 *
 * ### Localization
 *
 * To localize DayPicker, import the locale from `date-fns` package and use the
 * `locale` prop.
 *
 * For example, to use Spanish locale:
 *
 * ```
 * import { es } from 'date-fns/locale';
 * <DayPicker locale={es} />
 * ```
 */
function DayPicker(props) {
    return (jsxRuntimeExports.jsx(RootProvider, __assign({}, props, { children: jsxRuntimeExports.jsx(Root, { initialProps: props }) })));
}

/** @private */
function isValidDate(day) {
    return !isNaN(day.getTime());
}

/** Return props and setters for binding an input field to DayPicker. */
function useInput(options) {
    if (options === void 0) { options = {}; }
    var _a = options.locale, locale = _a === void 0 ? enUS : _a, required = options.required, _b = options.format, format$1 = _b === void 0 ? 'PP' : _b, defaultSelected = options.defaultSelected, _c = options.today, today = _c === void 0 ? new Date() : _c;
    var _d = parseFromToProps(options), fromDate = _d.fromDate, toDate = _d.toDate;
    // Shortcut to the DateFns functions
    var parseValue = function (value) { return parse(value, format$1, today, { locale: locale }); };
    // Initialize states
    var _e = useState(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today), month = _e[0], setMonth = _e[1];
    var _f = useState(defaultSelected), selectedDay = _f[0], setSelectedDay = _f[1];
    var defaultInputValue = defaultSelected
        ? format(defaultSelected, format$1, { locale: locale })
        : '';
    var _g = useState(defaultInputValue), inputValue = _g[0], setInputValue = _g[1];
    var reset = function () {
        setSelectedDay(defaultSelected);
        setMonth(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today);
        setInputValue(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : '');
    };
    var setSelected = function (date) {
        setSelectedDay(date);
        setMonth(date !== null && date !== void 0 ? date : today);
        setInputValue(date ? format(date, format$1, { locale: locale }) : '');
    };
    var handleDayClick = function (day, _a) {
        var selected = _a.selected;
        if (!required && selected) {
            setSelectedDay(undefined);
            setInputValue('');
            return;
        }
        setSelectedDay(day);
        setInputValue(day ? format(day, format$1, { locale: locale }) : '');
    };
    var handleMonthChange = function (month) {
        setMonth(month);
    };
    // When changing the input field, save its value in state and check if the
    // string is a valid date. If it is a valid day, set it as selected and update
    // the calendar’s month.
    var handleChange = function (e) {
        setInputValue(e.target.value);
        var day = parseValue(e.target.value);
        var isBefore = fromDate && differenceInCalendarDays(fromDate, day) > 0;
        var isAfter = toDate && differenceInCalendarDays(day, toDate) > 0;
        if (!isValidDate(day) || isBefore || isAfter) {
            setSelectedDay(undefined);
            return;
        }
        setSelectedDay(day);
        setMonth(day);
    };
    // Special case for _required_ fields: on blur, if the value of the input is not
    // a valid date, reset the calendar and the input value.
    var handleBlur = function (e) {
        var day = parseValue(e.target.value);
        if (!isValidDate(day)) {
            reset();
        }
    };
    // When focusing, make sure DayPicker visualizes the month of the date in the
    // input field.
    var handleFocus = function (e) {
        if (!e.target.value) {
            reset();
            return;
        }
        var day = parseValue(e.target.value);
        if (isValidDate(day)) {
            setMonth(day);
        }
    };
    var dayPickerProps = {
        month: month,
        onDayClick: handleDayClick,
        onMonthChange: handleMonthChange,
        selected: selectedDay,
        locale: locale,
        fromDate: fromDate,
        toDate: toDate,
        today: today
    };
    var inputProps = {
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        value: inputValue,
        placeholder: format(new Date(), format$1, { locale: locale })
    };
    return { dayPickerProps: dayPickerProps, inputProps: inputProps, reset: reset, setSelected: setSelected };
}

/** Returns true when the props are of type {@link DayPickerDefaultProps}. */
function isDayPickerDefault(props) {
    return props.mode === undefined || props.mode === 'default';
}


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-datepicker/lib/useDeprecatedWarning.js


const useDeprecatedWarning = (message, dependencies) => {
  react.useEffect(() => {
    const shouldWarn = filter_default()(dependencies).call(dependencies, i => i).length > 0;
    if (shouldWarn)  false ? 0 : void 0;
  }, dependencies);
};
/* harmony default export */ var lib_useDeprecatedWarning = (useDeprecatedWarning);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(54452);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-datepicker/lib/css/styles.css
var css_styles = __webpack_require__(29744);
var css_styles_default = /*#__PURE__*/__webpack_require__.n(css_styles);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-datepicker/lib/components/CustomDay/index.js







// Custom day with improved accessibility
// See original: https://github.com/gpbl/react-day-picker/blob/master/packages/react-day-picker/src/components/Day/Day.tsx
const CustomDay = _ref => {
  let {
    date,
    displayMonth
  } = _ref;
  const buttonRef = react.useRef(null);
  const dayRender = useDayRender(date, displayMonth, buttonRef);
  const ariaLabel = (0,esm_format/* default */.Z)(date, 'EEEE MMMM do, yyyy');
  if (dayRender.isHidden) {
    return /*#__PURE__*/react.createElement("div", {
      role: "gridcell"
    });
  }
  if (!dayRender.isButton) {
    return /*#__PURE__*/react.createElement("div", dayRender.divProps);
  }
  const fixedButtonProps = omit_default()(dayRender.buttonProps, ['role', 'aria-selected']);
  const isSelected = dayRender.buttonProps['aria-selected'];
  return /*#__PURE__*/react.createElement("div", {
    role: "gridcell",
    "aria-selected": isSelected,
    "aria-current": isSameDay(date, new Date()) ? 'date' : undefined,
    className: (css_styles_default())["grid-cell"]
  }, /*#__PURE__*/react.createElement(Button, (0,esm_extends["default"])({
    name: "day",
    ref: buttonRef,
    "aria-label": ariaLabel,
    "aria-pressed": isSelected || false
  }, fixedButtonProps)));
};
/* harmony default export */ var components_CustomDay = (CustomDay);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-datepicker/lib/css/daypicker-styles.css
var daypicker_styles = __webpack_require__(70067);
var daypicker_styles_default = /*#__PURE__*/__webpack_require__.n(daypicker_styles);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-datepicker/lib/css/daypicker-overrides.css
var daypicker_overrides = __webpack_require__(71644);
var daypicker_overrides_default = /*#__PURE__*/__webpack_require__.n(daypicker_overrides);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-datepicker/lib/components/DatePicker/index.js











const DatePicker_IconRight = () => /*#__PURE__*/react.createElement(Icon/* default */.Z, {
  size: "md",
  name: "caret_right"
});
const DatePicker_IconLeft = () => /*#__PURE__*/react.createElement(Icon/* default */.Z, {
  size: "md",
  name: "caret_left"
});
const DatePicker = _ref => {
  let {
    daypickerClasses: daypickerClassesProp,
    classes: classesProp,
    numberOfMonths = 1,
    pagedNavigation = numberOfMonths > 1,
    fromYear = new Date().getFullYear() - 5,
    toYear = new Date().getFullYear() + 10,
    // Deprecated
    date,
    onDateChange,
    selected,
    onSelect,
    // Deprecated - End

    value,
    onChange,
    ...props
  } = _ref;
  const dayPickerClasses = (0,lib.useClasses)((daypicker_styles_default()), (0,lib.compose)((daypicker_overrides_default())), daypickerClassesProp);
  const classes = (0,lib.useClasses)((css_styles_default()), classesProp);
  const idNamespace = (0,react_unique_id_lib/* useUniqueID */.h)();
  const today = new Date();
  lib_useDeprecatedWarning('`date`, `onDateChange`, `selected`, and `onSelect` are deprecated. Use `value` and `onChange`', [date, onDateChange, selected, onSelect]);
  const valueToUse =
  // eslint-disable-next-line no-nested-ternary
  typeof value === 'undefined' ? typeof selected === 'undefined' ? date : selected : value;
  return /*#__PURE__*/react.createElement("div", {
    className: classes['picker-container']
  }, /*#__PURE__*/react.createElement(DayPicker, (0,esm_extends["default"])({
    showOutsideDays: true,
    fixedWeeks: true,
    mode: "single",
    captionLayout: "dropdown",
    fromYear: fromYear,
    toYear: toYear,
    numberOfMonths: numberOfMonths,
    pagedNavigation: pagedNavigation,
    defaultMonth: today,
    id: idNamespace,
    selected: valueToUse,
    onSelect: (dateState, selectedDay, activeModifiers, evt) => {
      if (typeof onDateChange === 'function') {
        onDateChange(dateState, selectedDay, activeModifiers, evt);
      }
      if (typeof onSelect === 'function') {
        onSelect(dateState, selectedDay, activeModifiers, evt);
      }
      if (typeof onChange === 'function') {
        // This is to resemble the upcoming union custom events API and begin moving people towards
        // using `evt.detail.value`
        onChange({
          detail: {
            value: dateState,
            selectedDay,
            activeModifiers
          },
          parentEvent: evt
        });
      }
    }
  }, props, {
    classNames: dayPickerClasses,
    components: {
      IconLeft: DatePicker_IconLeft,
      IconRight: DatePicker_IconRight,
      Day: components_CustomDay
    }
  })));
};
/* harmony default export */ var components_DatePicker = (DatePicker);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-overlay/lib/css/index.css
var css = __webpack_require__(8678);
var css_default = /*#__PURE__*/__webpack_require__.n(css);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-overlay/lib/index.js





const Overlay = _ref => {
  let {
    as: ComponentToRender,
    children,
    color,
    className,
    fixedToRelative,
    enabled,
    visible,
    animation,
    ...props
  } = _ref;
  const positionClass = fixedToRelative ? (css_default())["fixed-to-relative"] : (css_default())["fixed-to-page"];
  return /*#__PURE__*/react.createElement(ComponentToRender, (0,esm_extends["default"])({
    className: classnames_default()((css_default()).overlay, (css_default())[`color-${color}`], positionClass, className, {
      [(css_default())["not-enabled"]]: !enabled,
      [(css_default())["not-visible"]]: !visible,
      [(css_default()).animated]: animation
    })
  }, props), children);
};
 false ? 0 : void 0;
Overlay.defaultProps = {
  as: 'aside',
  color: 'dark',
  className: '',
  fixedToRelative: false,
  enabled: true,
  visible: true,
  animation: true
};
/* harmony default export */ var tk_component_overlay_lib = (Overlay);
// EXTERNAL MODULE: ./node_modules/@xo-union/react-polymorphic/lib/index.js
var react_polymorphic_lib = __webpack_require__(45173);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/ui-accessibility/lib/ScreenReaderOnly/styles.css
var ScreenReaderOnly_styles = __webpack_require__(24065);
var ScreenReaderOnly_styles_default = /*#__PURE__*/__webpack_require__.n(ScreenReaderOnly_styles);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/ui-accessibility/lib/ScreenReaderOnly/index.js







/**
 * Wrap content that should only be visible to screen readers.
 *
 * ref is forwarded to underlying element
 *
 *
 * ### When to use `ScreenReaderOnly` instead of `aria-label`
 *
 * Use this component when the screen-reader content is a superset of the visual content or in
 * cases where the existing HTML is complex (hierarchically) but is mostly correct when read out
 * loud by a screen-reader -- In this case `ScreenReaderOnly` should only enhance the information
 * that is already present in the DOM. In this scenario `ScreenReaderOnly` will also help you avoid
 * duplication of HTML text (that may be rendered in separate HTML nodes) on `aria-label`
 * properties.
 *
 */
const ScreenReaderOnly = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    as,
    className,
    ...props
  } = _ref;
  const ComponentToRender = (0,react_polymorphic_lib/* useAsProp */.R)(as);
  return /*#__PURE__*/react.createElement(ComponentToRender, (0,esm_extends["default"])({
    ref: ref,
    className: classnames_default()((ScreenReaderOnly_styles_default())["sr-only"], className)
  }, props));
});
 false ? 0 : void 0;
ScreenReaderOnly.defaultProps = {
  as: 'span'
};
/* harmony default export */ var lib_ScreenReaderOnly = (ScreenReaderOnly);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/set.js
var core_js_set = __webpack_require__(39015);
var set_default = /*#__PURE__*/__webpack_require__.n(core_js_set);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/ui-accessibility/lib/utils/useSet.js


const useSet_useSet = setInit => {
  const [currentSet, updateSet] = react.useState(new (set_default())(setInit));
  const actions = react.useMemo(() => ({
    add: element => {
      updateSet(set => {
        const newSet = new (set_default())(set);
        newSet.add(element);
        return newSet;
      });
    },
    delete: element => {
      updateSet(set => {
        const newSet = new (set_default())(set);
        newSet.delete(element);
        return newSet;
      });
    }
  }), []);
  return [currentSet, actions];
};
/* harmony default export */ var utils_useSet = (useSet_useSet);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/ui-accessibility/lib/DialogHeading/index.js






const DialogHeadingContext = /*#__PURE__*/react.createContext({
  add: (noop_default()),
  delete: (noop_default())
});
const DialogHeadingDescribeIDsProvider = _ref => {
  let {
    children
  } = _ref;
  const [headingIDsSet, headingIDsSetActions] = utils_useSet();
  const describeIDs = headingIDsSet.size === 0 ? undefined : [...headingIDsSet].join(' ');
  return /*#__PURE__*/react.createElement(DialogHeadingContext.Provider, {
    value: headingIDsSetActions
  }, children(describeIDs));
};
 false ? 0 : void 0;

/**
 * Render a header that will be automatically associated via `aria-labelledby` with parent ModalContainer
 *
 * Passes ref to underlying element
 */
const DialogHeading = /*#__PURE__*/react.forwardRef((_ref2, ref) => {
  let {
    as: Type,
    active,
    id: idProp,
    ...props
  } = _ref2;
  const id = (0,react_unique_id_lib/* useUniqueID */.h)(idProp);
  const headerIDsSetActions = react.useContext(DialogHeadingContext);
  react.useEffect(() => {
    if (active) {
      headerIDsSetActions.add(id);
    } else {
      headerIDsSetActions.delete(id);
    }
    return () => headerIDsSetActions.delete(id);
  }, [active, id, headerIDsSetActions]);
  return /*#__PURE__*/react.createElement(Type, (0,esm_extends["default"])({
    ref: ref,
    id: id
  }, props));
});
DialogHeading.defaultProps = {
  as: 'h1',
  active: true
};
 false ? 0 : void 0;
DialogHeading.displayName = 'DialogHeading';

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(35964);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(61820);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/ui-accessibility/lib/ModalPortal/index.js




const ModalPortalRefContext = /*#__PURE__*/react.createContext();
const ModalPortalProvider = _ref => {
  let {
    children
  } = _ref;
  const ref = useRefForContext();
  return /*#__PURE__*/React.createElement(ModalPortalRefContext.Provider, {
    value: ref
  }, children(ref));
};
 false ? 0 : void 0;

/**
 * Renders its children inside of the modal container created by `LayoutRoot`
 */
const ModalPortal = _ref2 => {
  let {
    children
  } = _ref2;
  const ref = react.useContext(ModalPortalRefContext);

  // If layout is not preset, just render modal
  if (!ref) {
    return children;
  }

  // Layout is present but portal container hasn't mounted yet
  if (!ref.current) {
    return null;
  }
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react_dom.createPortal(children, ref.current));
};
ModalPortal.propTypes = {
  children: (prop_types_default()).node
};

// EXTERNAL MODULE: ./node_modules/react-focus-lock/dist/es2015/index.js + 29 modules
var es2015 = __webpack_require__(72444);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/ui-accessibility/lib/ModalRegister/index.js




const ModalRegisterContext = /*#__PURE__*/react.createContext({
  add: (noop_default()),
  delete: (noop_default())
});
const useModalRegisterEffect = enabled => {
  const self = react.useRef();
  const modalRegisterSet = react.useContext(ModalRegisterContext);
  react.useEffect(() => {
    if (enabled) {
      modalRegisterSet.add(self);
    } else {
      modalRegisterSet.delete(self);
    }
    return () => modalRegisterSet.delete(self);
  }, [enabled, modalRegisterSet]);
};
const ModalRegisterProvider = _ref => {
  let {
    children
  } = _ref;
  const [modalsRegisteredSet, registerActions] = useSet();
  const anyModalsAreOpen = modalsRegisteredSet.size > 0;
  return /*#__PURE__*/React.createElement(ModalRegisterContext.Provider, {
    value: registerActions
  }, children(anyModalsAreOpen));
};
 false ? 0 : void 0;

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/global-this.js
var global_this = __webpack_require__(26111);
var global_this_default = /*#__PURE__*/__webpack_require__.n(global_this);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/symbol/for.js
var symbol_for = __webpack_require__(57621);
var for_default = /*#__PURE__*/__webpack_require__.n(symbol_for);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/array/is-array.js
var is_array = __webpack_require__(49658);
var is_array_default = /*#__PURE__*/__webpack_require__.n(is_array);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/some.js
var some = __webpack_require__(80945);
var some_default = /*#__PURE__*/__webpack_require__.n(some);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/ui-accessibility/lib/useModalEffects/styles.css
var useModalEffects_styles = __webpack_require__(33946);
var useModalEffects_styles_default = /*#__PURE__*/__webpack_require__.n(useModalEffects_styles);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/ui-accessibility/lib/useModalEffects/index.js









const toClassList = classesString => classesString.split(/\s+/);

// When globalThis is used with array access Babel does not insert the polyfill.
// This alias is defined as a workaround.
const globalAlias = (global_this_default());
const $noScrollMountCount = for_default()('@xo-union/ui-accessibility/no-scroll-mounts');
globalAlias[$noScrollMountCount] = globalAlias[$noScrollMountCount] || 0;

// Render refs are useful to keep a reference to the latest rendered value
// Without causing a re-render of hooks that depend on the latest value (Such as effects)
const useRenderRef = value => {
  const ref = react.useRef(value);
  ref.current = value;
  return ref;
};
const useNoScrollEffect = function () {
  let {
    classes: classesProp,
    enabled = true
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const classes = (0,lib.useClasses)((useModalEffects_styles_default()), classesProp);
  const noScrollClassRef = useRenderRef(classes['no-scroll']);
  const enabledRef = useRenderRef(enabled);
  react.useEffect(() => {
    if (!enabled) {
      globalAlias[$noScrollMountCount] += 1;
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  react.useEffect(() => {
    const noScrollClass = noScrollClassRef.current;
    const handleClasses = () => {
      if (globalAlias[$noScrollMountCount] > 0) {
        document.body.classList.add(...toClassList(noScrollClass));
      } else if (globalAlias[$noScrollMountCount] === 0) {
        document.body.classList.remove(...toClassList(noScrollClass));
      } else {
        throw new Error('No scroll counter should never be less than 0');
      }
    };
    if (enabled) {
      globalAlias[$noScrollMountCount] += 1;
    } else {
      globalAlias[$noScrollMountCount] -= 1;
    }
    handleClasses();
    return () => {
      // Latest ref value is needed in cleanup
      // eslint-disable-next-line react-hooks/exhaustive-deps
      const latestEnabledValue = enabledRef.current;
      if (enabled && latestEnabledValue) {
        // If unmounting without becoming disabled
        globalAlias[$noScrollMountCount] -= 1;
      }
      handleClasses();
    };
  }, [enabled, enabledRef, noScrollClassRef]);
};
const useGlobalKeyboardEscapeEffect = _ref => {
  let {
    enabled = true,
    onEscapeKey
  } = _ref;
  react.useEffect(() => {
    const handleKeyDown = event => {
      if (event.key !== 'Escape') return;
      onEscapeKey(event);
    };
    const setup = () => {
      document.addEventListener('keydown', handleKeyDown);
    };
    const teardown = () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
    if (enabled) {
      setup();
    } else {
      teardown();
    }
    return teardown;
  }, [enabled, onEscapeKey]);
};
const useOutsideClickEffect = (_ref2, targetRefOrRefs) => {
  let {
    enabled = true,
    onClickOutside
  } = _ref2;
  react.useEffect(() => {
    const validRefsFilter = targetRef => !!(targetRef !== null && targetRef !== void 0 && targetRef.current);
    const handleClick = event => {
      var _context;
      const normalizedRefs = is_array_default()(targetRefOrRefs) ? targetRefOrRefs : [targetRefOrRefs];
      if (some_default()(_context = filter_default()(normalizedRefs).call(normalizedRefs, validRefsFilter)).call(_context, targetRef => targetRef.current.contains(event.target))) {
        return;
      }
      onClickOutside(event);
    };
    const setup = () => {
      document.addEventListener('click', handleClick, {
        capture: true
      });
    };
    const teardown = () => {
      document.removeEventListener('click', handleClick, {
        capture: true
      });
    };
    if (enabled) {
      setup();
    } else {
      teardown();
    }
    return teardown;
  }, [enabled, onClickOutside, targetRefOrRefs]);
};
const useDialogEffects = (_ref3, dialogRef) => {
  let {
    onClose = (noop_default()),
    onClickOutside = (noop_default()),
    onEscapeKey = (noop_default()),
    enabled = true
  } = _ref3;
  useGlobalKeyboardEscapeEffect({
    enabled,
    onEscapeKey: react.useCallback(event => {
      onEscapeKey(event);
      onClose(event);
    }, [onClose, onEscapeKey])
  });
  useOutsideClickEffect({
    enabled,
    onClickOutside: react.useCallback(event => {
      onClickOutside(event);
      onClose(event);
    }, [onClose, onClickOutside])
  }, dialogRef);
};
const useModalEffects = (_ref4, dialogRef) => {
  let {
    onClose = (noop_default()),
    onClickOutside = (noop_default()),
    onEscapeKey = (noop_default()),
    classes,
    enabled = true
  } = _ref4;
  useNoScrollEffect({
    enabled,
    classes
  });
  useDialogEffects({
    onClickOutside,
    onClose,
    onEscapeKey,
    enabled
  }, dialogRef);
};
/* harmony default export */ var lib_useModalEffects = (useModalEffects);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/ui-accessibility/lib/ModalContainer/index.js










/**
 * A simple wrapper with some basic accessibility features for modals.
 *
 * ### Features
 *
 * 1. Disable scroll on document body
 * 2. Lock focus
 * 3. Keyboard accessibility (Closing on pressing ESC)
 * 4. Outside click handling
 * 5. Label association with nested `DialogHeading` elements
 */
const ModalContainer = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    as: Type,
    classes,
    enabled,
    onClose,
    onClickOutside,
    onEscapeKey,
    initialFocusRef,
    children,
    autoFocus,
    focusLockProps,
    ...props
  } = _ref;
  const dialogRef = react.useRef();
  react.useImperativeHandle(ref, () => dialogRef.current);
  const activateFocusLock = react.useCallback(() => {
    var _initialFocusRef$curr;
    return initialFocusRef === null || initialFocusRef === void 0 ? void 0 : (_initialFocusRef$curr = initialFocusRef.current) === null || _initialFocusRef$curr === void 0 ? void 0 : _initialFocusRef$curr.focus();
  }, [initialFocusRef]);
  lib_useModalEffects({
    onClose,
    onClickOutside,
    onEscapeKey,
    enabled,
    classes
  }, dialogRef);
  useModalRegisterEffect(enabled);
  const ariaProps = enabled ? {
    role: 'dialog',
    'aria-modal': 'true'
  } : {
    role: 'none',
    'aria-hidden': 'true'
  };
  return /*#__PURE__*/react.createElement(es2015/* default */.ZP, (0,esm_extends["default"])({
    disabled: !enabled,
    autoFocus: initialFocusRef ? false : autoFocus,
    onActivation: initialFocusRef && activateFocusLock,
    returnFocus: true
  }, focusLockProps), /*#__PURE__*/react.createElement(DialogHeadingDescribeIDsProvider, null, headerDescribeIDs => /*#__PURE__*/react.createElement(Type, (0,esm_extends["default"])({}, ariaProps, {
    ref: dialogRef,
    "aria-labelledby": headerDescribeIDs
  }, props), children)));
});
ModalContainer.defaultProps = {
  autoFocus: true,
  enabled: true,
  as: 'div',
  onClose: (noop_default()),
  onClickOutside: (noop_default()),
  onEscapeKey: (noop_default())
};
 false ? 0 : void 0;
ModalContainer.displayName = 'ModalContainer';
/* harmony default export */ var lib_ModalContainer = (ModalContainer);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/ui-accessibility/lib/DialogContainer/index.js








/**
 * A simple wrapper with some basic accessibility features for dialogs.
 *
 * ### Features
 *
 * 2. Lock focus
 * 3. Keyboard accessibility (Closing on pressing ESC)
 * 4. Outside click handling
 * 5. Label association with nested `DialogHeading` elements
 */
const DialogContainer = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    as: Type,
    classes,
    enabled,
    onClose,
    onClickOutside,
    onEscapeKey,
    initialFocusRef,
    children,
    autoFocus,
    ...props
  } = _ref;
  const dialogRef = react.useRef();
  react.useImperativeHandle(ref, () => dialogRef.current);
  useDialogEffects({
    onClose,
    onClickOutside,
    onEscapeKey,
    enabled,
    classes
  }, dialogRef);
  const ariaProps = enabled ? {
    role: 'dialog'
  } : {
    role: 'none',
    'aria-hidden': 'true'
  };
  react.useEffect(() => {
    if (enabled) {
      var _initialFocusRef$curr;
      initialFocusRef === null || initialFocusRef === void 0 ? void 0 : (_initialFocusRef$curr = initialFocusRef.current) === null || _initialFocusRef$curr === void 0 ? void 0 : _initialFocusRef$curr.focus();
    }
  }, [enabled, initialFocusRef]);
  return /*#__PURE__*/react.createElement(DialogHeadingDescribeIDsProvider, null, headerDescribeIDs => /*#__PURE__*/react.createElement(Type, (0,esm_extends["default"])({}, ariaProps, {
    ref: dialogRef,
    "aria-labelledby": headerDescribeIDs
  }, props), children));
});
DialogContainer.defaultProps = {
  autoFocus: true,
  enabled: true,
  as: 'div',
  onClose: (noop_default()),
  onClickOutside: (noop_default()),
  onEscapeKey: (noop_default())
};
 false ? 0 : void 0;
DialogContainer.displayName = 'ModalContainer';
/* harmony default export */ var lib_DialogContainer = (DialogContainer);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-breakpoints/lib/useMedia.js
var useMedia = __webpack_require__(80427);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-datepicker/lib/useIsModalBreakpoint.js

const useIsModalBreakpoint = () => (0,useMedia/* useMediaScreenMax */.li)('xs').yes;
/* harmony default export */ var lib_useIsModalBreakpoint = (useIsModalBreakpoint);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-datepicker/lib/components/DropdownContainer/index.js







const ScreenReaderDescription = () => /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(lib_ScreenReaderOnly, {
  as: DialogHeading,
  role: "heading",
  "aria-level": "1"
}, "Date picker."), /*#__PURE__*/react.createElement(lib_ScreenReaderOnly, {
  as: "span"
}, "Date picker."));
const MobileOnlyModal = _ref => {
  let {
    id,
    isOpen,
    children,
    onClose,
    initialFocusRef
  } = _ref;
  const isModal = lib_useIsModalBreakpoint();
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ModalPortal, null, /*#__PURE__*/react.createElement(tk_component_overlay_lib, {
    enabled: isModal && isOpen,
    animation: false
  }, /*#__PURE__*/react.createElement(lib_ModalContainer, {
    id: isModal ? id : undefined,
    enabled: isModal && isOpen,
    onClose: onClose,
    initialFocusRef: initialFocusRef
  }, isModal && /*#__PURE__*/react.createElement(ScreenReaderDescription, null), isModal ? children(true) : null))), /*#__PURE__*/react.createElement(react.Fragment, null, isModal ? null : children(false)));
};
const DropdownContainer = /*#__PURE__*/react.forwardRef((_ref2, ref) => {
  let {
    id,
    isOpen = true,
    classes: classesProp,
    numberOfMonths = 1,
    children,
    onClose,
    onBlur,
    initialFocusRef
  } = _ref2;
  const classes = (0,lib.useClasses)((css_styles_default()), classesProp);
  const style = {
    '--tkww-union-datepicker-number-of-months': numberOfMonths
  };
  return /*#__PURE__*/react.createElement(MobileOnlyModal, {
    id: id,
    initialFocusRef: initialFocusRef,
    onClose: onClose,
    isOpen: isOpen
  }, isModal => /*#__PURE__*/react.createElement(lib_DialogContainer, {
    id: isModal ? undefined : id,
    initialFocusRef: initialFocusRef,
    onClose: onClose,
    enabled: isOpen && !isModal,
    ref: ref,
    style: style,
    onBlur: onBlur,
    className: classnames_default()(classes['relative-container'], isOpen ? classes['is-open'] : classes['is-closed']),
    "aria-hidden": isOpen ? undefined : 'true'
  }, /*#__PURE__*/react.createElement("div", {
    className: classes['dropdown-container']
  }, !isModal && /*#__PURE__*/react.createElement(ScreenReaderDescription, null), children)));
});
/* harmony default export */ var components_DropdownContainer = (DropdownContainer);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-datepicker/lib/components/DatePickerDropdown/index.js











const formatSelected = (selected, formatString, locale) => {
  if (!selected) return '';
  return (0,esm_format/* default */.Z)(selected, formatString, locale);
};
const DatePickerDropdown = _ref => {
  let {
    id,
    block = true,
    dateFormat = 'yyyy-MM-dd',
    date,
    onDateChange,
    selected,
    onSelect,
    value,
    onChange,
    renderInput,
    classes: classesProp,
    locale,
    ...rest
  } = _ref;
  const classes = (0,lib.useClasses)((css_styles_default()), classesProp);
  const [isOpen, setOpen] = react.useState(false);
  const isModal = lib_useIsModalBreakpoint();
  const valueToUse =
  // eslint-disable-next-line no-nested-ternary
  typeof value === 'undefined' ? typeof selected === 'undefined' ? date : selected : value;
  const dateString = formatSelected(valueToUse, dateFormat, locale);
  const containerRef = react.useRef();
  const inputRef = react.useRef();
  const closeButtonRef = react.useRef();
  const close = react.useCallback(() => {
    setOpen(false);
  }, []);
  const open = react.useCallback(() => {
    setOpen(true);
  }, []);
  const toggle = react.useCallback(() => {
    setOpen(v => !v);
  }, []);
  const handleKey = react.useCallback(evt => {
    if (evt.code === 'Space' || evt.key === ' ') {
      toggle();
      evt.preventDefault();
    }
    if (evt.key === 'Escape') {
      close();
      evt.preventDefault();
    }
  }, [toggle, close]);
  const handleChange = react.useCallback(evt => {
    if (typeof onChange === 'function') onChange(evt);
    close();
  }, [onChange, close]);
  const handleContainerBlur = react.useCallback(evt => {
    const focusLeftContainer = !containerRef.current.contains(evt.relatedTarget);
    if (!isModal && evt.relatedTarget && focusLeftContainer) {
      close();
    }
  }, [isModal, close]);
  const datepickerId = (0,react_unique_id_lib/* useUniqueID */.h)(id);
  const dialogId = `${datepickerId}-dialog`;
  react.useEffect(() => {
    if (!isOpen && containerRef.current.contains(document.activeElement)) {
      inputRef.current.focus();
    }
  }, [isOpen]);
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(classes['parent-container'], {
      [classes['is-block']]: block,
      [classes['is-inline']]: !block
    })
  }, renderInput({
    ref: inputRef,
    readOnly: true,
    onClick: open,
    onKeyDown: handleKey,
    value: dateString,
    role: 'button',
    type: 'button',
    'aria-haspopup': 'dialog',
    'aria-expanded': isOpen,
    'aria-controls': `${datepickerId}-dialog`
  }), /*#__PURE__*/react.createElement(components_DropdownContainer, {
    id: dialogId,
    ref: containerRef,
    initialFocusRef: closeButtonRef,
    isOpen: isOpen,
    classes: classes,
    numberOfMonths: 1,
    onClose: close,
    onBlur: handleContainerBlur
  }, /*#__PURE__*/react.createElement("div", {
    className: classes['close-button-container']
  }, /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
    ref: closeButtonRef,
    "aria-label": "close",
    className: classes['close-button'],
    onClick: close,
    name: "close",
    size: "md"
  })), /*#__PURE__*/react.createElement(components_DatePicker, (0,esm_extends["default"])({
    id: datepickerId,
    numberOfMonths: 1,
    classes: classes,
    date: date,
    value: value,
    selected: selected,
    onChange: handleChange,
    onDateChange: onDateChange,
    onSelect: onSelect
  }, rest))));
};
/* harmony default export */ var components_DatePickerDropdown = (DatePickerDropdown);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/DatePickerField/index.js




const DatePickerField = _ref => {
  let {
    id,
    name,
    subText,
    state,
    label,
    validations,
    onChange,
    classes,
    subTextOnInvalid,
    subTextOnValid,
    disabled,
    disabledDates,
    value,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement(components_DatePickerDropdown, (0,esm_extends["default"])({}, props, {
    value: value,
    onChange: onChange,
    block: true,
    disabled: disabledDates,
    renderInput: inputProps => /*#__PURE__*/react.createElement(components_Field, (0,esm_extends["default"])({
      id: id,
      name: name,
      subText: subText,
      state: state,
      label: label,
      classes: classes,
      validations: validations,
      subTextOnInvalid: subTextOnInvalid,
      subTextOnValid: subTextOnValid,
      disabled: disabled
    }, inputProps))
  }));
};
/* harmony default export */ var components_DatePickerField = (DatePickerField);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/Textarea/styles.css
var Textarea_styles = __webpack_require__(46140);
var Textarea_styles_default = /*#__PURE__*/__webpack_require__.n(Textarea_styles);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/Textarea/index.js













const Textarea = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    classes: classesProp,
    defaultValue,
    id: idProp,
    maxLength,
    name,
    placeholder,
    state,
    subText,
    value,
    label = upperFirst_default()(lowerCase_default()(name)),
    onChange = (noop_default()),
    ...restOfProps
  } = props;
  const classes = (0,lib.useClasses)((Textarea_styles_default()), classesProp);
  const id = (0,react_unique_id_lib/* useUniqueID */.h)(idProp);
  const isValueControlledRef = react.useRef(value !== undefined);
  let inputLength;
  let handleChange;
  if (isValueControlledRef.current) {
    inputLength = value.length;
    handleChange = onChange;
  } else {
    /* eslint-disable react-hooks/rules-of-hooks */
    const [inputLengthState, setInputLength] = react.useState((defaultValue || '').length);
    handleChange = evt => {
      setInputLength(evt.target.value.length);
      onChange(evt);
    };
    inputLength = inputLengthState;
  }
  const atInputLimit = inputLength >= maxLength;
  const classMap = {
    neutral: classes['is-neutral'],
    invalid: classes['is-invalid'],
    valid: classes['is-valid']
  };
  const validationClass = classMap[state];
  const lengthIndicatorValidationClass = atInputLimit ? classes['length-indicator-invalid'] : classes['length-indicator-valid'];
  const dataHasValue = inputLength > 0 ? '' : undefined;
  let placeholderIfNoLabel;
  let textAreaClasses = `${classes.input} ${validationClass}`;
  if (!label) {
    placeholderIfNoLabel = placeholder;
    textAreaClasses += ` ${classes.placeholder}`;
  }
  let subtextId;
  let lengthDescriptionId;
  let labelId;
  let ariaDescribedby = '';
  if (label) {
    labelId = `${id}-label`;
  }
  if (subText) {
    subtextId = `${id}-subtext`;
    ariaDescribedby += `${id}-subtext`;
  }
  if (maxLength) {
    lengthDescriptionId = `${id}-length`;
    ariaDescribedby += ` ${lengthDescriptionId}`;
  }
  return /*#__PURE__*/react.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/react.createElement("textarea", (0,esm_extends["default"])({
    ref: ref,
    className: textAreaClasses,
    "data-has-value": dataHasValue,
    defaultValue: defaultValue,
    id: id,
    name: name,
    placeholder: placeholderIfNoLabel,
    value: value,
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": labelId,
    onChange: handleChange
  }, restOfProps)), label && /*#__PURE__*/react.createElement("label", {
    className: classes.label,
    htmlFor: id,
    id: labelId
  }, label), subText && /*#__PURE__*/react.createElement(components_SubText, {
    state: state,
    className: classes['sub-text'],
    id: subtextId
  }, subText), maxLength && /*#__PURE__*/react.createElement(Caption/* default */.Z, {
    className: `${classes['length-indicator']} ${lengthIndicatorValidationClass}`,
    id: lengthDescriptionId
  }, `${inputLength}/${maxLength}`));
});
Textarea.defaultProps = {
  defaultValue: undefined,
  label: undefined,
  maxLength: undefined,
  onChange: (noop_default()),
  placeholder: undefined,
  subText: '',
  state: 'neutral',
  value: undefined
};
const Textarea_validationProp =  false ? 0 : {};
 false ? 0 : void 0;
/* harmony default export */ var components_Textarea = (WithValidations(Textarea));
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/sort.js
var sort = __webpack_require__(29591);
var sort_default = /*#__PURE__*/__webpack_require__.n(sort);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/map.js
var map = __webpack_require__(93726);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/find.js
var find = __webpack_require__(89189);
var find_default = /*#__PURE__*/__webpack_require__.n(find);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/starts-with.js
var starts_with = __webpack_require__(81277);
var starts_with_default = /*#__PURE__*/__webpack_require__.n(starts_with);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/find-index.js
var find_index = __webpack_require__(90466);
var find_index_default = /*#__PURE__*/__webpack_require__.n(find_index);
;// CONCATENATED MODULE: ./node_modules/@xo-union/util-rotate-number/lib/index.js
const rotateNumber = (currentNumber, offset, clockSize) => {
  /**
   * Make sure offset is constrained between the numbers in the clock
   * For example:
   *    Given a starting point of 0
   *    And an offset of -1
   *    And a clock size of 10
   *    Then the result should be 9
   */
  const normalizedOffset = offset % clockSize;
  const nextNumber = (clockSize + (
  // Make sure numbers are always within the first (positive) clock rotation
  currentNumber + normalizedOffset)) % clockSize;
  return nextNumber;
};
/* harmony default export */ var util_rotate_number_lib = (rotateNumber);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-select/lib/components/SelectContainer/useSelect.js









const bindDispatch = function (dispatch, actionCreator) {
  for (var _len = arguments.length, curry = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    curry[_key - 2] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }
    dispatch(actionCreator(...curry, ...params));
  };
};
const staticInitialState = {
  isOpen: false,
  lastActiveIndex: 0,
  activeIndex: 0,
  options: []
};
const actions = {
  types: {
    ROTATE_ACTIVE_INDEX: 'ROTATE_ACTIVE_INDEX',
    ACTIVATE_OPTION_MATCHING_TEXT: 'ACTIVATE_OPTION_MATCHING_TEXT',
    ADD_OPTION: 'ADD_OPTION',
    REMOVE_OPTION: 'REMOVE_OPTION',
    UPDATE_SELECTED_VALUE: 'UPDATE_SELECTED_VALUE',
    UPDATE_OPEN_VALUE: 'UPDATE_OPEN_VALUE'
  },
  rotateActiveIndex: offset => ({
    type: actions.types.ROTATE_ACTIVE_INDEX,
    payload: {
      offset
    }
  }),
  activateOptionMatchingText: text => ({
    type: actions.types.ACTIVATE_OPTION_MATCHING_TEXT,
    payload: {
      text
    }
  }),
  addOption: option => ({
    type: actions.types.ADD_OPTION,
    payload: {
      option
    }
  }),
  removeOption: optionID => ({
    type: actions.types.REMOVE_OPTION,
    payload: {
      optionID
    }
  }),
  updateSelectedValue: newValue => ({
    type: actions.types.UPDATE_SELECTED_VALUE,
    payload: {
      newValue
    }
  }),
  updateOpenValue: newValue => ({
    type: actions.types.UPDATE_OPEN_VALUE,
    payload: {
      newValue
    }
  })
};
const getWordsFromRef = ref => {
  var _ref$current, _ref$current$textCont, _ref$current$textCont2, _ref$current$textCont3;
  return ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : (_ref$current$textCont = _ref$current.textContent) === null || _ref$current$textCont === void 0 ? void 0 : (_ref$current$textCont2 = _ref$current$textCont.toLowerCase()) === null || _ref$current$textCont2 === void 0 ? void 0 : (_ref$current$textCont3 = _ref$current$textCont2.replace(/[^\w\s]+/g, '')) === null || _ref$current$textCont3 === void 0 ? void 0 : _ref$current$textCont3.split(/\s+/g)) || [];
};
const findIndexOfOptionMatchingText = (options, text, fallback) => {
  var _context;
  const optionsTextsSortedByLeastWords = sort_default()(_context = map_default()(options).call(options, (_ref, originalIndex) => {
    let {
      ref
    } = _ref;
    return {
      words: getWordsFromRef(ref),
      index: originalIndex
    };
  })).call(_context, (_ref2, _ref3) => {
    let {
      words: a
    } = _ref2;
    let {
      words: b
    } = _ref3;
    return a.length - b.length;
  });
  const result = find_default()(optionsTextsSortedByLeastWords).call(optionsTextsSortedByLeastWords, _ref4 => {
    let {
      words
    } = _ref4;
    return some_default()(words).call(words, word => starts_with_default()(word).call(word, text.toLowerCase()));
  });
  return result === undefined ? fallback : result.index;
};
const reducer = (state, action) => {
  switch (action.type) {
    case actions.types.OPEN:
      return {
        ...state,
        isOpen: true,
        lastActiveIndex: state.activeIndex
      };
    case actions.types.CLOSE:
      return {
        ...state,
        isOpen: false,
        activeIndex: state.lastActiveIndex
      };
    case actions.types.ROTATE_ACTIVE_INDEX:
      return {
        ...state,
        activeIndex: util_rotate_number_lib(state.activeIndex, action.payload.offset, state.options.length)
      };
    case actions.types.ACTIVATE_OPTION_MATCHING_TEXT:
      return {
        ...state,
        activeIndex: findIndexOfOptionMatchingText(state.options, action.payload.text, state.activeIndex)
      };
    case actions.types.ADD_OPTION:
      {
        let newActiveIndex = state.activeIndex;
        if (action.payload.option.value === state.value) {
          /*
           * If registered option has the selected value
           * adjust the active index
           * */
          newActiveIndex = state.options.length;
        }
        return {
          ...state,
          activeIndex: newActiveIndex,
          lastActiveIndex: newActiveIndex,
          options: [...state.options, action.payload.option]
        };
      }
    case actions.types.REMOVE_OPTION:
      {
        var _context2;
        const newOptions = filter_default()(_context2 = state.options).call(_context2, _ref5 => {
          let {
            id
          } = _ref5;
          return id !== action.payload.optionID;
        });
        const valueIsPresent = some_default()(newOptions).call(newOptions, option => option.value === state.value);
        return {
          ...state,
          activeIndex: valueIsPresent ? state.activeIndex : 0,
          lastActiveIndex: valueIsPresent ? state.lastActiveIndex : 0,
          options: newOptions
        };
      }
    case actions.types.UPDATE_SELECTED_VALUE:
      {
        var _context3;
        const value = action.payload.newValue;
        let newActiveIndex = find_index_default()(_context3 = state.options).call(_context3, option => value === option.value);

        /**
         * If no option matches the current value, reset the index to 0
         * */
        if (newActiveIndex === -1) {
          newActiveIndex = 0;
        }
        return {
          ...state,
          activeIndex: state.isOpen ? state.activeIndex : newActiveIndex,
          lastActiveIndex: newActiveIndex,
          value
        };
      }
    case actions.types.UPDATE_OPEN_VALUE:
      {
        const newOpenValue = action.payload.newValue;
        const nextActiveIndex = newOpenValue ? state.activeIndex : state.lastActiveIndex;
        return {
          ...state,
          isOpen: newOpenValue,
          activeIndex: nextActiveIndex,
          lastActiveIndex: nextActiveIndex
        };
      }
    default:
      {
        throw new Error(`Unxpected action type: ${action.type}`);
      }
  }
};
const useSelect = _ref6 => {
  let {
    isOpen,
    onOpen,
    onClose,
    value,
    defaultValue,
    disabled,
    onChange
  } = _ref6;
  const {
    current: isControlled
  } = react.useRef(typeof value !== 'undefined');
  const {
    current: openIsControlled
  } = react.useRef(typeof isOpen !== 'undefined');
  const initialState = {
    ...staticInitialState,
    value: (isControlled ? value : defaultValue) || ''
  };
  const [state, dispatch] = react.useReducer(reducer, initialState);
  if (value !== state.value && isControlled) {
    dispatch(actions.updateSelectedValue(value));
  }
  if (isOpen !== state.isOpen && openIsControlled) {
    dispatch(actions.updateOpenValue(isOpen));
  }
  return react.useMemo(() => {
    var _context4;
    const dispatchClose = bindDispatch(dispatch, actions.updateOpenValue, false);
    const dispatchOpen = bindDispatch(dispatch, actions.updateOpenValue, true);
    const close = () => {
      if (openIsControlled) {
        onClose();
      } else {
        dispatchClose();
      }
    };
    const open = () => {
      if (openIsControlled) {
        onOpen();
      } else {
        dispatchOpen();
      }
    };
    const toggle = () => {
      if (state.isOpen) {
        close();
      } else {
        open();
      }
    };
    const updateSelectedValue = bindDispatch(dispatch, actions.updateSelectedValue);
    const selectedOption = find_default()(_context4 = state.options).call(_context4, option => option.value === state.value);
    const emitChangeAndClose = evt => {
      onChange(evt);
      if (!isControlled) {
        updateSelectedValue(evt.target.value);
      }
      close();
    };
    return {
      disabled: !!disabled,
      onChange: emitChangeAndClose,
      options: state.options,
      value: state.value,
      isOpen: !disabled && state.isOpen,
      hasFocusedOption: !!(state.isOpen || selectedOption),
      activeOption: state.options[state.activeIndex],
      selectedOption,
      close,
      addOption: bindDispatch(dispatch, actions.addOption),
      removeOption: bindDispatch(dispatch, actions.removeOption),
      rotateActiveIndex: bindDispatch(dispatch, actions.rotateActiveIndex),
      activateOptionMatchingText: bindDispatch(dispatch, actions.activateOptionMatchingText),
      toggle,
      open,
      isControlled
    };
  }, [state, dispatch, disabled, onChange]);
};
/* harmony default export */ var SelectContainer_useSelect = (useSelect);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-select/lib/components/SelectContext/index.js

const SelectContext = /*#__PURE__*/react.createContext();
const useSelectContext = () => react.useContext(SelectContext);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/object/values.js
var values = __webpack_require__(77497);
var values_default = /*#__PURE__*/__webpack_require__.n(values);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-select/lib/components/ElementSync/index.js




const useSingleElementSync = () => {
  const [overwrittenID, setID] = react.useState(undefined);
  const fallbackID = (0,react_unique_id_lib/* useUniqueID */.h)();
  const ref = react.useRef();
  return react.useMemo(() => ({
    ref,
    id: overwrittenID === undefined ? fallbackID : overwrittenID,
    setID
  }), [fallbackID, overwrittenID]);
};
const useElementSyncInit = () => {
  const elements = {
    FocusedOption: useSingleElementSync(),
    Label: useSingleElementSync(),
    ListBox: useSingleElementSync(),
    MenuButton: useSingleElementSync(),
    NativeSelect: useSingleElementSync()
  };
  return react.useMemo(() => elements, values_default()(elements));
};
const ElementSyncContext = /*#__PURE__*/react.createContext();
const ElementSyncProvider = _ref => {
  let {
    children
  } = _ref;
  const context = useElementSyncInit();
  return /*#__PURE__*/react.createElement(ElementSyncContext.Provider, {
    value: context
  }, children);
};
 false ? 0 : void 0;
const useElementID = elementName => {
  const elements = react.useContext(ElementSyncContext);
  return elements[elementName].id;
};
const useElementRef = elementName => {
  const elements = react.useContext(ElementSyncContext);
  return elements[elementName].ref;
};
const useElementIDSync = (elementName, id) => {
  const elements = react.useContext(ElementSyncContext);
  react.useEffect(() => {
    elements[elementName].setID(id);
    return () => {
      elements[elementName].setID('');
    };
  }, [elements, elementName, id]);
  return elements[elementName].id;
};
const useElementIDAndRefSync = (elementName, id) => {
  const finalID = useElementIDSync(elementName, id);
  const ref = useElementRef(elementName);
  return [finalID, ref];
};
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-select/lib/components/SelectContainer/index.js







/**
 * Implements the state handling necessary to make a custom Select keyboard accessible.
 *
 * It additionally sets up the context necessary for all other Select and Option components
 * work.
 *
 * This component should be the parent wrapper to all custom Select components.
 *
 *
 * #### Select abstraction
 *
 * The select abstraction is accessible via a render prop or via context
 *
 * For example:
 *
 * ```jsx
 * import { SelectContainer } from '@xo-union/ui-select';
 *
 * <SelectContainer>
 *   {(select) => {
 *      // use `select` abstraction
 *   }}
 * </SelectContainer>
 * ```
 *
 * Via context (`MyComponent` must be nested inside of `SelectContainer`)
 *
 * ```jsx
 * import { useSelect } from '@xo-union/ui-select';
 *
 * const MyComponent = () => {
 *   const select = useSelect();
 *   // use `select` abstraction
 * }
 * ```
 *
 * #### Select abstraction properties
 *
 * | Property | Type | Description |
 * |----------|------|-------------|
 * | `select.disabled` | `bool` | True if the `SelectContainer` is disabled |
 * | `select.value` | `string` | Selected value. Corresponds to conotrolled or uncontrolled value  |
 * | `select.isOpen` | `bool` | Open state. Corresponds to controlled or uncontrolled isOpen value |
 * | `select.hasFocusedOption` | `bool` | Whether or not there is a a focused option (via keyboard or after selection) |
 * | `select.activeOption` | `OptionData` | Data of keyboard active option. |
 * | `select.selectedOption` | `OptionData` | Data of selected option. |
 * | `select.options` | `OptionData[]` | Data of selected option. |
 * | `select.close` | `(): void` | Trigger closing of select. |
 * | `select.open` | `(): void` | Trigger openning of select. |
 * | `select.toggle` | `(): void` | Trigger openning of select. |
 * | `select.rotateActiveIndex` | `(offset: number): void` | Offsets the active index. `rotateActiveIndex(1)` moves it one index forward. `rotateActiveIndex(-1)` moves it one index backwards. |
 * | `select.addOption` | `(option: OptionData): void` | Used internally to register options |
 * | `select.removeOption` | `(id: string): void` | Used internally to de-register options. Id corresponds to `OptionContainer` |
 *
 * ### OptionData type
 *
 * | Property | Type | Description |
 * |----------|------|-------------|
 * | `value` | `string` | Value corresponding to `OptionContainer`  |
 * | `id` | `string` | ID corresponding to `OptionContainer` |
 */
const SelectContainer = _ref => {
  let {
    defaultValue,
    value,
    onChange,
    isOpen,
    onOpen,
    onClose,
    disabled,
    children
  } = _ref;
  const select = SelectContainer_useSelect({
    isOpen,
    onOpen,
    onClose,
    defaultValue,
    value,
    onChange,
    disabled
  });
  return /*#__PURE__*/react.createElement(SelectContext.Provider, {
    value: select
  }, /*#__PURE__*/react.createElement(ElementSyncProvider, null, typeof children === 'function' ? children(select) : children));
};
 false ? 0 : void 0;
SelectContainer.defaultProps = {
  onChange: (noop_default()),
  onOpen: (noop_default()),
  onClose: (noop_default())
};
/* harmony default export */ var components_SelectContainer = (SelectContainer);
// EXTERNAL MODULE: ./node_modules/@xo-union/constant-key-codes/lib/index.js
var constant_key_codes_lib = __webpack_require__(62180);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/for-each.js
var for_each = __webpack_require__(28301);
var for_each_default = /*#__PURE__*/__webpack_require__.n(for_each);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-select/lib/components/useMergeRefs.js


const useMergeRefs = refs => react.useCallback(value => {
  for_each_default()(refs).call(refs, ref => {
    if (typeof ref === 'function') {
      ref(value);
    } else if (ref != null) {
      /* eslint-disable no-param-reassign */
      ref.current = value;
    }
  });
}, refs); // eslint-disable-line react-hooks/exhaustive-deps

/* harmony default export */ var components_useMergeRefs = (useMergeRefs);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-select/lib/components/MenuButton/index.js








const useEventHandlerProps = () => {
  const select = useSelectContext();
  return react.useMemo(() => {
    const onKeyDown = e => {
      if (e.keyCode === constant_key_codes_lib/* SPACE */.L_ || e.keyCode === constant_key_codes_lib/* RETURN */.Yl || e.keyCode === constant_key_codes_lib.UP || e.keyCode === constant_key_codes_lib/* DOWN */.WV) {
        select.open();
        e.preventDefault();
      }
      if (e.keyCode === constant_key_codes_lib/* ESC */._Q) {
        /**
         * Would prefer to use `currentTarget` but it makes testing a bit harder
         *
         * See this unresolved issue from enzyme:
         * https://github.com/airbnb/enzyme/issues/218
         */
        e.target.blur();
      }
    };
    return {
      onMouseDown: select.disabled ? (noop_default()) : select.toggle,
      onKeyDown: select.disabled ? (noop_default()) : onKeyDown
    };
  }, [select]);
};

/**
 * Renders the menu button for the custom select. This is the primary interactive component to
 * initiate usage of the Select
 */
const MenuButton = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    as: ComponentToRender,
    ...props
  } = _ref;
  const select = useSelectContext();
  const elementSyncRef = useElementRef('MenuButton');
  const labelID = useElementID('Label');
  const focusedOptionID = useElementID('FocusedOption');
  const listBoxID = useElementID('ListBox');
  const eventHandlerProps = useEventHandlerProps();
  return /*#__PURE__*/react.createElement(ComponentToRender, (0,esm_extends["default"])({
    ref: components_useMergeRefs([elementSyncRef, ref]),
    tabIndex: select.disabled ? '-1' : '0',
    disabled: select.disabled
  }, eventHandlerProps, {
    /* Aria props */
    "aria-labelledby": `${labelID} ${focusedOptionID}`,
    "aria-haspopup": "listbox",
    "aria-controls": listBoxID,
    "aria-expanded": select.isOpen,
    "aria-disabled": select.disabled
  }, props));
});
 false ? 0 : void 0;
MenuButton.defaultProps = {
  as: 'button'
};
/* harmony default export */ var components_MenuButton = (MenuButton);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-select/lib/components/FocusedOption/styles.css
var FocusedOption_styles = __webpack_require__(28448);
var FocusedOption_styles_default = /*#__PURE__*/__webpack_require__.n(FocusedOption_styles);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-select/lib/components/FocusedOption/index.js






/**
 * Renders container where the currently focused option is rendered. Requires option to render contents
 * in `OnFocusContainer` component
 **/
const FocusedOption = _ref => {
  let {
    as: ComponentToRender,
    className,
    id: idProp,
    ...props
  } = _ref;
  const [id, ref] = useElementIDAndRefSync('FocusedOption', idProp);
  return /*#__PURE__*/react.createElement(ComponentToRender, (0,esm_extends["default"])({
    ref: ref,
    className: `${(FocusedOption_styles_default()).disablePointerEvents} ${className}`,
    id: id
  }, props));
};
 false ? 0 : void 0;
FocusedOption.defaultProps = {
  as: 'span',
  className: ''
};
/* harmony default export */ var components_FocusedOption = (FocusedOption);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/set-timeout.js
var set_timeout = __webpack_require__(79021);
var set_timeout_default = /*#__PURE__*/__webpack_require__.n(set_timeout);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-select/lib/components/ListBox/index.js








const useTextBuffer = () => {
  const [textBuffer, setTextBuffer] = react.useState('');
  const timeoutRef = react.useRef();
  const addChar = char => {
    clearTimeout(timeoutRef.current);
    setTextBuffer(text => [text, char].join(''));
    timeoutRef.current = set_timeout_default()(() => {
      setTextBuffer('');
    }, 200);
  };
  return [textBuffer, addChar];
};
const ListBox_useEventHandlerProps = () => {
  const select = useSelectContext();
  const buttonRef = useElementRef('MenuButton');
  const [textBuffer, addChar] = useTextBuffer();
  const onKeyDown = e => {
    if (e.keyCode === constant_key_codes_lib/* RETURN */.Yl || e.keyCode === constant_key_codes_lib/* SPACE */.L_) {
      select.activeOption.select(e);
      set_timeout_default()(() => {
        buttonRef.current.focus();
      });
      e.preventDefault();
      return;
    }
    if (e.keyCode === constant_key_codes_lib/* DOWN */.WV) {
      select.rotateActiveIndex(1);
      e.preventDefault();
      return;
    }
    if (e.keyCode === constant_key_codes_lib.UP) {
      select.rotateActiveIndex(-1);
      e.preventDefault();
      return;
    }
    if (e.keyCode === constant_key_codes_lib/* ESC */._Q) {
      buttonRef.current.focus();

      // Prevent modals from being closed if rendered in modal
      e.nativeEvent.stopImmediatePropagation();
      return;
    }
    if (e.key.length === 1) {
      addChar(e.key);
    }
  };
  react.useEffect(() => {
    if (textBuffer.length > 0) select.activateOptionMatchingText(textBuffer);
  }, [textBuffer]);
  return {
    onKeyDown: select.disabled ? (noop_default()) : onKeyDown,
    onBlur: select.close
  };
};
const useListBoxFocusOnSelectOpen = () => {
  const select = useSelectContext();
  const ref = useElementRef('ListBox');
  react.useEffect(() => {
    const timeout = set_timeout_default()(() => {
      if (select.isOpen) {
        ref.current.focus();
      }
    });
    return () => {
      clearTimeout(timeout);
    };
  }, [select.isOpen, ref]);
};

/**
 * Renders the container for all custom options.
 *
 * Focus is added to this element when the Select is open.
 *
 * Additional props are passed to the underlying element.
 */
const ListBox = _ref => {
  var _select$activeOption;
  let {
    as: ComponentToRender,
    id: idProp,
    ...props
  } = _ref;
  const select = useSelectContext();
  const eventHandlerProps = ListBox_useEventHandlerProps();
  const activeDescendant = (_select$activeOption = select.activeOption) === null || _select$activeOption === void 0 ? void 0 : _select$activeOption.id;
  const [id, ref] = useElementIDAndRefSync('ListBox', idProp);
  useListBoxFocusOnSelectOpen();
  return /*#__PURE__*/react.createElement(ComponentToRender, (0,esm_extends["default"])({
    ref: ref,
    role: "listbox",
    id: id,
    "aria-activedescendant": activeDescendant,
    tabIndex: select.isOpen ? '0' : '-1'
  }, eventHandlerProps, props));
};
 false ? 0 : void 0;
ListBox.defaultProps = {
  as: 'ul'
};
/* harmony default export */ var components_ListBox = (ListBox);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-select/lib/components/Label/index.js





/**
 * Renders the label container for the custom Select.
 *
 * This is a simple wrapper around a span but it's ID is synced with the `MenuButton` component, which
 * makes a reference to the label via `aria-labelledby` to support screen readers
 */
const Label = _ref => {
  let {
    as: ComponentToRender,
    id: idProp,
    ...props
  } = _ref;
  const id = useElementIDSync('Label', idProp);
  return /*#__PURE__*/react.createElement(ComponentToRender, (0,esm_extends["default"])({
    id: id
  }, props));
};
 false ? 0 : void 0;
Label.defaultProps = {
  as: 'span'
};
/* harmony default export */ var components_Label = (Label);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/Select/styles.css
var Select_styles = __webpack_require__(74885);
var Select_styles_default = /*#__PURE__*/__webpack_require__.n(Select_styles);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/Select/index.js














const Select = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    // Container props
    defaultValue,
    value,
    onChange,
    onOpen,
    isOpen,
    onClose,
    disabled,
    // Other props
    name,
    label = upperFirst_default()(lowerCase_default()(name)),
    state,
    subText,
    children,
    classes: classesProp,
    id: idProp,
    onBlur,
    ...props
  } = _ref;
  const classes = (0,lib.useClasses)((Select_styles_default()), classesProp);
  const id = (0,react_unique_id_lib/* useUniqueID */.h)(idProp);
  let subTextId;
  if (subText) {
    subTextId = `${id}-subtext`;
  }
  return /*#__PURE__*/react.createElement(components_SelectContainer, {
    disabled: disabled,
    value: value,
    defaultValue: defaultValue,
    onChange: onChange,
    onOpen: onOpen,
    onClose: onClose,
    isOpen: isOpen
  }, select => {
    const iconName = select.isOpen ? 'caret_up' : 'caret_down';
    const dataHasValue = select.hasFocusedOption ? '' : undefined;
    const containerClasses = classnames_default()(classes.container, {
      [classes['is-open']]: select.isOpen,
      [classes['is-closed']]: !select.isOpen
    });
    const inputClasses = classnames_default()(classes.input, {
      [classes['is-neutral']]: state === 'neutral',
      [classes['is-invalid']]: state === 'invalid',
      [classes['is-valid']]: state === 'valid',
      [classes.disabled]: select.disabled
    });
    return /*#__PURE__*/react.createElement("div", {
      onBlur: onBlur,
      className: containerClasses
    }, /*#__PURE__*/react.createElement(components_MenuButton, (0,esm_extends["default"])({
      "aria-describedby": subTextId,
      className: inputClasses,
      "data-has-value": dataHasValue,
      type: "button"
    }, props, {
      ref: ref
    }), /*#__PURE__*/react.createElement(components_FocusedOption, null)), /*#__PURE__*/react.createElement(components_ListBox, {
      className: classes.list
    }, children), /*#__PURE__*/react.createElement(components_Label, {
      as: "div",
      className: classes.label
    }, label), /*#__PURE__*/react.createElement(Icon/* default */.Z, {
      name: iconName,
      size: "md",
      className: classes.caret
    }), /*#__PURE__*/react.createElement("input", {
      type: "hidden",
      name: name,
      value: select.value
    }), subText && /*#__PURE__*/react.createElement(components_SubText, {
      state: state,
      className: classes['sub-text'],
      id: subTextId
    }, subText));
  });
});
const Select_validationProp =  false ? 0 : {};
 false ? 0 : void 0;
Select.defaultProps = {
  state: 'neutral'
};
/* harmony default export */ var components_Select = (WithValidations(Select));
;// CONCATENATED MODULE: ./node_modules/compute-scroll-into-view/dist/index.mjs
function t(t){return"object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return(!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return!!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return!1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}var i=function(e,i){var o=window,l=i.scrollMode,d=i.block,f=i.inline,h=i.boundary,u=i.skipOverflowHiddenElements,s="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var a,c,g=document.scrollingElement||document.documentElement,p=[],m=e;t(m)&&s(m);){if((m=null==(c=(a=m).parentElement)?a.getRootNode().host||null:c)===g){p.push(m);break}null!=m&&m===document.body&&n(m)&&!n(document.documentElement)||null!=m&&n(m,u)&&p.push(m)}for(var w=o.visualViewport?o.visualViewport.width:innerWidth,v=o.visualViewport?o.visualViewport.height:innerHeight,W=window.scrollX||pageXOffset,H=window.scrollY||pageYOffset,b=e.getBoundingClientRect(),y=b.height,E=b.width,M=b.top,V=b.right,x=b.bottom,I=b.left,C="start"===d||"nearest"===d?M:"end"===d?x:M+y/2,R="center"===f?I+E/2:"end"===f?V:I,T=[],k=0;k<p.length;k++){var B=p[k],D=B.getBoundingClientRect(),O=D.height,X=D.width,Y=D.top,L=D.right,S=D.bottom,j=D.left;if("if-needed"===l&&M>=0&&I>=0&&x<=v&&V<=w&&M>=Y&&x<=S&&I>=j&&V<=L)return T;var N=getComputedStyle(B),q=parseInt(N.borderLeftWidth,10),z=parseInt(N.borderTopWidth,10),A=parseInt(N.borderRightWidth,10),F=parseInt(N.borderBottomWidth,10),G=0,J=0,K="offsetWidth"in B?B.offsetWidth-B.clientWidth-q-A:0,P="offsetHeight"in B?B.offsetHeight-B.clientHeight-z-F:0,Q="offsetWidth"in B?0===B.offsetWidth?0:X/B.offsetWidth:0,U="offsetHeight"in B?0===B.offsetHeight?0:O/B.offsetHeight:0;if(g===B)G="start"===d?C:"end"===d?C-v:"nearest"===d?r(H,H+v,v,z,F,H+C,H+C+y,y):C-v/2,J="start"===f?R:"center"===f?R-w/2:"end"===f?R-w:r(W,W+w,w,q,A,W+R,W+R+E,E),G=Math.max(0,G+H),J=Math.max(0,J+W);else{G="start"===d?C-Y-z:"end"===d?C-S+F+P:"nearest"===d?r(Y,S,O,z,F+P,C,C+y,y):C-(Y+O/2)+P/2,J="start"===f?R-j-q:"center"===f?R-(j+X/2)+K/2:"end"===f?R-L+A+K:r(j,L,X,q,A+K,R,R+E,E);var Z=B.scrollLeft,$=B.scrollTop;C+=$-(G=Math.max(0,Math.min($+G/U,B.scrollHeight-O/U+P))),R+=Z-(J=Math.max(0,Math.min(Z+J/Q,B.scrollWidth-X/Q+K)))}T.push({el:B,top:G,left:J})}return T};
//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/scroll-into-view-if-needed/es/index.js

function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}
function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = 'auto';
  }
  var canSmoothScroll = ('scrollBehavior' in document.body.style);
  actions.forEach(function (_ref) {
    var el = _ref.el,
      top = _ref.top,
      left = _ref.left;
    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top: top,
        left: left,
        behavior: behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}
function getOptions(options) {
  if (options === false) {
    return {
      block: 'end',
      inline: 'nearest'
    };
  }
  if (isOptionsObject(options)) {
    return options;
  }
  return {
    block: 'start',
    inline: 'nearest'
  };
}
function scrollIntoView(target, options) {
  var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
  if (isOptionsObject(options) && typeof options.behavior === 'function') {
    return options.behavior(isTargetAttached ? i(target, options) : []);
  }
  if (!isTargetAttached) {
    return;
  }
  var computeOptions = getOptions(options);
  return defaultBehavior(i(target, computeOptions), computeOptions.behavior);
}
/* harmony default export */ var es = (scrollIntoView);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-select/lib/components/OptionContext/index.js

const OptionContext = /*#__PURE__*/react.createContext();
const useOptionContext = () => react.useContext(OptionContext);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-select/lib/components/useErrorOnChange.js



/**
 * @param {*[]} values List of values that should not change
 * @param {string} message Error message included in thrown error
 */
const useErrorOnChange = (values, message) => {
  const length = react.useRef(values.length);
  if (length.current !== values.length) {
    throw new Error(message);
  }
  for_each_default()(values).call(values, value => {
    const ref = react.useRef(value);
    if (ref.current !== value) {
      throw new Error(message);
    }
  });
};
/* harmony default export */ var components_useErrorOnChange = (useErrorOnChange);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-select/lib/components/OptionContainer/index.js










/**
 * This component has to wrap all Option components.
 *
 * Integrates with parent `SelectContainer` to:
 *
 * 1. Sync selection state of option
 * 2. Create an abstraction that facilitates introspecting current option state.
 *    This facilitates answering the questions: "Is the option selected?", "Is the option active (keyboard selected)?"
 *
 * #### Option abstraction
 *
 * The option abstraction is accessible via a render prop or via context
 *
 * For example:
 *
 * ```jsx
 * import { OptionContainer } from '@xo-union/ui-select';
 *
 * <OptionContainer>
 *   {(option) => {
 *      // use `option` abstraction
 *   }}
 * </OptionContainer>
 * ```
 *
 * Via context (`MyComponent` must be nested inside of `OptionContainer`)
 *
 * ```jsx
 * import { useOption } from '@xo-union/ui-select';
 *
 * const MyComponent = () => {
 *   const option = useOption();
 *   // use `option` abstraction
 * }
 * ```
 *
 * #### Option abstraction properties
 *
 * | Property | Type | Description |
 * |----------|------|-------------|
 * | `option.isSelected` | `bool` | True if the `SelectContainer`'s `value` matches the `OptionContainer`'s value |
 * | `option.isActive` | `bool` | True if the option is selected with keyboard |
 * | `option.isFocused` | `bool` | When `SelectContainer` is open, an `active` option is also focused. Otherwise, a `selected` option is focused. |
 * | `option.optionElementRef` | `React.RefObject<HTMLElement>` | Ref to underlying HTML element |
 * | `option.selectOption` | `(eventObject?): void` |  Trigger selection of this option. |
 * | `option.value` | `string` |  Option's value |
 * | `option.id` | `string` |  Option's id |
 *
 */
const OptionContainer = _ref => {
  var _select$selectedOptio, _select$activeOption;
  let {
    id: idProp,
    value,
    children,
    onSelect
  } = _ref;
  components_useErrorOnChange([idProp, value], '`id` and `value` props cannot change on OptionContainer. Please use static value');
  const id = (0,react_unique_id_lib/* useUniqueID */.h)(idProp);
  const select = useSelectContext();
  const optionElementRef = react.useRef();
  const isSelected = ((_select$selectedOptio = select.selectedOption) === null || _select$selectedOptio === void 0 ? void 0 : _select$selectedOptio.id) === id;
  const isActive = ((_select$activeOption = select.activeOption) === null || _select$activeOption === void 0 ? void 0 : _select$activeOption.id) === id;
  const isFocused = select.isOpen ? isActive : isSelected;
  const changeEvent = react.useMemo(() => {
    const evt = {
      option: {
        value,
        id
      },
      // Allow `e.target.value` pattern to make custom select interoperable
      // with native selects
      target: {
        value
      }
    };
    return evt;
  }, [value, id]);
  const {
    onChange
  } = select;
  const selectOption = react.useCallback(originalEvent => {
    onSelect(changeEvent, originalEvent);
    onChange(changeEvent, originalEvent);
  }, [onSelect, onChange, changeEvent]);
  react.useEffect(() => {
    const optionForParentSelect = {
      ref: optionElementRef,
      select: selectOption,
      value,
      id
    };
    select.addOption(optionForParentSelect);
    return () => {
      select.removeOption(id);
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  react.useEffect(() => {
    // Patch to force SSR to work with hydrate
    // Since different IDs are being generated on the server and client side
    // And react will not ensure properties that mismatch are updated.
    if (optionElementRef.current && optionElementRef.current.id !== id) {
      optionElementRef.current.id = id;
    }
  }, []);
  react.useEffect(() => {
    set_timeout_default()(() => {
      if (isActive && optionElementRef.current && select.isOpen) {
        es(optionElementRef.current, {
          behavior: 'auto',
          scrollMode: 'if-needed'
        });
      }
    });
  }, [isActive, select.isOpen]);
  const optionContext = react.useMemo(() => ({
    isSelected,
    isActive,
    isFocused,
    optionElementRef,
    selectOption,
    id,
    value
  }), [id, value, isSelected, isActive, isFocused, selectOption]);
  return /*#__PURE__*/react.createElement(OptionContext.Provider, {
    value: optionContext
  }, typeof children === 'function' ? children(optionContext) : children);
};
 false ? 0 : void 0;
OptionContainer.defaultProps = {
  onSelect: (noop_default())
};
/* harmony default export */ var components_OptionContainer = (OptionContainer);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-select/lib/components/OnFocusContainer/index.js






/**
 * Renders its children inside of the container rendered by `FocusedOption`. If `FocusedOption` is
 * not rendered, this component has no effect.
 */
const OnFocusContainer = _ref => {
  let {
    children
  } = _ref;
  const option = useOptionContext();
  const focusedOptionRef = useElementRef('FocusedOption');
  if (!focusedOptionRef.current || !option.isFocused) {
    return null;
  }

  // Wrap in fragment so that react-docgen picks this up as a component
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react_dom.createPortal(children, focusedOptionRef.current));
};
 false ? 0 : void 0;
/* harmony default export */ var components_OnFocusContainer = (OnFocusContainer);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-select/lib/components/Option/index.js





/**
 * Renders custom option element.
 *
 * All additional props as passed through to the underlying element
 */
const Option = _ref => {
  let {
    as: ComponentToRender,
    children,
    ...props
  } = _ref;
  const option = useOptionContext();
  return /*#__PURE__*/react.createElement(ComponentToRender, (0,esm_extends["default"])({
    ref: option.optionElementRef,
    onMouseDown: evt => option.selectOption(evt),
    "aria-selected": option.isSelected,
    tabIndex: "-1",
    role: "option"
  }, props, {
    id: option.id
  }), children);
};
 false ? 0 : void 0;
Option.defaultProps = {
  as: 'li'
};
/* harmony default export */ var components_Option = (Option);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/Option/styles.css
var Option_styles = __webpack_require__(55316);
var Option_styles_default = /*#__PURE__*/__webpack_require__.n(Option_styles);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/Option/index.js








const Option_Option = props => {
  const {
    onSelect,
    value,
    id,
    children,
    classes: classesProp,
    label,
    ...rest
  } = props;
  const classes = (0,lib.useClasses)((Option_styles_default()), classesProp);
  return /*#__PURE__*/react.createElement(components_OptionContainer, {
    id: id,
    onSelect: onSelect,
    value: value
  }, option => {
    const containerClasses = classnames_default()(classes.container, {
      [classes['is-normal']]: !option.isActive && !option.isSelected,
      [classes['is-active']]: option.isActive,
      [classes['is-selected']]: option.isSelected
    });
    return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(components_OnFocusContainer, null, label || children || value), /*#__PURE__*/react.createElement(components_Option, (0,esm_extends["default"])({
      className: containerClasses
    }, rest), children || value));
  });
};
 false ? 0 : void 0;
/* harmony default export */ var lib_components_Option = (Option_Option);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/defineProperty.js + 3 modules
var defineProperty = __webpack_require__(86761);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/trim.js
var trim = __webpack_require__(90537);
var trim_default = /*#__PURE__*/__webpack_require__.n(trim);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(68726);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/AsyncTypeahead/styles.css
var AsyncTypeahead_styles = __webpack_require__(74510);
var AsyncTypeahead_styles_default = /*#__PURE__*/__webpack_require__.n(AsyncTypeahead_styles);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/AsyncTypeahead/components/SuggestionContainer/index.js





const SuggestionContainer = _ref => {
  let {
    children,
    classes
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: classes['list-container']
  }, children);
};
 false ? 0 : void 0;
/* harmony default export */ var components_SuggestionContainer = ((0,lib.withClasses)((AsyncTypeahead_styles_default()))(SuggestionContainer));
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/AsyncTypeahead/components/ListItem/BaseListItem.js






const BaseListItem = _ref => {
  let {
    active,
    children,
    classes,
    disabled,
    liRef,
    onClick,
    ...rest
  } = _ref;
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  let itemClass = classes.item;
  if (active) itemClass = classes['item-is-active'];
  if (disabled) itemClass = classes['item-is-disabled'];
  return /*#__PURE__*/react.createElement("li", (0,esm_extends["default"])({}, rest, {
    className: itemClass,
    ref: liRef,
    role: "option",
    "aria-selected": "false",
    onClick: !disabled && onClick ? onClick : null
  }), children);
};
 false ? 0 : void 0;
/* harmony default export */ var ListItem_BaseListItem = ((0,lib.withClasses)((AsyncTypeahead_styles_default()))(BaseListItem));
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/AsyncTypeahead/containers/listItemContainer.js





const listItemContainer = Component => {
  class WrappedListItem extends react.Component {
    constructor() {
      super(...arguments);
      (0,defineProperty/* default */.Z)(this, "handleOnClick", e => {
        const {
          suggestion,
          onClick
        } = this.props;
        this.context.onSuggestionClick(e, suggestion);
        if (onClick) onClick(e, suggestion);
      });
    }
    componentWillReceiveProps(_ref, _ref2) {
      let {
        position
      } = _ref;
      let {
        activeIndex
      } = _ref2;
      if (position == null) {
        return;
      }
      if (activeIndex === position) {
        // Ensures that if the menu items exceed the bounds of the menu, the
        // menu will scroll up or down as the user hits the arrow keys.
        es(this.li, {
          scrollMode: 'if-needed',
          behavior: 'auto'
        });
      }
    }
    render() {
      const {
        activeIndex
      } = this.context;
      const {
        position,
        suggestion,
        ...rest
      } = this.props;
      return /*#__PURE__*/react.createElement(Component, (0,esm_extends["default"])({}, rest, {
        liRef: li => {
          this.li = li;
        },
        active: activeIndex === position,
        onMouseDown: this.handleOnClick
      }));
    }
  }
   false ? 0 : void 0;
  WrappedListItem.contextTypes = {
    activeIndex: (prop_types_default()).number.isRequired,
    onSuggestionClick: (prop_types_default()).func.isRequired
  };
  return WrappedListItem;
};
/* harmony default export */ var containers_listItemContainer = (listItemContainer);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/AsyncTypeahead/components/ListItem/index.js



/* harmony default export */ var ListItem = (containers_listItemContainer(ListItem_BaseListItem));
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/AsyncTypeahead/components/List/index.js





const List = _ref => {
  let {
    children,
    classes
  } = _ref;
  return /*#__PURE__*/react.createElement("ul", {
    className: classes.list,
    role: "listbox"
  }, children);
};
 false ? 0 : void 0;
/* harmony default export */ var components_List = ((0,lib.withClasses)((AsyncTypeahead_styles_default()))(List));
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/AsyncTypeahead/utils/labelize.js
/* harmony default export */ var labelize = ((suggestion, key) => {
  let label;
  if (!suggestion) return null;
  if (typeof suggestion === 'string') {
    label = suggestion;
  } else if (typeof key === 'function') {
    label = key(suggestion);
  } else {
    label = suggestion[key];
  }
  return label;
});
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/AsyncTypeahead/components/SuggestionList/index.js







const SuggestionList = props => {
  const {
    classes,
    emptyLabel,
    suggestions,
    renderSuggestion,
    idKey,
    labelKey
  } = props;
  let listItems = /*#__PURE__*/react.createElement(ListItem, {
    classes: classes,
    disabled: true
  }, emptyLabel);
  if (suggestions.length > 0) {
    listItems = map_default()(suggestions).call(suggestions, (suggestion, idx) => /*#__PURE__*/react.createElement(ListItem, {
      key: idKey ? labelize(suggestion, idKey) : idx,
      suggestion: suggestion,
      position: idx,
      classes: classes
    }, renderSuggestion ? renderSuggestion(suggestion, props, idx) : labelize(suggestion, labelKey)));
  }
  return /*#__PURE__*/react.createElement(components_List, {
    classes: classes
  }, listItems);
};
 false ? 0 : void 0;
/* harmony default export */ var components_SuggestionList = (SuggestionList);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/AsyncTypeahead/utils/keyCode.js
/**
 * KeyCode
 *
 * Map of common (non-printable) keycodes for the `keydown` and `keyup` events.
 * Note that `keypress` handles things differently and may not return the same
 * values.
 */
const BACKSPACE = 8;
const TAB = 9;
const RETURN = 13;
const ESC = 27;
const SPACE = 32;
const LEFT = 37;
const UP = 38;
const RIGHT = 39;
const DOWN = 40;
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/components/AsyncTypeahead/components/AsyncTypeahead/index.js















class AsyncTypeahead extends react.Component {
  constructor(props) {
    super(props);
    (0,defineProperty/* default */.Z)(this, "handleBlur", e => {
      const container = e.currentTarget;
      const focusedElement = e.relatedTarget;
      if (!container.contains(focusedElement)) {
        this.hideSuggestions();
      }
    });
    (0,defineProperty/* default */.Z)(this, "inputRef", input => {
      this.input = input;
    });
    (0,defineProperty/* default */.Z)(this, "hideSuggestions", () => {
      this.setState({
        showSuggestions: false,
        activeIndex: -1
      });
    });
    (0,defineProperty/* default */.Z)(this, "focus", () => {
      const {
        query
      } = this.state;
      this.input.focus();
      this.input.setSelectionRange(query.length, query.length);
    });
    (0,defineProperty/* default */.Z)(this, "handleChange", e => {
      const query = e.target.value;
      this.setState({
        showSuggestions: true,
        activeIndex: -1
      });
      this.updateQuery(query);
      this.handleSearchDebounced(trim_default()(query).call(query));
    });
    (0,defineProperty/* default */.Z)(this, "handleSuggestionTabover", (e, suggestion) => {
      const {
        labelKey
      } = this.props;
      const {
        query
      } = this.state;
      const newQuery = labelize(suggestion, labelKey) || query;
      this.updateSelected(suggestion);
      this.updateQuery(newQuery);
      // TODO: MH - Don't do this extra call.
      // Currently used to update the suggestions after suggestion selection.
      this.handleSearchDebounced(trim_default()(newQuery).call(newQuery));
    });
    (0,defineProperty/* default */.Z)(this, "handleSuggestionClick", (e, suggestion) => {
      this.handleSuggestionTabover(e, suggestion);
      this.hideSuggestions();
    });
    (0,defineProperty/* default */.Z)(this, "handleListNavigation", e => {
      const {
        suggestions
      } = this.props;
      const {
        showSuggestions,
        activeIndex
      } = this.state;
      if (!showSuggestions) return;
      e.preventDefault();
      let newActiveIndex = activeIndex;

      // Increment or decrement index based on user keystroke.
      newActiveIndex += e.keyCode === UP ? -1 : 1;

      // If we've reached the end, go back to the beginning or vice-versa.
      if (newActiveIndex === suggestions.length) {
        newActiveIndex = -1;
      } else if (newActiveIndex === -2) {
        newActiveIndex = suggestions.length - 1;
      }
      this.setState({
        activeIndex: newActiveIndex
      });
    });
    (0,defineProperty/* default */.Z)(this, "handleEsc", e => {
      e.preventDefault();
      this.hideSuggestions();
    });
    (0,defineProperty/* default */.Z)(this, "handleTab", e => {
      const {
        suggestions
      } = this.props;
      const {
        showSuggestions,
        selected
      } = this.state;
      if (showSuggestions && suggestions.length > 0 && suggestions[0] !== selected) {
        this.handleSuggestionTabover(e, suggestions[0]);
      }
    });
    (0,defineProperty/* default */.Z)(this, "handleReturn", e => {
      const {
        suggestions
      } = this.props;
      const {
        showSuggestions,
        activeIndex
      } = this.state;
      if (!showSuggestions || activeIndex === -1) return;
      e.preventDefault();
      this.handleSuggestionClick(e, suggestions[activeIndex]);
    });
    (0,defineProperty/* default */.Z)(this, "handleKeyDown", e => {
      const handlers = {
        [UP]: this.handleListNavigation,
        [DOWN]: this.handleListNavigation,
        [ESC]: this.handleEsc,
        [TAB]: this.handleTab,
        [RETURN]: this.handleReturn
      };
      if (handlers[e.keyCode]) handlers[e.keyCode](e);
    });
    (0,defineProperty/* default */.Z)(this, "handleFocus", e => {
      const {
        suggestions,
        onFocus
      } = this.props;
      onFocus(e);
      this.setState({
        showSuggestions: suggestions.length > 0
      });
    });
    (0,defineProperty/* default */.Z)(this, "renderSuggestionList", () => {
      const {
        activeIndex
      } = this.state;
      const {
        renderSuggestionList,
        classes,
        ...rest
      } = this.props;
      const suggestionListProps = {
        ...rest,
        emptyLabel: this.getEmptyLabel(),
        activeIndex,
        onSuggestionClick: this.handleSuggestionClick
      };
      const containerContents = renderSuggestionList ? renderSuggestionList(suggestionListProps) : /*#__PURE__*/react.createElement(components_SuggestionList, (0,esm_extends["default"])({
        classes: classes
      }, suggestionListProps));
      return /*#__PURE__*/react.createElement(components_SuggestionContainer, {
        classes: classes
      }, containerContents);
    });
    this.state = AsyncTypeahead.getInitialState(props);
  }
  getChildContext() {
    return {
      activeIndex: this.state.activeIndex,
      onSuggestionClick: this.handleSuggestionClick
    };
  }
  componentWillMount() {
    this.handleSearchDebounced = debounce_default()(this.handleSearch, this.props.delay);
  }
  componentWillReceiveProps() {
    const {
      requestPending
    } = this.state;
    if (requestPending) {
      this.setState({
        requestPending: false
      });
    }
  }
  handleSearch(query) {
    this.setState({
      requestPending: true
    }, () => this.props.onSearch(query));
  }
  getEmptyLabel() {
    const {
      searchText,
      emptyLabel
    } = this.props;
    const {
      requestPending
    } = this.state;
    return requestPending ? searchText : emptyLabel;
  }
  updateQuery(query) {
    const {
      onInputChange
    } = this.props;
    this.setState({
      query
    });
    if (onInputChange) onInputChange(query);
  }
  updateSelected(selected) {
    const {
      onChange
    } = this.props;
    this.setState({
      selected
    });
    if (onChange) onChange(selected);
  }
  render() {
    const {
      query,
      showSuggestions,
      activeIndex
    } = this.state;
    const {
      classes,
      defaultInputValue,
      delay,
      emptyLabel,
      idKey,
      labelKey,
      onInputChange,
      onSearch,
      renderSuggestion,
      renderSuggestionList,
      suggestions,
      searchText,
      fieldClasses,
      ...rest
    } = this.props;
    return /*#__PURE__*/react.createElement("div", {
      className: classes.container,
      onBlur: this.handleBlur
    }, /*#__PURE__*/react.createElement(components_Field, (0,esm_extends["default"])({}, rest, {
      inputRef: this.inputRef,
      value: labelize(suggestions[activeIndex], labelKey) || query,
      onChange: this.handleChange,
      onKeyDown: this.handleKeyDown,
      onFocus: this.handleFocus,
      classes: fieldClasses
    })), showSuggestions && this.renderSuggestionList());
  }
}
(0,defineProperty/* default */.Z)(AsyncTypeahead, "getInitialState", props => ({
  query: props.defaultInputValue || '',
  showSuggestions: false,
  requestPending: false,
  activeIndex: -1,
  selected: null
}));
AsyncTypeahead.defaultProps = {
  defaultInputValue: null,
  delay: 200,
  emptyLabel: 'No matches found.',
  idKey: null,
  labelKey: 'label',
  onChange: null,
  onFocus: (noop_default()),
  onInputChange: null,
  onSearch: (noop_default()),
  renderSuggestion: null,
  renderSuggestionList: null,
  suggestions: [],
  searchText: 'Searching...'
};
 false ? 0 : void 0;
AsyncTypeahead.childContextTypes = {
  activeIndex: (prop_types_default()).number.isRequired,
  onSuggestionClick: (prop_types_default()).func.isRequired
};
/* harmony default export */ var components_AsyncTypeahead = ((0,lib.withClasses)((AsyncTypeahead_styles_default()))(AsyncTypeahead));
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-subnav/node_modules/@xo-union/tk-component-fields/lib/index.js








/***/ }),

/***/ 31430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _xo_union_tk_ui_typography_lib_globals_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28437);
/* harmony import */ var _xo_union_tk_ui_typography_lib_globals_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_xo_union_tk_ui_typography_lib_globals_css__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _xo_union_tk_ui_links_lib_globals_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65452);
/* harmony import */ var _xo_union_tk_ui_links_lib_globals_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_xo_union_tk_ui_links_lib_globals_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _reset_globals_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16926);
/* harmony import */ var _reset_globals_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_reset_globals_css__WEBPACK_IMPORTED_MODULE_2__);




/***/ }),

/***/ 53285:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _WeakMap = __webpack_require__(48492);
var _Object$defineProperty = __webpack_require__(710);
var _Object$getOwnPropertyDescriptor = __webpack_require__(17412);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Launcher;
var _tkComponentIcons = _interopRequireDefault(__webpack_require__(69464));
var _classnames = _interopRequireDefault(__webpack_require__(2597));
var _react = _interopRequireWildcard(__webpack_require__(99084));
var _index = __webpack_require__(11938);
var _LauncherModule = _interopRequireDefault(__webpack_require__(50688));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Launcher() {
  const {
    widgetType,
    displayWidget,
    setDisplayWidget,
    unreadMessages
  } = (0, _react.useContext)(_index.ZendeskContext);
  if (widgetType !== 'messenger') return null;
  function handleOnClick() {
    var _window;
    if ((_window = window) !== null && _window !== void 0 && _window.zE) {
      var _window2;
      (_window2 = window) === null || _window2 === void 0 || _window2.zE('messenger', 'open');
      setDisplayWidget(true);
    }
  }
  return /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)(_LauncherModule.default.zendeskLauncher, {
      [_LauncherModule.default.hide]: displayWidget
    }),
    id: "zendeskLauncher",
    "data-testid": "zendeskLauncher",
    "aria-label": "Help chat",
    onClick: handleOnClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _LauncherModule.default.iconChatContainer
  }, /*#__PURE__*/_react.default.createElement(_tkComponentIcons.default, {
    size: "lg",
    name: "chat_2",
    className: _LauncherModule.default.chatIcon
  }), unreadMessages ? /*#__PURE__*/_react.default.createElement("div", {
    className: _LauncherModule.default.messageCount
  }, /*#__PURE__*/_react.default.createElement("span", null, unreadMessages)) : null));
}

/***/ }),

/***/ 11938:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _WeakMap = __webpack_require__(48492);
var _Object$defineProperty = __webpack_require__(710);
var _Object$getOwnPropertyDescriptor = __webpack_require__(17412);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Zendesk = Zendesk;
exports.ZendeskContext = void 0;
var _react = _interopRequireWildcard(__webpack_require__(99084));
var _Launcher = _interopRequireDefault(__webpack_require__(53285));
var _ZendeskScript = _interopRequireDefault(__webpack_require__(19336));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ZendeskContext = exports.ZendeskContext = /*#__PURE__*/(0, _react.createContext)({
  displayWidget: false,
  setDisplayWidget: () => {},
  widgetType: null,
  setWidgetType: () => {},
  unreadMessages: 0,
  setUnreadMessages: () => {}
});
// In case only messaging widget will be used in the future,, configure the ZendeskScript component to import dynamically
function Zendesk(_ref) {
  let {
    tenant,
    apiKey,
    onError
  } = _ref;
  const [displayWidget, setDisplayWidget] = (0, _react.useState)(false);
  const [widgetType, setWidgetType] = (0, _react.useState)(null);
  const [unreadMessages, setUnreadMessages] = (0, _react.useState)(0);

  //Widget Messenger: check when the widget closes
  (0, _react.useEffect)(() => {
    var _window;
    if (displayWidget && (_window = window) !== null && _window !== void 0 && _window.zE) {
      var _window2;
      (_window2 = window) === null || _window2 === void 0 || _window2.zE('messenger:on', 'close', () => {
        setDisplayWidget(false);
      });
    }
  }, [displayWidget]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ZendeskContext.Provider, {
    value: {
      displayWidget,
      setDisplayWidget,
      widgetType,
      setWidgetType,
      unreadMessages,
      setUnreadMessages
    }
  }, /*#__PURE__*/_react.default.createElement(_ZendeskScript.default, {
    tenant: tenant,
    apiKey: apiKey,
    onError: onError
  }), /*#__PURE__*/_react.default.createElement(_Launcher.default, null)));
}

/***/ }),

/***/ 19336:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _WeakMap = __webpack_require__(48492);
var _Object$defineProperty = __webpack_require__(710);
var _Object$getOwnPropertyDescriptor = __webpack_require__(17412);
var _interopRequireDefault = __webpack_require__(8285);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ZendeskScript;
var _setTimeout2 = _interopRequireDefault(__webpack_require__(79021));
var _head = _interopRequireDefault(__webpack_require__(20158));
var _script = _interopRequireDefault(__webpack_require__(79140));
var _react = _interopRequireWildcard(__webpack_require__(99084));
var _index = __webpack_require__(11938);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ZendeskScript(_ref) {
  let {
    tenant,
    apiKey,
    onError
  } = _ref;
  const {
    setWidgetType,
    setUnreadMessages
  } = (0, _react.useContext)(_index.ZendeskContext);
  function initialize() {
    try {
      var _window;
      if (!((_window = window) !== null && _window !== void 0 && _window.zE)) return;
      const widgetType = window.zE.widget;
      setWidgetType(widgetType);
      if (widgetType === 'messenger') {
        window.zE('messenger', 'hide');
        window.zE('messenger:set', 'locale', 'en');
        window.zE('messenger:set', 'zIndex', 21);
        window.zE('messenger:on', 'unreadMessages', function (count) {
          setUnreadMessages(count);
        });
        window.zE('messenger', 'show');
      } else if (widgetType === 'classic') {
        window.zE('webWidget', 'hide');
        window.zE('webWidget', 'updateSettings', {
          webWidget: {
            offset: {
              mobile: {
                vertical: '100px'
              }
            },
            zIndex: 10,
            ...(tenant === 'tk' ? {
              color: {
                theme: '#FF44CB',
                launcher: '#FF44CB',
                launcherText: '#fff',
                button: '#FF44CB',
                resultLists: '#000',
                header: '#FF44CB',
                articleLinks: '#FF44CB'
              }
            } : {})
          }
        });
        window.zE('webWidget', 'show');
      } else {
        /* eslint-disable-next-line no-console */
        console.warn('Widget type not recognized:', widgetType);
      }
    } catch (error) {
      onError(error);
    }
  }
  function pollScriptLoaded() {
    const checkInterval = 100;
    const timeoutId = (0, _setTimeout2.default)(function check() {
      var _window2;
      if ((_window2 = window) !== null && _window2 !== void 0 && (_window2 = _window2.zE) !== null && _window2 !== void 0 && _window2.widget) {
        clearTimeout(timeoutId);
        initialize();
      } else {
        (0, _setTimeout2.default)(check, checkInterval);
      }
    }, checkInterval);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_head.default, null, /*#__PURE__*/_react.default.createElement("link", {
    rel: "dns-prefetch",
    href: "https://static.zdassets.com"
  })), /*#__PURE__*/_react.default.createElement(_script.default, {
    id: "ze-snippet",
    "data-testid": "ze-snippet",
    defer: true,
    src: `https://static.zdassets.com/ekr/snippet.js?key=${apiKey}`,
    onLoad: pollScriptLoaded
  }));
}

/***/ }),

/***/ 70132:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _context;
var _Object$defineProperty = __webpack_require__(710);
var _forEachInstanceProperty = __webpack_require__(28301);
var _Object$keys = __webpack_require__(9938);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Zendesk: true
};
_Object$defineProperty(exports, "Zendesk", {
  enumerable: true,
  get: function () {
    return _index.Zendesk;
  }
});
var _index = __webpack_require__(11938);
var _helpers = __webpack_require__(32464);
_forEachInstanceProperty(_context = _Object$keys(_helpers)).call(_context, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _helpers[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _helpers[key];
    }
  });
});

/***/ }),

/***/ 32464:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(710);
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSettingZendeskClassic = void 0;
//ZENDESK CLASSIC: Settings reference https://developer.zendesk.com/api-reference/widget/settings/#zindex
const updateSettingZendeskClassic = (command, data, onError) => {
  try {
    var _window$zE;
    if (!window.zE || ((_window$zE = window.zE) === null || _window$zE === void 0 ? void 0 : _window$zE.widget) !== 'classic') {
      return;
    }
    return window.zE('webWidget', command, data);
  } catch (error) {
    if (onError) onError(error);
  }
};
exports.updateSettingZendeskClassic = updateSettingZendeskClassic;

/***/ }),

/***/ 69464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IconButton": function() { return /* reexport */ components_IconButton; },
  "IconLink": function() { return /* reexport */ components_IconLink; },
  "default": function() { return /* reexport */ components_Icon; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/extends.js
var esm_extends = __webpack_require__(70509);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-zendesk/node_modules/@xo-union/tk-component-icons/lib/css/base.css
var base = __webpack_require__(5912);
var base_default = /*#__PURE__*/__webpack_require__.n(base);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-zendesk/node_modules/@xo-union/tk-component-icons/lib/icon-sets/v2/index.js
/* harmony default export */ var v2 = ({
  resolve: iconName => ({
    id: `v2-icon-${iconName}`,
    className: ''
  })
});
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-zendesk/node_modules/@xo-union/tk-component-icons/lib/components/Icon/index.js






/**
 * Component used to render a non interactive icon based on the definitions in the loaded icons fragment
 */
const Icon = _ref => {
  let {
    name,
    iconSet,
    className,
    size,
    ...rest
  } = _ref;
  const {
    id,
    className: ownClassName
  } = iconSet.resolve(name);
  const classes = [(base_default()).icon, size ? (base_default())[`size-${size}`] : (base_default())["icon-has-no-size"], className, ownClassName];
  return /*#__PURE__*/react.createElement("svg", (0,esm_extends["default"])({
    className: classes.join(' ')
  }, rest), /*#__PURE__*/react.createElement("use", {
    xlinkHref: `#${id}`
  }));
};
 false ? 0 : void 0;
Icon.defaultProps = {
  className: '',
  iconSet: v2,
  size: null
};
/* harmony default export */ var components_Icon = (Icon);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(61820);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-accessibility/lib/FocusBoundary/index.js
var FocusBoundary = __webpack_require__(9433);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-zendesk/node_modules/@xo-union/tk-component-icons/lib/css/interactive-icon.css
var interactive_icon = __webpack_require__(31046);
var interactive_icon_default = /*#__PURE__*/__webpack_require__.n(interactive_icon);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-zendesk/node_modules/@xo-union/tk-component-icons/lib/components/InteractiveIcon/index.js







const InteractiveIcon = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    name,
    className,
    iconSet,
    size,
    as: Type,
    block,
    'aria-label': ariaLabel,
    ...props
  } = _ref;
  const classes = [className, (interactive_icon_default()).container, block ? (interactive_icon_default())["is-block"] : (interactive_icon_default())["is-inline"], size ? (interactive_icon_default())[`size-${size}`] : ''];
  return /*#__PURE__*/react.createElement(FocusBoundary/* Focusable */.Y, (0,esm_extends["default"])({
    ref: ref,
    as: Type,
    className: classes.join(' ')
  }, ariaLabel && {
    'aria-label': ariaLabel
  }, props), /*#__PURE__*/react.createElement(components_Icon, (0,esm_extends["default"])({
    name: name,
    iconSet: iconSet,
    size: size
  }, ariaLabel && {
    'aria-hidden': true
  })));
});
 false ? 0 : void 0;
InteractiveIcon.defaultProps = {
  className: '',
  block: false,
  iconSet: v2,
  size: null,
  'aria-label': null
};
InteractiveIcon.displayName = 'InteractiveIcon';
/* harmony default export */ var components_InteractiveIcon = (InteractiveIcon);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-zendesk/node_modules/@xo-union/tk-component-icons/lib/components/IconButton/index.js





/**
 * Render an interactive icon as a button. Use this component when the interaction will leave the user
 * in the same url.
 *
 * Passes ref to underlying button
 */
const IconButton = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    block,
    size,
    name,
    as,
    ...rest
  } = _ref;
  return /*#__PURE__*/react.createElement(components_InteractiveIcon, (0,esm_extends["default"])({
    ref: ref,
    name: name,
    as: as,
    block: block,
    size: size
  }, rest));
});
IconButton.propTypes = {
  /**
   * Icon name
   */
  name: (prop_types_default()).string.isRequired,
  /**
   * Component to render
   */
  as: (prop_types_default()).elementType,
  /**
   * To determine if icon should have a block display
   */
  block: (prop_types_default()).bool,
  /**
   * Size class
   */
  size: prop_types_default().oneOf(['sm', 'md', 'lg'])
};
IconButton.defaultProps = {
  block: false,
  size: null,
  as: 'button'
};
IconButton.displayName = 'IconButton';
/* harmony default export */ var components_IconButton = (IconButton);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-zendesk/node_modules/@xo-union/tk-component-icons/lib/components/IconLink/index.js





/**
 * Render an interactive icon as a link. Use this component when the interaction will send the user
 * to a different url.
 *
 * Passes ref to underlying link
 */
const IconLink = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    name,
    size,
    block,
    as,
    ...rest
  } = _ref;
  return /*#__PURE__*/react.createElement(components_InteractiveIcon, (0,esm_extends["default"])({
    ref: ref,
    as: as,
    name: name,
    block: block,
    size: size
  }, rest));
});
IconLink.propTypes = {
  /**
   * Icon name
   */
  name: (prop_types_default()).string.isRequired,
  /**
   * Component to render
   */
  as: (prop_types_default()).elementType,
  /**
   * To determine if icon should have a block display
   */
  block: (prop_types_default()).bool,
  /**
   * Size class
   */
  size: prop_types_default().oneOf(['sm', 'md', 'lg'])
};
IconLink.defaultProps = {
  size: null,
  as: 'a'
};
IconLink.displayName = 'IconLink';
/* harmony default export */ var components_IconLink = (IconLink);
;// CONCATENATED MODULE: ./node_modules/@tkww/paper-zendesk/node_modules/@xo-union/tk-component-icons/lib/latest.js




/***/ }),

/***/ 56693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);


const brandClasses = {
  base: 'Union__brands-v1__base',
  'theknot-primary-color': 'Union__brands-v1__theknot Union__brands-v1--color-primary',
  'theknot-secondary-color': 'Union__brands-v1__theknot Union__brands-v1--color-secondary'
};
const BrandLogo = _ref => {
  let {
    color,
    size = 'lg',
    name,
    nameForId = name,
    nameForClasses = name,
    className = '',
    ...props
  } = _ref;
  const colorClass = brandClasses[`${nameForClasses}-${color}-color`] || '';
  const ownClassName = `Union__brands-v1__icon-${nameForClasses}_${size}`;
  const id = `Union__brands-v1__icon-${nameForId}_${size}`;
  const classes = [brandClasses.base, className, colorClass, ownClassName].join(' ');
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__["default"])({
    className: classes,
    "aria-labelledby": `${id}_title`,
    role: "img"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    xlinkHref: `#${id}`
  }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BrandLogo);

/***/ }),

/***/ 76903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "EM": function() { return /* binding */ AssumedTargetAnchor; },
  "u2": function() { return /* binding */ NewWindowAnchor; }
});

// UNUSED EXPORTS: hasDomainPattern, isSecureInteralURLPattern

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/extends.js
var esm_extends = __webpack_require__(70509);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/trim.js
var trim = __webpack_require__(90537);
var trim_default = /*#__PURE__*/__webpack_require__.n(trim);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-accessibility/lib/FocusBoundary/index.js
var FocusBoundary = __webpack_require__(9433);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/symbol/for.js
var symbol_for = __webpack_require__(57621);
var for_default = /*#__PURE__*/__webpack_require__.n(symbol_for);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-accessibility/lib/useDescriptionNode/index.js


const $counter = for_default()('@xo-union/ui-accessibility/useDescriptionNode--counter');
const useDescriptionNode = (id, description) => {
  react.useEffect(() => {
    let node = document.getElementById(id);
    if (!node) {
      node = document.createElement('div');
      node.style.display = 'none';
      node.setAttribute('aria-hidden', 'true');
      document.body.appendChild(node);
      node.setAttribute('id', id);
      node.textContent = description;
    }
    node[$counter] = node[$counter] || 0;
    node[$counter] += 1;
    return () => {
      node[$counter] -= 1;
      if (node[$counter] === 0) {
        document.body.removeChild(node);
      }
    };
  }, [id, description]);
};
/* harmony default export */ var lib_useDescriptionNode = (useDescriptionNode);
;// CONCATENATED MODULE: ./node_modules/@xo-union/component-standard-elements/lib/anchor/index.js





const hasDomainPattern = /^\/\/|^https?:\/\//;
const isSecureInteralURLPattern = /^https:\/\/(:?[^/]+\.)?theknot\.com(:?$|\/)/;
// Trust internal TK url, secure protocol paths OR relative paths
const allowReferrer = url => isSecureInteralURLPattern.test(url) || !hasDomainPattern.test(url);
const Link = props => /*#__PURE__*/react.createElement(FocusBoundary/* Focusable */.Y, (0,esm_extends["default"])({
  as: "a"
}, props));

/* eslint-disable jsx-a11y/anchor-has-content */
const descriptionID = 'Union__component-standard-elements__NewWindowAnchor-description';
const NewWindowAnchor = _ref => {
  var _context;
  let {
    rel,
    href,
    'aria-describedby': ariaDescribedBy,
    ...props
  } = _ref;
  const baseRel = allowReferrer(href) ? 'noopener' : 'noopener noreferrer';
  const relValue = rel ? `${baseRel} ${rel}` : baseRel;
  lib_useDescriptionNode(descriptionID, 'Opens in new window');
  const describedBy = trim_default()(_context = `${descriptionID} ${ariaDescribedBy || ''}`).call(_context);
  return /*#__PURE__*/react.createElement(Link, (0,esm_extends["default"])({
    target: "_blank",
    rel: relValue,
    href: href
  }, props, {
    "aria-describedby": describedBy
  }));
};
 false ? 0 : void 0;
const AssumedTargetAnchor = props => {
  const {
    href
  } = props;
  if (hasDomainPattern.test(href)) {
    return /*#__PURE__*/react.createElement(NewWindowAnchor, (0,esm_extends["default"])({
      href: props.href
    }, props));
  }
  return /*#__PURE__*/react.createElement(Link, props);
};
 false ? 0 : void 0;
AssumedTargetAnchor.defaultProps = {
  as: 'a'
};


/***/ }),

/***/ 62180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L_": function() { return /* binding */ SPACE; },
/* harmony export */   "UP": function() { return /* binding */ UP; },
/* harmony export */   "WV": function() { return /* binding */ DOWN; },
/* harmony export */   "Yl": function() { return /* binding */ RETURN; },
/* harmony export */   "_Q": function() { return /* binding */ ESC; }
/* harmony export */ });
/* unused harmony exports BACKSPACE, TAB, LEFT, RIGHT */
const BACKSPACE = 8;
const TAB = 9;
const RETURN = 13;
const ESC = 27;
const SPACE = 32;
const LEFT = 37;
const UP = 38;
const RIGHT = 39;
const DOWN = 40;

/***/ }),

/***/ 61950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_187__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_187__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_187__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_187__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_187__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_187__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__nested_webpack_require_187__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__nested_webpack_require_187__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __nested_webpack_require_187__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__nested_webpack_require_187__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __nested_webpack_require_187__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_187__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_187__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_187__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_187__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_187__(__nested_webpack_require_187__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(86806);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(74307);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(97620);

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_4021__) {

"use strict";
// ESM COMPAT FLAG
__nested_webpack_require_4021__.r(__webpack_exports__);

// EXPORTS
__nested_webpack_require_4021__.d(__webpack_exports__, "PageletContainer", function() { return /* reexport */ PageletContainer_PageletContainer; });
__nested_webpack_require_4021__.d(__webpack_exports__, "RemotePagelet", function() { return /* reexport */ RemotePagelet_RemotePagelet; });

// EXTERNAL MODULE: external "@xo-union/event-target-shim"
var event_target_shim_ = __nested_webpack_require_4021__(0);

// CONCATENATED MODULE: ./src/core/PageletContainer/CustomEvent.js
// eslint-disable-next-line func-style, prefer-arrow/prefer-arrow-functions
function CustomEvent() {
  // Defer requiring customevent to avoid runtime issue in nodejs
  // eslint-disable-next-line global-require
  const Constructor = __nested_webpack_require_4021__(1);

  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  return new Constructor(...params);
}

/* harmony default export */ var PageletContainer_CustomEvent = (CustomEvent);
// CONCATENATED MODULE: ./src/core/PageletContainer/createContainerContext/index.js
const createContainerContext = pageletContainer => ({
  // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
  get mountNode() {
    return pageletContainer.mountNode;
  },

  // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
  get props() {
    return pageletContainer.props;
  },

  addEventListener: function () {
    pageletContainer.addEventListener(...arguments);
  },
  removeEventListener: function () {
    pageletContainer.removeEventListener(...arguments);
  },
  pageletDidRender: () => {
    pageletContainer.mountNode.setAttribute('data-pagelet-render-state', 'ready');
  },
  pageletDidUnrender: () => {
    pageletContainer.mountNode.removeAttribute('data-pagelet-render-state');
  }
});

/* harmony default export */ var PageletContainer_createContainerContext = (createContainerContext);
// CONCATENATED MODULE: ./src/core/PageletContainer/index.js


 // Simple prepend ponyfill

const prepend = (parent, child) => {
  if (typeof parent.prepend === 'function') {
    parent.prepend(child);
    return;
  }

  parent.insertBefore(child, parent.firstChild);
};

const isRendered = pageletContainer => pageletContainer.mountNode.getAttribute('data-pagelet-render-state') === 'ready';

const emitErrorEvent = (pageletContainer, _ref) => {
  let {
    cancelable,
    detail
  } = _ref;
  const errorEvent = new PageletContainer_CustomEvent('error', {
    cancelable,
    detail: {
      isRendered: isRendered(pageletContainer),
      ...detail
    }
  });
  return pageletContainer.dispatchEvent(errorEvent);
};

const evaluatePageletScript = (scriptElement, containerContext) => {
  /* eslint-disable no-new-func */
  const source = scriptElement.innerHTML;
  const exec = new Function('pageletContainer', `'use strict';${source}`);
  exec.call({}, containerContext);
};

class PageletContainer_PageletContainer extends event_target_shim_["EventTarget"] {
  constructor(id) {
    let {
      errorPagelet,
      props
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super();
    this.id = id;
    this.errorPagelet = errorPagelet;
    this.props = props;
    this.mountNode = null;
    this.willMount = null;
    this.currentPagelet = null;
    this.wasPrepared = false;
    /**
     * Data passed to children
     */

    this.containerContext = PageletContainer_createContainerContext(this);
  }

  prepare() {
    if (this.wasPrepared) {
      return;
    }

    const rootNode = document.body.querySelector(`[data-pagelet-container-id="${this.id}"]`);
    const pageletScriptElement = rootNode.querySelector('script[type="text/x-union-pagelet-script"]');
    let mountNode = rootNode.querySelector('[data-pagelet-role="mount-root"]');

    if (!mountNode) {
      mountNode = document.createElement('div');
      mountNode.setAttribute('data-pagelet-role', 'mount-root');
      prepend(rootNode, mountNode);
    }

    if (pageletScriptElement) {
      evaluatePageletScript(pageletScriptElement, this.containerContext);
    }

    this.mountNode = mountNode;
    this.wasPrepared = true;
  }

  mount(pagelet) {
    if (!this.wasPrepared) {
      this.prepare();
    }

    this.willMount = pagelet;
    this.dispatchEvent(new PageletContainer_CustomEvent('will-load', {
      detail: {
        pagelet
      }
    }));
    pagelet.load().then(() => {
      /**
       * Cancel mounting if unmount was called or if mount was called consecutively with different pagelets
       */
      if (this.willMount !== pagelet) {
        return;
      }

      this.currentPagelet = pagelet;
      pagelet.mount(this.containerContext);
      this.willMount = null;
    }, error => {
      // eslint-disable-next-line no-console
      console.error(error);
      const notCanceled = emitErrorEvent(this, {
        cancelable: true,
        detail: {
          phase: 'load',
          error
        }
      });

      if (notCanceled) {
        this.errorPagelet.mount(this.containerContext);
      }
    });
  }

  unmount() {
    this.willMount = null;

    if (!this.currentPagelet) {
      // eslint-disable-next-line no-console
      console.warn('Called PageletContainer#unmount with no mounted pagelet');
      return;
    }

    this.currentPagelet.unmount(this.containerContext);
    this.currentPagelet = null;
  }

  setProps(newProps) {
    const event = new PageletContainer_CustomEvent('props', {
      detail: {
        previousProps: this.props,
        props: newProps
      }
    });
    this.props = newProps;
    this.dispatchEvent(event);
  }

}
// EXTERNAL MODULE: external "@babel/runtime-corejs3/core-js/promise"
var promise_ = __nested_webpack_require_4021__(2);
var promise_default = /*#__PURE__*/__nested_webpack_require_4021__.n(promise_);

// CONCATENATED MODULE: ./src/core/RemotePagelet/loadLinks/index.js


const amdImport = dependencies => new promise_default.a((resolve, reject) => {
  const handleError = error => {
    reject(error);
  };

  const handleSuccess = function () {
    for (var _len = arguments.length, _exports = new Array(_len), _key = 0; _key < _len; _key++) {
      _exports[_key] = arguments[_key];
    }

    resolve(_exports);
  };

  window.UNION_INTERNAL_MODULE_SYSTEM.require(dependencies, handleSuccess, handleError);
});

/* harmony default export */ var loadLinks = (_ref => {
  let {
    links: {
      js,
      css
    } = {}
  } = _ref;
  const dependencies = [js.toString()];

  if (css) {
    dependencies.push(`css-loader!${css}`);
  }

  return amdImport(dependencies).then(_ref2 => {
    let [_exports] = _ref2;
    return _exports;
  });
});
// CONCATENATED MODULE: ./src/core/RemotePagelet/index.js

class RemotePagelet_RemotePagelet {
  constructor() {
    let {
      links = {},
      jsExportName = 'default'
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.pageletInstance = null;
    this.links = links;
    this.jsExportName = jsExportName;
  }

  get isLoaded() {
    return !!this.pageletInstance;
  }

  load() {
    return loadLinks({
      links: this.links
    }).then(exports => {
      this.pageletInstance = exports[this.jsExportName];
    });
  }

  mount(params) {
    return this.pageletInstance.mount(params);
  }

  unmount(params) {
    return this.pageletInstance.unmount(params);
  }

}
// CONCATENATED MODULE: ./src/core/index.js



/***/ })
/******/ ]);

/***/ }),

/***/ 56303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84596);
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_classPrivateFieldSet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93204);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28301);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_instance_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_corejs3_core_js_global_this__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26111);
/* harmony import */ var _babel_runtime_corejs3_core_js_global_this__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_global_this__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48492);
/* harmony import */ var _babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _css_index_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60974);
/* harmony import */ var _css_index_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_css_index_css__WEBPACK_IMPORTED_MODULE_3__);


function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }




const eachClass = (domString, callback) => {
  var _context;
  _babel_runtime_corejs3_core_js_instance_for_each__WEBPACK_IMPORTED_MODULE_0___default()(_context = domString.split(/\s+/)).call(_context, callback);
};
var _classes = /*#__PURE__*/new (_babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_2___default())();
var _eventTarget = /*#__PURE__*/new (_babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_2___default())();
var _target = /*#__PURE__*/new (_babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_2___default())();
var _tabClasses = /*#__PURE__*/new (_babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_2___default())();
var _noTabClasses = /*#__PURE__*/new (_babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_2___default())();
var _addClassToTarget = /*#__PURE__*/new (_babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_2___default())();
var _removeClassFromTarget = /*#__PURE__*/new (_babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_2___default())();
var _handleKey = /*#__PURE__*/new (_babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_2___default())();
var _handleClick = /*#__PURE__*/new (_babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_2___default())();
class TabAccessibility {
  constructor() {
    let {
      classes = (_css_index_css__WEBPACK_IMPORTED_MODULE_3___default()),
      target = (_babel_runtime_corejs3_core_js_global_this__WEBPACK_IMPORTED_MODULE_1___default().document.body),
      eventTarget = (_babel_runtime_corejs3_core_js_global_this__WEBPACK_IMPORTED_MODULE_1___default())
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classPrivateFieldInitSpec(this, _classes, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _eventTarget, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _target, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _tabClasses, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _noTabClasses, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _addClassToTarget, {
      writable: true,
      value: className => (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _target).classList.add(className)
    });
    _classPrivateFieldInitSpec(this, _removeClassFromTarget, {
      writable: true,
      value: className => (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _target).classList.remove(className)
    });
    _classPrivateFieldInitSpec(this, _handleKey, {
      writable: true,
      value: e => {
        if (e.keyCode === 9) {
          eachClass((0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _tabClasses), (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _addClassToTarget));
          eachClass((0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _noTabClasses), (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _removeClassFromTarget));
        }
      }
    });
    _classPrivateFieldInitSpec(this, _handleClick, {
      writable: true,
      value: () => {
        eachClass((0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _tabClasses), (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _removeClassFromTarget));
        eachClass((0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _noTabClasses), (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _addClassToTarget));
      }
    });
    (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldSet__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, _classes, typeof classes === 'function' ? classes((_css_index_css__WEBPACK_IMPORTED_MODULE_3___default())) : classes);
    (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldSet__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, _eventTarget, eventTarget);
    (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldSet__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, _target, target);
    (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldSet__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, _tabClasses, `${(0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _classes).tab} Union__tab-accessibility__keyboard-interaction`);
    (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldSet__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, _noTabClasses, `${(0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _classes)['no-tab']} Union__tab-accessibility__mouse-interaction`);
  }
  mount() {
     false ? 0 : void 0;
    (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _eventTarget).addEventListener('keydown', (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _handleKey));
    (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _eventTarget).addEventListener('mousedown', (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _handleClick));
    eachClass((0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _noTabClasses), (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _addClassToTarget));
  }
  unmount() {
    (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _eventTarget).removeEventListener('keydown', (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _handleKey));
    (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _eventTarget).removeEventListener('mousedown', (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _handleClick));
    eachClass((0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _tabClasses), (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _removeClassFromTarget));
    eachClass((0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _noTabClasses), (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _removeClassFromTarget));
  }
}
const create = function () {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }
  return new TabAccessibility(...params);
};
/* harmony default export */ __webpack_exports__["Z"] = (create);

/***/ }),

/***/ 7477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ControlledSnackbar; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/extends.js
var esm_extends = __webpack_require__(70509);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(35964);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(61820);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var noop = __webpack_require__(21818);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ./node_modules/@xo-union/react-unique-id/lib/index.js
var lib = __webpack_require__(79946);
// EXTERNAL MODULE: ./node_modules/@xo-union/react-css-modules/lib/index.js
var react_css_modules_lib = __webpack_require__(33289);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-alerts/node_modules/@xo-union/tk-component-icons/lib/components/IconButton/index.js + 1 modules
var IconButton = __webpack_require__(59803);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-alerts/lib/components/Snackbar/styles.css
var styles = __webpack_require__(10204);
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-alerts/lib/components/Snackbar/index.js








const Snackbar = _ref => {
  let {
    children,
    visible,
    fixedToRelative,
    onClose,
    classes: classesProp,
    id: idProp,
    ...props
  } = _ref;
  const id = (0,lib/* useUniqueID */.h)(idProp);
  const classes = (0,react_css_modules_lib.useClasses)((styles_default()), classesProp);
  const visibility = visible ? 'is-visible' : `is-not-visible`;
  const visibleClass = classes[visibility];
  const dialogRole = visible ? 'alertdialog' : 'none';
  const role = visible ? 'alert' : 'none';
  const live = visible ? 'assertive' : 'off';
  const ariaHidden = !visible;
  const positionClass = fixedToRelative ? classes['fixed-to-relative'] : classes['fixed-to-page'];
  return /*#__PURE__*/react.createElement("div", {
    className: `${classes['snackbar-wrapper']} ${positionClass}`
  }, /*#__PURE__*/react.createElement("div", {
    className: `${classes.container} ${visibleClass}`,
    role: dialogRole,
    "aria-hidden": ariaHidden
  }, /*#__PURE__*/react.createElement("div", {
    className: classes['close-button-container']
  }, /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
    onClick: onClose,
    "aria-label": "Dismiss",
    "aria-controls": id,
    name: "close",
    size: "md"
  })), /*#__PURE__*/react.createElement("div", (0,esm_extends["default"])({
    role: role,
    "aria-live": live,
    id: id,
    className: classes.children
  }, props), children)));
};
Snackbar.defaultProps = {
  fixedToRelative: false,
  visible: false
};
 false ? 0 : void 0;
/* harmony default export */ var components_Snackbar = (Snackbar);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-alerts/lib/components/SnackbarContext/index.js
var SnackbarContext = __webpack_require__(26791);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-alerts/lib/components/ControlledSnackbar/index.js








const DEFAULT_AUTO_DISMISS_MS = 20000;
const GLOBAL_CONTAINER_ID = 'Union__global-snackbar-container';
const ControlledSnackbar = /*#__PURE__*/react.forwardRef((props, ref) => {
  const [containerElement, setContainerElement] = react.useState();
  const fallbackQueue = (0,SnackbarContext/* useSnackbarQueue */.m2)();
  const contextQueue = (0,SnackbarContext/* useSnackbarQueueContext */.mX)();
  const queue = contextQueue || fallbackQueue;
  const id = (0,lib/* useUniqueID */.h)();
  const {
    visible,
    onClose,
    ...snackbarProps
  } = props;
  react.useImperativeHandle(ref, () => {
    const api = {
      showAndDismiss: _ref => {
        let {
          data,
          dismissTimeout = DEFAULT_AUTO_DISMISS_MS
        } = _ref;
        queue.dismissAll(id);
        queue.push({
          id,
          data,
          dismissTimeout
        });
      },
      dismiss: () => {
        queue.dismissAll(id);
      },
      isVisible: () => queue.isVisible(id)
    };
    return api;
  }, [queue, id]);
  react.useEffect(() => {
    const container = document.getElementById(GLOBAL_CONTAINER_ID) || document.createElement('div');
    container.id = GLOBAL_CONTAINER_ID;
    document.body.appendChild(container);
    setContainerElement(container);
  }, []);
  const snackbar = /*#__PURE__*/react.createElement(components_Snackbar, (0,esm_extends["default"])({
    visible: queue.isVisible(id),
    onClose: () => {
      queue.dismissAll(id);
      props.onClose();
    }
  }, snackbarProps), typeof snackbarProps.children === 'function' ? snackbarProps.children(queue.getData(id)) : queue.getData(id));
  if (snackbarProps.fixedToRelative) {
    return snackbar;
  }
  if (containerElement) {
    return /*#__PURE__*/react_dom.createPortal(snackbar, containerElement);
  }
  return null;
});
ControlledSnackbar.defaultProps = {
  fixedToRelative: false,
  onClose: (noop_default())
};
ControlledSnackbar.propTypes = {
  /**
   * Contents of snackbar
   */
  children: prop_types_default().oneOfType([(prop_types_default()).node, (prop_types_default()).func]),
  /**
   * Whether or not to position the snackbar within a relative.
   * This use is discouraged except for a few scenarios like the sidebar. This
   * is only supported if the parent container is at the bottom of the viewport.
   */
  fixedToRelative: (prop_types_default()).bool,
  /**
   * Called when the close button is clicked
   */
  onClose: (prop_types_default()).func,
  /**
   * Should the snackbar be visible
   */
  visible: (prop_types_default()).bool,
  /**
   * ID of the snackbar component
   */
  id: (prop_types_default()).string
};
/* harmony default export */ var components_ControlledSnackbar = (ControlledSnackbar);

/***/ }),

/***/ 26791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m2": function() { return /* binding */ useSnackbarQueue; },
/* harmony export */   "mX": function() { return /* binding */ useSnackbarQueueContext; },
/* harmony export */   "wT": function() { return /* binding */ SnackbarProvider; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_flat_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99697);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_flat_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_instance_flat_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_corejs3_core_js_set_timeout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79021);
/* harmony import */ var _babel_runtime_corejs3_core_js_set_timeout__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_set_timeout__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93726);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_instance_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_corejs3_core_js_number_is_finite__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39831);
/* harmony import */ var _babel_runtime_corejs3_core_js_number_is_finite__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_number_is_finite__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99084);






const QueueContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createContext();
const useSnackbarQueueContext = () => react__WEBPACK_IMPORTED_MODULE_4__.useContext(QueueContext);
const useSnackbarQueue = () => {
  const cleanTimer = react__WEBPACK_IMPORTED_MODULE_4__.useRef();
  const dismissTimer = react__WEBPACK_IMPORTED_MODULE_4__.useRef();
  const [queue, setQueue] = react__WEBPACK_IMPORTED_MODULE_4__.useState([]);
  const first = queue[0];
  const clean = id => {
    setQueue(q => _babel_runtime_corejs3_core_js_instance_flat_map__WEBPACK_IMPORTED_MODULE_0___default()(q).call(q, el => {
      if (el.id === id && el.visible === false) {
        return [];
      }
      return el;
    }));
  };
  const timeoutClean = react__WEBPACK_IMPORTED_MODULE_4__.useCallback(id => {
    if (cleanTimer.current) {
      clearTimeout(cleanTimer.current);
    }
    cleanTimer.current = _babel_runtime_corejs3_core_js_set_timeout__WEBPACK_IMPORTED_MODULE_1___default()(() => {
      clean(id);
      cleanTimer.current = null;
    }, 500);
  }, []);
  const push = el => {
    setQueue(q => [...q, {
      ...el,
      visible: true
    }]);
  };
  const dismissFirst = react__WEBPACK_IMPORTED_MODULE_4__.useCallback(id => {
    setQueue(q => {
      let found = false;
      return _babel_runtime_corejs3_core_js_instance_map__WEBPACK_IMPORTED_MODULE_2___default()(q).call(q, el => {
        if (el.id === id && el.visible && !found) {
          found = true;
          return {
            ...el,
            visible: false
          };
        }
        return el;
      });
    });
    timeoutClean(id);
  }, [timeoutClean]);
  react__WEBPACK_IMPORTED_MODULE_4__.useEffect(() => {
    if (first && _babel_runtime_corejs3_core_js_number_is_finite__WEBPACK_IMPORTED_MODULE_3___default()(first.dismissTimeout)) {
      dismissTimer.current = _babel_runtime_corejs3_core_js_set_timeout__WEBPACK_IMPORTED_MODULE_1___default()(() => {
        dismissFirst(first.id);
      }, first.dismissTimeout);
    }
    return () => {
      clearTimeout(dismissTimer.current);
    };
  }, [first, dismissFirst]);
  react__WEBPACK_IMPORTED_MODULE_4__.useEffect(() => () => clearTimeout(cleanTimer.current), []);
  return react__WEBPACK_IMPORTED_MODULE_4__.useMemo(() => ({
    push,
    getData: id => {
      if (id === (first === null || first === void 0 ? void 0 : first.id)) {
        return first.data;
      }
      return null;
    },
    isVisible: id => {
      var _queue$;
      return id === ((_queue$ = queue[0]) === null || _queue$ === void 0 ? void 0 : _queue$.id) && queue[0].visible === true;
    },
    dismissAll: id => {
      setQueue(q => _babel_runtime_corejs3_core_js_instance_map__WEBPACK_IMPORTED_MODULE_2___default()(q).call(q, el => {
        if (el.id === id && el.visible) {
          return {
            ...el,
            visible: false
          };
        }
        return el;
      }));
      timeoutClean(id);
    },
    dismissFirst,
    clean
  }), [queue, timeoutClean, dismissFirst, first]);
};
const SnackbarProvider = _ref => {
  let {
    children
  } = _ref;
  const queue = useSnackbarQueue();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(QueueContext.Provider, {
    value: queue
  }, children);
};
 false ? 0 : void 0;

/***/ }),

/***/ 98166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var _css_base_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3105);
/* harmony import */ var _css_base_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_css_base_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _icon_sets_v2_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18149);






/**
 * Component used to render a non interactive icon based on the definitions in the loaded icons fragment
 */
const Icon = _ref => {
  let {
    name,
    iconSet,
    className,
    size,
    ...rest
  } = _ref;
  const {
    id,
    className: ownClassName
  } = iconSet.resolve(name);
  const classes = [(_css_base_css__WEBPACK_IMPORTED_MODULE_1___default().icon), size ? (_css_base_css__WEBPACK_IMPORTED_MODULE_1___default())[`size-${size}`] : (_css_base_css__WEBPACK_IMPORTED_MODULE_1___default()["icon-has-no-size"]), className, ownClassName];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__["default"])({
    className: classes.join(' ')
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    xlinkHref: `#${id}`
  }));
};
 false ? 0 : void 0;
Icon.defaultProps = {
  className: '',
  iconSet: _icon_sets_v2_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
  size: null
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ }),

/***/ 59803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_IconButton; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/extends.js
var esm_extends = __webpack_require__(70509);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(61820);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-accessibility/lib/FocusBoundary/index.js
var FocusBoundary = __webpack_require__(9433);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-alerts/node_modules/@xo-union/tk-component-icons/lib/icon-sets/v2/index.js
var v2 = __webpack_require__(18149);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-alerts/node_modules/@xo-union/tk-component-icons/lib/css/interactive-icon.css
var interactive_icon = __webpack_require__(70967);
var interactive_icon_default = /*#__PURE__*/__webpack_require__.n(interactive_icon);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-alerts/node_modules/@xo-union/tk-component-icons/lib/components/Icon/index.js
var Icon = __webpack_require__(98166);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-alerts/node_modules/@xo-union/tk-component-icons/lib/components/InteractiveIcon/index.js







const InteractiveIcon = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    name,
    className,
    iconSet,
    size,
    as: Type,
    block,
    'aria-label': ariaLabel,
    ...props
  } = _ref;
  const classes = [className, (interactive_icon_default()).container, block ? (interactive_icon_default())["is-block"] : (interactive_icon_default())["is-inline"], size ? (interactive_icon_default())[`size-${size}`] : ''];
  return /*#__PURE__*/react.createElement(FocusBoundary/* Focusable */.Y, (0,esm_extends["default"])({
    ref: ref,
    as: Type,
    className: classes.join(' ')
  }, ariaLabel && {
    'aria-label': ariaLabel
  }, props), /*#__PURE__*/react.createElement(Icon/* default */.Z, (0,esm_extends["default"])({
    name: name,
    iconSet: iconSet,
    size: size
  }, ariaLabel && {
    'aria-hidden': true
  })));
});
 false ? 0 : void 0;
InteractiveIcon.defaultProps = {
  className: '',
  block: false,
  iconSet: v2/* default */.Z,
  size: null,
  'aria-label': null
};
InteractiveIcon.displayName = 'InteractiveIcon';
/* harmony default export */ var components_InteractiveIcon = (InteractiveIcon);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-alerts/node_modules/@xo-union/tk-component-icons/lib/components/IconButton/index.js





/**
 * Render an interactive icon as a button. Use this component when the interaction will leave the user
 * in the same url.
 *
 * Passes ref to underlying button
 */
const IconButton = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    block,
    size,
    name,
    as,
    ...rest
  } = _ref;
  return /*#__PURE__*/react.createElement(components_InteractiveIcon, (0,esm_extends["default"])({
    ref: ref,
    name: name,
    as: as,
    block: block,
    size: size
  }, rest));
});
IconButton.propTypes = {
  /**
   * Icon name
   */
  name: (prop_types_default()).string.isRequired,
  /**
   * Component to render
   */
  as: (prop_types_default()).elementType,
  /**
   * To determine if icon should have a block display
   */
  block: (prop_types_default()).bool,
  /**
   * Size class
   */
  size: prop_types_default().oneOf(['sm', 'md', 'lg'])
};
IconButton.defaultProps = {
  block: false,
  size: null,
  as: 'button'
};
IconButton.displayName = 'IconButton';
/* harmony default export */ var components_IconButton = (IconButton);

/***/ }),

/***/ 18149:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
  resolve: iconName => ({
    id: `v2-icon-${iconName}`,
    className: ''
  })
});

/***/ }),

/***/ 17218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Button": function() { return /* reexport */ Button/* default */.Z; },
  "ButtonContainer": function() { return /* reexport */ components_ButtonContainer; },
  "Link": function() { return /* reexport */ Link/* default */.Z; },
  "LinkContainer": function() { return /* reexport */ components_LinkContainer; },
  "NonInteractiveButton": function() { return /* reexport */ components_NonInteractiveButton; },
  "ThemeProvider": function() { return /* reexport */ ThemeContext/* ThemeProvider */.f; }
});

// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-buttons/lib/components/Link/index.js
var Link = __webpack_require__(60588);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-buttons/lib/components/Button/index.js
var Button = __webpack_require__(34925);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/extends.js
var esm_extends = __webpack_require__(70509);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-buttons/lib/components/Animation.js
var Animation = __webpack_require__(54943);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-buttons/lib/components/LoadingContainer/index.js
var LoadingContainer = __webpack_require__(19954);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-buttons/lib/components/CtaContainer/index.js + 2 modules
var CtaContainer = __webpack_require__(50660);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-buttons/lib/components/ThemeContext.js
var ThemeContext = __webpack_require__(97367);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-buttons/lib/utilities/index.js
var utilities = __webpack_require__(69955);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-buttons/lib/components/NonInteractiveButton/index.js










/**
 * Render a non interactive button. This is ideal when rendering a button inside
 * of another interactive element (such as an interactive Card)
 */
const NonInteractiveButton = props => {
  const {
    active,
    as: Type,
    block,
    children,
    classes: classesProp,
    className,
    color,
    disabled,
    iconName,
    isLoading,
    labelDirection,
    loadingText,
    size,
    ...passThroughProps
  } = props;
  const classes = (0,ThemeContext/* useButtonClasses */.B)(classesProp);
  return /*#__PURE__*/react.createElement(Type, (0,esm_extends["default"])({
    className: (0,utilities/* getClassName */.gj)(props, false, classes)
  }, passThroughProps), /*#__PURE__*/react.createElement(Animation/* AnimatedElement */.F, {
    classes: classesProp
  }), isLoading ? /*#__PURE__*/react.createElement(LoadingContainer/* default */.Z, {
    classes: classesProp,
    loadingText: loadingText
  }) : /*#__PURE__*/react.createElement(CtaContainer/* default */.Z, {
    classes: classesProp,
    color: color,
    iconName: iconName,
    labelDirection: labelDirection,
    size: size
  }, children));
};
 false ? 0 : void 0;
NonInteractiveButton.defaultProps = {
  as: 'span',
  size: 'lg',
  color: 'primary',
  isLoading: false,
  loadingText: 'Loading'
};
/* harmony default export */ var components_NonInteractiveButton = (NonInteractiveButton);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-accessibility/lib/FocusBoundary/index.js
var FocusBoundary = __webpack_require__(9433);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-buttons/lib/components/LinkContainer/index.js






/**
 * Render a native link as the interactive container to a `NonInteractiveButton`
 *
 * ref is passed to underlying link
 */
const LinkContainer = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    as: Type,
    children,
    ...ownProps
  } = _ref;
  const finalProps = (0,utilities/* useLinkProps */.eY)(ownProps, true);
  return /*#__PURE__*/react.createElement(FocusBoundary/* Focusable */.Y, (0,esm_extends["default"])({
    as: Type,
    ref: ref
  }, finalProps), children);
});
 false ? 0 : void 0;
LinkContainer.defaultProps = {
  as: 'a'
};
LinkContainer.displayName = 'LinkContainer';
/* harmony default export */ var components_LinkContainer = (LinkContainer);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-buttons/lib/components/ButtonContainer/index.js





/**
 * Render a button element as the interactive container to a `NonInteractiveButton`
 *
 * ref is passed to underlying button
 */
const ButtonContainer = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    as: Type,
    children,
    ...ownProps
  } = _ref;
  const finalProps = (0,utilities/* useButtonProps */.FT)(ownProps, true);
  return /*#__PURE__*/react.createElement(FocusBoundary/* Focusable */.Y, (0,esm_extends["default"])({
    as: Type,
    ref: ref
  }, finalProps), children);
});
 false ? 0 : void 0;
ButtonContainer.defaultProps = {
  as: 'button'
};
ButtonContainer.displayName = 'ButtonContainer';
/* harmony default export */ var components_ButtonContainer = (ButtonContainer);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-buttons/lib/index.js







/***/ }),

/***/ 55961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var _xo_union_component_standard_elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76903);
/* harmony import */ var _xo_union_tk_component_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94956);
/* harmony import */ var _css_index_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15618);
/* harmony import */ var _css_index_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_css_index_css__WEBPACK_IMPORTED_MODULE_3__);






const FooterLink = _ref => {
  let {
    children,
    href,
    trackableProps = {},
    ...rest
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_xo_union_component_standard_elements__WEBPACK_IMPORTED_MODULE_1__/* .AssumedTargetAnchor */ .EM, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__["default"])({
    href: href,
    className: (_css_index_css__WEBPACK_IMPORTED_MODULE_3___default().footerLink)
  }, (0,_xo_union_tk_component_analytics__WEBPACK_IMPORTED_MODULE_4__/* .createTrackableProps */ .Ur)(trackableProps), rest), children);
};
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (FooterLink);

/***/ }),

/***/ 83825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_FooterNav; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/array/from.js
var from = __webpack_require__(56699);
var from_default = /*#__PURE__*/__webpack_require__.n(from);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/for-each.js
var for_each = __webpack_require__(28301);
var for_each_default = /*#__PURE__*/__webpack_require__.n(for_each);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/global-this.js
var global_this = __webpack_require__(26111);
var global_this_default = /*#__PURE__*/__webpack_require__.n(global_this);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/set-timeout.js
var set_timeout = __webpack_require__(79021);
var set_timeout_default = /*#__PURE__*/__webpack_require__.n(set_timeout);
// EXTERNAL MODULE: ./node_modules/matches-selector/index.js
var matches_selector = __webpack_require__(65792);
var matches_selector_default = /*#__PURE__*/__webpack_require__.n(matches_selector);
// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var noop = __webpack_require__(21818);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-analytics/lib/wrapper/index.mjs


/* eslint-disable no-console */
let warn = noop;
if (false) {}
const createWrapper = fnName => {
  const wrapper = function () {
    if (globalThis.analytics) {
      globalThis.analytics[fnName](...arguments);
    } else {
      warn();
    }
  };
  return wrapper;
};
/* harmony default export */ var wrapper = ({
  track: createWrapper('track'),
  alias: createWrapper('alias'),
  identify: createWrapper('identify'),
  reset: createWrapper('reset')
});
// EXTERNAL MODULE: ./node_modules/@segment/is-meta/lib/index.js
var lib = __webpack_require__(89228);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-analytics/lib/getMappableValue.js
const getMappableValue = function (subject) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof subject === 'function' ? subject(...params) : subject;
};
/* harmony default export */ var lib_getMappableValue = (getMappableValue);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-analytics/lib/generic-click-tracker/index.js











const eventWillChangePage = event => {
  const element = event.target;
  const MOUSE_MIDDLE_BUTTON = 1;
  const willOpenNewTab = lib_default()(event) || event.button === MOUSE_MIDDLE_BUTTON;
  const target = element.getAttribute('target');
  const href = element.getAttribute('href');
  return element.tagName === 'A' && href && target !== '_blank' && !willOpenNewTab;
};
const getContextEventData = _ref => {
  let {
    element,
    contextEnd
  } = _ref;
  const data = {};
  const source = {};
  let currentElement = element;
  const processAttribute = attribute => {
    const match = attribute.name.match(/^data-trackable-context-(.+)$/);
    if (match) {
      const contextAttributeName = match[1];
      if (data[contextAttributeName]) {
        /* eslint-disable no-console */
        console.warn(`Trackable context property \`${contextAttributeName}\` is overwritten\n`, 'Previously defined by: ', currentElement, '\n', 'Overwritten by: ', source[contextAttributeName]);
      } else {
        data[contextAttributeName] = attribute.value;
        source[contextAttributeName] = currentElement;
      }
    }
  };
  while (currentElement && currentElement !== contextEnd) {
    const attributes = from_default()(currentElement.attributes);
    for_each_default()(attributes).call(attributes, processAttribute);
    currentElement = currentElement.parentElement;
  }
  return data;
};
const createLinkFollowStrategy = function () {
  let {
    timeout = 300,
    location = (global_this_default()).location
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return event => {
    const element = event.target;
    if (eventWillChangePage(event)) {
      const href = element.getAttribute('href');
      event.preventDefault();
      set_timeout_default()(() => {
        // eslint-disable-next-line no-param-reassign
        location.href = href;
      }, timeout);
    }
  };
};
const useGenericClickTracker = _ref2 => {
  let {
    eventName,
    eventData,
    trackableSelector = 'a',
    analytics: analyticsProp,
    followStrategy: followStrategyProp
  } = _ref2;
  const defaultFollowStrategy = react.useCallback(createLinkFollowStrategy(), []);
  const followStrategy = followStrategyProp === undefined ? defaultFollowStrategy : followStrategyProp;
  return react.useCallback(event => {
    const element = event.target;
    const analytics = analyticsProp || wrapper;
    if (matches_selector_default()(element, trackableSelector)) {
      const contextProperties = getContextEventData({
        element,
        contextEnd: event.currentTarget
      });
      const finalEventName = lib_getMappableValue(eventName, element, contextProperties);
      const finalEventData = lib_getMappableValue(eventData, element, contextProperties);
      analytics.track(finalEventName, finalEventData);
      if (followStrategy === false) {
        event.preventDefault();
      }
      if (typeof followStrategy === 'function') {
        followStrategy(event);
      }
    }
  }, [eventName, eventData, analyticsProp, followStrategy, trackableSelector]);
};
const generic_click_tracker_GenericClickTracker = _ref3 => {
  let {
    as: ComponentToRender,
    children,
    onClick,
    ...props
  } = _ref3;
  const handleAnalytics = useGenericClickTracker(props);
  const finalOnClick = react.useCallback(function () {
    handleAnalytics(...arguments);
    return onClick(...arguments);
  }, [onClick, handleAnalytics]);
  return /*#__PURE__*/react.createElement(ComponentToRender, {
    onClick: finalOnClick
  }, children);
};
 false ? 0 : void 0;
generic_click_tracker_GenericClickTracker.defaultProps = {
  followStrategy: createLinkFollowStrategy(),
  trackableSelector: 'a',
  as: 'div',
  onClick: (noop_default())
};
/* harmony default export */ var generic_click_tracker = ((/* unused pure expression or super */ null && (generic_click_tracker_GenericClickTracker)));
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/trim.js
var trim = __webpack_require__(90537);
var trim_default = /*#__PURE__*/__webpack_require__.n(trim);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-analytics/lib/click-tracker/getSelectionValue/index.js

const getSelectionValue = (element, contextProperties) => {
  var _context;
  let selection = element.getAttribute('data-trackable-selection') || trim_default()(_context = element.textContent).call(_context);
  const namespace = element.getAttribute('data-trackable-group') || contextProperties.group;
  if (namespace) {
    selection = `${namespace} > ${selection}`;
  }
  return selection.toLowerCase();
};
/* harmony default export */ var click_tracker_getSelectionValue = (getSelectionValue);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-analytics/lib/click-tracker/getEventData/index.js


const getEventData = _ref => {
  let {
    element,
    eventData,
    product,
    contextProperties
  } = _ref;
  return {
    ...lib_getMappableValue(eventData, element, contextProperties),
    selection: click_tracker_getSelectionValue(element, contextProperties),
    product,
    platform: 'web'
  };
};
/* harmony default export */ var click_tracker_getEventData = (getEventData);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-analytics/lib/click-tracker/index.js





const defaultTrackableSelector = 'a,[data-trackable],[data-trackable-selection]';
const useDefaultEventDataMapper = _ref => {
  let {
    eventData = {},
    product
  } = _ref;
  return react.useCallback((element, contextProperties) => click_tracker_getEventData({
    element,
    eventData,
    product,
    contextProperties
  }), [eventData, product]);
};
const useClickTracker = _ref2 => {
  let {
    eventData = {},
    product,
    ...props
  } = _ref2;
  const defaultEventDataMapper = useDefaultEventDataMapper({
    eventData,
    product
  });
  return useGenericClickTracker({
    trackableSelector: defaultTrackableSelector,
    eventData: defaultEventDataMapper,
    ...props
  });
};
const ClickTracker = _ref3 => {
  let {
    product,
    eventData = {},
    ...props
  } = _ref3;
  const defaultEventDataMapper = useDefaultEventDataMapper({
    eventData,
    product
  });
  return /*#__PURE__*/React.createElement(GenericClickTracker, _extends({
    trackableSelector: defaultTrackableSelector,
    eventData: defaultEventDataMapper
  }, props));
};
 false ? 0 : void 0;
/* harmony default export */ var click_tracker = ((/* unused pure expression or super */ null && (ClickTracker)));
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/extends.js
var esm_extends = __webpack_require__(70509);
// EXTERNAL MODULE: ./node_modules/@xo-union/react-css-modules/lib/index.js
var react_css_modules_lib = __webpack_require__(33289);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-css-grid/lib/styles.css
var lib_styles = __webpack_require__(35075);
var styles_default = /*#__PURE__*/__webpack_require__.n(lib_styles);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-grid/lib/components/FullBleedContainer/index.js






const FullBleedContainer = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    children,
    classes: classesProp,
    as: ComponentToRender,
    ...props
  } = _ref;
  const classes = (0,react_css_modules_lib.useClasses)((styles_default()), classesProp);
  return /*#__PURE__*/react.createElement(ComponentToRender, (0,esm_extends["default"])({
    ref: ref,
    className: classes['full-bleed-container']
  }, props), children);
});
 false ? 0 : void 0;
FullBleedContainer.defaultProps = {
  as: 'div'
};
/* harmony default export */ var components_FullBleedContainer = (FullBleedContainer);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-grid/lib/components/TopLevelContainer/index.js






const TopLevelContainer = _ref => {
  let {
    children,
    classes: classesProp,
    as: ComponentToRender,
    ...props
  } = _ref;
  const classes = (0,react_css_modules_lib.useClasses)((styles_default()), classesProp);
  return /*#__PURE__*/react.createElement(ComponentToRender, (0,esm_extends["default"])({
    className: classes['top-level-container']
  }, props), children);
};
 false ? 0 : void 0;
TopLevelContainer.defaultProps = {
  as: 'div'
};
/* harmony default export */ var components_TopLevelContainer = (TopLevelContainer);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/classnames/index.js
var classnames = __webpack_require__(76548);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-grid/lib/components/Row/index.js







const Row = _ref => {
  let {
    as: ComponentToRender,
    children,
    className,
    classes: classesProp,
    hAlign,
    hGutters,
    noGutters,
    vAlign,
    vGutters,
    ...props
  } = _ref;
  const classes = (0,react_css_modules_lib.useClasses)((styles_default()), classesProp);
  const containerClass = classnames_default()(className, classes.row, hAlign && (styles_default())[`justify-content-${hAlign}`], vAlign && (styles_default())[`align-items-${vAlign}`], {
    [(styles_default())["no-gutters"]]: hGutters === false || noGutters
  }, {
    [(styles_default())["vertical-gutters"]]: vGutters
  });
  return /*#__PURE__*/react.createElement(ComponentToRender, (0,esm_extends["default"])({
    className: containerClass
  }, props), children);
};
Row.defaultProps = {
  as: 'div',
  hGutters: true,
  noGutters: false,
  vGutters: false,
  className: ''
};
 false ? 0 : void 0;
/* harmony default export */ var components_Row = (Row);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/reduce.js
var reduce = __webpack_require__(86432);
var reduce_default = /*#__PURE__*/__webpack_require__.n(reduce);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/object/keys.js
var keys = __webpack_require__(9938);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/concat.js
var concat = __webpack_require__(33028);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-grid/lib/components/Column/index.js








const getGridSizeClasses = breakpoints => {
  var _context;
  return reduce_default()(_context = keys_default()(breakpoints)).call(_context, (classes, key) => {
    if (!breakpoints[key]) {
      return classes;
    }
    const sizeSuffix = breakpoints[key] === true ? '' : `-${breakpoints[key]}`;
    const breakpointInfix = key === 'xs' ? '' : `-${key}`;
    return classnames_default()(classes, (styles_default())[`col${breakpointInfix}${sizeSuffix}`]);
  }, '');
};
const getGridOrderClass = orderBreakpoints => {
  var _context2;
  return reduce_default()(_context2 = keys_default()(orderBreakpoints)).call(_context2, (classes, key) => {
    if (!orderBreakpoints[key]) {
      return classes;
    }
    const [, breakpoint] = key.match(/order(..)?$/);
    const breakpointInfix = breakpoint ? `-${breakpoint.toLowerCase()}` : '';
    const valueSuffix = `-${orderBreakpoints[key]}`;
    return classnames_default()(classes, (styles_default())[`order${breakpointInfix}${valueSuffix}`]);
  }, '');
};
const Column = _ref => {
  let {
    xs,
    sm,
    md,
    lg,
    xl,
    xxl,
    order,
    orderSm,
    orderMd,
    orderLg,
    orderXl,
    orderXxl,
    children,
    className,
    as: ComponentToRender,
    ...props
  } = _ref;
  const classes = [getGridOrderClass({
    order,
    orderSm,
    orderMd,
    orderLg,
    orderXl,
    orderXxl
  }), getGridSizeClasses({
    xs,
    sm,
    md,
    lg,
    xl,
    xxl
  }), className];
  return /*#__PURE__*/react.createElement(ComponentToRender, (0,esm_extends["default"])({
    className: classnames_default()(classes)
  }, props), children);
};
const allowedColumnValues =  false ? 0 : {};
const columnNumberPropType =  false ? 0 : {};
const allowedColumnSizeProps =  false ? 0 : {};
const columnSizePropType =  false ? 0 : {};
 false ? 0 : void 0;
Column.defaultProps = {
  className: '',
  as: 'div'
};
/* harmony default export */ var components_Column = (Column);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/css/index.css
var css = __webpack_require__(15618);
var css_default = /*#__PURE__*/__webpack_require__.n(css);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-consent-management/lib/CookieSettingsButton.js


/// <reference types="@xo-union/consent-management/globals" />



// This is temporary until fragment version is adapted
const getFallbackButtonProps = () => {
  const ot = (global_this_default()).OneTrust;
  const data = ot.GetDomainData();
  const cm = data.ConsentModel;
  return {
    text: data.CookieSettingButtonText,
    isVisible: cm.Name !== 'notice only'
  };
};
const defaultRenderFunction = buttonProps => /*#__PURE__*/react.createElement("button", (0,esm_extends["default"])({
  type: "button"
}, buttonProps));
const CookieSettingsButton = _ref => {
  let {
    children = defaultRenderFunction,
    ...rest
  } = _ref;
  const [visible, setVisible] = react.useState(false);
  const [text, setText] = react.useState('Your privacy choices');
  react.useEffect(() => {
    const uc = (global_this_default()).UnionConsentManagement;
    if (!uc) return (noop_default());
    if (!uc.consentPlatformEnabled) {
      setVisible(false);
      return (noop_default());
    }

    // wait for provider to load so we can get the final text and avoid flash of content
    const onProviderLoad = () => {
      const props = uc.getCookieSettingsButtonProps ? uc.getCookieSettingsButtonProps() : getFallbackButtonProps();
      setVisible(props.isVisible);
      setText(props.text);
    };
    uc.addEventListener('provider-load', onProviderLoad);
    return () => {
      uc.removeEventListener('provider-load', onProviderLoad);
    };
  }, []);
  const buttonProps = {
    ...rest,
    disabled: !visible,
    onClick: () => global_this_default().UnionConsentManagement.togglePreferencesModal(),
    children: text
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, children(buttonProps, {
    text,
    visible
  }));
};
/* harmony default export */ var lib_CookieSettingsButton = (CookieSettingsButton);
// EXTERNAL MODULE: ./node_modules/@xo-union/component-blank-button/lib/css/styles.css
var css_styles = __webpack_require__(90248);
var css_styles_default = /*#__PURE__*/__webpack_require__.n(css_styles);
;// CONCATENATED MODULE: ./node_modules/@xo-union/component-blank-button/lib/index.js





/**
 * Renders a button with vendor specific styles removed
 *
 * Forwards the ref to the underlying button
 */
const BlankButton = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    className,
    ...props
  } = _ref;
  const finalClassName = `${(css_styles_default()).button} ${className}`;
  // eslint-disable-next-line react/button-has-type
  return /*#__PURE__*/react.createElement("button", (0,esm_extends["default"])({
    ref: ref,
    className: finalClassName
  }, props));
});
BlankButton.displayName = 'BlankButton';
 false ? 0 : void 0;
BlankButton.defaultProps = {
  className: ''
};
/* harmony default export */ var component_blank_button_lib = (BlankButton);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/FooterLink/index.js
var FooterLink = __webpack_require__(55961);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/CopyrightSection/index.js



const CopyrightSection = _ref => {
  let {
    copyrightText = `©1997-${new Date().getFullYear()} XO Group Inc.`
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: (css_default()).copyrightItem
  }, copyrightText);
};
 false ? 0 : void 0;
/* harmony default export */ var components_CopyrightSection = (CopyrightSection);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/utils/urls.js

const DIST_NAME = 'tk-pagelet-footer-nav';
const getFooterAssetUrl = (tag, path) => getUrl({
  params: {
    name: DIST_NAME,
    tag,
    path
  }
});
const getFooterSSIUrl = (tag, path) => getSSIUrl({
  params: {
    name: DIST_NAME,
    tag,
    path
  }
});
const KNOT_HOST_MAP = {
  qa: 'https://qa-beta.theknot.com',
  production: 'https://www.theknot.com'
};
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/HostContext.js



const Context = /*#__PURE__*/react.createContext();
const useTKHost = () => react.useContext(Context);
const TKHostProvider = _ref => {
  let {
    env,
    children
  } = _ref;
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: KNOT_HOST_MAP[env] || ''
  }, children);
};
 false ? 0 : void 0;
const TKHostConsumer = Context.Consumer;
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/sections/BusinessSection/index.js








const BusinessItem = props => /*#__PURE__*/react.createElement("li", null, /*#__PURE__*/react.createElement(FooterLink/* default */.Z, (0,esm_extends["default"])({
  className: (css_default()).businessItemBase
}, props)));
const BusinessSection = () => {
  const tkHost = useTKHost();
  return /*#__PURE__*/react.createElement("div", {
    className: (css_default()).businessLinksContainer
  }, /*#__PURE__*/react.createElement("ul", {
    className: (css_default()).businessLinksContainer,
    role: "list"
  }, /*#__PURE__*/react.createElement(BusinessItem, {
    href: `${tkHost}/privacy-policy`
  }, "Privacy policy"), /*#__PURE__*/react.createElement(BusinessItem, {
    href: `${tkHost}/terms-and-conditions`
  }, "Terms of use"), /*#__PURE__*/react.createElement(BusinessItem, {
    href: `${tkHost}/marketplace/AI-terms`
  }, "AI"), /*#__PURE__*/react.createElement(BusinessItem, {
    href: "https://www.theknotww.com/accessibility-statement"
  }, "Accessibility"), /*#__PURE__*/react.createElement(BusinessItem, {
    href: "https://theknotww.zendesk.com/hc/en-us/requests/new?ticket_form_id=360000590371",
    rel: "nofollow"
  }, "Do not sell my info"), /*#__PURE__*/react.createElement(BusinessItem, {
    href: "https://www.theknotww.com/ca-collection-notice/"
  }, "CA privacy"), /*#__PURE__*/react.createElement(BusinessItem, {
    href: "https://images.theknot.com/rules/2024/The-Knot-Rewards-Program-Terms-and-Conditions.pdf"
  }, "The Knot Rewards"), /*#__PURE__*/react.createElement("li", null, /*#__PURE__*/react.createElement(lib_CookieSettingsButton, {
    className: (css_default()).cookieSettingsButton
  }, buttonProps => /*#__PURE__*/react.createElement(component_blank_button_lib, (0,esm_extends["default"])({
    type: "button"
  }, buttonProps))))), /*#__PURE__*/react.createElement(components_CopyrightSection, null));
};
/* harmony default export */ var sections_BusinessSection = (BusinessSection);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-analytics/lib/trackable/index.js
var trackable = __webpack_require__(94956);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-icons/lib/css/base.css
var base = __webpack_require__(90510);
var base_default = /*#__PURE__*/__webpack_require__.n(base);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-icons/lib/icon-sets/v2/index.js
/* harmony default export */ var v2 = ({
  resolve: iconName => ({
    id: `v2-icon-${iconName}`,
    className: ''
  })
});
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-icons/lib/components/Icon/index.js






/**
 * Component used to render a non interactive icon based on the definitions in the loaded icons fragment
 */
const Icon = _ref => {
  let {
    name,
    iconSet,
    className,
    size,
    ...rest
  } = _ref;
  const {
    id,
    className: ownClassName
  } = iconSet.resolve(name);
  const classes = [(base_default()).icon, size ? (base_default())[`size-${size}`] : (base_default())["icon-has-no-size"], className, ownClassName];
  return /*#__PURE__*/react.createElement("svg", (0,esm_extends["default"])({
    className: classes.join(' ')
  }, rest), /*#__PURE__*/react.createElement("use", {
    xlinkHref: `#${id}`
  }));
};
 false ? 0 : void 0;
Icon.defaultProps = {
  className: '',
  iconSet: v2,
  size: null
};
/* harmony default export */ var components_Icon = (Icon);
// EXTERNAL MODULE: ./node_modules/@xo-union/react-unique-id/lib/index.js
var react_unique_id_lib = __webpack_require__(79946);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/sections/SectionGroup/index.js










const SectionGroup = props => {
  const [isOpen, setIsOpen] = react.useState(false);
  const handleSectionLabelClick = () => {
    setIsOpen(isOpenValue => !isOpenValue);
  };
  const {
    title,
    children,
    className = '',
    trackableProps: {
      selection
    }
  } = props;
  const titleID = (0,react_unique_id_lib/* useUniqueID */.h)();
  const listID = (0,react_unique_id_lib/* useUniqueID */.h)();
  return /*#__PURE__*/react.createElement("div", {
    role: "group",
    "aria-roledescription": "navigation level 2",
    "aria-labelledby": titleID,
    className: className
  }, /*#__PURE__*/react.createElement(component_blank_button_lib, (0,esm_extends["default"])({
    className: (css_default()).mobileSectionLabel,
    onClick: handleSectionLabelClick,
    type: "button",
    "aria-expanded": isOpen ? 'true' : 'false',
    "aria-controls": listID
  }, (0,trackable/* createTrackableProps */.Ur)({
    selection: isOpen ? `collapse-${selection}` : `expand-${selection}`
  })), title, /*#__PURE__*/react.createElement(components_Icon, {
    name: isOpen ? 'caret_up' : 'caret_down',
    size: "md"
  })), /*#__PURE__*/react.createElement("div", {
    role: "heading",
    "aria-level": "1",
    className: (css_default()).desktopSectionLabel,
    id: titleID
  }, title), /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((css_default()).sectionItemsWrapper, !isOpen && (css_default()).hidden)
  }, /*#__PURE__*/react.createElement("div", {
    id: listID,
    role: "list",
    className: (css_default()).sectionItemsList
  }, children)));
};
 false ? 0 : void 0;
const SectionGroupRow = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/react.createElement(components_Row, {
    role: "presentation",
    className: (css_default()).sectionGroupRow
  }, children);
};
 false ? 0 : void 0;
const SectionColumn = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/react.createElement(components_Column, {
    role: "presentation",
    xs: "12",
    md: "6"
  }, children);
};
 false ? 0 : void 0;
/* harmony default export */ var sections_SectionGroup = (SectionGroup);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/sections/SectionItem/index.js




const SectionItem = props => /*#__PURE__*/react.createElement("div", {
  role: "listitem"
}, /*#__PURE__*/react.createElement(FooterLink/* default */.Z, (0,esm_extends["default"])({
  className: (css_default()).sectionItem
}, props)));
/* harmony default export */ var sections_SectionItem = (SectionItem);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/sections/ProductsSection/index.js





const ProductsSection = () => {
  const tkHost = useTKHost();
  return /*#__PURE__*/react.createElement(sections_SectionGroup, {
    title: "Planning & Inspiration",
    className: (css_default()).productsSection,
    trackableProps: {
      selection: 'planning'
    }
  }, /*#__PURE__*/react.createElement(SectionGroupRow, null, /*#__PURE__*/react.createElement(SectionColumn, null, /*#__PURE__*/react.createElement(sections_SectionItem, {
    href: `${tkHost}/gs/wedding-websites`
  }, "Wedding websites"), /*#__PURE__*/react.createElement(sections_SectionItem, {
    className: (css_default()).sectionItem,
    href: `${tkHost}/registry`
  }, "Registry"), /*#__PURE__*/react.createElement(sections_SectionItem, {
    href: `${tkHost}/marketplace`
  }, "Marketplace"), /*#__PURE__*/react.createElement(sections_SectionItem, {
    href: `${tkHost}/paper/invitations/wedding`
  }, "Wedding invitations"), /*#__PURE__*/react.createElement(sections_SectionItem, {
    href: `${tkHost}/wedding-planning-app`
  }, "Get The Knot app"), /*#__PURE__*/react.createElement(sections_SectionItem, {
    href: `${tkHost}/wedding-budget`
  }, "Wedding budget"), /*#__PURE__*/react.createElement(sections_SectionItem, {
    href: `${tkHost}/wedding-checklist`
  }, "Wedding checklist"), /*#__PURE__*/react.createElement(sections_SectionItem, {
    href: `${tkHost}/gs/guest-list`
  }, "Wedding guest list")), /*#__PURE__*/react.createElement(SectionColumn, null, /*#__PURE__*/react.createElement(sections_SectionItem, {
    href: `${tkHost}/content`,
    trackableProps: {
      selection: 'wedding etiquette'
    }
  }, "Wedding ideas & etiquette"), /*#__PURE__*/react.createElement(sections_SectionItem, {
    href: `${tkHost}/content/getting-engaged-advice`
  }, "Engagement"), /*#__PURE__*/react.createElement(sections_SectionItem, {
    href: `${tkHost}/content/wedding-rehearsal-party-advice`,
    trackableProps: {
      selection: 'parties events'
    }
  }, "Parties & events"), /*#__PURE__*/react.createElement(sections_SectionItem, {
    href: `${tkHost}/fashion/wedding-dresses`,
    trackableProps: {
      selection: 'wedding dresses'
    }
  }, "Wedding dresses"), /*#__PURE__*/react.createElement(sections_SectionItem, {
    href: `${tkHost}/content/wedding-gift-favor-advice`
  }, "Gifts"), /*#__PURE__*/react.createElement(sections_SectionItem, {
    href: `${tkHost}/real-weddings/photos`
  }, "Real Wedding photos"), /*#__PURE__*/react.createElement(sections_SectionItem, {
    href: "https://forums.theknot.com/community"
  }, "Community"))));
};
/* harmony default export */ var sections_ProductsSection = (ProductsSection);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/map.js
var map = __webpack_require__(93726);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/sections/TheCompanySection/index.js








const TheCompanySection = () => {
  const tkHost = useTKHost();
  const items = [{
    children: 'The Knot Worldwide',
    href: 'https://www.theknotww.com/'
  }, {
    children: 'About us',
    href: 'https://www.theknotww.com/about-us/'
  }, {
    children: 'The Knot Editorial',
    href: `${tkHost}/about-editorial`
  }, {
    children: 'Careers',
    href: 'https://www.theknotww.com/careers/'
  }, {
    children: 'International',
    href: 'https://www.theknotww.com/international/'
  }, {
    children: 'Press',
    href: 'https://www.theknotww.com/press-room/'
  }, {
    children: 'National advertising',
    href: 'https://www.theknotww.com/advertising/national/',
    trackableProps: {
      selection: 'advertisers'
    }
  }, {
    children: 'Our sponsors',
    href: 'https://www.theknot.com/partners',
    trackableProps: {
      selection: 'sponsors'
    }
  }];
  return /*#__PURE__*/react.createElement(sections_SectionGroup, {
    title: "The Company",
    trackableProps: {
      selection: 'company'
    },
    className: (css_default()).companySection
  }, map_default()(items).call(items, itemProps => /*#__PURE__*/react.createElement(sections_SectionItem, (0,esm_extends["default"])({
    key: itemProps.href
  }, itemProps))));
};
 false ? 0 : void 0;
/* harmony default export */ var sections_TheCompanySection = (TheCompanySection);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/sections/BrandsSection/index.js








const BrandsSection = () => {
  const items = [{
    children: 'The Bump',
    href: 'https://www.thebump.com'
  }, {
    children: 'The Bash',
    href: 'https://www.thebash.com'
  }, {
    children: 'Simply Eloped',
    href: 'https://simplyeloped.com'
  }];
  return /*#__PURE__*/react.createElement(sections_SectionGroup, {
    title: "Sister Sites",
    trackableProps: {
      selection: 'sister-sites'
    },
    className: classnames_default()((css_default()).section, (css_default()).brandsSection)
  }, map_default()(items).call(items, itemProps => /*#__PURE__*/react.createElement(sections_SectionItem, (0,esm_extends["default"])({
    key: itemProps.href
  }, itemProps))));
};
 false ? 0 : void 0;
/* harmony default export */ var sections_BrandsSection = (BrandsSection);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/sections/HelpSection/index.js







const HelpSection = () => {
  const items = [{
    children: 'Help Center',
    href: 'https://helpcenter.theknot.com/hc/en-us'
  }];
  return /*#__PURE__*/react.createElement(sections_SectionGroup, {
    title: "Help",
    trackableProps: {
      selection: 'help'
    },
    className: (css_default()).section
  }, map_default()(items).call(items, itemProps => /*#__PURE__*/react.createElement(sections_SectionItem, (0,esm_extends["default"])({
    key: itemProps.href
  }, itemProps))));
};
 false ? 0 : void 0;
/* harmony default export */ var sections_HelpSection = (HelpSection);
// EXTERNAL MODULE: ./node_modules/@xo-union/component-standard-elements/lib/anchor/index.js + 1 modules
var lib_anchor = __webpack_require__(76903);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(61820);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-accessibility/lib/FocusBoundary/index.js
var FocusBoundary = __webpack_require__(9433);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-icons/lib/css/interactive-icon.css
var interactive_icon = __webpack_require__(50049);
var interactive_icon_default = /*#__PURE__*/__webpack_require__.n(interactive_icon);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-icons/lib/components/InteractiveIcon/index.js







const InteractiveIcon = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    name,
    className,
    iconSet,
    size,
    as: Type,
    block,
    'aria-label': ariaLabel,
    ...props
  } = _ref;
  const classes = [className, (interactive_icon_default()).container, block ? (interactive_icon_default())["is-block"] : (interactive_icon_default())["is-inline"], size ? (interactive_icon_default())[`size-${size}`] : ''];
  return /*#__PURE__*/react.createElement(FocusBoundary/* Focusable */.Y, (0,esm_extends["default"])({
    ref: ref,
    as: Type,
    className: classes.join(' ')
  }, ariaLabel && {
    'aria-label': ariaLabel
  }, props), /*#__PURE__*/react.createElement(components_Icon, (0,esm_extends["default"])({
    name: name,
    iconSet: iconSet,
    size: size
  }, ariaLabel && {
    'aria-hidden': true
  })));
});
 false ? 0 : void 0;
InteractiveIcon.defaultProps = {
  className: '',
  block: false,
  iconSet: v2,
  size: null,
  'aria-label': null
};
InteractiveIcon.displayName = 'InteractiveIcon';
/* harmony default export */ var components_InteractiveIcon = (InteractiveIcon);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-icons/lib/components/IconLink/index.js





/**
 * Render an interactive icon as a link. Use this component when the interaction will send the user
 * to a different url.
 *
 * Passes ref to underlying link
 */
const IconLink = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    name,
    size,
    block,
    as,
    ...rest
  } = _ref;
  return /*#__PURE__*/react.createElement(components_InteractiveIcon, (0,esm_extends["default"])({
    ref: ref,
    as: as,
    name: name,
    block: block,
    size: size
  }, rest));
});
IconLink.propTypes = {
  /**
   * Icon name
   */
  name: (prop_types_default()).string.isRequired,
  /**
   * Component to render
   */
  as: (prop_types_default()).elementType,
  /**
   * To determine if icon should have a block display
   */
  block: (prop_types_default()).bool,
  /**
   * Size class
   */
  size: prop_types_default().oneOf(['sm', 'md', 'lg'])
};
IconLink.defaultProps = {
  size: null,
  as: 'a'
};
IconLink.displayName = 'IconLink';
/* harmony default export */ var components_IconLink = (IconLink);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/graphicElements/SocialIcon/index.js







const SocialIcon = _ref => {
  let {
    name
  } = _ref;
  return /*#__PURE__*/react.createElement(components_IconLink, (0,esm_extends["default"])({
    as: lib_anchor/* NewWindowAnchor */.u2,
    name: `social_${name}_selected`,
    href: `https://${name}.com/theknot`,
    className: (css_default()).socialIcon,
    size: "md",
    "aria-label": name
  }, (0,trackable/* createTrackableProps */.Ur)({
    selection: name
  })));
};
 false ? 0 : void 0;
/* harmony default export */ var graphicElements_SocialIcon = (SocialIcon);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/sections/SocialSection/index.js



const SocialSection = () => /*#__PURE__*/react.createElement("div", {
  role: "group",
  "aria-roledescription": "navigation level 2",
  "aria-label": "social media"
}, /*#__PURE__*/react.createElement("ul", {
  role: "list",
  className: (css_default()).socialIconsSection
}, /*#__PURE__*/react.createElement("li", null, /*#__PURE__*/react.createElement(graphicElements_SocialIcon, {
  name: "facebook"
})), /*#__PURE__*/react.createElement("li", null, /*#__PURE__*/react.createElement(graphicElements_SocialIcon, {
  name: "twitter"
})), /*#__PURE__*/react.createElement("li", null, /*#__PURE__*/react.createElement(graphicElements_SocialIcon, {
  name: "pinterest"
})), /*#__PURE__*/react.createElement("li", null, /*#__PURE__*/react.createElement(graphicElements_SocialIcon, {
  name: "instagram"
}))));
/* harmony default export */ var sections_SocialSection = (SocialSection);
// EXTERNAL MODULE: ./node_modules/@xo-union/component-brand-logo/lib/BrandLogo.js
var BrandLogo = __webpack_require__(56693);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/graphicElements/TKBrandLogo/index.js





const TKBrandLogo = () => /*#__PURE__*/react.createElement("a", (0,esm_extends["default"])({
  href: "/",
  className: (css_default()).logo,
  "aria-label": "The Knot home"
}, (0,trackable/* createTrackableProps */.Ur)({
  selection: 'tk-logo'
})), /*#__PURE__*/react.createElement(BrandLogo/* default */.Z, {
  name: "theknot",
  size: "lg",
  color: "secondary"
}));
/* harmony default export */ var graphicElements_TKBrandLogo = (TKBrandLogo);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/graphicElements/Heart/index.js


const SVG_TITLE_ID = 'footer-heart';
const Heart = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", {
    "aria-labelledby": SVG_TITLE_ID,
    className: className,
    height: "14",
    role: "img",
    width: "19",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react.createElement("title", {
    id: SVG_TITLE_ID
  }, "love"), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.5 3.5c.5-1 1.4-3.5 4.3-3.5 2.8 0 5.4 1.9 5.2 5.9-.2 2.6-3.3 5.3-9.5 8C3.3 11.3.2 8.6 0 6-.2 1.9 2.4 0 5.2 0 8.1 0 9 2.5 9.5 3.5z"
  }));
};
 false ? 0 : void 0;
/* harmony default export */ var graphicElements_Heart = (Heart);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-typography/lib/components/Subhead/index.js
var Subhead = __webpack_require__(70479);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-typography/lib/font-scale-categories.css
var font_scale_categories = __webpack_require__(86085);
var font_scale_categories_default = /*#__PURE__*/__webpack_require__.n(font_scale_categories);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-ui-typography/lib/components/Overline/index.js




const Overline = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    className,
    as: ComponentToRender,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement(ComponentToRender, (0,esm_extends["default"])({
    ref: ref,
    className: `${className} ${(font_scale_categories_default()).overline}`
  }, props));
});
Overline.defaultProps = {
  className: '',
  as: 'div'
};
Overline.propTypes = {
  /**
   * Additional classes to apply
   */
  className: (prop_types_default()).string,
  /**
   * Component to render
   */
  as: (prop_types_default()).elementType
};
/* harmony default export */ var components_Overline = (Overline);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-typography/lib/components/Editorial/index.js
var Editorial = __webpack_require__(43786);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-typography/lib/components/Body/index.js + 1 modules
var Body = __webpack_require__(33558);
;// CONCATENATED MODULE: ./node_modules/@tkww/orion-web-lib-react/lib/useLayoutEffect.js

const useLayoutEffect = typeof window === 'undefined' ? react.useEffect : react.useLayoutEffect;
;// CONCATENATED MODULE: ./node_modules/@tkww/orion-web-ext-zendesk/lib/meta.js
/* provided dependency */ var process = __webpack_require__(37082);
const meta = {
  scriptId: 'ze-snippet',
  scriptHost: 'https://static.zdassets.com',
  scriptSrc() {
    let apiKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : process.env.ORION_WEB_ZENDESK_API_KEY ?? process.env.REACT_APP_ORION_WEB_ZENDESK_API_KEY;
    if (!apiKey) {
      throw new Error('Zendesk requires an API key');
    }
    return `${meta.scriptHost}/ekr/snippet.js?key=${apiKey}`;
  }
};
;// CONCATENATED MODULE: ./node_modules/@tkww/orion-web-ext-zendesk/lib/getProxy.js
/* provided dependency */ var getProxy_process = __webpack_require__(37082);

const ensureScriptLoaded = _ref => {
  let {
    apiKey
  } = _ref;
  let snippet = document.getElementById(meta.scriptId);
  if (!snippet) {
    snippet = document.createElement('script');
    snippet.id = meta.scriptId;
    snippet.src = meta.scriptSrc(apiKey);
    snippet.async = true;
    document.head.appendChild(snippet);
    const promise = new Promise((resolve, reject) => {
      snippet.addEventListener('load', resolve, {
        once: true
      });
      snippet.addEventListener('error', reject, {
        once: true
      });
    });
    snippet[zScriptPromise] = promise;
    return promise;
  }
  if (snippet[zScriptPromise]) {
    return snippet[zScriptPromise];
  }
  return globalThis.zE ? Promise.resolve() : Promise.reject(new Error('Zendesk script already loaded but did not find zE global'));
};
const zEPrivateGlobal = Symbol.for('@tkww/orion-web-ext-zendesk/zEPrivateGlobal');
const zScriptPromise = Symbol.for('@tkww/orion-web-ext-zendesk/zScriptPromise');
const globals = function () {
  let assign = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  globalThis[zEPrivateGlobal] = globalThis[zEPrivateGlobal] || {
    proxy: null,
    isLoading: false,
    isLoaded: false,
    config: {
      loading: getProxy_process.env.ORION_WEB_ZENDESK_LOADING ?? getProxy_process.env.REACT_APP_ORION_WEB_ZENDESK_LOADING ?? 'lazy'
    },
    q: []
  };
  return Object.assign(globalThis[zEPrivateGlobal], assign);
};
const configure = props => {
  const {
    config
  } = globals();
  Object.assign(config, props);
};
const getProxy = () => {
  var _globalThis$zEPrivate;
  if ((_globalThis$zEPrivate = globalThis[zEPrivateGlobal]) !== null && _globalThis$zEPrivate !== void 0 && _globalThis$zEPrivate.proxy) {
    return globals().proxy;
  }
  const eventTarget = new EventTarget();
  const load = () => {
    const {
      config,
      isLoaded,
      isLoading
    } = globals();
    if (isLoaded || isLoading) {
      return;
    }
    globals({
      isLoading: true
    });
    eventTarget.dispatchEvent(new CustomEvent('loadingStateChange', {
      detail: {
        isLoading: true
      }
    }));
    ensureScriptLoaded({
      apiKey: config.apiKey
    }).then(() => {
      const {
        q
      } = globals({
        isLoaded: true
      });
      if (Array.isArray(q)) {
        q.forEach(args => {
          globalThis.zE(...args);
        });
        q.splice(0);
        globals({
          q: {
            push: args => globalThis.zE(...args)
          }
        });
      }
      globalThis.zE(() => {
        globals({
          isLoading: false
        });
        eventTarget.dispatchEvent(new CustomEvent('loadingStateChange', {
          detail: {
            isLoading: false
          }
        }));
      });
    }).catch(err => {
      eventTarget.dispatchEvent(new CustomEvent('error', {
        detail: err
      }));
      globals({
        isLoading: false
      });
      eventTarget.dispatchEvent(new CustomEvent('loadingStateChange', {
        detail: {
          isLoading: false
        }
      }));
    });
  };
  const zE = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return globals().q.push(args);
  };
  zE('messenger:on', 'open', () => {
    eventTarget.dispatchEvent(new CustomEvent('open'));
  });
  zE('messenger:on', 'close', () => {
    eventTarget.dispatchEvent(new CustomEvent('close'));
  });
  zE('messenger:on', 'unreadMessages', count => {
    eventTarget.dispatchEvent(new CustomEvent('unreadMessages', {
      detail: {
        count
      }
    }));
  });
  zE('messenger:set', 'locale', 'en');
  zE('messenger:set', 'zIndex', 21);
  zE('messenger', 'show');
  const loadWrap = fn => {
    return function () {
      if (config.loading === 'lazy') {
        load();
      }
      fn(...arguments);
    };
  };
  const {
    config,
    proxy
  } = globals({
    proxy: {
      addEventListener: eventTarget.addEventListener.bind(eventTarget),
      removeEventListener: eventTarget.removeEventListener.bind(eventTarget),
      load,
      show: loadWrap(() => {
        zE('messenger', 'show');
      }),
      hide: loadWrap(() => {
        zE('messenger', 'hide');
      }),
      open: loadWrap(() => {
        zE('messenger', 'open');
      }),
      close: loadWrap(() => {
        zE('messenger', 'close');
      }),
      set zIndex(value) {
        zE('messenger:set', 'zIndex', value);
      },
      set locale(value) {
        zE('messenger:set', 'locale', value);
      },
      get isLoading() {
        return globals().isLoading;
      }
    }
  });
  if (config.loading === 'eager') {
    load();
  }
  return proxy;
};
;// CONCATENATED MODULE: ./node_modules/@tkww/orion-web-ext-zendesk/lib/react/useZendeskWidget.js



const useZendeskWidget = () => {
  const [unreadMessages, setUnreadMessages] = (0,react.useState)(0);
  const [isOpen, setIsOpen] = (0,react.useState)(false);
  const [isLoading, setIsLoading] = (0,react.useState)(false);
  const proxyRef = (0,react.useRef)();
  useLayoutEffect(() => {
    proxyRef.current = getProxy();
    setIsLoading(proxyRef.current.isLoading);
  }, []);
  (0,react.useEffect)(() => {
    const onOpen = () => {
      setIsOpen(true);
    };
    const onClose = () => {
      setIsOpen(false);
    };
    const onUnreadMessages = evt => {
      setUnreadMessages(evt.detail.count);
    };
    const onLoadingStateChange = evt => {
      setIsLoading(evt.detail.isLoading);
    };
    const proxy = proxyRef.current;
    proxy.addEventListener('loadingStateChange', onLoadingStateChange);
    proxy.addEventListener('open', onOpen);
    proxy.addEventListener('close', onClose);
    proxy.addEventListener('unreadMessages', onUnreadMessages);
    return () => {
      proxy.removeEventListener('loadingStateChange', onLoadingStateChange);
      proxy.removeEventListener('open', onOpen);
      proxy.removeEventListener('close', onClose);
      proxy.removeEventListener('unreadMessages', onUnreadMessages);
    };
  }, []);
  const actions = (0,react.useMemo)(() => ({
    setZIndex: value => {
      proxyRef.current.zIndex = value;
    },
    setLocale(value) {
      proxyRef.current.locale = value;
    },
    open: () => {
      var _proxyRef$current;
      (_proxyRef$current = proxyRef.current) === null || _proxyRef$current === void 0 || _proxyRef$current.open();
    },
    close: () => {
      var _proxyRef$current2;
      (_proxyRef$current2 = proxyRef.current) === null || _proxyRef$current2 === void 0 || _proxyRef$current2.close();
    }
  }), []);
  const data = (0,react.useMemo)(() => ({
    isLoading,
    isOpen,
    unreadMessages
  }), [isLoading, isOpen, unreadMessages]);
  return [data, actions];
};
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-buttons/lib/css/index.css
var lib_css = __webpack_require__(99050);
var lib_css_default = /*#__PURE__*/__webpack_require__.n(lib_css);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-buttons/lib/components/ThemeContext.js





const ClassesContext = /*#__PURE__*/react.createContext((lib_css_default()));
const ThemeProvider = _ref => {
  let {
    children,
    classes: classesProp
  } = _ref;
  const classes = useClasses(styles, classesProp);
  return /*#__PURE__*/React.createElement(ClassesContext.Provider, {
    value: classes
  }, children);
};
 false ? 0 : void 0;
const ThemeContext_useButtonClasses = override => {
  const contextClasses = react.useContext(ClassesContext);
  const ownClasses = (0,react_css_modules_lib.useClasses)((lib_css_default()), override);
  if (override !== undefined) {
    return ownClasses;
  }
  return contextClasses;
};
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-buttons/lib/components/Animation.js




const ANIMATION_DURATION = 250;
const Animation_useAnimationProps = () => {
  const [clicked, setClicked] = react.useState(false);
  const timerRef = react.useRef();
  const onClick = react.useCallback(() => {
    setClicked(true);
    clearTimeout(timerRef.current);
    timerRef.current = set_timeout_default()(() => {
      setClicked(false);
    }, ANIMATION_DURATION);
  }, []);
  react.useEffect(() => () => {
    clearTimeout(timerRef.current);
  }, []);
  return {
    clicked,
    onClick
  };
};
const AnimatedElement = _ref => {
  let {
    classes: classesProp
  } = _ref;
  const classes = ThemeContext_useButtonClasses(classesProp);
  return /*#__PURE__*/react.createElement("span", {
    "aria-hidden": "true",
    className: classes['animated-element']
  });
};
 false ? 0 : void 0;
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-buttons/lib/components/CtaContainer/index.js






const CtaContainer = _ref => {
  let {
    children,
    classes: classesProp,
    iconName,
    labelDirection,
    size
  } = _ref;
  const classes = ThemeContext_useButtonClasses(classesProp);
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(classes['cta-container'], iconName && classes[`has-${labelDirection || 'left'}-label`])
  }, iconName && /*#__PURE__*/react.createElement(components_Icon, {
    name: iconName,
    className: classes.icon,
    size: size === 'lg' ? 'lg' : 'md',
    "aria-hidden": "true"
  }), children);
};
 false ? 0 : void 0;
/* harmony default export */ var components_CtaContainer = (CtaContainer);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-spinner/lib/components/Spinner/index.js
var Spinner = __webpack_require__(15771);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-buttons/lib/components/LoadingContainer/index.js





const LoadingContainer = _ref => {
  let {
    classes: classesProp,
    loadingText
  } = _ref;
  const classes = ThemeContext_useButtonClasses(classesProp);
  return /*#__PURE__*/react.createElement("div", {
    className: classes['loading-container']
  }, /*#__PURE__*/react.createElement(Spinner/* default */.Z, {
    className: classes['loading-spinner'],
    size: "sm"
  }), loadingText);
};
 false ? 0 : void 0;
/* harmony default export */ var components_LoadingContainer = (LoadingContainer);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-buttons/lib/utilities/index.js




const getClassName = (ownProps, animationProps, classes) => classnames_default()(classes.btn, classes[ownProps.size], classes[ownProps.color], ownProps.className, ownProps.block === true && classes.block, `block-${ownProps.block}` in classes && classes[`block-${ownProps.block}`], ownProps.disabled && classes.disabled, ownProps.isLoading && classes.disabled, ownProps.active && classes.active, animationProps.clicked && classes.clicked);
const getContainerClassName = (ownProps, animationProps, classes) => classnames_default()(classes.container, ownProps.className, ownProps.disabled && classes.disabled, ownProps.active && classes.active, animationProps.clicked && classes.clicked);
const mergeCallbacks = function () {
  for (var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++) {
    callbacks[_key] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    for_each_default()(callbacks).call(callbacks, callback => {
      if (typeof callback === 'function') {
        callback(...args);
      }
    });
  };
};
const disabledProps = {
  tabIndex: '-1',
  role: 'button',
  'aria-disabled': 'true'
};
const disabledClickHandler = evt => {
  evt.preventDefault();
};
const handleLinkProps = (ownProps, animationProps, isContainer, linkStyles) => {
  const {
    active,
    block,
    classes,
    className,
    color,
    disabled,
    href,
    iconName,
    isLoading,
    labelDirection,
    onClick: ownOnClick,
    size,
    to,
    ...passThroughProps
  } = ownProps;
  const isDisabled = disabled || isLoading || !href && !to;
  const additionalProps = isDisabled ? disabledProps : {
    href,
    to
  };
  const onClick = isDisabled ? disabledClickHandler : mergeCallbacks(animationProps.onClick, ownOnClick);
  const classNameFunc = isContainer ? getContainerClassName : getClassName;
  return {
    ...passThroughProps,
    ...additionalProps,
    onClick,
    className: classNameFunc(ownProps, animationProps, linkStyles)
  };
};
const handleButtonProps = (ownProps, animationProps, isContainer, buttonStyles) => {
  const {
    active,
    block,
    classes,
    className,
    color,
    disabled,
    iconName,
    isLoading,
    labelDirection,
    onClick: ownOnClick,
    size,
    type,
    ...passThroughProps
  } = ownProps;
  const isDisabled = isLoading || disabled;
  const classNameFunc = isContainer ? getContainerClassName : getClassName;
  return {
    ...passThroughProps,
    'aria-disabled': isDisabled,
    className: classNameFunc(ownProps, animationProps, buttonStyles),
    disabled: isDisabled,
    onClick: mergeCallbacks(animationProps.onClick, ownOnClick),
    type
  };
};
const useButtonProps = (ownProps, isContainer) => {
  const animationProps = Animation_useAnimationProps();
  const classes = ThemeContext_useButtonClasses(ownProps.classes);
  return handleButtonProps(ownProps, animationProps, isContainer, classes);
};
const useLinkProps = (ownProps, isContainer) => {
  const animationProps = useAnimationProps();
  const classes = useButtonClasses(ownProps.classes);
  return handleLinkProps(ownProps, animationProps, isContainer, classes);
};
const limitPropUsageToTertiaryButtons = propType => function (props, propName) {
  if (props[propName] && props.color !== 'tertiary') {
    return new Error(`The ${propName} prop is only available if the \`color\` prop is set to "tertiary".`);
  }
  for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    rest[_key3 - 2] = arguments[_key3];
  }
  return propType(props, propName, ...rest);
};
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/node_modules/@xo-union/tk-component-buttons/lib/components/Button/index.js










/**
 * Render native button with union styles
 *
 * ref is passed to underlying button
 */
const Button = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    as: Type,
    loadingText,
    ...ownProps
  } = _ref;
  const {
    isLoading
  } = ownProps;
  const finalProps = useButtonProps(ownProps, false);
  return /*#__PURE__*/react.createElement(FocusBoundary/* Focusable */.Y, (0,esm_extends["default"])({
    as: Type,
    ref: ref
  }, finalProps), /*#__PURE__*/react.createElement(AnimatedElement, {
    classes: ownProps.classes
  }), isLoading ? /*#__PURE__*/react.createElement(components_LoadingContainer, {
    classes: ownProps.classes,
    loadingText: loadingText
  }) : /*#__PURE__*/react.createElement(components_CtaContainer, (0,esm_extends["default"])({
    classes: ownProps.classes
  }, ownProps)));
});
 false ? 0 : void 0;
Button.defaultProps = {
  as: 'button',
  size: 'lg',
  color: 'primary',
  isLoading: false,
  loadingText: 'Loading'
};
Button.displayName = 'Button';
/* harmony default export */ var components_Button = (Button);
;// CONCATENATED MODULE: ./node_modules/@tkww/orion-web-lib-react/lib/reactVersion.js

const REACT_MAJOR_VERSION = parseInt(react.version.split('.')[0], 10);
const isRsc = REACT_MAJOR_VERSION >= 19 && react.useState === undefined;
;// CONCATENATED MODULE: ./node_modules/@tkww/orion-web-lib-react/lib/useRscCompatibleRef.js
// eslint-disable-next-line no-restricted-imports


const fallback = current => ({
  current
});

/**
 * Create a ref that falls back to a plain object if `useRef` is not available.
 *
 * Only use this if the ref is optional and the component/hook is meant to
 * be used in client and server components.
 * @group React Hooks
 */
const useRscCompatibleRef = isRsc ? fallback : react.useRef;
// EXTERNAL MODULE: ./node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(15058);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ./node_modules/@tkww/orion-web-lib-react/lib/useUnstableReference.js




/**
 * Use an object that is unstable across renders.
 * This hook will perform a deep comparison and only change
 * the value if the new value is different from the previous value.
 *
 * @group React Hooks
 */
const useUnstableReference = value => {
  /* eslint-disable react-hooks/rules-of-hooks */
  if (isRsc) {
    return value;
  }
  const ref = useRscCompatibleRef(value);
  if (!fast_deep_equal_default()(ref.current, value)) {
    ref.current = value;
  }
  return ref.current;
};
;// CONCATENATED MODULE: ./node_modules/@tkww/orion-web-lib-react/lib/useRenderRef/useRenderRef.js
'use client';


const useRenderRef = value => {
  const ref = (0,react.useRef)(value);
  ref.current = value;
  return ref;
};
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/utils/useThrottledState.js



const useThrottledState = (state, delay) => {
  const [finalState, setFinalState] = (0,react.useState)(state);
  const stableState = useUnstableReference(state);
  const lastStateRef = useRenderRef(stableState);
  const timerRef = (0,react.useRef)(null);
  const delayRef = useRenderRef(delay);
  const isMountedRef = (0,react.useRef)(false);
  (0,react.useEffect)(() => {
    isMountedRef.current = true;
    if (!timerRef.current) {
      timerRef.current = set_timeout_default()(() => {
        timerRef.current = null;
        if (isMountedRef.current) {
          setFinalState(lastStateRef.current);
        }
      }, delayRef.current);
      return () => {
        isMountedRef.current = false;
      };
    }
  }, [stableState]);
  return finalState;
};
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/sections/ChatSection/index.js









const ChatSection = _ref => {
  let {
    hideInMobile,
    hideInDesktop
  } = _ref;
  const [data, actions] = useZendeskWidget();
  const throttledIsLoading = useThrottledState(data.isLoading, 500);
  const handleClick = () => data.isOpen ? actions.close() : actions.open();
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((css_default()).chatSection, hideInDesktop && (css_default()).hideChatInDesktop, hideInMobile && (css_default()).hideChatInMobile)
  }, /*#__PURE__*/react.createElement(component_blank_button_lib, {
    className: (css_default()).chatBubble,
    onClick: handleClick
  }, throttledIsLoading ? /*#__PURE__*/react.createElement(Spinner/* default */.Z, {
    className: (css_default()).chatSpinner,
    size: "lg"
  }) : /*#__PURE__*/react.createElement(components_Icon, {
    name: "speech_bubble_dots",
    size: "lg"
  })), /*#__PURE__*/react.createElement(components_Button, {
    color: "quaternary-alternative",
    size: "md",
    onClick: handleClick,
    isLoading: throttledIsLoading,
    loadingText: "Opening Zendesk Chat"
  }, "Need help?\xA0", /*#__PURE__*/react.createElement("span", {
    className: (css_default()).chatCta
  }, "Chat with us")));
};
/* harmony default export */ var sections_ChatSection = (ChatSection);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/graphicElements/QrCode/index.js


const QrCode = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", {
    className: className,
    role: "img",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#FFFFFF",
    d: "M0,0 h29v29H0z",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#000000",
    d: "M0 0h7v1H0zM13 0h1v1H13zM15 0h1v1H15zM17 0h4v1H17zM22,0 h7v1H22zM0 1h1v1H0zM6 1h1v1H6zM9 1h1v1H9zM11 1h1v1H11zM13 1h3v1H13zM17 1h1v1H17zM20 1h1v1H20zM22 1h1v1H22zM28,1 h1v1H28zM0 2h1v1H0zM2 2h3v1H2zM6 2h1v1H6zM8 2h4v1H8zM13 2h1v1H13zM18 2h1v1H18zM22 2h1v1H22zM24 2h3v1H24zM28,2 h1v1H28zM0 3h1v1H0zM2 3h3v1H2zM6 3h1v1H6zM8 3h5v1H8zM14 3h2v1H14zM17 3h1v1H17zM19 3h1v1H19zM22 3h1v1H22zM24 3h3v1H24zM28,3 h1v1H28zM0 4h1v1H0zM2 4h3v1H2zM6 4h1v1H6zM8 4h1v1H8zM10 4h1v1H10zM16 4h5v1H16zM22 4h1v1H22zM24 4h3v1H24zM28,4 h1v1H28zM0 5h1v1H0zM6 5h1v1H6zM8 5h2v1H8zM15 5h1v1H15zM17 5h2v1H17zM22 5h1v1H22zM28,5 h1v1H28zM0 6h7v1H0zM8 6h1v1H8zM10 6h1v1H10zM12 6h1v1H12zM14 6h1v1H14zM16 6h1v1H16zM18 6h1v1H18zM20 6h1v1H20zM22,6 h7v1H22zM8 7h1v1H8zM11 7h2v1H11zM14 7h2v1H14zM20 7h1v1H20zM0 8h1v1H0zM2 8h5v1H2zM11 8h1v1H11zM15 8h5v1H15zM22 8h5v1H22zM1 9h2v1H1zM4 9h1v1H4zM7 9h4v1H7zM12 9h13v1H12zM28,9 h1v1H28zM2 10h1v1H2zM4 10h1v1H4zM6 10h1v1H6zM8 10h1v1H8zM11 10h7v1H11zM22 10h2v1H22zM1 11h4v1H1zM9 11h1v1H9zM12 11h2v1H12zM15 11h1v1H15zM19 11h4v1H19zM25 11h1v1H25zM27 11h1v1H27zM0 12h2v1H0zM3 12h1v1H3zM5 12h2v1H5zM14 12h1v1H14zM16 12h2v1H16zM19 12h1v1H19zM25 12h2v1H25zM0 13h2v1H0zM3 13h1v1H3zM7 13h1v1H7zM9 13h1v1H9zM11 13h1v1H11zM15 13h5v1H15zM21 13h4v1H21zM28,13 h1v1H28zM2 14h3v1H2zM6 14h1v1H6zM9 14h1v1H9zM11 14h2v1H11zM15 14h4v1H15zM22 14h5v1H22zM3 15h1v1H3zM8 15h3v1H8zM14 15h2v1H14zM18 15h1v1H18zM22 15h3v1H22zM27 15h1v1H27zM0 16h2v1H0zM4 16h1v1H4zM6 16h2v1H6zM11 16h1v1H11zM17 16h2v1H17zM20 16h1v1H20zM25 16h2v1H25zM0 17h2v1H0zM3 17h1v1H3zM7 17h1v1H7zM9 17h1v1H9zM12 17h3v1H12zM16 17h1v1H16zM19 17h2v1H19zM22 17h3v1H22zM26 17h1v1H26zM28,17 h1v1H28zM0 18h1v1H0zM2 18h1v1H2zM4 18h1v1H4zM6 18h5v1H6zM12 18h4v1H12zM17 18h2v1H17zM24 18h1v1H24zM26 18h1v1H26zM0 19h1v1H0zM3 19h1v1H3zM5 19h1v1H5zM11 19h1v1H11zM13 19h1v1H13zM15 19h1v1H15zM21 19h1v1H21zM27 19h1v1H27zM0 20h1v1H0zM2 20h1v1H2zM6 20h2v1H6zM10 20h1v1H10zM12 20h1v1H12zM14 20h1v1H14zM20 20h5v1H20zM26,20 h3v1H26zM8 21h2v1H8zM11 21h2v1H11zM16 21h5v1H16zM24,21 h5v1H24zM0 22h7v1H0zM9 22h2v1H9zM12 22h1v1H12zM15 22h1v1H15zM19 22h2v1H19zM22 22h1v1H22zM24 22h3v1H24zM0 23h1v1H0zM6 23h1v1H6zM8 23h3v1H8zM14 23h2v1H14zM18 23h3v1H18zM24 23h1v1H24zM27 23h1v1H27zM0 24h1v1H0zM2 24h3v1H2zM6 24h1v1H6zM8 24h2v1H8zM16 24h1v1H16zM20 24h5v1H20zM26 24h1v1H26zM0 25h1v1H0zM2 25h3v1H2zM6 25h1v1H6zM8 25h1v1H8zM10 25h1v1H10zM12 25h1v1H12zM14 25h1v1H14zM16 25h4v1H16zM21 25h1v1H21zM25,25 h4v1H25zM0 26h1v1H0zM2 26h3v1H2zM6 26h1v1H6zM8 26h2v1H8zM12 26h1v1H12zM14 26h3v1H14zM18 26h1v1H18zM21 26h7v1H21zM0 27h1v1H0zM6 27h1v1H6zM9 27h3v1H9zM13 27h1v1H13zM16 27h1v1H16zM20 27h1v1H20zM22 27h1v1H22zM24 27h2v1H24zM27 27h1v1H27zM0 28h7v1H0zM8 28h2v1H8zM13 28h1v1H13zM15 28h2v1H15zM19 28h1v1H19zM21 28h6v1H21z",
    shapeRendering: "crispEdges"
  }));
};
 false ? 0 : void 0;
/* harmony default export */ var graphicElements_QrCode = (QrCode);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/graphicElements/AppleStoreBadge/index.js



const AppleStoreBadge = props => /*#__PURE__*/react.createElement(lib_anchor/* NewWindowAnchor */.u2, (0,esm_extends["default"])({
  href: "https://itunes.apple.com/us/app/wedding-planner-by-the-knot/id457941553?mt=8"
}, props), /*#__PURE__*/react.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/react.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/react.createElement("path", {
  fill: "#A6A6A6",
  d: "M110.1 0H7.5c-.7 0-1.3 0-2 .2A6.7 6.7 0 0 0 2 2 6.3 6.3 0 0 0 .2 5.5a13 13 0 0 0-.2 2v25c0 .7 0 1.3.2 2A6.6 6.6 0 0 0 2 38a6.3 6.3 0 0 0 3.5 1.8 13.5 13.5 0 0 0 3 .2H111.1a41.7 41.7 0 0 0 3-.2 6.8 6.8 0 0 0 3.5-1.8 6.4 6.4 0 0 0 1.8-3.5l.2-2v-1-22-1-1l-.2-2c-.1-.6-.4-1.3-.7-1.9a6.5 6.5 0 0 0-4.7-3.4 13 13 0 0 0-2-.2h-1.9z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#000",
  d: "M8.4 39.1a40 40 0 0 1-2.7-.1 5.9 5.9 0 0 1-3-1.6 5.3 5.3 0 0 1-1.6-3 12.4 12.4 0 0 1-.2-2.9v-23-1c0-.6 0-1.2.2-1.8a5.8 5.8 0 0 1 1.5-3 5.6 5.6 0 0 1 3-1.6C6.4.9 7 .9 7.7.9h104.6c.5 0 1.2 0 1.8.2a5.6 5.6 0 0 1 4.6 4.6l.2 1.9v24.9c0 .6 0 1.2-.2 1.8a5.7 5.7 0 0 1-1.5 3A5.4 5.4 0 0 1 114 39a12.5 12.5 0 0 1-2.8.1H8.4z"
}), /*#__PURE__*/react.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/react.createElement("path", {
  d: "M24.8 20.3a5 5 0 0 1 2.3-4.2 5 5 0 0 0-4-2.1c-1.6-.2-3.3 1-4.1 1-.9 0-2.2-1-3.6-1a5.3 5.3 0 0 0-4.5 2.8c-2 3.3-.5 8.2 1.4 11 .9 1.3 2 2.7 3.4 2.7s1.9-.9 3.6-.9c1.6 0 2.1.9 3.5.9 1.5 0 2.5-1.4 3.4-2.7.6-1 1.1-2 1.5-3.1-1.8-.7-3-2.5-3-4.4zM22 12.2c.8-1 1.2-2.2 1.2-3.5a5 5 0 0 0-3.3 1.7c-.8.9-1.2 2.1-1.1 3.3 1.3 0 2.4-.5 3.2-1.5z"
}), /*#__PURE__*/react.createElement("g", null, /*#__PURE__*/react.createElement("path", {
  fillRule: "nonzero",
  d: "M42.3 27.1h-4.7l-1.2 3.4h-2L39 18.1h2l4.6 12.4h-2l-1.2-3.4zm-4.2-1.5h3.7L40 20l-2 5.5zM55.2 26c0 2.8-1.5 4.6-3.8 4.6a3 3 0 0 1-2.9-1.6v4.5h-1.9v-12h1.8v1.4c.7-1 1.8-1.6 3-1.6 2.2 0 3.8 1.9 3.8 4.7zm-2 0c0-1.9-.9-3-2.3-3-1.5 0-2.4 1.2-2.4 3s1 3 2.4 3 2.3-1.2 2.3-3zM65.1 26c0 2.8-1.5 4.6-3.8 4.6a3 3 0 0 1-2.8-1.6v4.5h-1.9v-12h1.8v1.4c.6-1 1.7-1.6 3-1.6 2.2 0 3.7 1.9 3.7 4.7zm-1.9 0c0-1.9-1-3-2.4-3s-2.4 1.2-2.4 3 1 3 2.4 3c1.5 0 2.4-1.2 2.4-3z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M71.7 27c.1 1.3 1.3 2 3 2 1.5 0 2.7-.7 2.7-1.8 0-1-.7-1.6-2.3-2l-1.6-.4c-2.3-.5-3.4-1.6-3.4-3.3 0-2.2 1.9-3.6 4.6-3.6 2.6 0 4.4 1.4 4.4 3.6h-1.8c-.2-1.3-1.2-2-2.7-2-1.5 0-2.5.8-2.5 1.9 0 .8.7 1.4 2.3 1.7l1.3.4c2.6.6 3.6 1.6 3.6 3.4 0 2.3-1.8 3.8-4.8 3.8-2.7 0-4.6-1.4-4.7-3.7h2zM83.3 19.3v2.1h1.8V23h-1.8v5c0 .8.4 1.1 1.1 1.1h.7v1.5h-1c-2 0-2.6-.6-2.6-2.4v-5.2h-1.3v-1.5h1.3v-2.1h1.8z"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "nonzero",
  d: "M86 26c0-2.9 1.7-4.7 4.4-4.7 2.6 0 4.3 1.8 4.3 4.7 0 2.8-1.7 4.6-4.3 4.6-2.7 0-4.3-1.8-4.3-4.6zm6.8 0c0-2-1-3.1-2.4-3.1-1.5 0-2.4 1.1-2.4 3 0 2 .9 3.2 2.4 3.2s2.4-1.2 2.4-3.1z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M96.2 21.4H98V23c.2-1 1.2-1.7 2.2-1.7l.6.1v1.8l-.8-.2a1.9 1.9 0 0 0-2 2.1v5.4h-1.8v-9z"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "nonzero",
  d: "M109.4 27.8c-.3 1.7-1.9 2.8-4 2.8-2.5 0-4.2-1.8-4.2-4.6s1.7-4.7 4.2-4.7 4 1.8 4 4.5v.6h-6.3v.1a2.4 2.4 0 0 0 2.4 2.6 2 2 0 0 0 2.1-1.3h1.8zm-6.3-2.7h4.5a2.2 2.2 0 0 0-2.2-2.3 2.3 2.3 0 0 0-2.3 2.3z"
}))), /*#__PURE__*/react.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/react.createElement("path", {
  fillRule: "nonzero",
  d: "M37.8 8.7a2.6 2.6 0 0 1 2.8 3c0 1.9-1 3-2.8 3h-2.1v-6h2.1zM36.6 14h1.1a1.9 1.9 0 0 0 2-2.2 1.9 1.9 0 0 0-2-2.1h-1.1v4.3zM41.7 12.4a2.1 2.1 0 1 1 4.2 0 2.1 2.1 0 1 1-4.2 0zm3.3 0c0-1-.4-1.5-1.2-1.5-.8 0-1.2.6-1.2 1.5 0 1 .4 1.6 1.2 1.6.8 0 1.2-.6 1.2-1.6z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M51.6 14.7h-.9l-1-3.3-1 3.3h-.9l-1.2-4.5h.9l.8 3.4 1-3.4h.8l.9 3.4h.1l.8-3.4h.9zM53.9 10.2h.8v.7c.3-.5.8-.8 1.4-.8a1.5 1.5 0 0 1 1.6 1.7v2.9h-1V12c0-.7-.2-1-.9-1a1 1 0 0 0-1 1v2.7h-1v-4.5zM59.1 8.4h.9v6.3h-.9z"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "nonzero",
  d: "M61.2 12.4a2.1 2.1 0 1 1 4.3 0 2.1 2.1 0 1 1-4.3 0zm3.4 0c0-1-.5-1.5-1.3-1.5-.7 0-1.2.6-1.2 1.5 0 1 .5 1.6 1.2 1.6.8 0 1.3-.6 1.3-1.6zM66.4 13.4c0-.8.6-1.3 1.7-1.3h1.2v-.5c0-.5-.3-.7-1-.7-.4 0-.8.2-.9.5h-.8c0-.8.8-1.3 1.8-1.3 1.1 0 1.8.6 1.8 1.5v3.1h-.9v-.6c-.3.4-.9.7-1.4.7a1.4 1.4 0 0 1-1.5-1.4zm2.9-.4v-.3h-1.1c-.6 0-1 .3-1 .7 0 .4.4.6 1 .6a1 1 0 0 0 1.1-1zM71.3 12.4c0-1.4.8-2.3 2-2.3.5 0 1 .3 1.3.8V8.4h1v6.3h-.9V14c-.4.5-.9.8-1.5.8-1.1 0-1.9-1-1.9-2.4zm1 0c0 1 .4 1.6 1.2 1.6.7 0 1.2-.6 1.2-1.6 0-.9-.5-1.5-1.2-1.5-.8 0-1.2.6-1.2 1.5zM79.2 12.4a2.1 2.1 0 1 1 4.3 0 2.1 2.1 0 1 1-4.3 0zm3.4 0c0-1-.5-1.5-1.2-1.5-.8 0-1.3.6-1.3 1.5 0 1 .5 1.6 1.3 1.6.7 0 1.2-.6 1.2-1.6z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M84.7 10.2h.8v.7c.3-.5.9-.8 1.4-.8a1.5 1.5 0 0 1 1.6 1.7v2.9h-.9V12c0-.7-.3-1-1-1a1 1 0 0 0-1 1v2.7h-1v-4.5zM93.5 9v1.2h1v.8h-1v2.3c0 .5.2.7.7.7h.3v.7a3 3 0 0 1-.5 0c-1 0-1.4-.3-1.4-1.2V11H92v-.8h.7V9.1h1zM95.7 8.4h.9V11c.3-.5.8-.8 1.4-.8a1.5 1.5 0 0 1 1.6 1.7v2.9h-1V12c0-.7-.2-1-.9-1a1 1 0 0 0-1.1 1v2.7h-.9V8.4z"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "nonzero",
  d: "M104.8 13.5c-.3.8-1.1 1.4-2 1.3a2 2 0 0 1-2-2.3 2 2 0 0 1 2-2.4c1.3 0 2 .9 2 2.3v.3h-3.2a1.2 1.2 0 0 0 1.2 1.3 1 1 0 0 0 1.1-.5h.9zm-3.2-1.5h2.3a1 1 0 0 0-1.1-1.1 1.2 1.2 0 0 0-1.2 1.1z"
})))));
/* harmony default export */ var graphicElements_AppleStoreBadge = (AppleStoreBadge);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/graphicElements/GooglePlayBadge/index.js




const cls2Styles = {
  fill: '#fff',
  stroke: '#fff',
  strokeMiterLimit: '10',
  strokeWidth: '.2px'
};
const cls9Styles = {
  isolation: 'isolate',
  opacity: '.12'
};
const GooglePlayBadge = props => /*#__PURE__*/react.createElement(lib_anchor/* NewWindowAnchor */.u2, (0,esm_extends["default"])({
  href: "https://play.google.com/store/apps/details?id=com.xogrp.planner&hl=en_US"
}, props), /*#__PURE__*/react.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
  id: "linear-gradient",
  x1: "31.8",
  y1: "183.29",
  x2: "15.02",
  y2: "166.51",
  gradientTransform: "matrix(1 0 0 -1 0 202)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0",
  stopColor: "#00a0ff"
}), /*#__PURE__*/react.createElement("stop", {
  offset: ".01",
  stopColor: "#00a1ff"
}), /*#__PURE__*/react.createElement("stop", {
  offset: ".26",
  stopColor: "#00beff"
}), /*#__PURE__*/react.createElement("stop", {
  offset: ".51",
  stopColor: "#00d2ff"
}), /*#__PURE__*/react.createElement("stop", {
  offset: ".76",
  stopColor: "#00dfff"
}), /*#__PURE__*/react.createElement("stop", {
  offset: "1",
  stopColor: "#00e3ff"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: "43.83",
  y1: "172",
  x2: "19.64",
  y2: "172",
  gradientTransform: "matrix(1 0 0 -1 0 202)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0",
  stopColor: "#ffe000"
}), /*#__PURE__*/react.createElement("stop", {
  offset: ".41",
  stopColor: "#ffbd00"
}), /*#__PURE__*/react.createElement("stop", {
  offset: ".78",
  stopColor: "orange"
}), /*#__PURE__*/react.createElement("stop", {
  offset: "1",
  stopColor: "#ff9c00"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: "34.83",
  y1: "169.7",
  x2: "12.07",
  y2: "146.95",
  gradientTransform: "matrix(1 0 0 -1 0 202)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0",
  stopColor: "#ff3a44"
}), /*#__PURE__*/react.createElement("stop", {
  offset: "1",
  stopColor: "#c31162"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: "17.3",
  y1: "191.82",
  x2: "27.46",
  y2: "181.66",
  gradientTransform: "matrix(1 0 0 -1 0 202)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0",
  stopColor: "#32a071"
}), /*#__PURE__*/react.createElement("stop", {
  offset: ".07",
  stopColor: "#2da771"
}), /*#__PURE__*/react.createElement("stop", {
  offset: ".48",
  stopColor: "#15cf74"
}), /*#__PURE__*/react.createElement("stop", {
  offset: ".8",
  stopColor: "#06e775"
}), /*#__PURE__*/react.createElement("stop", {
  offset: "1",
  stopColor: "#00f076"
}))), /*#__PURE__*/react.createElement("rect", {
  width: "135",
  height: "40",
  rx: "5"
}), /*#__PURE__*/react.createElement("path", {
  d: "M140 10.8a4.2 4.2 0 0 1 4.2 4.2v30a4.2 4.2 0 0 1-4.2 4.2H15a4.2 4.2 0 0 1-4.2-4.2V15a4.2 4.2 0 0 1 4.2-4.2h125m0-.8H15a5 5 0 0 0-5 5v30a5 5 0 0 0 5 5h125a5 5 0 0 0 5-5V15a5 5 0 0 0-5-5z",
  transform: "translate(-10 -10)",
  fill: "#a6a6a6"
}), /*#__PURE__*/react.createElement("path", {
  style: cls2Styles,
  d: "M57.42 20.24a2.72 2.72 0 0 1-.75 2 2.9 2.9 0 0 1-2.2.88 3 3 0 0 1-2.21-.9 3.19 3.19 0 0 1 0-4.46 3.16 3.16 0 0 1 3.44-.65 2.54 2.54 0 0 1 .94.67l-.53.53a2 2 0 0 0-1.64-.72 2.4 2.4 0 1 0 1.68 4.13 1.92 1.92 0 0 0 .5-1.22h-2.18v-.72h2.91a3.75 3.75 0 0 1 .04.46zM62 17.74h-2.7v1.9h2.46v.72H59.3v1.9H62V23h-3.48v-6H62zM65.28 23h-.77v-5.26h-1.68V17H67v.74h-1.72zM69.94 23v-6h.77v6zM74.13 23h-.77v-5.26h-1.68V17h4.12v.74h-1.67zM83.61 22.22a3.11 3.11 0 0 1-4.4 0 3.24 3.24 0 0 1 0-4.44 2.93 2.93 0 0 1 2.2-.91 3 3 0 0 1 2.2.91 3.07 3.07 0 0 1 .88 2.22 3 3 0 0 1-.88 2.22zm-3.83-.5a2.29 2.29 0 0 0 3.26 0 2.54 2.54 0 0 0 0-3.44 2.29 2.29 0 0 0-3.26 0 2.54 2.54 0 0 0 0 3.44zM85.58 23v-6h.93l2.92 4.67V17h.77v6h-.8l-3.05-4.89V23z",
  transform: "translate(-10 -10)"
}), /*#__PURE__*/react.createElement("path", {
  d: "M78.14 31.75A4.26 4.26 0 1 0 82.41 36a4.19 4.19 0 0 0-4.27-4.25zm0 6.83a2.58 2.58 0 1 1 2.4-2.58 2.46 2.46 0 0 1-2.4 2.58zm-9.32-6.83A4.26 4.26 0 1 0 73.09 36a4.19 4.19 0 0 0-4.27-4.25zm0 6.83a2.58 2.58 0 1 1 2.4-2.58 2.46 2.46 0 0 1-2.4 2.58zm-11.08-5.52v1.8h4.32a3.77 3.77 0 0 1-1 2.27 4.42 4.42 0 0 1-3.34 1.32 4.8 4.8 0 0 1 0-9.6A4.64 4.64 0 0 1 61 30.14l1.27-1.27a6.3 6.3 0 0 0-4.53-1.82 6.61 6.61 0 1 0 0 13.21 6.07 6.07 0 0 0 4.61-1.85 6 6 0 0 0 1.56-4.23 6.27 6.27 0 0 0-.09-1.12zm45.31 1.4a4 4 0 0 0-3.64-2.71 4 4 0 0 0-4 4.25 4.23 4.23 0 0 0 7.76 2.37l-1.45-1a2.41 2.41 0 0 1-2.09 1.17 2.15 2.15 0 0 1-2.06-1.29l5.69-2.35zm-5.8 1.42a2.34 2.34 0 0 1 2.23-2.49 1.64 1.64 0 0 1 1.57.91zM92.63 40h1.87V27.5h-1.87zm-3.06-7.3h-.07a2.94 2.94 0 0 0-2.24-1 4.26 4.26 0 0 0 0 8.51 2.88 2.88 0 0 0 2.24-1h.07v.61c0 1.63-.87 2.5-2.27 2.5a2.36 2.36 0 0 1-2.15-1.51l-1.62.67A4 4 0 0 0 87.3 44c2.19 0 4-1.29 4-4.43V32h-1.73zm-2.15 5.88a2.58 2.58 0 0 1 0-5.15A2.39 2.39 0 0 1 89.7 36a2.38 2.38 0 0 1-2.28 2.58zm24.39-11.08h-4.48V40h1.87v-4.74h2.61a3.89 3.89 0 1 0 0-7.76zm0 6h-2.61v-4.26h2.65a2.14 2.14 0 1 1 0 4.28zm11.54-1.79a3.49 3.49 0 0 0-3.33 1.91l1.65.69a1.78 1.78 0 0 1 1.71-.91 1.8 1.8 0 0 1 2 1.61v.12a4.18 4.18 0 0 0-1.95-.48c-1.78 0-3.6 1-3.6 2.82a2.89 2.89 0 0 0 3.11 2.75 2.65 2.65 0 0 0 2.38-1.22h.06v1h1.8v-4.81c0-2.19-1.66-3.46-3.79-3.46zm-.23 6.85c-.61 0-1.46-.31-1.46-1.06 0-1 1.06-1.34 2-1.34a3.32 3.32 0 0 1 1.7.42 2.26 2.26 0 0 1-2.2 2zM133.74 32l-2.14 5.42h-.06L129.32 32h-2l3.33 7.58-1.9 4.21h1.95L135.82 32zm-16.8 8h1.86V27.5h-1.86z",
  transform: "translate(-10 -10)",
  fill: "#fff"
}), /*#__PURE__*/react.createElement("g", null, /*#__PURE__*/react.createElement("path", {
  d: "M20.44 17.54a2 2 0 0 0-.47 1.4v22.12a1.94 1.94 0 0 0 .47 1.4l.07.08L32.9 30.15v-.3L20.51 17.47z",
  transform: "translate(-10 -10)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/react.createElement("path", {
  d: "M37 34.28l-4.1-4.13v-.3l4.1-4.13.09.06L42 28.56c1.4.79 1.4 2.09 0 2.89l-4.89 2.78z",
  transform: "translate(-10 -10)",
  fill: "url(#linear-gradient-2)"
}), /*#__PURE__*/react.createElement("path", {
  d: "M37.12 34.22L32.9 30 20.44 42.46a1.62 1.62 0 0 0 2.07.07l14.61-8.31",
  transform: "translate(-10 -10)",
  fill: "url(#linear-gradient-3)"
}), /*#__PURE__*/react.createElement("path", {
  d: "M37.12 25.78l-14.61-8.3a1.61 1.61 0 0 0-2.07.06L32.9 30z",
  transform: "translate(-10 -10)",
  fill: "url(#linear-gradient-4)"
}), /*#__PURE__*/react.createElement("path", {
  d: "M37 34.13l-14.49 8.25a1.66 1.66 0 0 1-2 0l-.07.07.07.08a1.66 1.66 0 0 0 2 0l14.61-8.31z",
  transform: "translate(-10 -10)",
  style: {
    isolation: 'isolate'
  },
  opacity: ".2"
}), /*#__PURE__*/react.createElement("path", {
  style: cls9Styles,
  d: "M20.44 42.32a2 2 0 0 1-.44-1.41v.15a1.94 1.94 0 0 0 .47 1.4l.07-.07zM42 31.3l-5 2.83.09.09L42 31.44A1.75 1.75 0 0 0 43.06 30 1.86 1.86 0 0 1 42 31.3z",
  transform: "translate(-10 -10)"
}), /*#__PURE__*/react.createElement("path", {
  d: "M22.51 17.62L42 28.7a1.86 1.86 0 0 1 1.06 1.3A1.75 1.75 0 0 0 42 28.56L22.51 17.48c-1.39-.8-2.54-.14-2.54 1.46v.15c.03-1.6 1.15-2.26 2.54-1.47z",
  transform: "translate(-10 -10)",
  style: {
    isolation: 'isolate'
  },
  opacity: ".25",
  fill: "#fff"
}))));
 false ? 0 : void 0;
/* harmony default export */ var graphicElements_GooglePlayBadge = (GooglePlayBadge);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/AppDownload/index.js









const AppDownload = () => /*#__PURE__*/react.createElement("div", {
  className: (css_default()).appDownload
}, /*#__PURE__*/react.createElement(Subhead/* default */.Z, {
  bold: true,
  as: "div"
}, "One free app for everything wedding planning."), /*#__PURE__*/react.createElement("div", {
  className: (css_default()).appContainer
}, /*#__PURE__*/react.createElement("div", {
  className: (css_default()).qrCodeContainer
}, /*#__PURE__*/react.createElement(graphicElements_QrCode, {
  className: (css_default()).qrCode
}), /*#__PURE__*/react.createElement(components_Overline, {
  as: "span"
}, "Get the app")), /*#__PURE__*/react.createElement("div", {
  className: (css_default()).storeBadgeContainer
}, /*#__PURE__*/react.createElement(graphicElements_AppleStoreBadge, (0,esm_extends["default"])({
  className: (css_default()).storeBadge,
  "aria-label": "Download on the Apple store"
}, (0,trackable/* createTrackableProps */.Ur)({
  selection: 'app-store'
}))), /*#__PURE__*/react.createElement(graphicElements_GooglePlayBadge, (0,esm_extends["default"])({
  className: (css_default()).storeBadge,
  "aria-label": "Get it on Google play"
}, (0,trackable/* createTrackableProps */.Ur)({
  selection: 'google-play'
}))))), /*#__PURE__*/react.createElement(Editorial/* default */.Z, {
  bold: true,
  as: "div",
  className: (css_default()).areYouVendorHeader
}, "Are you a vendor?"), /*#__PURE__*/react.createElement(Body/* Body2 */.p, null, "Sign up on The Knot to reach more couples and book more weddings!"), /*#__PURE__*/react.createElement(Body/* Body2 */.p, (0,esm_extends["default"])({
  bold: true,
  as: lib_anchor/* NewWindowAnchor */.u2,
  href: "https://vendors.theknot.com/vendors-advertising-dr?itm_source=theknot.com&itm_medium=referral&itm_campaign=footer-nav",
  className: (css_default()).areYouVendorLink
}, (0,trackable/* createTrackableProps */.Ur)({
  selection: 'are-you-a-vendor'
})), "Start here ", /*#__PURE__*/react.createElement(components_Icon, {
  name: "forward",
  size: "sm"
})), /*#__PURE__*/react.createElement(sections_ChatSection, {
  hideInDesktop: true
}));
/* harmony default export */ var components_AppDownload = (AppDownload);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/index.js










const defaultRenderFooterLinks = () => /*#__PURE__*/react.createElement(sections_BusinessSection, null);
const FooterNav = _ref => {
  let {
    analyticsProps,
    knotHostEnv = null,
    renderFooterLinks = defaultRenderFooterLinks
  } = _ref;
  const handleAnalyticsClick = useClickTracker({
    eventName: 'Footer Interaction',
    ...analyticsProps
  });
  return /*#__PURE__*/react.createElement(TKHostProvider, {
    env: knotHostEnv
  }, /*#__PURE__*/react.createElement(components_FullBleedContainer, {
    className: classnames_default()((css_default()).container)
  }, /*#__PURE__*/react.createElement(components_TopLevelContainer, {
    as: "nav",
    "aria-label": "Footer",
    onClick: handleAnalyticsClick
  }, /*#__PURE__*/react.createElement(components_Row, null, /*#__PURE__*/react.createElement(components_Column, {
    xs: "12",
    className: (css_default()).logoColumn
  }, /*#__PURE__*/react.createElement(graphicElements_TKBrandLogo, {
    name: "theknot"
  }), /*#__PURE__*/react.createElement("div", {
    className: (css_default()).madeWith
  }, "made with", /*#__PURE__*/react.createElement(graphicElements_Heart, {
    className: (css_default()).heartIcon
  }))), /*#__PURE__*/react.createElement(components_Column, {
    xs: "12",
    md: "12",
    lg: "6",
    xl: "8",
    className: (css_default()).linksColumn
  }, /*#__PURE__*/react.createElement(components_Row, {
    className: (css_default()).linksRow
  }, /*#__PURE__*/react.createElement(components_Column, {
    xs: "12",
    md: "12",
    lg: "12",
    xl: "6"
  }, /*#__PURE__*/react.createElement(sections_ProductsSection, null)), /*#__PURE__*/react.createElement(components_Column, {
    xs: "12",
    md: "12",
    lg: "12",
    xl: "6",
    orderLg: "3",
    orderXl: "2"
  }, /*#__PURE__*/react.createElement(components_Row, {
    className: (css_default()).rowColumns
  }, /*#__PURE__*/react.createElement(components_Column, {
    xs: "12",
    md: "12",
    lg: "6"
  }, /*#__PURE__*/react.createElement(sections_TheCompanySection, null)), /*#__PURE__*/react.createElement(components_Column, {
    xs: "12",
    md: "12",
    lg: "6"
  }, /*#__PURE__*/react.createElement(sections_BrandsSection, null), /*#__PURE__*/react.createElement(sections_HelpSection, null))))), /*#__PURE__*/react.createElement(sections_ChatSection, {
    hideInMobile: true
  })), /*#__PURE__*/react.createElement(components_Column, {
    xs: "12",
    md: "12",
    lg: "6",
    xl: "4",
    orderLg: "2",
    orderXl: "3"
  }, /*#__PURE__*/react.createElement(components_AppDownload, null))), /*#__PURE__*/react.createElement("div", {
    className: (css_default()).footer
  }, /*#__PURE__*/react.createElement("div", {
    role: "group",
    "aria-roledescription": "navigation level 2",
    "aria-label": "Other items"
  }, /*#__PURE__*/react.createElement("slot", {
    name: "footer-links"
  }, /*#__PURE__*/react.createElement(TKHostConsumer, null, host => renderFooterLinks({
    host
  })))), /*#__PURE__*/react.createElement(sections_SocialSection, null)))));
};
/* harmony default export */ var components_FooterNav = (FooterNav);

/***/ }),

/***/ 94956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ur": function() { return /* binding */ createTrackableProps; }
/* harmony export */ });
/* unused harmony exports TRACKABLE_PROPS, PropTypes */
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61820);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

const TRACKABLE_PROPS = (/* unused pure expression or super */ null && (['data-trackable-group', 'data-trackable', 'data-trackable-selection']));
function createTrackableProps() {
  let {
    selection,
    group
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const props = {};
  if (group) {
    props['data-trackable-group'] = group;
  }
  if (selection) {
    props['data-trackable-selection'] = selection;
  } else {
    props['data-trackable'] = true;
  }
  return props;
}
const PropTypes = {
  trackableProps: prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    selection: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    group: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string)
  })
};

/***/ }),

/***/ 53275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* reexport */ components_HeaderNavPagelet; }
});

// UNUSED EXPORTS: SubNav, SubNavLinkItem

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(35964);
var react_dom_namespaceObject = /*#__PURE__*/__webpack_require__.t(react_dom, 2);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/defineProperty.js + 3 modules
var defineProperty = __webpack_require__(86761);
// EXTERNAL MODULE: ./node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(97729);
// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var noop = __webpack_require__(21818);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ./node_modules/@xo-union/react-pagelet/node_modules/@xo-union/pagelet/lib/core/index.js
var core = __webpack_require__(61950);
;// CONCATENATED MODULE: ./node_modules/@xo-union/react-pagelet/lib/ReactPagelet/index.js

/* eslint-disable max-classes-per-file */



class ReactPageletContainer extends react.Component {
  constructor() {
    super(...arguments);
    // eslint-disable-next-line react/destructuring-assignment
    (0,defineProperty/* default */.Z)(this, "state", this.props.initialProps);
  }
  render() {
    return /*#__PURE__*/react.createElement(this.props.Wrapped, this.state);
  }
}
(0,defineProperty/* default */.Z)(ReactPageletContainer, "defaultProps", {
  initialProps: {}
});
 false ? 0 : void 0;
class ReactPagelet {
  constructor(component, componentProps) {
    (0,defineProperty/* default */.Z)(this, "reactRef", /*#__PURE__*/react.createRef());
    (0,defineProperty/* default */.Z)(this, "initialProps", {});
    (0,defineProperty/* default */.Z)(this, "updateReactProps", evt => {
      this.reactRef.current.setState(evt.detail.props);
    });
    this.component = component;
    this.componentProps = componentProps;
  }
  mount(container) {
    /*
    Would use hydrate to properly re-use server generated DOM.
    However, this causes a bug if the server generated markup is significantly different from the
    client generated markup. Therefore, using #render to ovewrite whatever HTML is there
    */

    react_dom.render( /*#__PURE__*/react.createElement(ReactPageletContainer, {
      ref: this.reactRef,
      Wrapped: this.component,
      initialProps: {
        ...container.props,
        ...this.componentProps
      }
    }), container.mountNode);
    container.pageletDidRender();
    container.addEventListener('props', this.updateReactProps);
  }
  unmount(container) {
    container.removeEventListener('props', this.updateReactProps);
    react_dom.unmountComponentAtNode(container.mountNode);
    container.pageletDidUnrender();
  }
}
;// CONCATENATED MODULE: ./node_modules/@xo-union/react-pagelet/lib/index.js

/* eslint-disable react/destructuring-assignment */






class PageletContainer extends react.Component {
  constructor() {
    super(...arguments);
    /**
     * Remove ability to change props that may cause a re-render. If they change, that would trigger
     * a re-render which would unmount the pagelet without a proper clean up
     */
    (0,defineProperty/* default */.Z)(this, "containerId", this.props.containerId);
    (0,defineProperty/* default */.Z)(this, "links", this.props.links);
    (0,defineProperty/* default */.Z)(this, "ssi", this.props.ssi);
    (0,defineProperty/* default */.Z)(this, "renderPlaceholder", this.props.renderPlaceholder);
    (0,defineProperty/* default */.Z)(this, "renderError", this.props.renderError);
    (0,defineProperty/* default */.Z)(this, "pageletContainer", new core.PageletContainer(this.containerId, {
      errorPagelet: new ReactPagelet(this.renderError),
      props: this.props.pageletProps
    }));
    (0,defineProperty/* default */.Z)(this, "remotePagelet", new core.RemotePagelet({
      links: this.links,
      jsExportName: this.props.exportName
    }));
  }
  componentDidMount() {
    this.pageletContainer.addEventListener('error', this.props.onError);
    this.pageletContainer.mount(this.remotePagelet);
  }
  componentDidUpdate() {
    this.pageletContainer.setProps(this.props.pageletProps);
  }
  componentWillUnmount() {
    this.pageletContainer.unmount();
  }
  render() {
    if (this.ssi) {
      /* eslint-disable react/no-danger */

      const pageletHTML = server_browser.renderToStaticMarkup( /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
        "data-pagelet-role": "placeholder"
      }, this.renderPlaceholder())));
      return /*#__PURE__*/react.createElement("div", {
        "data-pagelet-container-id": this.containerId,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
          __html: `<!--#include virtual="${this.links.ssi}" -->${pageletHTML}`
        }
      });
    }
    return /*#__PURE__*/react.createElement("div", {
      "data-pagelet-container-id": this.containerId
    }, /*#__PURE__*/react.createElement("div", {
      "data-pagelet-role": "placeholder"
    }, this.renderPlaceholder()));
  }
}
(0,defineProperty/* default */.Z)(PageletContainer, "defaultProps", {
  exportName: 'default',
  pageletProps: {},
  ssi: false,
  renderPlaceholder: () => 'Loading...',
  renderError: () => 'There was an error loading this part of the page. Try again soon.',
  onError: (noop_default())
});
 false ? 0 : void 0;
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet.js + 1 modules
var classPrivateFieldGet = __webpack_require__(84596);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet.js + 1 modules
var classPrivateFieldSet = __webpack_require__(93204);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/weak-map.js
var weak_map = __webpack_require__(48492);
var weak_map_default = /*#__PURE__*/__webpack_require__.n(weak_map);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/native-url/index.js
var native_url = __webpack_require__(49436);
;// CONCATENATED MODULE: ./node_modules/@xo-union/url-template/lib/index.js



function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

var _templateString = /*#__PURE__*/new (weak_map_default())();
var _variables = /*#__PURE__*/new (weak_map_default())();
var _replacer = /*#__PURE__*/new (weak_map_default())();
class UrlTemplate {
  constructor(templateString, variables) {
    _classPrivateFieldInitSpec(this, _templateString, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _variables, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _replacer, {
      writable: true,
      value: (_match, capture) => {
        if (Object.prototype.hasOwnProperty.call((0,classPrivateFieldGet/* default */.Z)(this, _variables), capture)) {
          return (0,classPrivateFieldGet/* default */.Z)(this, _variables)[capture];
        }
        throw new Error(`Unspecified template variable: ${capture}`);
      }
    });
    (0,classPrivateFieldSet/* default */.Z)(this, _templateString, templateString);
    (0,classPrivateFieldSet/* default */.Z)(this, _variables, variables);
  }
  set(key, value) {
    (0,classPrivateFieldGet/* default */.Z)(this, _variables)[key] = value;
  }
  toString() {
    const url = (0,native_url.parse)((0,classPrivateFieldGet/* default */.Z)(this, _templateString));
    url.pathname = decodeURIComponent(url.pathname || '').replace(/\{([A-Za-z_$]+)\}/g, (0,classPrivateFieldGet/* default */.Z)(this, _replacer)).replace(/\/{2,}/g, '/');
    return (0,native_url.format)(url);
  }
  toJSON() {
    return this.toString();
  }
}
;// CONCATENATED MODULE: ./node_modules/@xo-union/dist-url/lib/index.js
/* provided dependency */ var process = __webpack_require__(37082);

const SSI_URL_TEMPLATE = '/union-dist/{name}/{tag}/{path}';
const QA_URL_TEMPLATE = 'https://qa.union.theknot.com/dist/v2/{name}/{tag}/{path}';
const PROD_URL_TEMPLATE = 'https://union.theknot.com/dist/v2/{name}/{tag}/{path}';
const urlTemplateFromEnv = () => {
  const env = (() => {
    if (process.env.UNION_ASSETS_ENV) {
      if (process.env.UNION_ASSETS_ENV !== "qa" && process.env.UNION_ASSETS_ENV !== "production") {
        throw new Error(`Expected UNION_ASSETS_ENV to be 'qa' or 'production'.`);
      }
      console.warn('Using UNION_ASSETS_ENV could result in a misconfigured environment. It is best that you use UNION_DEPLOYMENT_ENV for all your Union services integrations.');
      return process.env.UNION_ASSETS_ENV;
    }
    if (true) {
      if (false) {}
      return "production";
    }
    if (false) {}
    throw new Error("Expected UNION_DEPLOYMENT_ENV to be either 'qa' or 'production'.");
  })();
  if (env === 'qa') {
    return QA_URL_TEMPLATE;
  }
  return PROD_URL_TEMPLATE;
};
const getUrl = _ref => {
  let {
    urlTemplate = process.env.UNION_DISTRIBUTION_URL_TEMPLATE || urlTemplateFromEnv(),
    params
  } = _ref;
  return new UrlTemplate(urlTemplate, params);
};
const getSSIUrl = _ref2 => {
  let {
    urlTemplate = process.env.UNION_SSI_URL_TEMPLATE || SSI_URL_TEMPLATE,
    params
  } = _ref2;
  return new UrlTemplate(urlTemplate, params);
};
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-header-nav/lib/utils/urls.js

const DIST_NAME = 'tk-pagelet-header-nav';
const getHeaderAssetUrl = (tag, path) => getUrl({
  params: {
    name: DIST_NAME,
    tag,
    path
  }
});
const getHeaderSSIUrl = (tag, path) => getSSIUrl({
  params: {
    name: DIST_NAME,
    tag,
    path
  }
});
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-breakpoints/lib/variables.js
var variables = __webpack_require__(78510);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-colors/lib/variables.css
var lib_variables = __webpack_require__(49455);
var variables_default = /*#__PURE__*/__webpack_require__.n(lib_variables);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-header-nav/lib/components/HeaderNavPagelet/Placeholder.js



const styles = () => `
.Union__header-nav-pagelet-placeholder {
  background-color: ${(variables_default()).varBackgroundLight};
  border-bottom: 1px solid #ccc;
  display: flex;
  height: 60px;
}

@media (${variables/* default.inDesktop */.Z.inDesktop}) {
  .Union__header-nav-pagelet-placeholder {
    height: 120px;
  }
}
`;
/* harmony default export */ var Placeholder = (() => /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("style", {
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML: {
    __html: styles()
  }
}), /*#__PURE__*/react.createElement("div", {
  className: "Union__header-nav-pagelet-placeholder"
})));
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-header-nav/lib/components/HeaderNavPagelet/index.js





const handleError = evt => {
  if (evt.detail.isRendered && evt.detail.phase === 'load' && "production" === 'production') {
    /**
     * If header nav is already rendered, do not show error view
     */
    evt.preventDefault();
  }
};

/**
 * Renders a header nav pagelet which gets dynamically updated as changes to the header are made.
 *
 * Besides its own props, this component also accepts all props accepted by the HeaderNav component
 */
const HeaderNavPagelet = _ref => {
  let {
    tag,
    ssi,
    ...props
  } = _ref;
  const links = {
    ssi: getHeaderSSIUrl(tag, 'index.html'),
    css: getHeaderAssetUrl(tag, 'styles.css'),
    js: getHeaderAssetUrl(tag, 'main.js')
  };
  return /*#__PURE__*/react.createElement(PageletContainer, {
    onError: handleError,
    renderPlaceholder: Placeholder,
    renderError: Placeholder,
    containerId: "header-navigation",
    links: links,
    ssi: ssi,
    pageletProps: props
  });
};
HeaderNavPagelet.defaultProps = {
  tag: 'latest',
  ssi: false
};
 false ? 0 : void 0;
/* harmony default export */ var components_HeaderNavPagelet = (HeaderNavPagelet);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-header-nav/lib/remote.js


if (typeof UNION_INTERNAL_MODULE_SYSTEM !== 'undefined') {
  /* eslint-disable no-undef */
  UNION_INTERNAL_MODULE_SYSTEM.define('react', () => react_namespaceObject);
  UNION_INTERNAL_MODULE_SYSTEM.define('react-dom', () => react_dom_namespaceObject);
}




/***/ }),

/***/ 52824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IconButton": function() { return /* reexport */ IconButton/* default */.Z; },
  "IconLink": function() { return /* reexport */ components_IconLink; },
  "default": function() { return /* reexport */ Icon/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-icons/lib/components/Icon/index.js
var Icon = __webpack_require__(21647);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-icons/lib/components/IconButton/index.js
var IconButton = __webpack_require__(51197);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/extends.js
var esm_extends = __webpack_require__(70509);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(61820);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-icons/lib/components/InteractiveIcon/index.js
var InteractiveIcon = __webpack_require__(9875);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-icons/lib/components/IconLink/index.js





/**
 * Render an interactive icon as a link. Use this component when the interaction will send the user
 * to a different url.
 *
 * Passes ref to underlying link
 */
const IconLink = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    name,
    size,
    block,
    as,
    ...rest
  } = _ref;
  return /*#__PURE__*/react.createElement(InteractiveIcon/* default */.Z, (0,esm_extends["default"])({
    ref: ref,
    as: as,
    name: name,
    block: block,
    size: size
  }, rest));
});
IconLink.propTypes = {
  /**
   * Icon name
   */
  name: (prop_types_default()).string.isRequired,
  /**
   * Component to render
   */
  as: (prop_types_default()).elementType,
  /**
   * To determine if icon should have a block display
   */
  block: (prop_types_default()).bool,
  /**
   * Size class
   */
  size: prop_types_default().oneOf(['sm', 'md', 'lg'])
};
IconLink.defaultProps = {
  size: null,
  as: 'a'
};
IconLink.displayName = 'IconLink';
/* harmony default export */ var components_IconLink = (IconLink);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-icons/lib/latest.js




/***/ }),

/***/ 87947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/extends.js
var esm_extends = __webpack_require__(70509);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/@xo-union/react-unique-id/lib/index.js
var lib = __webpack_require__(79946);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-accessibility/lib/MainContentLabel/index.js


const MainContentLabelContext = /*#__PURE__*/(0,react.createContext)();
const MainContentLabelProvider = _ref => {
  let {
    children,
    id
  } = _ref;
  return /*#__PURE__*/react.createElement(MainContentLabelContext.Provider, {
    value: {
      id
    }
  }, children);
};
 false ? 0 : void 0;
const useMainContentLabel = () => useContext(MainContentLabelContext);

// EXTERNAL MODULE: ./node_modules/@xo-union/ui-accessibility/lib/ModalRegister/index.js + 6 modules
var ModalRegister = __webpack_require__(91167);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-accessibility/lib/ModalPortal/index.js + 1 modules
var ModalPortal = __webpack_require__(42092);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-accessibility/lib/LayoutRoot/index.js





/**
 * This component creates a separation at the application root between the modal elements and other
 * elements on the page.
 *
 * This is helpful for accessibility reasons because it allows us to easily hide the other elements
 * from screen readers when modals are open. Additionally, this helps avoid styling discrepencies
 * created by inherited properties when rendering a modal.
 *
 * If you use `Layout` from [@xo-union/tk-component-layout](/packages/@xo-union/tk-component-layout)
 * you do not need to use this component.
 */
const LayoutRoot = _ref => {
  let {
    children
  } = _ref;
  const anyModalIsOpen = (0,ModalRegister/* useModalRootRegisterNode */.Pt)().size > 0;
  return /*#__PURE__*/react.createElement(ModalPortal/* ModalPortalProvider */.d, null, portalRef => /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    "data-union-main-content": "",
    inert: anyModalIsOpen ? '' : undefined,
    "aria-hidden": anyModalIsOpen ? 'true' : undefined
  }, children), /*#__PURE__*/react.createElement("div", {
    "data-union-modal-content": "",
    inert: anyModalIsOpen ? undefined : '',
    "aria-hidden": anyModalIsOpen ? undefined : 'true',
    ref: portalRef
  })));
};
 false ? 0 : void 0;
/* harmony default export */ var lib_LayoutRoot = (LayoutRoot);
// EXTERNAL MODULE: ./node_modules/@xo-union/react-css-modules/lib/index.js
var react_css_modules_lib = __webpack_require__(33289);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-css-grid/lib/styles.css
var styles = __webpack_require__(1640);
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-grid/lib/components/TopLevelContainer/index.js
var TopLevelContainer = __webpack_require__(84439);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-grid/lib/components/Row/index.js
var Row = __webpack_require__(19766);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-grid/lib/components/Column/index.js
var Column = __webpack_require__(51665);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-grid/lib/components/ContainerWithStickyColumn/index.js









const MainContentColumn = _ref => {
  let {
    children,
    classes: classesProp
  } = _ref;
  const classes = (0,react_css_modules_lib.useClasses)((styles_default()), classesProp);
  return /*#__PURE__*/react.createElement(Column/* default */.Z, {
    className: classes['main-content-column']
  }, children);
};
 false ? 0 : void 0;
const StickyLeftColumn = _ref2 => {
  let {
    children,
    classes: classesProp
  } = _ref2;
  const classes = (0,react_css_modules_lib.useClasses)((styles_default()), classesProp);
  return /*#__PURE__*/react.createElement(Column/* default */.Z, {
    as: "aside",
    className: classes['sticky-left-column']
  }, children);
};
 false ? 0 : void 0;
const ContainerWithStickyColumn = _ref3 => {
  let {
    as: ComponentToRender,
    classes,
    stickyColumnContent,
    mainContent,
    ...rest
  } = _ref3;
  return /*#__PURE__*/react.createElement(TopLevelContainer/* default */.Z, (0,esm_extends["default"])({
    as: ComponentToRender,
    classes: classes
  }, rest), /*#__PURE__*/react.createElement(Row/* default */.Z, {
    hGutters: false
  }, /*#__PURE__*/react.createElement(StickyLeftColumn, {
    classes: classes
  }, stickyColumnContent), /*#__PURE__*/react.createElement(MainContentColumn, {
    classes: classes
  }, mainContent)));
};
 false ? 0 : void 0;
ContainerWithStickyColumn.defaultProps = {
  as: 'div'
};
/* harmony default export */ var components_ContainerWithStickyColumn = (ContainerWithStickyColumn);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-alerts/lib/components/SnackbarContext/index.js
var SnackbarContext = __webpack_require__(26791);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-layout/lib/css/styles.css
var css_styles = __webpack_require__(1489);
var css_styles_default = /*#__PURE__*/__webpack_require__.n(css_styles);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-layout/lib/components/SkipToContent.js





const SkipToContent = _ref => {
  let {
    classes,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("a", {
    className: classes['skip-to-content'],
    href: `#${props.mainContentId}`
  }, "Skip to Main Content");
};
 false ? 0 : void 0;
/* harmony default export */ var components_SkipToContent = ((0,react_css_modules_lib.withClasses)((css_styles_default()))(SkipToContent));
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-layout/lib/components/Layout.js








const Layout = _ref => {
  let {
    header,
    leftNav,
    footer,
    masthead,
    children,
    mainContentId,
    mastheadTitleId,
    ...rest
  } = _ref;
  const finalMastheadTitleID = (0,lib/* useUniqueID */.h)(mastheadTitleId);
  const mainSection = leftNav ? /*#__PURE__*/react.createElement(components_ContainerWithStickyColumn, (0,esm_extends["default"])({
    as: "main",
    id: mainContentId,
    stickyColumnContent: leftNav,
    mainContent: children
  }, rest)) : /*#__PURE__*/react.createElement(MainContentLabelProvider, {
    id: finalMastheadTitleID
  }, /*#__PURE__*/react.createElement("main", (0,esm_extends["default"])({
    id: mainContentId,
    "aria-labelledby": masthead && finalMastheadTitleID
  }, rest), masthead && /*#__PURE__*/react.createElement("section", {
    "aria-labelledby": finalMastheadTitleID
  }, masthead), children));
  return /*#__PURE__*/react.createElement(lib_LayoutRoot, null, /*#__PURE__*/react.createElement(SnackbarContext/* SnackbarProvider */.wT, null, /*#__PURE__*/react.createElement(components_SkipToContent, {
    mainContentId: mainContentId
  }), header ? /*#__PURE__*/react.createElement("header", null, header) : undefined, mainSection, footer ? /*#__PURE__*/react.createElement("footer", null, footer) : undefined));
};
 false ? 0 : void 0;
Layout.defaultProps = {
  mainContentId: 'union-layout-main'
};
/* harmony default export */ var components_Layout = (Layout);

/***/ }),

/***/ 91354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Desktop": function() { return /* reexport */ lib_Desktop; },
  "MATCHES": function() { return /* reexport */ matches/* default */.Z; },
  "Media": function() { return /* reexport */ lib_Media; },
  "useDesktopMedia": function() { return /* reexport */ useMedia/* useDesktopMedia */._8; },
  "useMedia": function() { return /* reexport */ useMedia/* default */.ZP; },
  "useMediaScreenMax": function() { return /* reexport */ useMedia/* useMediaScreenMax */.li; },
  "useMediaScreenMin": function() { return /* reexport */ useMedia/* useMediaScreenMin */.KT; },
  "useMobileMedia": function() { return /* reexport */ useMedia/* useMobileMedia */.VB; },
  "variables": function() { return /* reexport */ variables/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-breakpoints/lib/matches.js
var matches = __webpack_require__(4622);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/defineProperty.js + 3 modules
var defineProperty = __webpack_require__(86761);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet.js + 1 modules
var classPrivateFieldGet = __webpack_require__(84596);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet.js + 1 modules
var classPrivateFieldSet = __webpack_require__(93204);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/global-this.js
var global_this = __webpack_require__(26111);
var global_this_default = /*#__PURE__*/__webpack_require__.n(global_this);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/weak-map.js
var weak_map = __webpack_require__(48492);
var weak_map_default = /*#__PURE__*/__webpack_require__.n(weak_map);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-ui-breakpoints/lib/Media.js





function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }



var _media = /*#__PURE__*/new (weak_map_default())();
class Media extends react.Component {
  constructor() {
    super(...arguments);
    _classPrivateFieldInitSpec(this, _media, {
      writable: true,
      value: null
    });
    (0,defineProperty/* default */.Z)(this, "state", {
      matches: matches/* default.NOT_SURE */.Z.NOT_SURE
    });
    (0,defineProperty/* default */.Z)(this, "handleMediaChange", mediaEvent => {
      this.setState({
        matches: mediaEvent.matches ? matches/* default.YES */.Z.YES : matches/* default.NO */.Z.NO
      });
    });
  }
  componentDidMount() {
    (0,classPrivateFieldSet/* default */.Z)(this, _media, global_this_default().matchMedia(this.props.query));
    this.handleMediaChange((0,classPrivateFieldGet/* default */.Z)(this, _media));
    (0,classPrivateFieldGet/* default */.Z)(this, _media).addListener(this.handleMediaChange);
  }
  componentWillUnmount() {
    (0,classPrivateFieldGet/* default */.Z)(this, _media).removeListener(this.handleMediaChange);
  }
  render() {
    return this.props.children(this.state.matches);
  }
}
 false ? 0 : void 0;
/* harmony default export */ var lib_Media = (Media);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/extends.js
var esm_extends = __webpack_require__(70509);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-breakpoints/lib/variables.js
var variables = __webpack_require__(78510);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-ui-breakpoints/lib/Desktop.js




const Desktop = props => /*#__PURE__*/react.createElement(lib_Media, (0,esm_extends["default"])({
  query: `(${variables/* default.inDesktop */.Z.inDesktop})`
}, props));
/* harmony default export */ var lib_Desktop = (Desktop);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-breakpoints/lib/useMedia.js
var useMedia = __webpack_require__(80427);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-ui-breakpoints/lib/index.js






/***/ }),

/***/ 4622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_core_js_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15446);
/* harmony import */ var _babel_runtime_corejs3_core_js_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_symbol__WEBPACK_IMPORTED_MODULE_0__);

const MATCHES = {
  NOT_SURE: _babel_runtime_corejs3_core_js_symbol__WEBPACK_IMPORTED_MODULE_0___default()('MATCHES.NOT_SURE'),
  YES: _babel_runtime_corejs3_core_js_symbol__WEBPACK_IMPORTED_MODULE_0___default()('MATCHES.YES'),
  NO: _babel_runtime_corejs3_core_js_symbol__WEBPACK_IMPORTED_MODULE_0___default()('MATCHES.NO')
};
/* harmony default export */ __webpack_exports__["Z"] = (MATCHES);

/***/ }),

/***/ 80427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KT": function() { return /* binding */ useMediaScreenMin; },
/* harmony export */   "VB": function() { return /* binding */ useMobileMedia; },
/* harmony export */   "_8": function() { return /* binding */ useDesktopMedia; },
/* harmony export */   "li": function() { return /* binding */ useMediaScreenMax; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_global_this__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26111);
/* harmony import */ var _babel_runtime_corejs3_core_js_global_this__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_global_this__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_corejs3_core_js_object_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9938);
/* harmony import */ var _babel_runtime_corejs3_core_js_object_keys__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_object_keys__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28858);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_instance_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99084);
/* harmony import */ var _variables_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78510);
/* harmony import */ var _matches_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4622);






const useMedia = query => {
  const [matches, setMatches] = react__WEBPACK_IMPORTED_MODULE_3__.useState(_matches_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].NOT_SURE */ .Z.NOT_SURE);
  const media = react__WEBPACK_IMPORTED_MODULE_3__.useRef();
  const handleMediaChange = mediaEvent => {
    setMatches(mediaEvent.matches ? _matches_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].YES */ .Z.YES : _matches_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].NO */ .Z.NO);
  };
  react__WEBPACK_IMPORTED_MODULE_3__.useEffect(() => {
    media.current = _babel_runtime_corejs3_core_js_global_this__WEBPACK_IMPORTED_MODULE_0___default().matchMedia(query);
    handleMediaChange(media.current);
    media.current.addEventListener('change', handleMediaChange);
    return () => {
      media.current.removeEventListener('change', handleMediaChange);
    };
  }, [query]);
  return {
    matches,
    yes: matches === _matches_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].YES */ .Z.YES,
    no: matches === _matches_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].NO */ .Z.NO,
    notSure: matches === _matches_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].NOT_SURE */ .Z.NOT_SURE
  };
};
const useMobileMedia = () => useMedia(`(${_variables_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].inMobile */ .Z.inMobile})`);
const useDesktopMedia = () => useMedia(`(${_variables_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].inDesktop */ .Z.inDesktop})`);
const strictGet = function (obj, key) {
  let keysAllowed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _babel_runtime_corejs3_core_js_object_keys__WEBPACK_IMPORTED_MODULE_1___default()(obj);
  if (!_babel_runtime_corejs3_core_js_instance_includes__WEBPACK_IMPORTED_MODULE_2___default()(keysAllowed).call(keysAllowed, key)) throw new Error(`Invalid key: ${key.toString()}. Valid keys: ${keysAllowed.join(', ')}`);
  return obj[key];
};
const screenSizes = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
const useMediaScreenMin = screenSize => useMedia(`(min-width: ${strictGet(_variables_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, screenSize, screenSizes)})`);
const useMediaScreenMax = screenSize => useMedia(`(max-width: ${strictGet(_variables_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, `${screenSize}Max`, ['xsMax', 'smMax', 'mdMax', 'lgMax', 'xlMax'])})`);
/* harmony default export */ __webpack_exports__["ZP"] = (useMedia);

/***/ }),

/***/ 78510:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const range = (min, max) => ({
  min,
  max
});
const px = num => `${num}px`;
const ranges = {
  xs: range(0, 479.98),
  sm: range(480, 767.98),
  md: range(768, 1023.98),
  lg: range(1024, 1191.98),
  xl: range(1192, 1359.98),
  xxl: range(1360, Infinity)
};
const inMobile = `max-width: ${px(ranges.sm.max)}`;
const inDesktop = `min-width: ${px(ranges.md.min)}`;
/* harmony default export */ __webpack_exports__["Z"] = ({
  xs: px(ranges.xs.min),
  xsMax: px(ranges.xs.max),
  sm: px(ranges.sm.min),
  smMax: px(ranges.sm.max),
  md: px(ranges.md.min),
  mdMax: px(ranges.md.max),
  lg: px(ranges.lg.min),
  lgMax: px(ranges.lg.max),
  xl: px(ranges.xl.min),
  xlMax: px(ranges.xl.max),
  xxl: px(ranges.xxl.min),
  inMobile,
  inDesktop,
  ranges
});

/***/ }),

/***/ 11945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SubNavButton": function() { return /* reexport */ components_SubNavButton; },
  "SubNavContainer": function() { return /* reexport */ components_SubNavContainer; },
  "SubNavLink": function() { return /* reexport */ components_SubNavLink; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/extends.js
var esm_extends = __webpack_require__(70509);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/array/from.js
var from = __webpack_require__(56699);
var from_default = /*#__PURE__*/__webpack_require__.n(from);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/for-each.js
var for_each = __webpack_require__(28301);
var for_each_default = /*#__PURE__*/__webpack_require__.n(for_each);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/global-this.js
var global_this = __webpack_require__(26111);
var global_this_default = /*#__PURE__*/__webpack_require__.n(global_this);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/set-timeout.js
var set_timeout = __webpack_require__(79021);
var set_timeout_default = /*#__PURE__*/__webpack_require__.n(set_timeout);
// EXTERNAL MODULE: ./node_modules/matches-selector/index.js
var matches_selector = __webpack_require__(65792);
var matches_selector_default = /*#__PURE__*/__webpack_require__.n(matches_selector);
// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var noop = __webpack_require__(21818);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-analytics/node_modules/@xo-union/tk-analytics/lib/wrapper/index.mjs


/* eslint-disable no-console */
let warn = noop;
if (false) {}
const createWrapper = fnName => {
  const wrapper = function () {
    if (globalThis.analytics) {
      globalThis.analytics[fnName](...arguments);
    } else {
      warn();
    }
  };
  return wrapper;
};
/* harmony default export */ var wrapper = ({
  track: createWrapper('track'),
  alias: createWrapper('alias'),
  identify: createWrapper('identify'),
  reset: createWrapper('reset')
});
// EXTERNAL MODULE: ./node_modules/@segment/is-meta/lib/index.js
var lib = __webpack_require__(89228);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-analytics/lib/getMappableValue.js
const getMappableValue = function (subject) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof subject === 'function' ? subject(...params) : subject;
};
/* harmony default export */ var lib_getMappableValue = (getMappableValue);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-analytics/lib/generic-click-tracker/index.js











const eventWillChangePage = event => {
  const element = event.target;
  const MOUSE_MIDDLE_BUTTON = 1;
  const willOpenNewTab = lib_default()(event) || event.button === MOUSE_MIDDLE_BUTTON;
  const target = element.getAttribute('target');
  const href = element.getAttribute('href');
  return element.tagName === 'A' && href && target !== '_blank' && !willOpenNewTab;
};
const getContextEventData = _ref => {
  let {
    element,
    contextEnd
  } = _ref;
  const data = {};
  const source = {};
  let currentElement = element;
  const processAttribute = attribute => {
    const match = attribute.name.match(/^data-trackable-context-(.+)$/);
    if (match) {
      const contextAttributeName = match[1];
      if (data[contextAttributeName]) {
        /* eslint-disable no-console */
        console.warn(`Trackable context property \`${contextAttributeName}\` is overwritten\n`, 'Previously defined by: ', currentElement, '\n', 'Overwritten by: ', source[contextAttributeName]);
      } else {
        data[contextAttributeName] = attribute.value;
        source[contextAttributeName] = currentElement;
      }
    }
  };
  while (currentElement && currentElement !== contextEnd) {
    const attributes = from_default()(currentElement.attributes);
    for_each_default()(attributes).call(attributes, processAttribute);
    currentElement = currentElement.parentElement;
  }
  return data;
};
const createLinkFollowStrategy = function () {
  let {
    timeout = 300,
    location = (global_this_default()).location
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return event => {
    const element = event.target;
    if (eventWillChangePage(event)) {
      const href = element.getAttribute('href');
      event.preventDefault();
      set_timeout_default()(() => {
        // eslint-disable-next-line no-param-reassign
        location.href = href;
      }, timeout);
    }
  };
};
const generic_click_tracker_useGenericClickTracker = _ref2 => {
  let {
    eventName,
    eventData,
    trackableSelector = 'a',
    analytics: analyticsProp,
    followStrategy: followStrategyProp
  } = _ref2;
  const defaultFollowStrategy = react.useCallback(createLinkFollowStrategy(), []);
  const followStrategy = followStrategyProp === undefined ? defaultFollowStrategy : followStrategyProp;
  return react.useCallback(event => {
    const element = event.target;
    const analytics = analyticsProp || wrapper;
    if (matches_selector_default()(element, trackableSelector)) {
      const contextProperties = getContextEventData({
        element,
        contextEnd: event.currentTarget
      });
      const finalEventName = lib_getMappableValue(eventName, element, contextProperties);
      const finalEventData = lib_getMappableValue(eventData, element, contextProperties);
      analytics.track(finalEventName, finalEventData);
      if (followStrategy === false) {
        event.preventDefault();
      }
      if (typeof followStrategy === 'function') {
        followStrategy(event);
      }
    }
  }, [eventName, eventData, analyticsProp, followStrategy, trackableSelector]);
};
const GenericClickTracker = _ref3 => {
  let {
    as: ComponentToRender,
    children,
    onClick,
    ...props
  } = _ref3;
  const handleAnalytics = generic_click_tracker_useGenericClickTracker(props);
  const finalOnClick = react.useCallback(function () {
    handleAnalytics(...arguments);
    return onClick(...arguments);
  }, [onClick, handleAnalytics]);
  return /*#__PURE__*/react.createElement(ComponentToRender, {
    onClick: finalOnClick
  }, children);
};
 false ? 0 : void 0;
GenericClickTracker.defaultProps = {
  followStrategy: createLinkFollowStrategy(),
  trackableSelector: 'a',
  as: 'div',
  onClick: (noop_default())
};
/* harmony default export */ var generic_click_tracker = (GenericClickTracker);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/trim.js
var trim = __webpack_require__(90537);
var trim_default = /*#__PURE__*/__webpack_require__.n(trim);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-analytics/lib/click-tracker/getSelectionValue/index.js

const getSelectionValue = (element, contextProperties) => {
  var _context;
  let selection = element.getAttribute('data-trackable-selection') || trim_default()(_context = element.textContent).call(_context);
  const namespace = element.getAttribute('data-trackable-group') || contextProperties.group;
  if (namespace) {
    selection = `${namespace} > ${selection}`;
  }
  return selection.toLowerCase();
};
/* harmony default export */ var click_tracker_getSelectionValue = (getSelectionValue);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-analytics/lib/click-tracker/getEventData/index.js


const getEventData = _ref => {
  let {
    element,
    eventData,
    product,
    contextProperties
  } = _ref;
  return {
    ...lib_getMappableValue(eventData, element, contextProperties),
    selection: click_tracker_getSelectionValue(element, contextProperties),
    product,
    platform: 'web'
  };
};
/* harmony default export */ var click_tracker_getEventData = (getEventData);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-analytics/lib/click-tracker/index.js





const defaultTrackableSelector = 'a,[data-trackable],[data-trackable-selection]';
const useDefaultEventDataMapper = _ref => {
  let {
    eventData = {},
    product
  } = _ref;
  return react.useCallback((element, contextProperties) => click_tracker_getEventData({
    element,
    eventData,
    product,
    contextProperties
  }), [eventData, product]);
};
const useClickTracker = _ref2 => {
  let {
    eventData = {},
    product,
    ...props
  } = _ref2;
  const defaultEventDataMapper = useDefaultEventDataMapper({
    eventData,
    product
  });
  return useGenericClickTracker({
    trackableSelector: defaultTrackableSelector,
    eventData: defaultEventDataMapper,
    ...props
  });
};
const ClickTracker = _ref3 => {
  let {
    product,
    eventData = {},
    ...props
  } = _ref3;
  const defaultEventDataMapper = useDefaultEventDataMapper({
    eventData,
    product
  });
  return /*#__PURE__*/react.createElement(generic_click_tracker, (0,esm_extends["default"])({
    trackableSelector: defaultTrackableSelector,
    eventData: defaultEventDataMapper
  }, props));
};
 false ? 0 : void 0;
/* harmony default export */ var click_tracker = (ClickTracker);
// EXTERNAL MODULE: ./node_modules/@xo-union/react-css-modules/lib/index.js
var react_css_modules_lib = __webpack_require__(33289);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-accessibility/lib/ScreenReaderOnly/index.js
var ScreenReaderOnly = __webpack_require__(72944);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-typography/lib/components/Caption/index.js
var Caption = __webpack_require__(27308);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-sub-nav/lib/components/SubNavContainer/styles.css
var styles = __webpack_require__(70093);
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-ui-sub-nav/lib/components/SubNavContainer/index.js









const SubNavContainer = _ref => {
  let {
    analyticsProps,
    children,
    classes: classesProp,
    links
  } = _ref;
  const classes = (0,react_css_modules_lib.useClasses)((styles_default()), classesProp);
  return /*#__PURE__*/react.createElement(click_tracker, (0,esm_extends["default"])({
    eventName: "Sub Nav Interaction"
  }, analyticsProps), /*#__PURE__*/react.createElement(Caption/* default */.Z, {
    as: "nav",
    "aria-labelledby": "sub-nav",
    className: classes['sub-nav-container']
  }, /*#__PURE__*/react.createElement(ScreenReaderOnly/* default */.Z, {
    id: "sub-nav"
  }, "Secondary Navigation Menu"), /*#__PURE__*/react.createElement("ul", {
    className: classes['sub-nav-item-list'],
    role: "list"
  }, links), children));
};
 false ? 0 : void 0;
SubNavContainer.defaultProps = {
  analyticsProps: {}
};
/* harmony default export */ var components_SubNavContainer = (SubNavContainer);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-sub-nav/node_modules/classnames/index.js
var classnames = __webpack_require__(56183);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-typography/lib/components/Body/index.js + 1 modules
var Body = __webpack_require__(33558);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(61820);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-analytics/lib/trackable/index.js

const TRACKABLE_PROPS = (/* unused pure expression or super */ null && (['data-trackable-group', 'data-trackable', 'data-trackable-selection']));
function createTrackableProps() {
  let {
    selection,
    group
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const props = {};
  if (group) {
    props['data-trackable-group'] = group;
  }
  if (selection) {
    props['data-trackable-selection'] = selection;
  } else {
    props['data-trackable'] = true;
  }
  return props;
}
const PropTypes = {
  trackableProps: prop_types_default().shape({
    selection: (prop_types_default()).string,
    group: (prop_types_default()).string
  })
};
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-sub-nav/lib/components/SubNavLink/styles.css
var SubNavLink_styles = __webpack_require__(44805);
var SubNavLink_styles_default = /*#__PURE__*/__webpack_require__.n(SubNavLink_styles);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-ui-sub-nav/lib/components/SubNavLink/index.js









const SubNavLink = _ref => {
  let {
    active,
    classes: classesProp,
    href,
    children,
    trackableProps,
    ...props
  } = _ref;
  const classes = (0,react_css_modules_lib.useClasses)((SubNavLink_styles_default()), classesProp);
  const activeLinkStyle = active && classes.active;
  return /*#__PURE__*/react.createElement("li", {
    className: classnames_default()(classes['list-item'], activeLinkStyle)
  }, /*#__PURE__*/react.createElement(Body/* Body2 */.p, (0,esm_extends["default"])({}, props, {
    as: "a",
    className: classes.link,
    href: href
  }, createTrackableProps(trackableProps)), children));
};
 false ? 0 : void 0;
/* harmony default export */ var components_SubNavLink = (SubNavLink);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-buttons/lib/components/Button/index.js
var Button = __webpack_require__(34925);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-sub-nav/lib/components/SubNavButton/styles.css
var SubNavButton_styles = __webpack_require__(55828);
var SubNavButton_styles_default = /*#__PURE__*/__webpack_require__.n(SubNavButton_styles);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-ui-sub-nav/lib/components/SubNavButton/index.js








const SubNavButton = _ref => {
  let {
    classes: classesProp,
    children,
    trackableProps,
    ...props
  } = _ref;
  const classes = (0,react_css_modules_lib.useClasses)((SubNavButton_styles_default()), classesProp);
  return /*#__PURE__*/react.createElement("li", {
    className: classes['list-item']
  }, /*#__PURE__*/react.createElement(Button/* default */.Z, (0,esm_extends["default"])({
    type: "button"
  }, props, {
    className: classes.button,
    color: "primary-alternative",
    size: "md"
  }, createTrackableProps(trackableProps)), children));
};
 false ? 0 : void 0;
/* harmony default export */ var components_SubNavButton = (SubNavButton);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-ui-sub-nav/lib/index.js




/***/ }),

/***/ 27308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61820);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _withWeightModifiers_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63889);
/* harmony import */ var _font_scale_categories_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86085);
/* harmony import */ var _font_scale_categories_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_font_scale_categories_css__WEBPACK_IMPORTED_MODULE_2__);





const Caption = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
    className,
    as: ComponentToRender,
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComponentToRender, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__["default"])({
    ref: ref,
    className: `${className} ${(_font_scale_categories_css__WEBPACK_IMPORTED_MODULE_2___default())[`caption-${size}`]}`
  }, props));
});
Caption.defaultProps = {
  className: '',
  as: 'div',
  size: 'lg'
};
Caption.propTypes = {
  /**
   * Font size
   */
  size: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf(['sm', 'lg']),
  /**
   * Additional classes to apply
   */
  className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /**
   * Component to render
   */
  as: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().elementType)
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,_withWeightModifiers_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Caption));

/***/ }),

/***/ 70479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61820);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _withWeightModifiers_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63889);
/* harmony import */ var _font_scale_categories_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86085);
/* harmony import */ var _font_scale_categories_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_font_scale_categories_css__WEBPACK_IMPORTED_MODULE_2__);






/**
 * This component also supports the font weight modifier props.
 */
const Subhead = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
    className,
    as: ComponentToRender,
    ...props
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComponentToRender, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__["default"])({
    ref: ref,
    className: `${className} ${(_font_scale_categories_css__WEBPACK_IMPORTED_MODULE_2___default().subhead)}`
  }, props));
});
Subhead.defaultProps = {
  className: '',
  as: 'div'
};
Subhead.propTypes = {
  /**
   * Additional classes to apply
   */
  className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /**
   * Component to render
   */
  as: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().elementType)
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,_withWeightModifiers_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Subhead));

/***/ }),

/***/ 24021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(44345);

module.exports = parent;


/***/ }),

/***/ 92750:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(65504);

module.exports = parent;


/***/ }),

/***/ 25822:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(98633);

module.exports = parent;


/***/ }),

/***/ 28432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(25602);

module.exports = parent;


/***/ }),

/***/ 45330:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(82391);

module.exports = parent;


/***/ }),

/***/ 61897:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(83703);

module.exports = parent;


/***/ }),

/***/ 92748:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(49307);

module.exports = parent;


/***/ }),

/***/ 47093:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(67737);

module.exports = parent;


/***/ }),

/***/ 13338:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(93635);

module.exports = parent;


/***/ }),

/***/ 8822:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(67857);
__webpack_require__(87569);
var path = __webpack_require__(3999);

module.exports = path.Array.from;


/***/ }),

/***/ 90130:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(36713);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('Array').findIndex;


/***/ }),

/***/ 93448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(78715);
__webpack_require__(68137);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('Array').flatMap;


/***/ }),

/***/ 64158:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(66103);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('Array').sort;


/***/ }),

/***/ 8608:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(59433);
var method = __webpack_require__(90130);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.findIndex;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.findIndex) ? method : own;
};


/***/ }),

/***/ 77659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(59433);
var method = __webpack_require__(93448);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.flatMap;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.flatMap) ? method : own;
};


/***/ }),

/***/ 48360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(59433);
var method = __webpack_require__(64158);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.sort;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.sort) ? method : own;
};


/***/ }),

/***/ 37551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(59433);
var method = __webpack_require__(55141);

var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.startsWith;
  return typeof it == 'string' || it === StringPrototype
    || (isPrototypeOf(StringPrototype, it) && own === StringPrototype.startsWith) ? method : own;
};


/***/ }),

/***/ 89642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(59433);
var method = __webpack_require__(1572);

var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.trim;
  return typeof it == 'string' || it === StringPrototype
    || (isPrototypeOf(StringPrototype, it) && own === StringPrototype.trim) ? method : own;
};


/***/ }),

/***/ 99588:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(84683);
var path = __webpack_require__(3999);

module.exports = path.Number.isFinite;


/***/ }),

/***/ 552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(43163);
var path = __webpack_require__(3999);

var Object = path.Object;

var getOwnPropertyDescriptor = module.exports = function getOwnPropertyDescriptor(it, key) {
  return Object.getOwnPropertyDescriptor(it, key);
};

if (Object.getOwnPropertyDescriptor.sham) getOwnPropertyDescriptor.sham = true;


/***/ }),

/***/ 97431:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(61552);
var path = __webpack_require__(3999);

module.exports = path.Object.values;


/***/ }),

/***/ 55141:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(90855);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('String').startsWith;


/***/ }),

/***/ 1572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(76804);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('String').trim;


/***/ }),

/***/ 56161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(66097);


/***/ }),

/***/ 62755:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(74682);


/***/ }),

/***/ 26333:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(65208);


/***/ }),

/***/ 10426:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(22713);


/***/ }),

/***/ 58911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(62515);


/***/ }),

/***/ 12504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(31824);


/***/ }),

/***/ 94611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(4164);


/***/ }),

/***/ 16462:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72015);


/***/ }),

/***/ 87896:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(6077);


/***/ }),

/***/ 66097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(24021);

module.exports = parent;


/***/ }),

/***/ 74682:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(92750);

module.exports = parent;


/***/ }),

/***/ 65208:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(25822);

module.exports = parent;


/***/ }),

/***/ 22713:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(28432);

module.exports = parent;


/***/ }),

/***/ 62515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(45330);

module.exports = parent;


/***/ }),

/***/ 31824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(61897);

module.exports = parent;


/***/ }),

/***/ 4164:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(92748);

module.exports = parent;


/***/ }),

/***/ 72015:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(47093);

module.exports = parent;


/***/ }),

/***/ 6077:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(13338);

module.exports = parent;


/***/ }),

/***/ 88593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var tryToString = __webpack_require__(4101);

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};


/***/ }),

/***/ 50753:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var userAgent = __webpack_require__(82182);

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),

/***/ 49955:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var UA = __webpack_require__(82182);

module.exports = /MSIE|Trident/.test(UA);


/***/ }),

/***/ 45917:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var userAgent = __webpack_require__(82182);

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),

/***/ 31921:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(41614);

var globalIsFinite = global.isFinite;

// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
module.exports = Number.isFinite || function isFinite(it) {
  return typeof it == 'number' && globalIsFinite(it);
};


/***/ }),

/***/ 92776:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var PROPER_FUNCTION_NAME = (__webpack_require__(29892).PROPER);
var fails = __webpack_require__(19699);
var whitespaces = __webpack_require__(71052);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};


/***/ }),

/***/ 21123:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(21481);
var requireObjectCoercible = __webpack_require__(30849);
var toString = __webpack_require__(80717);
var whitespaces = __webpack_require__(71052);

var replace = uncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ 71052:
/***/ (function(module) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ 36713:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var $findIndex = (__webpack_require__(16918).findIndex);
var addToUnscopables = __webpack_require__(86724);

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ 78715:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var flattenIntoArray = __webpack_require__(74820);
var aCallable = __webpack_require__(23188);
var toObject = __webpack_require__(77020);
var lengthOfArrayLike = __webpack_require__(48368);
var arraySpeciesCreate = __webpack_require__(93201);

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A;
    aCallable(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});


/***/ }),

/***/ 87569:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var from = __webpack_require__(12196);
var checkCorrectnessOfIteration = __webpack_require__(14896);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ 66103:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var uncurryThis = __webpack_require__(21481);
var aCallable = __webpack_require__(23188);
var toObject = __webpack_require__(77020);
var lengthOfArrayLike = __webpack_require__(48368);
var deletePropertyOrThrow = __webpack_require__(88593);
var toString = __webpack_require__(80717);
var fails = __webpack_require__(19699);
var internalSort = __webpack_require__(11644);
var arrayMethodIsStrict = __webpack_require__(15419);
var FF = __webpack_require__(50753);
var IE_OR_EDGE = __webpack_require__(49955);
var V8 = __webpack_require__(59483);
var WEBKIT = __webpack_require__(45917);

var test = [];
var nativeSort = uncurryThis(test.sort);
var push = uncurryThis(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});


/***/ }),

/***/ 68137:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__(86724);

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');


/***/ }),

/***/ 84683:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var numberIsFinite = __webpack_require__(31921);

// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
$({ target: 'Number', stat: true }, { isFinite: numberIsFinite });


/***/ }),

/***/ 43163:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var fails = __webpack_require__(19699);
var toIndexedObject = __webpack_require__(69693);
var nativeGetOwnPropertyDescriptor = (__webpack_require__(86038).f);
var DESCRIPTORS = __webpack_require__(14406);

var FORCED = !DESCRIPTORS || fails(function () { nativeGetOwnPropertyDescriptor(1); });

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ 61552:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var $values = (__webpack_require__(80138).values);

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ 90855:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var uncurryThis = __webpack_require__(97028);
var getOwnPropertyDescriptor = (__webpack_require__(86038).f);
var toLength = __webpack_require__(55371);
var toString = __webpack_require__(80717);
var notARegExp = __webpack_require__(61729);
var requireObjectCoercible = __webpack_require__(30849);
var correctIsRegExpLogic = __webpack_require__(28477);
var IS_PURE = __webpack_require__(53720);

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var nativeStartsWith = uncurryThis(''.startsWith);
var stringSlice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return nativeStartsWith
      ? nativeStartsWith(that, search, index)
      : stringSlice(that, index, index + search.length) === search;
  }
});


/***/ }),

/***/ 76804:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var $trim = (__webpack_require__(21123).trim);
var forcedStringTrimMethod = __webpack_require__(92776);

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ 44345:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(8822);

module.exports = parent;


/***/ }),

/***/ 65504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(8608);

module.exports = parent;


/***/ }),

/***/ 98633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(77659);

module.exports = parent;


/***/ }),

/***/ 25602:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(48360);

module.exports = parent;


/***/ }),

/***/ 82391:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(37551);

module.exports = parent;


/***/ }),

/***/ 83703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(89642);

module.exports = parent;


/***/ }),

/***/ 49307:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(99588);

module.exports = parent;


/***/ }),

/***/ 67737:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(552);

module.exports = parent;


/***/ }),

/***/ 93635:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(97431);

module.exports = parent;


/***/ }),

/***/ 74307:
/***/ (function(module) {

"use strict";


function useNative() {
	if (typeof window.CustomEvent === 'function') {
		return true;
	}

	return false;
}

// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
module.exports = useNative() ? window.CustomEvent : function (event, params) {
	var e = document.createEvent('CustomEvent');

	params = params || {
		bubbles: false,
		cancelable: false,
		detail: undefined
	};

	e.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);

	return e;
};


/***/ }),

/***/ 15058:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 61723:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(27635),
    root = __webpack_require__(66380);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1885:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(27635),
    root = __webpack_require__(66380);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 78428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(27635),
    root = __webpack_require__(66380);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 91586:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(55058),
    stackClear = __webpack_require__(79116),
    stackDelete = __webpack_require__(1408),
    stackGet = __webpack_require__(7873),
    stackHas = __webpack_require__(66017),
    stackSet = __webpack_require__(16398);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 93802:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(66380);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 82639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(27635),
    root = __webpack_require__(66380);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 94885:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 92565:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 18662:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(6000),
    isArguments = __webpack_require__(44505),
    isArray = __webpack_require__(10188),
    isBuffer = __webpack_require__(33023),
    isIndex = __webpack_require__(63864),
    isTypedArray = __webpack_require__(59670);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 88769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(21728),
    keys = __webpack_require__(13074);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 89834:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(21728),
    keysIn = __webpack_require__(43225);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 63690:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(91586),
    arrayEach = __webpack_require__(94885),
    assignValue = __webpack_require__(68242),
    baseAssign = __webpack_require__(88769),
    baseAssignIn = __webpack_require__(89834),
    cloneBuffer = __webpack_require__(61566),
    copyArray = __webpack_require__(50081),
    copySymbols = __webpack_require__(97071),
    copySymbolsIn = __webpack_require__(16206),
    getAllKeys = __webpack_require__(68473),
    getAllKeysIn = __webpack_require__(39759),
    getTag = __webpack_require__(63249),
    initCloneArray = __webpack_require__(14053),
    initCloneByTag = __webpack_require__(16618),
    initCloneObject = __webpack_require__(18464),
    isArray = __webpack_require__(10188),
    isBuffer = __webpack_require__(33023),
    isMap = __webpack_require__(28977),
    isObject = __webpack_require__(80053),
    isSet = __webpack_require__(39478),
    keys = __webpack_require__(13074),
    keysIn = __webpack_require__(43225);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 13271:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(80053);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 94962:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(73234),
    isArray = __webpack_require__(10188);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 82024:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(63249),
    isObjectLike = __webpack_require__(69538);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 69951:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(63249),
    isObjectLike = __webpack_require__(69538);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 41735:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(54638),
    isLength = __webpack_require__(49813),
    isObjectLike = __webpack_require__(69538);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 29206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(25803),
    nativeKeys = __webpack_require__(94332);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 57924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(80053),
    isPrototype = __webpack_require__(25803),
    nativeKeysIn = __webpack_require__(74844);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 6000:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 8805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(1105);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 21322:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 56092:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(4112),
    last = __webpack_require__(74826),
    parent = __webpack_require__(12977),
    toKey = __webpack_require__(38915);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 73938:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(93802);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 61566:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(66380);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 73991:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(73938);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 98589:
/***/ (function(module) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 78897:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(91367);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 32922:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(73938);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 50081:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 21728:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(68242),
    baseAssignValue = __webpack_require__(40380);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 97071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(21728),
    getSymbols = __webpack_require__(10161);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 16206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(21728),
    getSymbolsIn = __webpack_require__(46247);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 17849:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPlainObject = __webpack_require__(29376);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ 68473:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(94962),
    getSymbols = __webpack_require__(10161),
    keys = __webpack_require__(13074);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 39759:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(94962),
    getSymbolsIn = __webpack_require__(46247),
    keysIn = __webpack_require__(43225);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 48483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(88493);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 10161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(92565),
    stubArray = __webpack_require__(10434);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 46247:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(73234),
    getPrototype = __webpack_require__(48483),
    getSymbols = __webpack_require__(10161),
    stubArray = __webpack_require__(10434);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 63249:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(61723),
    Map = __webpack_require__(59965),
    Promise = __webpack_require__(1885),
    Set = __webpack_require__(78428),
    WeakMap = __webpack_require__(82639),
    baseGetTag = __webpack_require__(54638),
    toSource = __webpack_require__(71636);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 14053:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 16618:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(73938),
    cloneDataView = __webpack_require__(73991),
    cloneRegExp = __webpack_require__(98589),
    cloneSymbol = __webpack_require__(78897),
    cloneTypedArray = __webpack_require__(32922);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 18464:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(13271),
    getPrototype = __webpack_require__(48483),
    isPrototype = __webpack_require__(25803);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 25803:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 94332:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(88493);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 74844:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 69509:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(12347);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 88493:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 12977:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(36281),
    baseSlice = __webpack_require__(56634);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 79116:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(55058);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 1408:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 7873:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 66017:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 16398:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(55058),
    Map = __webpack_require__(59965),
    MapCache = __webpack_require__(33602);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 1105:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 68726:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(80053),
    now = __webpack_require__(48518),
    toNumber = __webpack_require__(50097);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 83270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(24483),
    isLength = __webpack_require__(49813);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 33023:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(66380),
    stubFalse = __webpack_require__(9917);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 28977:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMap = __webpack_require__(82024),
    baseUnary = __webpack_require__(21322),
    nodeUtil = __webpack_require__(69509);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 29376:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(54638),
    getPrototype = __webpack_require__(48483),
    isObjectLike = __webpack_require__(69538);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 39478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsSet = __webpack_require__(69951),
    baseUnary = __webpack_require__(21322),
    nodeUtil = __webpack_require__(69509);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 59670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(41735),
    baseUnary = __webpack_require__(21322),
    nodeUtil = __webpack_require__(69509);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 13074:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(18662),
    baseKeys = __webpack_require__(29206),
    isArrayLike = __webpack_require__(83270);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 43225:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(18662),
    baseKeysIn = __webpack_require__(57924),
    isArrayLike = __webpack_require__(83270);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 74826:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 48518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(66380);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 54452:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(85198),
    baseClone = __webpack_require__(63690),
    baseUnset = __webpack_require__(56092),
    castPath = __webpack_require__(4112),
    copyObject = __webpack_require__(21728),
    customOmitClone = __webpack_require__(17849),
    flatRest = __webpack_require__(91721),
    getAllKeysIn = __webpack_require__(39759);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ 10434:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 9917:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 50097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(8805),
    isObject = __webpack_require__(80053),
    isSymbol = __webpack_require__(77352);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 65792:
/***/ (function(module) {

"use strict";


var proto = typeof Element !== 'undefined' ? Element.prototype : {};
var vendor = proto.matches
  || proto.matchesSelector
  || proto.webkitMatchesSelector
  || proto.mozMatchesSelector
  || proto.msMatchesSelector
  || proto.oMatchesSelector;

module.exports = match;

/**
 * Match `el` to `selector`.
 *
 * @param {Element} el
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */

function match(el, selector) {
  if (!el || el.nodeType !== 1) return false;
  if (vendor) return vendor.call(el, selector);
  var nodes = el.parentNode.querySelectorAll(selector);
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i] == el) return true;
  }
  return false;
}


/***/ }),

/***/ 49436:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){var e={477:function(e){"use strict";e.exports=__webpack_require__(66108)}};var t={};function __nccwpck_require__(o){var a=t[o];if(a!==undefined){return a.exports}var s=t[o]={exports:{}};var n=true;try{e[o](s,s.exports,__nccwpck_require__);n=false}finally{if(n)delete t[o]}return s.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var o={};!function(){var e=o;var t,a=(t=__nccwpck_require__(477))&&"object"==typeof t&&"default"in t?t.default:t,s=/https?|ftp|gopher|file/;function r(e){"string"==typeof e&&(e=d(e));var t=function(e,t,o){var a=e.auth,s=e.hostname,n=e.protocol||"",p=e.pathname||"",c=e.hash||"",i=e.query||"",u=!1;a=a?encodeURIComponent(a).replace(/%3A/i,":")+"@":"",e.host?u=a+e.host:s&&(u=a+(~s.indexOf(":")?"["+s+"]":s),e.port&&(u+=":"+e.port)),i&&"object"==typeof i&&(i=t.encode(i));var f=e.search||i&&"?"+i||"";return n&&":"!==n.substr(-1)&&(n+=":"),e.slashes||(!n||o.test(n))&&!1!==u?(u="//"+(u||""),p&&"/"!==p[0]&&(p="/"+p)):u||(u=""),c&&"#"!==c[0]&&(c="#"+c),f&&"?"!==f[0]&&(f="?"+f),{protocol:n,host:u,pathname:p=p.replace(/[?#]/g,encodeURIComponent),search:f=f.replace("#","%23"),hash:c}}(e,a,s);return""+t.protocol+t.host+t.pathname+t.search+t.hash}var n="http://",p="w.w",c=n+p,i=/^([a-z0-9.+-]*:\/\/\/)([a-z0-9.+-]:\/*)?/i,u=/https?|ftp|gopher|file/;function h(e,t){var o="string"==typeof e?d(e):e;e="object"==typeof e?r(e):e;var a=d(t),s="";o.protocol&&!o.slashes&&(s=o.protocol,e=e.replace(o.protocol,""),s+="/"===t[0]||"/"===e[0]?"/":""),s&&a.protocol&&(s="",a.slashes||(s=a.protocol,t=t.replace(a.protocol,"")));var p=e.match(i);p&&!a.protocol&&(e=e.substr((s=p[1]+(p[2]||"")).length),/^\/\/[^/]/.test(t)&&(s=s.slice(0,-1)));var f=new URL(e,c+"/"),m=new URL(t,f).toString().replace(c,""),v=a.protocol||o.protocol;return v+=o.slashes||a.slashes?"//":"",!s&&v?m=m.replace(n,v):s&&(m=m.replace(n,"")),u.test(m)||~t.indexOf(".")||"/"===e.slice(-1)||"/"===t.slice(-1)||"/"!==m.slice(-1)||(m=m.slice(0,-1)),s&&(m=s+("/"===m[0]?m.substr(1):m)),m}function l(){}l.prototype.parse=d,l.prototype.format=r,l.prototype.resolve=h,l.prototype.resolveObject=h;var f=/^https?|ftp|gopher|file/,m=/^(.*?)([#?].*)/,v=/^([a-z0-9.+-]*:)(\/{0,3})(.*)/i,_=/^([a-z0-9.+-]*:)?\/\/\/*/i,b=/^([a-z0-9.+-]*:)(\/{0,2})\[(.*)\]$/i;function d(e,t,o){if(void 0===t&&(t=!1),void 0===o&&(o=!1),e&&"object"==typeof e&&e instanceof l)return e;var s=(e=e.trim()).match(m);e=s?s[1].replace(/\\/g,"/")+s[2]:e.replace(/\\/g,"/"),b.test(e)&&"/"!==e.slice(-1)&&(e+="/");var n=!/(^javascript)/.test(e)&&e.match(v),i=_.test(e),u="";n&&(f.test(n[1])||(u=n[1].toLowerCase(),e=""+n[2]+n[3]),n[2]||(i=!1,f.test(n[1])?(u=n[1],e=""+n[3]):e="//"+n[3]),3!==n[2].length&&1!==n[2].length||(u=n[1],e="/"+n[3]));var g,y=(s?s[1]:e).match(/^https?:\/\/[^/]+(:[0-9]+)(?=\/|$)/),w=y&&y[1],C=new l,U="",j="";try{g=new URL(e)}catch(t){U=t,u||o||!/^\/\//.test(e)||/^\/\/.+[@.]/.test(e)||(j="/",e=e.substr(1));try{g=new URL(e,c)}catch(e){return C.protocol=u,C.href=u,C}}C.slashes=i&&!j,C.host=g.host===p?"":g.host,C.hostname=g.hostname===p?"":g.hostname.replace(/(\[|\])/g,""),C.protocol=U?u||null:g.protocol,C.search=g.search.replace(/\\/g,"%5C"),C.hash=g.hash.replace(/\\/g,"%5C");var x=e.split("#");!C.search&&~x[0].indexOf("?")&&(C.search="?"),C.hash||""!==x[1]||(C.hash="#"),C.query=t?a.decode(g.search.substr(1)):C.search.substr(1),C.pathname=j+(n?function(e){return e.replace(/['^|`]/g,(function(e){return"%"+e.charCodeAt().toString(16).toUpperCase()})).replace(/((?:%[0-9A-F]{2})+)/g,(function(e,t){try{return decodeURIComponent(t).split("").map((function(e){var t=e.charCodeAt();return t>256||/^[a-z0-9]$/i.test(e)?e:"%"+t.toString(16).toUpperCase()})).join("")}catch(e){return t}}))}(g.pathname):g.pathname),"about:"===C.protocol&&"blank"===C.pathname&&(C.protocol="",C.pathname=""),U&&"/"!==e[0]&&(C.pathname=C.pathname.substr(1)),u&&!f.test(u)&&"/"!==e.slice(-1)&&"/"===C.pathname&&(C.pathname=""),C.path=C.pathname+C.search,C.auth=[g.username,g.password].map(decodeURIComponent).filter(Boolean).join(":"),C.port=g.port,w&&!C.host.endsWith(w)&&(C.host+=w,C.port=w.slice(1)),C.href=j?""+C.pathname+C.search+C.hash:r(C);var q=/^(file)/.test(C.href)?["host","hostname"]:[];return Object.keys(C).forEach((function(e){~q.indexOf(e)||(C[e]=C[e]||null)})),C}e.parse=d,e.format=r,e.resolve=h,e.resolveObject=function(e,t){return d(h(e,t))},e.Url=l}();module.exports=o})();

/***/ }),

/***/ 79140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(77519)


/***/ }),

/***/ 70133:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 86896:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 66108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(70133);
exports.encode = exports.stringify = __webpack_require__(86896);


/***/ }),

/***/ 23596:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.2
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l=__webpack_require__(32319),m=__webpack_require__(99084);function p(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var q=60106,r=60107,u=60108,z=60114,B=60109,aa=60110,ba=60112,D=60113,ca=60120,da=60115,ea=60116,fa=60121,ha=60117,ia=60119,ja=60129,ka=60131;
if("function"===typeof Symbol&&Symbol.for){var E=Symbol.for;q=E("react.portal");r=E("react.fragment");u=E("react.strict_mode");z=E("react.profiler");B=E("react.provider");aa=E("react.context");ba=E("react.forward_ref");D=E("react.suspense");ca=E("react.suspense_list");da=E("react.memo");ea=E("react.lazy");fa=E("react.block");ha=E("react.fundamental");ia=E("react.scope");ja=E("react.debug_trace_mode");ka=E("react.legacy_hidden")}
function F(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case r:return"Fragment";case q:return"Portal";case z:return"Profiler";case u:return"StrictMode";case D:return"Suspense";case ca:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case aa:return(a.displayName||"Context")+".Consumer";case B:return(a._context.displayName||"Context")+".Provider";case ba:var b=a.render;b=b.displayName||b.name||"";return a.displayName||
(""!==b?"ForwardRef("+b+")":"ForwardRef");case da:return F(a.type);case fa:return F(a._render);case ea:b=a._payload;a=a._init;try{return F(a(b))}catch(c){}}return null}var la=m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,ma={};function I(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2,a._threadCount=c+1}function na(a,b,c,d){if(d&&(d=a.contextType,"object"===typeof d&&null!==d))return I(d,c),d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c}else b=ma;return b}
for(var J=new Uint16Array(16),K=0;15>K;K++)J[K]=K+1;J[15]=0;var oa=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,pa=Object.prototype.hasOwnProperty,qa={},ra={};
function sa(a){if(pa.call(ra,a))return!0;if(pa.call(qa,a))return!1;if(oa.test(a))return ra[a]=!0;qa[a]=!0;return!1}function ta(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function ua(a,b,c,d){if(null===b||"undefined"===typeof b||ta(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function M(a,b,c,d,f,h,t){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=h;this.removeEmptyString=t}var N={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){N[a]=new M(a,0,!1,a,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];N[b]=new M(b,1,!1,a[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){N[a]=new M(a,2,!1,a.toLowerCase(),null,!1,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){N[a]=new M(a,2,!1,a,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){N[a]=new M(a,3,!1,a.toLowerCase(),null,!1,!1)});
["checked","multiple","muted","selected"].forEach(function(a){N[a]=new M(a,3,!0,a,null,!1,!1)});["capture","download"].forEach(function(a){N[a]=new M(a,4,!1,a,null,!1,!1)});["cols","rows","size","span"].forEach(function(a){N[a]=new M(a,6,!1,a,null,!1,!1)});["rowSpan","start"].forEach(function(a){N[a]=new M(a,5,!1,a.toLowerCase(),null,!1,!1)});var va=/[\-:]([a-z])/g;function wa(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(va,
wa);N[b]=new M(b,1,!1,a,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(va,wa);N[b]=new M(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(va,wa);N[b]=new M(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(a){N[a]=new M(a,1,!1,a.toLowerCase(),null,!1,!1)});
N.xlinkHref=new M("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){N[a]=new M(a,1,!1,a.toLowerCase(),null,!0,!0)});var xa=/["'&<>]/;
function O(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=xa.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b}a=f!==d?c+a.substring(f,d):c}return a}
function ya(a,b){var c=N.hasOwnProperty(a)?N[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||ua(a,b,c,!1))return"";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+'="'+(O(b)+'"')}return sa(a)?a+'="'+(O(b)+'"'):""}function za(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
var Aa="function"===typeof Object.is?Object.is:za,P=null,Q=null,R=null,S=!1,T=!1,U=null,V=0;function W(){if(null===P)throw Error(p(321));return P}function Ba(){if(0<V)throw Error(p(312));return{memoizedState:null,queue:null,next:null}}function Ca(){null===R?null===Q?(S=!1,Q=R=Ba()):(S=!0,R=Q):null===R.next?(S=!1,R=R.next=Ba()):(S=!0,R=R.next);return R}function Da(a,b,c,d){for(;T;)T=!1,V+=1,R=null,c=a(b,d);Ea();return c}function Ea(){P=null;T=!1;Q=null;V=0;R=U=null}
function Fa(a,b){return"function"===typeof b?b(a):b}function Ga(a,b,c){P=W();R=Ca();if(S){var d=R.queue;b=d.dispatch;if(null!==U&&(c=U.get(d),void 0!==c)){U.delete(d);d=R.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);R.memoizedState=d;return[d,b]}return[R.memoizedState,b]}a=a===Fa?"function"===typeof b?b():b:void 0!==c?c(b):b;R.memoizedState=a;a=R.queue={last:null,dispatch:null};a=a.dispatch=Ha.bind(null,P,a);return[R.memoizedState,a]}
function Ia(a,b){P=W();R=Ca();b=void 0===b?null:b;if(null!==R){var c=R.memoizedState;if(null!==c&&null!==b){var d=c[1];a:if(null===d)d=!1;else{for(var f=0;f<d.length&&f<b.length;f++)if(!Aa(b[f],d[f])){d=!1;break a}d=!0}if(d)return c[0]}}a=a();R.memoizedState=[a,b];return a}function Ha(a,b,c){if(!(25>V))throw Error(p(301));if(a===P)if(T=!0,a={action:c,next:null},null===U&&(U=new Map),c=U.get(b),void 0===c)U.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}}function Ja(){}
var X=null,Ka={readContext:function(a){var b=X.threadID;I(a,b);return a[b]},useContext:function(a){W();var b=X.threadID;I(a,b);return a[b]},useMemo:Ia,useReducer:Ga,useRef:function(a){P=W();R=Ca();var b=R.memoizedState;return null===b?(a={current:a},R.memoizedState=a):b},useState:function(a){return Ga(Fa,a)},useLayoutEffect:function(){},useCallback:function(a,b){return Ia(function(){return a},b)},useImperativeHandle:Ja,useEffect:Ja,useDebugValue:Ja,useDeferredValue:function(a){W();return a},useTransition:function(){W();
return[function(a){a()},!1]},useOpaqueIdentifier:function(){return(X.identifierPrefix||"")+"R:"+(X.uniqueID++).toString(36)},useMutableSource:function(a,b){W();return b(a._source)}},La={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};function Ma(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var Na={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Oa=l({menuitem:!0},Na),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Pa=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Pa.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
var Qa=/([A-Z])/g,Ra=/^ms-/,Z=m.Children.toArray,Sa=la.ReactCurrentDispatcher,Ta={listing:!0,pre:!0,textarea:!0},Ua=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Va={},Wa={};function Xa(a){if(void 0===a||null===a)return a;var b="";m.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Ya=Object.prototype.hasOwnProperty,Za={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function $a(a,b){if(void 0===a)throw Error(p(152,F(b)||"Component"));}
function ab(a,b,c){function d(d,h){var e=h.prototype&&h.prototype.isReactComponent,f=na(h,b,c,e),t=[],g=!1,n={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===t)return null},enqueueReplaceState:function(a,c){g=!0;t=[c]},enqueueSetState:function(a,c){if(null===t)return null;t.push(c)}};if(e){if(e=new h(d.props,f,n),"function"===typeof h.getDerivedStateFromProps){var k=h.getDerivedStateFromProps.call(null,d.props,e.state);null!=k&&(e.state=l({},e.state,k))}}else if(P={},e=h(d.props,
f,n),e=Da(h,d.props,e,f),null==e||null==e.render){a=e;$a(a,h);return}e.props=d.props;e.context=f;e.updater=n;n=e.state;void 0===n&&(e.state=n=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof h.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof h.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),t.length){n=t;var v=
g;t=null;g=!1;if(v&&1===n.length)e.state=n[0];else{k=v?n[0]:e.state;var H=!0;for(v=v?1:0;v<n.length;v++){var x=n[v];x="function"===typeof x?x.call(e,k,d.props,f):x;null!=x&&(H?(H=!1,k=l({},k,x)):l(k,x))}e.state=k}}else t=null;a=e.render();$a(a,h);if("function"===typeof e.getChildContext&&(d=h.childContextTypes,"object"===typeof d)){var y=e.getChildContext();for(var A in y)if(!(A in d))throw Error(p(108,F(h)||"Unknown",A));}y&&(b=l({},b,y))}for(;m.isValidElement(a);){var f=a,h=f.type;if("function"!==
typeof h)break;d(f,h)}return{child:a,context:b}}
var bb=function(){function a(a,b,f){m.isValidElement(a)?a.type!==r?a=[a]:(a=a.props.children,a=m.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:La.html,children:a,childIndex:0,context:ma,footer:""};var c=J[0];if(0===c){var d=J;c=d.length;var g=2*c;if(!(65536>=g))throw Error(p(304));var e=new Uint16Array(g);e.set(d);J=e;J[0]=c+1;for(d=c;d<g-1;d++)J[d]=d+1;J[g-1]=0}else J[0]=J[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;
this.makeStaticMarkup=b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[];this.uniqueID=0;this.identifierPrefix=f&&f.identifierPrefix||""}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;J[a]=J[0];J[0]=a}};b.pushProvider=function(a){var b=++this.contextIndex,c=a.type._context,h=this.threadID;I(c,h);var t=c[h];this.contextStack[b]=c;this.contextValueStack[b]=t;c[h]=a.props.value};b.popProvider=
function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};b.read=function(a){if(this.exhausted)return null;var b=X;X=this;var c=Sa.current;Sa.current=Ka;try{for(var h=[""],t=!1;h[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var g=this.threadID;
J[g]=J[0];J[0]=g;break}var e=this.stack[this.stack.length-1];if(t||e.childIndex>=e.children.length){var L=e.footer;""!==L&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===B)this.popProvider(e.type);else if(e.type===D){this.suspenseDepth--;var G=h.pop();if(t){t=!1;var C=e.fallbackFrame;if(!C)throw Error(p(303));this.stack.push(C);h[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else h[this.suspenseDepth]+=
G}h[this.suspenseDepth]+=L}else{var n=e.children[e.childIndex++],k="";try{k+=this.render(n,e.context,e.domNamespace)}catch(v){if(null!=v&&"function"===typeof v.then)throw Error(p(294));throw v;}finally{}h.length<=this.suspenseDepth&&h.push("");h[this.suspenseDepth]+=k}}return h[0]}finally{Sa.current=c,X=b,Ea()}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return"";if(this.makeStaticMarkup)return O(f);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+O(f);
this.previousWasTextNode=!0;return O(f)}b=ab(a,b,this.threadID);a=b.child;b=b.context;if(null===a||!1===a)return"";if(!m.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===q)throw Error(p(257));throw Error(p(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case ka:case ja:case u:case z:case ca:case r:return a=Z(a.props.children),this.stack.push({type:null,
domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case D:throw Error(p(294));case ia:throw Error(p(343));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case ba:P={};var d=c.render(a.props,a.ref);d=Da(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return"";case da:return a=[m.createElement(c.type,l({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),
"";case B:return c=Z(a.props.children),f={type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""},this.pushProvider(a),this.stack.push(f),"";case aa:c=a.type;d=a.props;var g=this.threadID;I(c,g);c=Z(d.children(c[g]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return"";case ha:throw Error(p(338));case ea:return c=a.type,d=c._init,c=d(c._payload),a=[m.createElement(c,l({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,
context:b,footer:""}),""}throw Error(p(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();f===La.html&&Ma(c);if(!Va.hasOwnProperty(c)){if(!Ua.test(c))throw Error(p(65,c));Va[c]=!0}var d=a.props;if("input"===c)d=l({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var g=d.value;if(null==g){g=d.defaultValue;var e=d.children;if(null!=e){if(null!=
g)throw Error(p(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(p(93));e=e[0]}g=""+e}null==g&&(g="")}d=l({},d,{value:void 0,children:""+g})}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=l({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var L=Xa(d.children);if(null!=e){var G=null!=d.value?d.value+"":L;g=!1;if(Array.isArray(e))for(var C=0;C<e.length;C++){if(""+e[C]===G){g=!0;break}}else g=""+e===G;d=l({selected:void 0,children:void 0},
d,{selected:g,children:L})}}if(g=d){if(Oa[c]&&(null!=g.children||null!=g.dangerouslySetInnerHTML))throw Error(p(137,c));if(null!=g.dangerouslySetInnerHTML){if(null!=g.children)throw Error(p(60));if(!("object"===typeof g.dangerouslySetInnerHTML&&"__html"in g.dangerouslySetInnerHTML))throw Error(p(61));}if(null!=g.style&&"object"!==typeof g.style)throw Error(p(62));}g=d;e=this.makeStaticMarkup;L=1===this.stack.length;G="<"+a.type;b:if(-1===c.indexOf("-"))C="string"===typeof g.is;else switch(c){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":C=
!1;break b;default:C=!0}for(w in g)if(Ya.call(g,w)){var n=g[w];if(null!=n){if("style"===w){var k=void 0,v="",H="";for(k in n)if(n.hasOwnProperty(k)){var x=0===k.indexOf("--"),y=n[k];if(null!=y){if(x)var A=k;else if(A=k,Wa.hasOwnProperty(A))A=Wa[A];else{var cb=A.replace(Qa,"-$1").toLowerCase().replace(Ra,"-ms-");A=Wa[A]=cb}v+=H+A+":";H=k;x=null==y||"boolean"===typeof y||""===y?"":x||"number"!==typeof y||0===y||Y.hasOwnProperty(H)&&Y[H]?(""+y).trim():y+"px";v+=x;H=";"}}n=v||null}k=null;C?Za.hasOwnProperty(w)||
(k=w,k=sa(k)&&null!=n?k+'="'+(O(n)+'"'):""):k=ya(w,n);k&&(G+=" "+k)}}e||L&&(G+=' data-reactroot=""');var w=G;g="";Na.hasOwnProperty(c)?w+="/>":(w+=">",g="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children,"string"===typeof e||"number"===typeof e){e=O(e);break a}e=null}null!=e?(d=[],Ta.hasOwnProperty(c)&&"\n"===e.charAt(0)&&(w+="\n"),w+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===f?Ma(a):"http://www.w3.org/2000/svg"===
f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:g});this.previousWasTextNode=!1;return w};return a}();exports.renderToNodeStream=function(){throw Error(p(207));};exports.renderToStaticMarkup=function(a,b){a=new bb(a,!0,b);try{return a.read(Infinity)}finally{a.destroy()}};exports.renderToStaticNodeStream=function(){throw Error(p(208));};exports.renderToString=function(a,b){a=new bb(a,!1,b);try{return a.read(Infinity)}finally{a.destroy()}};
exports.version="17.0.2";


/***/ }),

/***/ 97729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(23596);
} else {}


/***/ }),

/***/ 68325:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(99084);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(61820);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _event = __webpack_require__(66763);

var _scrollParent = __webpack_require__(38106);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _debounce = __webpack_require__(30962);

var _debounce2 = _interopRequireDefault(_debounce);

var _throttle = __webpack_require__(9804);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: 0,
  height: 0
};
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = component.ref;

  var parentTop = void 0;
  var parentLeft = void 0;
  var parentHeight = void 0;
  var parentWidth = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentLeft = _parent$getBoundingCl.left;
    parentHeight = _parent$getBoundingCl.height;
    parentWidth = _parent$getBoundingCl.width;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentLeft = defaultBoundingClientRect.left;
    parentHeight = defaultBoundingClientRect.height;
    parentWidth = defaultBoundingClientRect.width;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowInnerWidth = window.innerWidth || document.documentElement.clientWidth;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionLeft = Math.max(parentLeft, 0); // intersection's left relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
  var intersectionWidth = Math.min(windowInnerWidth, parentLeft + parentWidth) - intersectionLeft; // width

  // check whether the element is visible in the intersection
  var top = void 0;
  var left = void 0;
  var height = void 0;
  var width = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    left = _node$getBoundingClie.left;
    height = _node$getBoundingClie.height;
    width = _node$getBoundingClie.width;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    left = defaultBoundingClientRect.left;
    height = defaultBoundingClientRect.height;
    width = defaultBoundingClientRect.width;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection
  var offsetLeft = left - intersectionLeft; // element's left relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0 && offsetLeft - offsets[0] <= intersectionWidth && offsetLeft + width + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = component.ref;

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = component.ref;
  if (!(node instanceof HTMLElement)) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

/**
 * Forces the component to display regardless of whether the element is visible in the viewport.
 */
var forceVisible = function forceVisible() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    listener.visible = true;
    listener.forceUpdate();
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var isString = function isString(string) {
  return typeof string === 'string';
};

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    _this.setRef = _this.setRef.bind(_this);
    return _this;
  }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var scrollport = window;
      var scrollContainer = this.props.scrollContainer;

      if (scrollContainer) {
        if (isString(scrollContainer)) {
          scrollport = scrollport.document.querySelector(scrollContainer);
        }
      }
      var needResetFinalLazyLoadHandler = this.props.debounce !== undefined && delayType === 'throttle' || delayType === 'debounce' && this.props.debounce === undefined;

      if (needResetFinalLazyLoadHandler) {
        (0, _event.off)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, _event.on)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0 && typeof window !== 'undefined') {
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(element) {
      if (element) {
        this.ref = element;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          height = _props2.height,
          children = _props2.children,
          placeholder = _props2.placeholder,
          className = _props2.className,
          classNamePrefix = _props2.classNamePrefix,
          style = _props2.style;


      return _react2.default.createElement(
        'div',
        { className: classNamePrefix + '-wrapper ' + className, ref: this.setRef, style: style },
        this.visible ? children : placeholder ? placeholder : _react2.default.createElement('div', {
          style: { height: height },
          className: classNamePrefix + '-placeholder'
        })
      );
    }
  }]);

  return LazyLoad;
}(_react.Component);

LazyLoad.propTypes = {
  className: _propTypes2.default.string,
  classNamePrefix: _propTypes2.default.string,
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  scrollContainer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  unmountIfInvisible: _propTypes2.default.bool,
  style: _propTypes2.default.object
};

LazyLoad.defaultProps = {
  className: '',
  classNamePrefix: 'lazyload',
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var decorator = function decorator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component2) {
      _inherits(LazyLoadDecorated, _Component2);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this2 = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this2.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this2;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            LazyLoad,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(_react.Component);
  };
};

__webpack_unused_export__ = decorator;
exports.ZP = LazyLoad;
__webpack_unused_export__ = lazyLoadHandler;
__webpack_unused_export__ = forceVisible;

/***/ }),

/***/ 30962:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/***/ }),

/***/ 66763:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}

/***/ }),

/***/ 38106:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

/**
 * @fileOverview Find scroll parent
 */

exports["default"] = function (node) {
  if (!(node instanceof HTMLElement)) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};

/***/ }),

/***/ 9804:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

/***/ }),

/***/ 56699:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(56161);

/***/ }),

/***/ 90466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(62755);

/***/ }),

/***/ 99697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(26333);

/***/ }),

/***/ 29591:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(10426);

/***/ }),

/***/ 81277:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(58911);

/***/ }),

/***/ 90537:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(12504);

/***/ }),

/***/ 39831:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(94611);

/***/ }),

/***/ 17412:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16462);

/***/ }),

/***/ 77497:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(87896);

/***/ }),

/***/ 8285:
/***/ (function(module) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 68068:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 2597:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 76548:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 56183:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 82222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ }),

/***/ 86806:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EventTarget": function() { return /* binding */ EventTarget; },
/* harmony export */   "defineEventAttribute": function() { return /* binding */ defineEventAttribute; }
/* harmony export */ });
/**
 * @author Toru Nagashima <https://github.com/mysticatea>
 * @copyright 2015 Toru Nagashima. All rights reserved.
 * See LICENSE file in root directory for full license.
 */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/**
 * @typedef {object} PrivateData
 * @property {EventTarget} eventTarget The event target.
 * @property {{type:string}} event The original event object.
 * @property {number} eventPhase The current event phase.
 * @property {EventTarget|null} currentTarget The current event target.
 * @property {boolean} canceled The flag to prevent default.
 * @property {boolean} stopped The flag to stop propagation.
 * @property {boolean} immediateStopped The flag to stop propagation immediately.
 * @property {Function|null} passiveListener The listener if the current listener is passive. Otherwise this is null.
 * @property {number} timeStamp The unix time.
 * @private
 */

/**
 * Private data for event wrappers.
 * @type {WeakMap<Event, PrivateData>}
 * @private
 */
var privateData = new WeakMap();
/**
 * Cache for wrapper classes.
 * @type {WeakMap<Object, Function>}
 * @private
 */

var wrappers = new WeakMap();
/**
 * Get private data.
 * @param {Event} event The event object to get private data.
 * @returns {PrivateData} The private data of the event.
 * @private
 */

function pd(event) {
  var retv = privateData.get(event);
  console.assert(retv != null, "'this' is expected an Event object, but got", event);
  return retv;
}
/**
 * https://dom.spec.whatwg.org/#set-the-canceled-flag
 * @param data {PrivateData} private data.
 */


function setCancelFlag(data) {
  if (data.passiveListener != null) {
    if (typeof console !== "undefined" && typeof console.error === "function") {
      console.error("Unable to preventDefault inside passive event listener invocation.", data.passiveListener);
    }

    return;
  }

  if (!data.event.cancelable) {
    return;
  }

  data.canceled = true;

  if (typeof data.event.preventDefault === "function") {
    data.event.preventDefault();
  }
}
/**
 * @see https://dom.spec.whatwg.org/#interface-event
 * @private
 */

/**
 * The event wrapper.
 * @constructor
 * @param {EventTarget} eventTarget The event target of this dispatching.
 * @param {Event|{type:string}} event The original event to wrap.
 */


function Event(eventTarget, event) {
  privateData.set(this, {
    eventTarget: eventTarget,
    event: event,
    eventPhase: 2,
    currentTarget: eventTarget,
    canceled: false,
    stopped: false,
    immediateStopped: false,
    passiveListener: null,
    timeStamp: event.timeStamp || Date.now()
  }); // https://heycam.github.io/webidl/#Unforgeable

  Object.defineProperty(this, "isTrusted", {
    value: false,
    enumerable: true
  }); // Define accessors

  var keys = Object.keys(event);

  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];

    if (!(key in this)) {
      Object.defineProperty(this, key, defineRedirectDescriptor(key));
    }
  }
} // Should be enumerable, but class methods are not enumerable.


Event.prototype = {
  /**
   * The type of this event.
   * @type {string}
   */
  get type() {
    return pd(this).event.type;
  },

  /**
   * The target of this event.
   * @type {EventTarget}
   */
  get target() {
    return pd(this).eventTarget;
  },

  /**
   * The target of this event.
   * @type {EventTarget}
   */
  get currentTarget() {
    return pd(this).currentTarget;
  },

  /**
   * @returns {EventTarget[]} The composed path of this event.
   */
  composedPath: function composedPath() {
    var currentTarget = pd(this).currentTarget;

    if (currentTarget == null) {
      return [];
    }

    return [currentTarget];
  },

  /**
   * Constant of NONE.
   * @type {number}
   */
  get NONE() {
    return 0;
  },

  /**
   * Constant of CAPTURING_PHASE.
   * @type {number}
   */
  get CAPTURING_PHASE() {
    return 1;
  },

  /**
   * Constant of AT_TARGET.
   * @type {number}
   */
  get AT_TARGET() {
    return 2;
  },

  /**
   * Constant of BUBBLING_PHASE.
   * @type {number}
   */
  get BUBBLING_PHASE() {
    return 3;
  },

  /**
   * The target of this event.
   * @type {number}
   */
  get eventPhase() {
    return pd(this).eventPhase;
  },

  /**
   * Stop event bubbling.
   * @returns {void}
   */
  stopPropagation: function stopPropagation() {
    var data = pd(this);
    data.stopped = true;

    if (typeof data.event.stopPropagation === "function") {
      data.event.stopPropagation();
    }
  },

  /**
   * Stop event bubbling.
   * @returns {void}
   */
  stopImmediatePropagation: function stopImmediatePropagation() {
    var data = pd(this);
    data.stopped = true;
    data.immediateStopped = true;

    if (typeof data.event.stopImmediatePropagation === "function") {
      data.event.stopImmediatePropagation();
    }
  },

  /**
   * The flag to be bubbling.
   * @type {boolean}
   */
  get bubbles() {
    return Boolean(pd(this).event.bubbles);
  },

  /**
   * The flag to be cancelable.
   * @type {boolean}
   */
  get cancelable() {
    return Boolean(pd(this).event.cancelable);
  },

  /**
   * Cancel this event.
   * @returns {void}
   */
  preventDefault: function preventDefault() {
    setCancelFlag(pd(this));
  },

  /**
   * The flag to indicate cancellation state.
   * @type {boolean}
   */
  get defaultPrevented() {
    return pd(this).canceled;
  },

  /**
   * The flag to be composed.
   * @type {boolean}
   */
  get composed() {
    return Boolean(pd(this).event.composed);
  },

  /**
   * The unix time of this event.
   * @type {number}
   */
  get timeStamp() {
    return pd(this).timeStamp;
  },

  /**
   * The target of this event.
   * @type {EventTarget}
   * @deprecated
   */
  get srcElement() {
    return pd(this).eventTarget;
  },

  /**
   * The flag to stop event bubbling.
   * @type {boolean}
   * @deprecated
   */
  get cancelBubble() {
    return pd(this).stopped;
  },

  set cancelBubble(value) {
    if (!value) {
      return;
    }

    var data = pd(this);
    data.stopped = true;

    if (typeof data.event.cancelBubble === "boolean") {
      data.event.cancelBubble = true;
    }
  },

  /**
   * The flag to indicate cancellation state.
   * @type {boolean}
   * @deprecated
   */
  get returnValue() {
    return !pd(this).canceled;
  },

  set returnValue(value) {
    if (!value) {
      setCancelFlag(pd(this));
    }
  },

  /**
   * Initialize this event object. But do nothing under event dispatching.
   * @param {string} type The event type.
   * @param {boolean} [bubbles=false] The flag to be possible to bubble up.
   * @param {boolean} [cancelable=false] The flag to be possible to cancel.
   * @deprecated
   */
  initEvent: function initEvent() {// Do nothing.
  }
}; // `constructor` is not enumerable.

Object.defineProperty(Event.prototype, "constructor", {
  value: Event,
  configurable: true,
  writable: true
}); // Ensure `event instanceof window.Event` is `true`.

if (typeof window !== "undefined" && typeof window.Event !== "undefined") {
  Object.setPrototypeOf(Event.prototype, window.Event.prototype); // Make association for wrappers.

  wrappers.set(window.Event.prototype, Event);
}
/**
 * Get the property descriptor to redirect a given property.
 * @param {string} key Property name to define property descriptor.
 * @returns {PropertyDescriptor} The property descriptor to redirect the property.
 * @private
 */


function defineRedirectDescriptor(key) {
  return {
    get: function get() {
      return pd(this).event[key];
    },
    set: function set(value) {
      pd(this).event[key] = value;
    },
    configurable: true,
    enumerable: true
  };
}
/**
 * Get the property descriptor to call a given method property.
 * @param {string} key Property name to define property descriptor.
 * @returns {PropertyDescriptor} The property descriptor to call the method property.
 * @private
 */


function defineCallDescriptor(key) {
  return {
    value: function value() {
      var event = pd(this).event;
      return event[key].apply(event, arguments);
    },
    configurable: true,
    enumerable: true
  };
}
/**
 * Define new wrapper class.
 * @param {Function} BaseEvent The base wrapper class.
 * @param {Object} proto The prototype of the original event.
 * @returns {Function} The defined wrapper class.
 * @private
 */


function defineWrapper(BaseEvent, proto) {
  var keys = Object.keys(proto);

  if (keys.length === 0) {
    return BaseEvent;
  }
  /** CustomEvent */


  function CustomEvent(eventTarget, event) {
    BaseEvent.call(this, eventTarget, event);
  }

  CustomEvent.prototype = Object.create(BaseEvent.prototype, {
    constructor: {
      value: CustomEvent,
      configurable: true,
      writable: true
    }
  }); // Define accessors.

  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];

    if (!(key in BaseEvent.prototype)) {
      var descriptor = Object.getOwnPropertyDescriptor(proto, key);
      var isFunc = typeof descriptor.value === "function";
      Object.defineProperty(CustomEvent.prototype, key, isFunc ? defineCallDescriptor(key) : defineRedirectDescriptor(key));
    }
  }

  return CustomEvent;
}
/**
 * Get the wrapper class of a given prototype.
 * @param {Object} proto The prototype of the original event to get its wrapper.
 * @returns {Function} The wrapper class.
 * @private
 */


function getWrapper(proto) {
  if (proto == null || proto === Object.prototype) {
    return Event;
  }

  var wrapper = wrappers.get(proto);

  if (wrapper == null) {
    wrapper = defineWrapper(getWrapper(Object.getPrototypeOf(proto)), proto);
    wrappers.set(proto, wrapper);
  }

  return wrapper;
}
/**
 * Wrap a given event to management a dispatching.
 * @param {EventTarget} eventTarget The event target of this dispatching.
 * @param {Object} event The event to wrap.
 * @returns {Event} The wrapper instance.
 * @private
 */


function wrapEvent(eventTarget, event) {
  var Wrapper = getWrapper(Object.getPrototypeOf(event));
  return new Wrapper(eventTarget, event);
}
/**
 * Get the immediateStopped flag of a given event.
 * @param {Event} event The event to get.
 * @returns {boolean} The flag to stop propagation immediately.
 * @private
 */

function isStopped(event) {
  return pd(event).immediateStopped;
}
/**
 * Set the current event phase of a given event.
 * @param {Event} event The event to set current target.
 * @param {number} eventPhase New event phase.
 * @returns {void}
 * @private
 */

function setEventPhase(event, eventPhase) {
  pd(event).eventPhase = eventPhase;
}
/**
 * Set the current target of a given event.
 * @param {Event} event The event to set current target.
 * @param {EventTarget|null} currentTarget New current target.
 * @returns {void}
 * @private
 */

function setCurrentTarget(event, currentTarget) {
  pd(event).currentTarget = currentTarget;
}
/**
 * Set a passive listener of a given event.
 * @param {Event} event The event to set current target.
 * @param {Function|null} passiveListener New passive listener.
 * @returns {void}
 * @private
 */

function setPassiveListener(event, passiveListener) {
  pd(event).passiveListener = passiveListener;
}

/**
 * @typedef {object} ListenerNode
 * @property {Function} listener
 * @property {1|2|3} listenerType
 * @property {boolean} passive
 * @property {boolean} once
 * @property {ListenerNode|null} next
 * @private
 */

/**
 * @type {WeakMap<object, Map<string, ListenerNode>>}
 * @private
 */

var listenersMap = new WeakMap(); // Listener types

var CAPTURE = 1;
var BUBBLE = 2;
var ATTRIBUTE = 3;
/**
 * Check whether a given value is an object or not.
 * @param {any} x The value to check.
 * @returns {boolean} `true` if the value is an object.
 */

function isObject(x) {
  return x !== null && _typeof(x) === "object"; //eslint-disable-line no-restricted-syntax
}
/**
 * Get listeners.
 * @param {EventTarget} eventTarget The event target to get.
 * @returns {Map<string, ListenerNode>} The listeners.
 * @private
 */


function getListeners(eventTarget) {
  var listeners = listenersMap.get(eventTarget);

  if (listeners == null) {
    throw new TypeError("'this' is expected an EventTarget object, but got another value.");
  }

  return listeners;
}
/**
 * Get the property descriptor for the event attribute of a given event.
 * @param {string} eventName The event name to get property descriptor.
 * @returns {PropertyDescriptor} The property descriptor.
 * @private
 */


function defineEventAttributeDescriptor(eventName) {
  return {
    get: function get() {
      var listeners = getListeners(this);
      var node = listeners.get(eventName);

      while (node != null) {
        if (node.listenerType === ATTRIBUTE) {
          return node.listener;
        }

        node = node.next;
      }

      return null;
    },
    set: function set(listener) {
      if (typeof listener !== "function" && !isObject(listener)) {
        listener = null; // eslint-disable-line no-param-reassign
      }

      var listeners = getListeners(this); // Traverse to the tail while removing old value.

      var prev = null;
      var node = listeners.get(eventName);

      while (node != null) {
        if (node.listenerType === ATTRIBUTE) {
          // Remove old value.
          if (prev !== null) {
            prev.next = node.next;
          } else if (node.next !== null) {
            listeners.set(eventName, node.next);
          } else {
            listeners.delete(eventName);
          }
        } else {
          prev = node;
        }

        node = node.next;
      } // Add new value.


      if (listener !== null) {
        var newNode = {
          listener: listener,
          listenerType: ATTRIBUTE,
          passive: false,
          once: false,
          next: null
        };

        if (prev === null) {
          listeners.set(eventName, newNode);
        } else {
          prev.next = newNode;
        }
      }
    },
    configurable: true,
    enumerable: true
  };
}
/**
 * Define an event attribute (e.g. `eventTarget.onclick`).
 * @param {Object} eventTargetPrototype The event target prototype to define an event attrbite.
 * @param {string} eventName The event name to define.
 * @returns {void}
 */


function defineEventAttribute(eventTargetPrototype, eventName) {
  Object.defineProperty(eventTargetPrototype, "on".concat(eventName), defineEventAttributeDescriptor(eventName));
}
/**
 * Define a custom EventTarget with event attributes.
 * @param {string[]} eventNames Event names for event attributes.
 * @returns {EventTarget} The custom EventTarget.
 * @private
 */


function defineCustomEventTarget(eventNames) {
  /** CustomEventTarget */
  function CustomEventTarget() {
    EventTarget.call(this);
  }

  CustomEventTarget.prototype = Object.create(EventTarget.prototype, {
    constructor: {
      value: CustomEventTarget,
      configurable: true,
      writable: true
    }
  });

  for (var i = 0; i < eventNames.length; ++i) {
    defineEventAttribute(CustomEventTarget.prototype, eventNames[i]);
  }

  return CustomEventTarget;
}
/**
 * EventTarget.
 *
 * - This is constructor if no arguments.
 * - This is a function which returns a CustomEventTarget constructor if there are arguments.
 *
 * For example:
 *
 *     class A extends EventTarget {}
 *     class B extends EventTarget("message") {}
 *     class C extends EventTarget("message", "error") {}
 *     class D extends EventTarget(["message", "error"]) {}
 */


function EventTarget() {
  /*eslint-disable consistent-return */
  if (this instanceof EventTarget) {
    listenersMap.set(this, new Map());
    return;
  }

  if (arguments.length === 1 && Array.isArray(arguments[0])) {
    return defineCustomEventTarget(arguments[0]);
  }

  if (arguments.length > 0) {
    var types = new Array(arguments.length);

    for (var i = 0; i < arguments.length; ++i) {
      types[i] = arguments[i];
    }

    return defineCustomEventTarget(types);
  }

  throw new TypeError("Cannot call a class as a function");
  /*eslint-enable consistent-return */
} // Should be enumerable, but class methods are not enumerable.


EventTarget.prototype = {
  /**
   * Add a given listener to this event target.
   * @param {string} eventName The event name to add.
   * @param {Function} listener The listener to add.
   * @param {boolean|{capture?:boolean,passive?:boolean,once?:boolean}} [options] The options for this listener.
   * @returns {void}
   */
  addEventListener: function addEventListener(eventName, listener, options) {
    if (listener == null) {
      return;
    }

    if (typeof listener !== "function" && !isObject(listener)) {
      throw new TypeError("'listener' should be a function or an object.");
    }

    var listeners = getListeners(this);
    var optionsIsObj = isObject(options);
    var capture = optionsIsObj ? Boolean(options.capture) : Boolean(options);
    var listenerType = capture ? CAPTURE : BUBBLE;
    var newNode = {
      listener: listener,
      listenerType: listenerType,
      passive: optionsIsObj && Boolean(options.passive),
      once: optionsIsObj && Boolean(options.once),
      next: null // Set it as the first node if the first node is null.

    };
    var node = listeners.get(eventName);

    if (node === undefined) {
      listeners.set(eventName, newNode);
      return;
    } // Traverse to the tail while checking duplication..


    var prev = null;

    while (node != null) {
      if (node.listener === listener && node.listenerType === listenerType) {
        // Should ignore duplication.
        return;
      }

      prev = node;
      node = node.next;
    } // Add it.


    prev.next = newNode;
  },

  /**
   * Remove a given listener from this event target.
   * @param {string} eventName The event name to remove.
   * @param {Function} listener The listener to remove.
   * @param {boolean|{capture?:boolean,passive?:boolean,once?:boolean}} [options] The options for this listener.
   * @returns {void}
   */
  removeEventListener: function removeEventListener(eventName, listener, options) {
    if (listener == null) {
      return;
    }

    var listeners = getListeners(this);
    var capture = isObject(options) ? Boolean(options.capture) : Boolean(options);
    var listenerType = capture ? CAPTURE : BUBBLE;
    var prev = null;
    var node = listeners.get(eventName);

    while (node != null) {
      if (node.listener === listener && node.listenerType === listenerType) {
        if (prev !== null) {
          prev.next = node.next;
        } else if (node.next !== null) {
          listeners.set(eventName, node.next);
        } else {
          listeners.delete(eventName);
        }

        return;
      }

      prev = node;
      node = node.next;
    }
  },

  /**
   * Dispatch a given event.
   * @param {Event|{type:string}} event The event to dispatch.
   * @returns {boolean} `false` if canceled.
   */
  dispatchEvent: function dispatchEvent(event) {
    if (event == null || typeof event.type !== "string") {
      throw new TypeError('"event.type" should be a string.');
    } // If listeners aren't registered, terminate.


    var listeners = getListeners(this);
    var eventName = event.type;
    var node = listeners.get(eventName);

    if (node == null) {
      return true;
    } // Since we cannot rewrite several properties, so wrap object.


    var wrappedEvent = wrapEvent(this, event); // This doesn't process capturing phase and bubbling phase.
    // This isn't participating in a tree.

    var prev = null;

    while (node != null) {
      // Remove this listener if it's once
      if (node.once) {
        if (prev !== null) {
          prev.next = node.next;
        } else if (node.next !== null) {
          listeners.set(eventName, node.next);
        } else {
          listeners.delete(eventName);
        }
      } else {
        prev = node;
      } // Call this listener


      setPassiveListener(wrappedEvent, node.passive ? node.listener : null);

      if (typeof node.listener === "function") {
        try {
          node.listener.call(this, wrappedEvent);
        } catch (err) {
          if (typeof console !== "undefined" && typeof console.error === "function") {
            console.error(err);
          }
        }
      } else if (node.listenerType !== ATTRIBUTE && typeof node.listener.handleEvent === "function") {
        node.listener.handleEvent(wrappedEvent);
      } // Break if `event.stopImmediatePropagation` was called.


      if (isStopped(wrappedEvent)) {
        break;
      }

      node = node.next;
    }

    setPassiveListener(wrappedEvent, null);
    setEventPhase(wrappedEvent, 0);
    setCurrentTarget(wrappedEvent, null);
    return !wrappedEvent.defaultPrevented;
  }
}; // `constructor` is not enumerable.

Object.defineProperty(EventTarget.prototype, "constructor", {
  value: EventTarget,
  configurable: true,
  writable: true
}); // Ensure `eventTarget instanceof window.EventTarget` is `true`.

if (typeof window !== "undefined" && typeof window.EventTarget !== "undefined") {
  Object.setPrototypeOf(EventTarget.prototype, window.EventTarget.prototype);
}

/* harmony default export */ __webpack_exports__["default"] = (EventTarget);

//# sourceMappingURL=event-target-shim.mjs.map


/***/ }),

/***/ 51411:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

/***/ })

}]);